export const usa_map = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -133.08837890625003,
              45.44471679159555
            ],
            [
              -128.16650390625,
              45.44471679159555
            ],
            [
              -128.16650390625,
              48.06339653776211
            ],
            [
              -133.08837890625003,
              48.06339653776211
            ],
            [
              -133.08837890625003,
              45.44471679159555
            ]
          ]
        ]
      },
      "properties": {
        "featurecla": "Admin-1 scale rank",
        "scalerank": 2,
        "adm1_code": "USA-3563",
        "diss_me": 3563,
        "adm1_cod_1": "USA-3563",
        "iso_3166_2": "US-AK",
        "wikipedia": "http://en.wikipedia.org/wiki/Alaska",
        "sr_sov_a3": "US1",
        "sr_adm0_a3": "USA",
        "iso_a2": "US",
        "adm0_sr": 6,
        "admin0_lab": 2,
        "name": "Alaska",
        "name_alt": "AK|Alaska",
        "name_local": "",
        "type": "State",
        "type_en": "State",
        "code_local": "US02",
        "code_hasc": "US.AK",
        "note": "",
        "hasc_maybe": "",
        "region": "West",
        "region_cod": "",
        "region_big": "Pacific",
        "big_code": "",
        "provnum_ne": 0,
        "gadm_level": 1,
        "check_me": 0,
        "scaleran_1": 2,
        "datarank": 1,
        "abbrev": "Alaska",
        "postal": "AK",
        "area_sqkm": 0,
        "sameascity": -99,
        "labelrank": 0,
        "featurec_1": "Admin-1 scale rank",
        "admin": "United States of America",
        "name_len": 6,
        "mapcolor9": 1,
        "mapcolor13": 1
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [ -88.0713, 30.2523 ],
            [ -88.1593, 30.2309 ],
            [ -88.2897, 30.2329 ],
            [ -88.3163, 30.2405 ],
            [ -88.2639, 30.2547 ],
            [ -88.1094, 30.2737 ],
            [ -88.0713, 30.2523 ]
          ],
          [
            [ -87.5662, 30.7956 ],
            [ -87.4217, 30.6716 ],
            [ -87.4083, 30.6415 ],
            [ -87.4338, 30.5459 ],
            [ -87.4294, 30.4779 ],
            [ -87.4448, 30.4426 ],
            [ -87.4801, 30.4117 ],
            [ -87.4895, 30.3777 ],
            [ -87.5133, 30.3681 ],
            [ -87.6223, 30.2648 ],
            [ -88.0059, 30.2309 ],
            [ -87.985, 30.2544 ],
            [ -87.904, 30.2591 ],
            [ -87.7903, 30.2918 ],
            [ -87.8133, 30.3469 ],
            [ -87.8571, 30.4074 ],
            [ -87.8976, 30.4141 ],
            [ -87.9243, 30.4496 ],
            [ -87.923, 30.5616 ],
            [ -87.9489, 30.6269 ],
            [ -88.0113, 30.6942 ],
            [ -88.0324, 30.6812 ],
            [ -88.0784, 30.5662 ],
            [ -88.1166, 30.4153 ],
            [ -88.1354, 30.3666 ],
            [ -88.2492, 30.3632 ],
            [ -88.3499, 30.3735 ],
            [ -88.3996, 30.3708 ],
            [ -88.4128, 30.5766 ],
            [ -88.4233, 30.7643 ],
            [ -88.4337, 30.952 ],
            [ -88.4442, 31.1397 ],
            [ -88.4547, 31.3274 ],
            [ -88.4652, 31.5151 ],
            [ -88.4757, 31.7028 ],
            [ -88.4862, 31.8905 ],
            [ -88.4618, 32.0752 ],
            [ -88.4374, 32.26 ],
            [ -88.413, 32.4447 ],
            [ -88.3886, 32.6294 ],
            [ -88.3641, 32.8142 ],
            [ -88.3397, 32.9989 ],
            [ -88.3153, 33.1836 ],
            [ -88.2909, 33.3683 ],
            [ -88.2665, 33.5531 ],
            [ -88.2421, 33.7378 ],
            [ -88.2177, 33.9225 ],
            [ -88.1933, 34.1073 ],
            [ -88.1689, 34.292 ],
            [ -88.1445, 34.4767 ],
            [ -88.1201, 34.6615 ],
            [ -88.0956, 34.8462 ],
            [ -88.0895, 34.8931 ],
            [ -88.0882, 34.9091 ],
            [ -88.0848, 34.9331 ],
            [ -88.1733, 34.999 ],
            [ -88.1908, 35.012 ],
            [ -88.2031, 35.0242 ],
            [ -88.1904, 35.025 ],
            [ -88.03, 35.0235 ],
            [ -87.8696, 35.022 ],
            [ -87.7092, 35.0205 ],
            [ -87.5487, 35.0189 ],
            [ -87.3883, 35.0175 ],
            [ -87.2279, 35.0159 ],
            [ -87.0674, 35.0145 ],
            [ -86.907, 35.0129 ],
            [ -86.7466, 35.0114 ],
            [ -86.5862, 35.0099 ],
            [ -86.4257, 35.0084 ],
            [ -86.2653, 35.0069 ],
            [ -86.1049, 35.0054 ],
            [ -85.9444, 35.0039 ],
            [ -85.784, 35.0024 ],
            [ -85.6236, 35.0009 ],
            [ -85.5972, 34.8731 ],
            [ -85.5708, 34.7453 ],
            [ -85.5444, 34.6175 ],
            [ -85.5179, 34.4897 ],
            [ -85.4915, 34.3619 ],
            [ -85.4651, 34.2341 ],
            [ -85.4387, 34.1063 ],
            [ -85.4123, 33.9786 ],
            [ -85.3859, 33.8507 ],
            [ -85.3595, 33.723 ],
            [ -85.3331, 33.5952 ],
            [ -85.3066, 33.4674 ],
            [ -85.2802, 33.3396 ],
            [ -85.2538, 33.2118 ],
            [ -85.2274, 33.084 ],
            [ -85.201, 32.9562 ],
            [ -85.1763, 32.8982 ],
            [ -85.1565, 32.8043 ],
            [ -85.015, 32.5262 ],
            [ -84.9739, 32.4093 ],
            [ -84.986, 32.3609 ],
            [ -84.9685, 32.3198 ],
            [ -84.9215, 32.2859 ],
            [ -84.9297, 32.2466 ],
            [ -84.993, 32.2018 ],
            [ -85.0346, 32.1474 ],
            [ -85.0646, 32.051 ],
            [ -85.0644, 32.0505 ],
            [ -85.1241, 31.8805 ],
            [ -85.1248, 31.7768 ],
            [ -85.0672, 31.6354 ],
            [ -85.067, 31.6352 ],
            [ -85.0549, 31.5727 ],
            [ -85.0926, 31.2957 ],
            [ -85.0674, 31.1176 ],
            [ -85.0073, 31.0017 ],
            [ -85.33, 31.0011 ],
            [ -85.6534, 31.0011 ],
            [ -85.9768, 31.001 ],
            [ -86.3002, 31.0009 ],
            [ -86.6236, 31.0009 ],
            [ -86.9469, 31.0008 ],
            [ -87.2703, 31.0008 ],
            [ -87.5937, 31.0007 ],
            [ -87.6074, 30.9293 ],
            [ -87.6011, 30.8606 ],
            [ -87.5662, 30.7956 ]
          ]
        ]
      },
      "properties": {
        "featurecla": "Admin-1 scale rank",
        "scalerank": 2,
        "adm1_code": "USA-3541",
        "diss_me": 3541,
        "adm1_cod_1": "USA-3541",
        "iso_3166_2": "US-AL",
        "wikipedia": "http://en.wikipedia.org/wiki/Alabama",
        "sr_sov_a3": "US1",
        "sr_adm0_a3": "USA",
        "iso_a2": "US",
        "adm0_sr": 5,
        "admin0_lab": 2,
        "name": "Alabama",
        "name_alt": "AL|Ala.",
        "name_local": "",
        "type": "State",
        "type_en": "State",
        "code_local": "US01",
        "code_hasc": "US.AL",
        "note": "",
        "hasc_maybe": "",
        "region": "South",
        "region_cod": "",
        "region_big": "East South Central",
        "big_code": "",
        "provnum_ne": 0,
        "gadm_level": 1,
        "check_me": 0,
        "scaleran_1": 2,
        "datarank": 1,
        "abbrev": "Ala.",
        "postal": "AL",
        "area_sqkm": 0,
        "sameascity": -99,
        "labelrank": 0,
        "featurec_1": "Admin-1 scale rank",
        "admin": "United States of America",
        "name_len": 7,
        "mapcolor9": 1,
        "mapcolor13": 1
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [ -89.7048, 36.0016 ],
            [ -89.7093, 35.9831 ],
            [ -89.6892, 35.9436 ],
            [ -89.6889, 35.921 ],
            [ -89.7038, 35.9069 ],
            [ -89.7382, 35.8987 ],
            [ -89.7636, 35.8888 ],
            [ -89.7689, 35.8721 ],
            [ -89.7699, 35.8643 ],
            [ -89.7681, 35.8452 ],
            [ -89.7636, 35.828 ],
            [ -89.7797, 35.8057 ],
            [ -89.8946, 35.7505 ],
            [ -89.9435, 35.6791 ],
            [ -89.9265, 35.5917 ],
            [ -89.9673, 35.5033 ],
            [ -90.066, 35.4141 ],
            [ -90.1079, 35.3142 ],
            [ -90.0929, 35.2036 ],
            [ -90.1423, 35.1143 ],
            [ -90.256, 35.0464 ],
            [ -90.2938, 35.0045 ],
            [ -90.2937, 35.0011 ],
            [ -90.2934, 34.9701 ],
            [ -90.2821, 34.9453 ],
            [ -90.3199, 34.8992 ],
            [ -90.4159, 34.8516 ],
            [ -90.4676, 34.8053 ],
            [ -90.4748, 34.7601 ],
            [ -90.4972, 34.7381 ],
            [ -90.5392, 34.7282 ],
            [ -90.5638, 34.6612 ],
            [ -90.584, 34.5037 ],
            [ -90.6354, 34.4139 ],
            [ -90.7181, 34.3917 ],
            [ -90.7623, 34.3564 ],
            [ -90.7681, 34.3081 ],
            [ -90.8172, 34.2522 ],
            [ -90.9097, 34.1888 ],
            [ -90.9403, 34.1286 ],
            [ -90.9088, 34.0716 ],
            [ -90.9147, 34.0486 ],
            [ -90.9431, 34.0297 ],
            [ -91.0431, 34.0029 ],
            [ -91.0604, 33.9893 ],
            [ -91.0702, 33.9742 ],
            [ -91.0501, 33.9452 ],
            [ -91.0382, 33.9014 ],
            [ -91.0527, 33.8276 ],
            [ -91.0772, 33.7967 ],
            [ -91.1003, 33.7674 ],
            [ -91.1841, 33.7157 ],
            [ -91.2075, 33.6757 ],
            [ -91.1704, 33.6475 ],
            [ -91.1727, 33.6167 ],
            [ -91.2146, 33.5834 ],
            [ -91.2027, 33.547 ],
            [ -91.193, 33.5225 ],
            [ -91.1543, 33.5002 ],
            [ -91.141, 33.4385 ],
            [ -91.1685, 33.3595 ],
            [ -91.1633, 33.2945 ],
            [ -91.1173, 33.2408 ],
            [ -91.1068, 33.2179 ],
            [ -91.1529, 33.0406 ],
            [ -91.15, 33.0159 ],
            [ -91.3462, 33.0152 ],
            [ -91.5259, 33.015 ],
            [ -91.7055, 33.0148 ],
            [ -91.8852, 33.0145 ],
            [ -92.0649, 33.0143 ],
            [ -92.2446, 33.0141 ],
            [ -92.4243, 33.0139 ],
            [ -92.6039, 33.0137 ],
            [ -92.7836, 33.0135 ],
            [ -92.9633, 33.0133 ],
            [ -93.143, 33.0131 ],
            [ -93.3226, 33.0128 ],
            [ -93.5023, 33.0126 ],
            [ -93.6819, 33.0124 ],
            [ -93.8616, 33.0122 ],
            [ -94.0413, 33.012 ],
            [ -94.0428, 33.1476 ],
            [ -94.0443, 33.2832 ],
            [ -94.0458, 33.4188 ],
            [ -94.0473, 33.5544 ],
            [ -94.0988, 33.5773 ],
            [ -94.1915, 33.589 ],
            [ -94.2385, 33.5812 ],
            [ -94.2947, 33.5875 ],
            [ -94.3326, 33.565 ],
            [ -94.3577, 33.561 ],
            [ -94.378, 33.5661 ],
            [ -94.3901, 33.5856 ],
            [ -94.432, 33.5997 ],
            [ -94.4841, 33.6484 ],
            [ -94.4813, 33.7571 ],
            [ -94.4785, 33.8658 ],
            [ -94.4757, 33.9745 ],
            [ -94.4729, 34.0831 ],
            [ -94.4701, 34.1918 ],
            [ -94.4673, 34.3005 ],
            [ -94.4645, 34.4092 ],
            [ -94.4616, 34.5178 ],
            [ -94.4588, 34.6265 ],
            [ -94.456, 34.7352 ],
            [ -94.4532, 34.8439 ],
            [ -94.4504, 34.9525 ],
            [ -94.4476, 35.0612 ],
            [ -94.4447, 35.1699 ],
            [ -94.442, 35.2786 ],
            [ -94.4391, 35.3873 ],
            [ -94.4615, 35.5265 ],
            [ -94.484, 35.6657 ],
            [ -94.5064, 35.8048 ],
            [ -94.5288, 35.9441 ],
            [ -94.5512, 36.0833 ],
            [ -94.5736, 36.2225 ],
            [ -94.596, 36.3617 ],
            [ -94.6184, 36.5009 ],
            [ -94.3399, 36.5009 ],
            [ -94.0614, 36.5009 ],
            [ -93.7828, 36.5009 ],
            [ -93.5043, 36.5009 ],
            [ -93.2258, 36.5009 ],
            [ -92.9473, 36.5009 ],
            [ -92.6688, 36.5009 ],
            [ -92.3903, 36.5009 ],
            [ -92.1118, 36.5009 ],
            [ -91.8333, 36.5009 ],
            [ -91.5548, 36.5009 ],
            [ -91.2763, 36.5009 ],
            [ -90.9978, 36.5009 ],
            [ -90.7192, 36.5009 ],
            [ -90.4407, 36.5009 ],
            [ -90.1622, 36.5009 ],
            [ -90.1181, 36.4225 ],
            [ -90.0745, 36.3718 ],
            [ -90.0671, 36.3343 ],
            [ -90.0757, 36.2967 ],
            [ -90.1493, 36.2159 ],
            [ -90.2162, 36.1784 ],
            [ -90.2526, 36.1377 ],
            [ -90.303, 36.0994 ],
            [ -90.3811, 35.9927 ],
            [ -90.2168, 35.9949 ],
            [ -90.0525, 35.9971 ],
            [ -89.8882, 35.9993 ],
            [ -89.7048, 36.0016 ]
          ]
        ]
      },
      "properties": {
        "featurecla": "Admin-1 scale rank",
        "scalerank": 2,
        "adm1_code": "USA-3528",
        "diss_me": 3528,
        "adm1_cod_1": "USA-3528",
        "iso_3166_2": "US-AR",
        "wikipedia": "http://en.wikipedia.org/wiki/Arkansas",
        "sr_sov_a3": "US1",
        "sr_adm0_a3": "USA",
        "iso_a2": "US",
        "adm0_sr": 1,
        "admin0_lab": 2,
        "name": "Arkansas",
        "name_alt": "AR|Ark.",
        "name_local": "",
        "type": "State",
        "type_en": "State",
        "code_local": "US05",
        "code_hasc": "US.AR",
        "note": "",
        "hasc_maybe": "",
        "region": "South",
        "region_cod": "",
        "region_big": "West South Central",
        "big_code": "",
        "provnum_ne": 0,
        "gadm_level": 1,
        "check_me": 0,
        "scaleran_1": 2,
        "datarank": 1,
        "abbrev": "Ark.",
        "postal": "AR",
        "area_sqkm": 0,
        "sameascity": -99,
        "labelrank": 0,
        "featurec_1": "Admin-1 scale rank",
        "admin": "United States of America",
        "name_len": 8,
        "mapcolor9": 1,
        "mapcolor13": 1
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [ -109.0467, 37.0008 ],
            [ -109.0467, 36.6463 ],
            [ -109.0467, 36.2918 ],
            [ -109.0468, 35.9373 ],
            [ -109.0469, 35.5828 ],
            [ -109.0469, 35.2283 ],
            [ -109.047, 34.8738 ],
            [ -109.047, 34.5193 ],
            [ -109.0471, 34.1648 ],
            [ -109.0471, 33.8103 ],
            [ -109.0472, 33.4558 ],
            [ -109.0472, 33.1013 ],
            [ -109.0473, 32.7468 ],
            [ -109.0473, 32.3922 ],
            [ -109.0474, 32.0377 ],
            [ -109.0474, 31.6832 ],
            [ -109.0478, 31.3279 ],
            [ -109.2748, 31.3275 ],
            [ -109.6282, 31.3268 ],
            [ -109.9817, 31.3262 ],
            [ -110.3351, 31.3255 ],
            [ -110.6885, 31.3249 ],
            [ -111.042, 31.3242 ],
            [ -111.5162, 31.4722 ],
            [ -111.9905, 31.6202 ],
            [ -112.4647, 31.7682 ],
            [ -112.939, 31.9163 ],
            [ -113.4132, 32.0643 ],
            [ -113.8875, 32.2123 ],
            [ -114.3617, 32.3603 ],
            [ -114.836, 32.5083 ],
            [ -114.788, 32.5648 ],
            [ -114.7248, 32.7153 ],
            [ -114.7209, 32.7245 ],
            [ -114.7209, 32.7245 ],
            [ -114.5822, 32.7347 ],
            [ -114.5165, 32.7728 ],
            [ -114.4775, 32.842 ],
            [ -114.469, 32.9123 ],
            [ -114.4909, 32.9836 ],
            [ -114.5505, 33.0368 ],
            [ -114.6481, 33.0718 ],
            [ -114.7044, 33.1698 ],
            [ -114.7194, 33.3309 ],
            [ -114.7017, 33.4178 ],
            [ -114.6512, 33.4306 ],
            [ -114.6026, 33.4699 ],
            [ -114.556, 33.5356 ],
            [ -114.5216, 33.6076 ],
            [ -114.4993, 33.6859 ],
            [ -114.4951, 33.7847 ],
            [ -114.5091, 33.9039 ],
            [ -114.4183, 34.0511 ],
            [ -114.3293, 34.142 ],
            [ -114.1635, 34.2534 ],
            [ -114.1256, 34.2865 ],
            [ -114.125, 34.3141 ],
            [ -114.1251, 34.3172 ],
            [ -114.1588, 34.3552 ],
            [ -114.308, 34.4329 ],
            [ -114.371, 34.4885 ],
            [ -114.3769, 34.5397 ],
            [ -114.3789, 34.5406 ],
            [ -114.398, 34.5897 ],
            [ -114.5575, 34.7946 ],
            [ -114.6109, 34.9074 ],
            [ -114.6105, 34.9911 ],
            [ -114.6105, 34.9976 ],
            [ -114.591, 35.3528 ],
            [ -114.6485, 35.4759 ],
            [ -114.6621, 35.5454 ],
            [ -114.6452, 35.6305 ],
            [ -114.6501, 35.6835 ],
            [ -114.6771, 35.7298 ],
            [ -114.6837, 35.8136 ],
            [ -114.6871, 35.9173 ],
            [ -114.7323, 35.9837 ],
            [ -114.7414, 36.0135 ],
            [ -114.7158, 36.085 ],
            [ -114.6691, 36.1217 ],
            [ -114.593, 36.1476 ],
            [ -114.5053, 36.1564 ],
            [ -114.4061, 36.1483 ],
            [ -114.3315, 36.1163 ],
            [ -114.2816, 36.0603 ],
            [ -114.2321, 36.0317 ],
            [ -114.1832, 36.0303 ],
            [ -114.1194, 36.0767 ],
            [ -114.0619, 36.1752 ],
            [ -114.0429, 36.1818 ],
            [ -114.0412, 36.6125 ],
            [ -114.0403, 37.0042 ],
            [ -113.7282, 37.0039 ],
            [ -113.4161, 37.0037 ],
            [ -113.104, 37.0035 ],
            [ -112.7919, 37.0033 ],
            [ -112.4798, 37.0031 ],
            [ -112.1677, 37.0029 ],
            [ -111.8556, 37.0027 ],
            [ -111.5435, 37.0025 ],
            [ -111.2314, 37.0023 ],
            [ -110.9193, 37.0021 ],
            [ -110.6072, 37.0019 ],
            [ -110.2951, 37.0017 ],
            [ -109.983, 37.0015 ],
            [ -109.6709, 37.0013 ],
            [ -109.3588, 37.0011 ],
            [ -109.0467, 37.0008 ]
          ]
        ]
      },
      "properties": {
        "featurecla": "Admin-1 scale rank",
        "scalerank": 2,
        "adm1_code": "USA-3520",
        "diss_me": 3520,
        "adm1_cod_1": "USA-3520",
        "iso_3166_2": "US-AZ",
        "wikipedia": "http://en.wikipedia.org/wiki/Arizona",
        "sr_sov_a3": "US1",
        "sr_adm0_a3": "USA",
        "iso_a2": "US",
        "adm0_sr": 1,
        "admin0_lab": 2,
        "name": "Arizona",
        "name_alt": "AZ|Ariz.",
        "name_local": "",
        "type": "State",
        "type_en": "State",
        "code_local": "US04",
        "code_hasc": "US.AZ",
        "note": "",
        "hasc_maybe": "",
        "region": "West",
        "region_cod": "",
        "region_big": "Mountain",
        "big_code": "",
        "provnum_ne": 0,
        "gadm_level": 1,
        "check_me": 0,
        "scaleran_1": 2,
        "datarank": 1,
        "abbrev": "Ariz.",
        "postal": "AZ",
        "area_sqkm": 0,
        "sameascity": -99,
        "labelrank": 0,
        "featurec_1": "Admin-1 scale rank",
        "admin": "United States of America",
        "name_len": 7,
        "mapcolor9": 1,
        "mapcolor13": 1
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [ -118.3504, 32.8276 ],
            [ -118.4086, 32.8185 ],
            [ -118.4732, 32.8389 ],
            [ -118.5289, 32.9356 ],
            [ -118.5902, 33.0112 ],
            [ -118.5571, 33.0327 ],
            [ -118.5075, 32.9599 ],
            [ -118.3832, 32.8495 ],
            [ -118.3504, 32.8276 ]
          ],
          [
            [ -119.438, 33.2172 ],
            [ -119.4825, 33.2153 ],
            [ -119.5437, 33.2246 ],
            [ -119.5752, 33.2783 ],
            [ -119.5251, 33.2821 ],
            [ -119.4788, 33.2746 ],
            [ -119.4421, 33.2324 ],
            [ -119.438, 33.2172 ]
          ],
          [
            [ -118.348, 33.3858 ],
            [ -118.2975, 33.3121 ],
            [ -118.3702, 33.3212 ],
            [ -118.4463, 33.3171 ],
            [ -118.4694, 33.3571 ],
            [ -118.492, 33.4128 ],
            [ -118.5073, 33.427 ],
            [ -118.5594, 33.432 ],
            [ -118.5633, 33.4371 ],
            [ -118.5694, 33.4642 ],
            [ -118.5548, 33.4771 ],
            [ -118.3917, 33.4151 ],
            [ -118.348, 33.3858 ]
          ],
          [
            [ -120.0436, 33.9189 ],
            [ -120.1139, 33.9049 ],
            [ -120.1671, 33.9181 ],
            [ -120.2519, 34.0138 ],
            [ -120.0718, 34.0265 ],
            [ -119.9944, 33.9849 ],
            [ -119.9839, 33.9733 ],
            [ -120.0436, 33.9189 ]
          ],
          [
            [ -120.3066, 34.0249 ],
            [ -120.3597, 34.0223 ],
            [ -120.4416, 34.0329 ],
            [ -120.4129, 34.0563 ],
            [ -120.3677, 34.0733 ],
            [ -120.3533, 34.0606 ],
            [ -120.3066, 34.0249 ]
          ],
          [
            [ -119.8824, 34.0797 ],
            [ -119.6789, 34.0285 ],
            [ -119.5691, 34.053 ],
            [ -119.5493, 34.0282 ],
            [ -119.5622, 34.0066 ],
            [ -119.8096, 33.9678 ],
            [ -119.8855, 33.9949 ],
            [ -119.8924, 34.0322 ],
            [ -119.918, 34.0678 ],
            [ -119.8824, 34.0797 ]
          ],
          [
            [ -124.2284, 42.0008 ],
            [ -123.9557, 42.0006 ],
            [ -123.692, 42.0006 ],
            [ -123.4284, 42.0006 ],
            [ -123.1647, 42.0006 ],
            [ -122.901, 42.0006 ],
            [ -122.6374, 42.0006 ],
            [ -122.3737, 42.0006 ],
            [ -122.1101, 42.0006 ],
            [ -121.8464, 42.0006 ],
            [ -121.5827, 42.0006 ],
            [ -121.3191, 42.0006 ],
            [ -121.0554, 42.0006 ],
            [ -120.7918, 42.0006 ],
            [ -120.5281, 42.0006 ],
            [ -120.2645, 42.0006 ],
            [ -120.0008, 42.0006 ],
            [ -120.0008, 41.8131 ],
            [ -120.0007, 41.6255 ],
            [ -120.0007, 41.438 ],
            [ -120.0006, 41.2505 ],
            [ -120.0006, 41.063 ],
            [ -120.0006, 40.8755 ],
            [ -120.0005, 40.688 ],
            [ -120.0004, 40.5004 ],
            [ -120.0004, 40.3129 ],
            [ -120.0003, 40.1254 ],
            [ -120.0003, 39.9379 ],
            [ -120.0002, 39.7503 ],
            [ -120.0002, 39.5628 ],
            [ -120.0001, 39.3753 ],
            [ -120.0001, 39.1878 ],
            [ -120.0001, 39.0003 ],
            [ -119.7658, 38.8368 ],
            [ -119.5316, 38.6733 ],
            [ -119.2974, 38.5098 ],
            [ -119.0632, 38.3463 ],
            [ -118.8289, 38.1828 ],
            [ -118.5947, 38.0193 ],
            [ -118.3605, 37.8559 ],
            [ -118.1263, 37.6924 ],
            [ -117.9429, 37.5546 ],
            [ -117.7596, 37.4168 ],
            [ -117.5763, 37.279 ],
            [ -117.3929, 37.1412 ],
            [ -117.2096, 37.0034 ],
            [ -117.0263, 36.8655 ],
            [ -116.8429, 36.7278 ],
            [ -116.6596, 36.59 ],
            [ -116.4057, 36.3918 ],
            [ -116.1517, 36.1936 ],
            [ -115.8978, 35.9955 ],
            [ -115.6439, 35.7973 ],
            [ -115.39, 35.5991 ],
            [ -115.1361, 35.401 ],
            [ -114.8822, 35.2028 ],
            [ -114.6105, 34.9911 ],
            [ -114.6109, 34.9074 ],
            [ -114.5575, 34.7946 ],
            [ -114.398, 34.5897 ],
            [ -114.3789, 34.5406 ],
            [ -114.3769, 34.5397 ],
            [ -114.371, 34.4885 ],
            [ -114.308, 34.4329 ],
            [ -114.1588, 34.3552 ],
            [ -114.1251, 34.3172 ],
            [ -114.125, 34.3141 ],
            [ -114.1256, 34.2865 ],
            [ -114.1635, 34.2534 ],
            [ -114.3293, 34.142 ],
            [ -114.4183, 34.0511 ],
            [ -114.5091, 33.9039 ],
            [ -114.4951, 33.7847 ],
            [ -114.4993, 33.6859 ],
            [ -114.5216, 33.6076 ],
            [ -114.556, 33.5356 ],
            [ -114.6026, 33.4699 ],
            [ -114.6512, 33.4306 ],
            [ -114.7017, 33.4178 ],
            [ -114.7194, 33.3309 ],
            [ -114.7044, 33.1698 ],
            [ -114.6481, 33.0718 ],
            [ -114.5505, 33.0368 ],
            [ -114.4909, 32.9836 ],
            [ -114.469, 32.9123 ],
            [ -114.4775, 32.842 ],
            [ -114.5165, 32.7728 ],
            [ -114.5822, 32.7347 ],
            [ -114.7209, 32.7245 ],
            [ -114.7209, 32.7245 ],
            [ -114.7248, 32.7153 ],
            [ -114.8391, 32.7047 ],
            [ -115.1252, 32.6833 ],
            [ -115.4114, 32.6619 ],
            [ -115.6975, 32.6405 ],
            [ -115.9837, 32.619 ],
            [ -116.2698, 32.5976 ],
            [ -116.556, 32.5762 ],
            [ -116.8421, 32.5548 ],
            [ -117.1283, 32.5334 ],
            [ -117.1305, 32.5398 ],
            [ -117.1374, 32.6492 ],
            [ -117.1837, 32.6879 ],
            [ -117.2435, 32.664 ],
            [ -117.2707, 32.8063 ],
            [ -117.2558, 32.8734 ],
            [ -117.263, 32.9389 ],
            [ -117.3188, 33.1001 ],
            [ -117.4674, 33.2955 ],
            [ -117.7885, 33.5385 ],
            [ -117.9521, 33.6196 ],
            [ -118.0805, 33.7222 ],
            [ -118.1619, 33.7507 ],
            [ -118.2644, 33.7586 ],
            [ -118.2942, 33.7123 ],
            [ -118.4104, 33.7439 ],
            [ -118.3929, 33.8583 ],
            [ -118.5062, 34.0174 ],
            [ -118.5989, 34.035 ],
            [ -118.832, 34.0245 ],
            [ -119.1437, 34.112 ],
            [ -119.2358, 34.1641 ],
            [ -119.2676, 34.2574 ],
            [ -119.4137, 34.3386 ],
            [ -119.6061, 34.418 ],
            [ -119.7132, 34.3997 ],
            [ -119.8533, 34.412 ],
            [ -120.053, 34.4693 ],
            [ -120.1696, 34.4765 ],
            [ -120.3965, 34.4596 ],
            [ -120.4812, 34.4716 ],
            [ -120.5598, 34.5439 ],
            [ -120.6447, 34.58 ],
            [ -120.6267, 34.6689 ],
            [ -120.6376, 34.7494 ],
            [ -120.6249, 34.812 ],
            [ -120.663, 34.9493 ],
            [ -120.6336, 35.0765 ],
            [ -120.6591, 35.1224 ],
            [ -120.707, 35.1576 ],
            [ -120.8574, 35.2097 ],
            [ -120.8849, 35.2749 ],
            [ -120.8603, 35.3654 ],
            [ -120.8996, 35.4251 ],
            [ -121.0228, 35.4808 ],
            [ -121.1379, 35.6071 ],
            [ -121.2838, 35.6763 ],
            [ -121.3439, 35.7922 ],
            [ -121.4337, 35.8639 ],
            [ -121.465, 35.9274 ],
            [ -121.6644, 36.154 ],
            [ -121.8774, 36.3311 ],
            [ -121.9102, 36.4329 ],
            [ -121.9186, 36.5723 ],
            [ -121.8351, 36.6575 ],
            [ -121.79, 36.7323 ],
            [ -121.7945, 36.801 ],
            [ -121.8074, 36.8512 ],
            [ -121.8807, 36.9389 ],
            [ -122.1642, 36.991 ],
            [ -122.3949, 37.2075 ],
            [ -122.4085, 37.3732 ],
            [ -122.4992, 37.5426 ],
            [ -122.5005, 37.6528 ],
            [ -122.5142, 37.772 ],
            [ -122.4456, 37.798 ],
            [ -122.3841, 37.7885 ],
            [ -122.3903, 37.7411 ],
            [ -122.3697, 37.6559 ],
            [ -122.2976, 37.5919 ],
            [ -122.2287, 37.5639 ],
            [ -122.166, 37.5017 ],
            [ -122.119, 37.4828 ],
            [ -122.0705, 37.4783 ],
            [ -122.0965, 37.5182 ],
            [ -122.1241, 37.5438 ],
            [ -122.158, 37.6264 ],
            [ -122.2222, 37.732 ],
            [ -122.296, 37.7904 ],
            [ -122.3334, 37.8966 ],
            [ -122.3655, 37.9212 ],
            [ -122.3854, 37.9606 ],
            [ -122.3142, 38.0073 ],
            [ -122.217, 38.0406 ],
            [ -122.0867, 38.0496 ],
            [ -121.7169, 38.0341 ],
            [ -121.6381, 38.0613 ],
            [ -121.573, 38.0524 ],
            [ -121.5253, 38.0559 ],
            [ -121.6257, 38.0839 ],
            [ -121.6822, 38.0748 ],
            [ -121.7486, 38.0805 ],
            [ -121.8808, 38.075 ],
            [ -121.9342, 38.0868 ],
            [ -121.9931, 38.1201 ],
            [ -122.0315, 38.1235 ],
            [ -122.1538, 38.0655 ],
            [ -122.2083, 38.0725 ],
            [ -122.3371, 38.1359 ],
            [ -122.3934, 38.1448 ],
            [ -122.4839, 38.1088 ],
            [ -122.4949, 37.9536 ],
            [ -122.4669, 37.8382 ],
            [ -122.5213, 37.8264 ],
            [ -122.5842, 37.8741 ],
            [ -122.6807, 37.9023 ],
            [ -122.7604, 37.9456 ],
            [ -122.8729, 38.026 ],
            [ -122.932, 38.0555 ],
            [ -122.9988, 37.9886 ],
            [ -123.0015, 38.0193 ],
            [ -122.9682, 38.097 ],
            [ -122.9776, 38.2273 ],
            [ -122.8768, 38.1234 ],
            [ -122.9082, 38.1966 ],
            [ -122.9865, 38.2771 ],
            [ -123.0462, 38.3051 ],
            [ -123.1212, 38.4493 ],
            [ -123.2897, 38.5359 ],
            [ -123.4248, 38.6756 ],
            [ -123.7011, 38.9073 ],
            [ -123.7195, 39.111 ],
            [ -123.8203, 39.3684 ],
            [ -123.7778, 39.515 ],
            [ -123.7835, 39.6187 ],
            [ -123.8329, 39.7755 ],
            [ -123.8845, 39.8608 ],
            [ -124.1085, 40.0945 ],
            [ -124.324, 40.252 ],
            [ -124.3565, 40.3711 ],
            [ -124.3717, 40.4912 ],
            [ -124.3245, 40.5981 ],
            [ -124.2837, 40.7105 ],
            [ -124.2539, 40.7403 ],
            [ -124.2423, 40.7279 ],
            [ -124.2506, 40.7039 ],
            [ -124.22, 40.6965 ],
            [ -124.2084, 40.7461 ],
            [ -124.1902, 40.7717 ],
            [ -124.2225, 40.775 ],
            [ -124.2192, 40.7907 ],
            [ -124.1999, 40.8221 ],
            [ -124.1331, 40.9698 ],
            [ -124.14, 41.1559 ],
            [ -124.0685, 41.3842 ],
            [ -124.0719, 41.4595 ],
            [ -124.1177, 41.6218 ],
            [ -124.1632, 41.719 ],
            [ -124.2446, 41.7879 ],
            [ -124.2087, 41.8886 ],
            [ -124.2117, 41.9846 ],
            [ -124.2284, 42.0008 ]
          ]
        ]
      },
      "properties": {
        "featurecla": "Admin-1 scale rank",
        "scalerank": 2,
        "adm1_code": "USA-3521",
        "diss_me": 3521,
        "adm1_cod_1": "USA-3521",
        "iso_3166_2": "US-CA",
        "wikipedia": "http://en.wikipedia.org/wiki/California",
        "sr_sov_a3": "US1",
        "sr_adm0_a3": "USA",
        "iso_a2": "US",
        "adm0_sr": 8,
        "admin0_lab": 2,
        "name": "California",
        "name_alt": "CA|Calif.",
        "name_local": "",
        "type": "State",
        "type_en": "State",
        "code_local": "US06",
        "code_hasc": "US.CA",
        "note": "",
        "hasc_maybe": "",
        "region": "West",
        "region_cod": "",
        "region_big": "Pacific",
        "big_code": "",
        "provnum_ne": 0,
        "gadm_level": 1,
        "check_me": 0,
        "scaleran_1": 2,
        "datarank": 1,
        "abbrev": "Calif.",
        "postal": "CA",
        "area_sqkm": 0,
        "sameascity": -99,
        "labelrank": 0,
        "featurec_1": "Admin-1 scale rank",
        "admin": "United States of America",
        "name_len": 10,
        "mapcolor9": 1,
        "mapcolor13": 1
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [ -102.0245, 40.0011 ],
            [ -102.0238, 39.8136 ],
            [ -102.023, 39.6261 ],
            [ -102.0223, 39.4386 ],
            [ -102.0216, 39.251 ],
            [ -102.0208, 39.0635 ],
            [ -102.0201, 38.876 ],
            [ -102.0194, 38.6885 ],
            [ -102.0186, 38.501 ],
            [ -102.0179, 38.3135 ],
            [ -102.0172, 38.1259 ],
            [ -102.0164, 37.9384 ],
            [ -102.0157, 37.7509 ],
            [ -102.015, 37.5634 ],
            [ -102.0143, 37.3759 ],
            [ -102.0135, 37.1884 ],
            [ -102.0128, 37.0008 ],
            [ -102.2598, 37.0008 ],
            [ -102.5068, 37.0008 ],
            [ -102.7538, 37.0008 ],
            [ -103.0008, 37.0008 ],
            [ -103.3787, 37.0008 ],
            [ -103.7566, 37.0008 ],
            [ -104.1344, 37.0008 ],
            [ -104.5123, 37.0008 ],
            [ -104.8902, 37.0008 ],
            [ -105.268, 37.0008 ],
            [ -105.6459, 37.0008 ],
            [ -106.0238, 37.0008 ],
            [ -106.4016, 37.0008 ],
            [ -106.7795, 37.0008 ],
            [ -107.1574, 37.0008 ],
            [ -107.5352, 37.0008 ],
            [ -107.9131, 37.0008 ],
            [ -108.2909, 37.0008 ],
            [ -108.6688, 37.0008 ],
            [ -109.0467, 37.0008 ],
            [ -109.0466, 37.2509 ],
            [ -109.0466, 37.5008 ],
            [ -109.0466, 37.7508 ],
            [ -109.0466, 38.0008 ],
            [ -109.0466, 38.2508 ],
            [ -109.0466, 38.5009 ],
            [ -109.0465, 38.7509 ],
            [ -109.0465, 39.0008 ],
            [ -109.0465, 39.2508 ],
            [ -109.0465, 39.5008 ],
            [ -109.0465, 39.7509 ],
            [ -109.0465, 40.0009 ],
            [ -109.0464, 40.2509 ],
            [ -109.0464, 40.5009 ],
            [ -109.0464, 40.7508 ],
            [ -109.0464, 41.0009 ],
            [ -108.7324, 41.0009 ],
            [ -108.4183, 41.0009 ],
            [ -108.1043, 41.0009 ],
            [ -107.7902, 41.0009 ],
            [ -107.4761, 41.0009 ],
            [ -107.1621, 41.0009 ],
            [ -106.8481, 41.0009 ],
            [ -106.534, 41.0009 ],
            [ -106.22, 41.0009 ],
            [ -105.9059, 41.0009 ],
            [ -105.5919, 41.0009 ],
            [ -105.2778, 41.0009 ],
            [ -104.9638, 41.0009 ],
            [ -104.6498, 41.0009 ],
            [ -104.3357, 41.0009 ],
            [ -104.0217, 41.0009 ],
            [ -103.7721, 41.0008 ],
            [ -103.5225, 41.0008 ],
            [ -103.2729, 41.0008 ],
            [ -103.0233, 41.0007 ],
            [ -102.7737, 41.0007 ],
            [ -102.5242, 41.0007 ],
            [ -102.2746, 41.0006 ],
            [ -102.025, 41.0006 ],
            [ -102.025, 40.8757 ],
            [ -102.0249, 40.7507 ],
            [ -102.0248, 40.6258 ],
            [ -102.0247, 40.5009 ],
            [ -102.0247, 40.3759 ],
            [ -102.0246, 40.251 ],
            [ -102.0245, 40.1261 ],
            [ -102.0245, 40.0011 ]
          ]
        ]
      },
      "properties": {
        "featurecla": "Admin-1 scale rank",
        "scalerank": 2,
        "adm1_code": "USA-3522",
        "diss_me": 3522,
        "adm1_cod_1": "USA-3522",
        "iso_3166_2": "US-CO",
        "wikipedia": "http://en.wikipedia.org/wiki/Colorado",
        "sr_sov_a3": "US1",
        "sr_adm0_a3": "USA",
        "iso_a2": "US",
        "adm0_sr": 1,
        "admin0_lab": 2,
        "name": "Colorado",
        "name_alt": "CO|Colo.",
        "name_local": "",
        "type": "State",
        "type_en": "State",
        "code_local": "US08",
        "code_hasc": "US.CO",
        "note": "",
        "hasc_maybe": "",
        "region": "West",
        "region_cod": "",
        "region_big": "Mountain",
        "big_code": "",
        "provnum_ne": 0,
        "gadm_level": 1,
        "check_me": 0,
        "scaleran_1": 2,
        "datarank": 1,
        "abbrev": "Colo.",
        "postal": "CO",
        "area_sqkm": 0,
        "sameascity": -99,
        "labelrank": 0,
        "featurec_1": "Admin-1 scale rank",
        "admin": "United States of America",
        "name_len": 8,
        "mapcolor9": 1,
        "mapcolor13": 1
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [ -71.8008, 42.012 ],
            [ -71.8003, 41.9582 ],
            [ -71.7996, 41.883 ],
            [ -71.799, 41.8285 ],
            [ -71.7982, 41.7531 ],
            [ -71.7973, 41.6676 ],
            [ -71.7965, 41.5889 ],
            [ -71.7958, 41.52 ],
            [ -71.7992, 41.4792 ],
            [ -71.8045, 41.4167 ],
            [ -71.8299, 41.3927 ],
            [ -71.8424, 41.3355 ],
            [ -71.9299, 41.341 ],
            [ -72.0739, 41.3261 ],
            [ -72.2653, 41.2917 ],
            [ -72.3711, 41.3122 ],
            [ -72.4794, 41.2758 ],
            [ -72.8472, 41.2658 ],
            [ -72.9247, 41.2852 ],
            [ -73.0237, 41.2165 ],
            [ -73.1823, 41.1758 ],
            [ -73.583, 41.0219 ],
            [ -73.6305, 40.9919 ],
            [ -73.6821, 41.0547 ],
            [ -73.723, 41.1045 ],
            [ -73.6419, 41.1434 ],
            [ -73.5798, 41.1731 ],
            [ -73.5218, 41.2009 ],
            [ -73.4841, 41.219 ],
            [ -73.5145, 41.2575 ],
            [ -73.5447, 41.296 ],
            [ -73.5367, 41.3909 ],
            [ -73.5287, 41.4858 ],
            [ -73.5206, 41.5808 ],
            [ -73.5126, 41.6757 ],
            [ -73.5046, 41.7707 ],
            [ -73.4966, 41.8657 ],
            [ -73.4886, 41.9606 ],
            [ -73.4806, 42.0556 ],
            [ -73.3965, 42.0529 ],
            [ -73.3123, 42.0502 ],
            [ -73.2282, 42.0475 ],
            [ -73.1441, 42.0448 ],
            [ -73.06, 42.0421 ],
            [ -72.9759, 42.0395 ],
            [ -72.8918, 42.0368 ],
            [ -72.8077, 42.0341 ],
            [ -72.8065, 42.008 ],
            [ -72.7633, 42.0112 ],
            [ -72.7576, 42.0341 ],
            [ -72.6381, 42.0327 ],
            [ -72.5186, 42.0312 ],
            [ -72.3991, 42.0298 ],
            [ -72.2796, 42.0284 ],
            [ -72.1601, 42.027 ],
            [ -72.0406, 42.0256 ],
            [ -71.9211, 42.0241 ],
            [ -71.8016, 42.0227 ],
            [ -71.8008, 42.012 ]
          ]
        ]
      },
      "properties": {
        "featurecla": "Admin-1 scale rank",
        "scalerank": 2,
        "adm1_code": "USA-3537",
        "diss_me": 3537,
        "adm1_cod_1": "USA-3537",
        "iso_3166_2": "US-CT",
        "wikipedia": "http://en.wikipedia.org/wiki/Connecticut",
        "sr_sov_a3": "US1",
        "sr_adm0_a3": "USA",
        "iso_a2": "US",
        "adm0_sr": 1,
        "admin0_lab": 2,
        "name": "Connecticut",
        "name_alt": "CT|Conn.",
        "name_local": "",
        "type": "State",
        "type_en": "State",
        "code_local": "US09",
        "code_hasc": "US.CT",
        "note": "",
        "hasc_maybe": "",
        "region": "Northeast",
        "region_cod": "",
        "region_big": "New England",
        "big_code": "",
        "provnum_ne": 0,
        "gadm_level": 1,
        "check_me": 0,
        "scaleran_1": 2,
        "datarank": 1,
        "abbrev": "Conn.",
        "postal": "CT",
        "area_sqkm": 0,
        "sameascity": -99,
        "labelrank": 0,
        "featurec_1": "Admin-1 scale rank",
        "admin": "United States of America",
        "name_len": 11,
        "mapcolor9": 1,
        "mapcolor13": 1
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [ -77.0304, 38.8893 ],
            [ -77.053, 38.9153 ],
            [ -77.1018, 38.936 ],
            [ -77.1221, 38.9435 ],
            [ -77.0421, 39.0118 ],
            [ -76.9888, 38.9523 ],
            [ -76.9312, 38.8882 ],
            [ -77.0197, 38.8065 ],
            [ -77.0304, 38.8893 ]
          ]
        ]
      },
      "properties": {
        "featurecla": "Admin-1 scale rank",
        "scalerank": 2,
        "adm1_code": "USA-3556",
        "diss_me": 3556,
        "adm1_cod_1": "USA-3556",
        "iso_3166_2": "US-DC",
        "wikipedia": "http://en.wikipedia.org/wiki/Washington,_D.C.",
        "sr_sov_a3": "US1",
        "sr_adm0_a3": "USA",
        "iso_a2": "US",
        "adm0_sr": 1,
        "admin0_lab": 2,
        "name": "District of Columbia",
        "name_alt": "DC|D.C.",
        "name_local": "",
        "type": "Federal District",
        "type_en": "Federal District",
        "code_local": "US11",
        "code_hasc": "US.DC",
        "note": "",
        "hasc_maybe": "",
        "region": "",
        "region_cod": "",
        "region_big": "",
        "big_code": "",
        "provnum_ne": 0,
        "gadm_level": 1,
        "check_me": 0,
        "scaleran_1": 2,
        "datarank": 1,
        "abbrev": "D.C.",
        "postal": "DC",
        "area_sqkm": 0,
        "sameascity": 9,
        "labelrank": 9,
        "featurec_1": "Admin-1 scale rank",
        "admin": "United States of America",
        "name_len": 20,
        "mapcolor9": 1,
        "mapcolor13": 1
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [ -75.421, 39.8154 ],
            [ -75.4644, 39.7809 ],
            [ -75.5021, 39.7174 ],
            [ -75.5876, 39.6408 ],
            [ -75.5816, 39.5895 ],
            [ -75.5673, 39.553 ],
            [ -75.5739, 39.4769 ],
            [ -75.5198, 39.4028 ],
            [ -75.4127, 39.2814 ],
            [ -75.3922, 39.0928 ],
            [ -75.3104, 38.9666 ],
            [ -75.1851, 38.8194 ],
            [ -75.0887, 38.7775 ],
            [ -75.084, 38.7228 ],
            [ -75.1285, 38.6324 ],
            [ -75.1871, 38.5911 ],
            [ -75.1109, 38.5994 ],
            [ -75.0729, 38.5787 ],
            [ -75.0359, 38.5033 ],
            [ -75.0377, 38.4556 ],
            [ -75.1447, 38.4549 ],
            [ -75.3663, 38.4549 ],
            [ -75.5879, 38.455 ],
            [ -75.6886, 38.455 ],
            [ -75.6909, 38.455 ],
            [ -75.6932, 38.455 ],
            [ -75.6955, 38.455 ],
            [ -75.6978, 38.455 ],
            [ -75.7001, 38.455 ],
            [ -75.7024, 38.455 ],
            [ -75.7047, 38.4551 ],
            [ -75.707, 38.4551 ],
            [ -75.7167, 38.6135 ],
            [ -75.7265, 38.7719 ],
            [ -75.7362, 38.9303 ],
            [ -75.7459, 39.0887 ],
            [ -75.7556, 39.2471 ],
            [ -75.7653, 39.4056 ],
            [ -75.775, 39.5639 ],
            [ -75.7847, 39.7224 ],
            [ -75.7091, 39.8029 ],
            [ -75.6768, 39.8272 ],
            [ -75.6346, 39.8395 ],
            [ -75.5104, 39.8434 ],
            [ -75.421, 39.8154 ]
          ]
        ]
      },
      "properties": {
        "featurecla": "Admin-1 scale rank",
        "scalerank": 2,
        "adm1_code": "USA-3555",
        "diss_me": 3555,
        "adm1_cod_1": "USA-3555",
        "iso_3166_2": "US-DE",
        "wikipedia": "http://en.wikipedia.org/wiki/Delaware",
        "sr_sov_a3": "US1",
        "sr_adm0_a3": "USA",
        "iso_a2": "US",
        "adm0_sr": 1,
        "admin0_lab": 2,
        "name": "Delaware",
        "name_alt": "DE|Del.",
        "name_local": "",
        "type": "State",
        "type_en": "State",
        "code_local": "US10",
        "code_hasc": "US.DE",
        "note": "",
        "hasc_maybe": "",
        "region": "South",
        "region_cod": "",
        "region_big": "South Atlantic",
        "big_code": "",
        "provnum_ne": 0,
        "gadm_level": 1,
        "check_me": 0,
        "scaleran_1": 2,
        "datarank": 1,
        "abbrev": "Del.",
        "postal": "DE",
        "area_sqkm": 0,
        "sameascity": -99,
        "labelrank": 0,
        "featurec_1": "Admin-1 scale rank",
        "admin": "United States of America",
        "name_len": 8,
        "mapcolor9": 1,
        "mapcolor13": 1
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [ -81.7838, 24.5446 ],
            [ -81.8092, 24.5423 ],
            [ -81.8114, 24.5578 ],
            [ -81.7677, 24.5767 ],
            [ -81.7387, 24.5754 ],
            [ -81.7398, 24.5545 ],
            [ -81.7838, 24.5446 ]
          ],
          [
            [ -81.5667, 24.5999 ],
            [ -81.6315, 24.59 ],
            [ -81.5793, 24.6294 ],
            [ -81.5623, 24.6891 ],
            [ -81.5316, 24.6425 ],
            [ -81.5322, 24.6142 ],
            [ -81.5667, 24.5999 ]
          ],
          [
            [ -81.3348, 24.6505 ],
            [ -81.3648, 24.6299 ],
            [ -81.379, 24.6363 ],
            [ -81.379, 24.6663 ],
            [ -81.4217, 24.7326 ],
            [ -81.4201, 24.75 ],
            [ -81.3223, 24.6851 ],
            [ -81.3198, 24.6676 ],
            [ -81.3348, 24.6505 ]
          ],
          [
            [ -81.0442, 24.7168 ],
            [ -81.09, 24.6931 ],
            [ -81.1374, 24.7105 ],
            [ -81.0853, 24.7342 ],
            [ -80.9305, 24.7595 ],
            [ -80.9889, 24.7279 ],
            [ -81.0442, 24.7168 ]
          ],
          [
            [ -80.8294, 24.8037 ],
            [ -80.8484, 24.8037 ],
            [ -80.8389, 24.8179 ],
            [ -80.7994, 24.8463 ],
            [ -80.7852, 24.8353 ],
            [ -80.7868, 24.821 ],
            [ -80.8294, 24.8037 ]
          ],
          [
            [ -80.6383, 24.9032 ],
            [ -80.6651, 24.8984 ],
            [ -80.6257, 24.9411 ],
            [ -80.6146, 24.9379 ],
            [ -80.6383, 24.9032 ]
          ],
          [
            [ -80.3818, 25.1423 ],
            [ -80.5806, 24.9542 ],
            [ -80.5586, 25.0013 ],
            [ -80.481, 25.102 ],
            [ -80.456, 25.1493 ],
            [ -80.4037, 25.1793 ],
            [ -80.3549, 25.2337 ],
            [ -80.3513, 25.297 ],
            [ -80.2805, 25.3412 ],
            [ -80.2571, 25.3476 ],
            [ -80.3818, 25.1423 ]
          ],
          [
            [ -82.0372, 26.4536 ],
            [ -82.0728, 26.4275 ],
            [ -82.145, 26.4467 ],
            [ -82.1844, 26.4809 ],
            [ -82.2014, 26.548 ],
            [ -82.1386, 26.477 ],
            [ -82.1161, 26.4609 ],
            [ -82.0372, 26.4536 ]
          ],
          [
            [ -82.0838, 26.5523 ],
            [ -82.0852, 26.4936 ],
            [ -82.1356, 26.592 ],
            [ -82.1691, 26.7007 ],
            [ -82.1211, 26.6655 ],
            [ -82.0838, 26.5523 ]
          ],
          [
            [ -80.1868, 27.2784 ],
            [ -80.1705, 27.2048 ],
            [ -80.2625, 27.3756 ],
            [ -80.3761, 27.6434 ],
            [ -80.4369, 27.8506 ],
            [ -80.3958, 27.7946 ],
            [ -80.3555, 27.6786 ],
            [ -80.1868, 27.2784 ]
          ],
          [
            [ -84.9079, 29.6426 ],
            [ -85.0083, 29.6066 ],
            [ -85.1167, 29.6328 ],
            [ -85.0493, 29.6378 ],
            [ -85.0005, 29.6272 ],
            [ -84.877, 29.6787 ],
            [ -84.8122, 29.7176 ],
            [ -84.7372, 29.7324 ],
            [ -84.9079, 29.6426 ]
          ],
          [
            [ -82.3993, 30.575 ],
            [ -82.2399, 30.5657 ],
            [ -82.2389, 30.5326 ],
            [ -82.2127, 30.4807 ],
            [ -82.2062, 30.4216 ],
            [ -82.1942, 30.3934 ],
            [ -82.1626, 30.3757 ],
            [ -82.1123, 30.3714 ],
            [ -82.0618, 30.4046 ],
            [ -82.0298, 30.4777 ],
            [ -82.0218, 30.5599 ],
            [ -82.0412, 30.6532 ],
            [ -82.0382, 30.732 ],
            [ -82.0129, 30.7781 ],
            [ -81.9831, 30.7895 ],
            [ -81.9571, 30.8143 ],
            [ -81.9356, 30.8195 ],
            [ -81.8805, 30.8063 ],
            [ -81.6734, 30.7402 ],
            [ -81.5039, 30.7314 ],
            [ -81.4572, 30.6408 ],
            [ -81.3857, 30.27 ],
            [ -81.3371, 30.1412 ],
            [ -81.2495, 29.7938 ],
            [ -81.1045, 29.457 ],
            [ -80.9, 29.0499 ],
            [ -80.5643, 28.5564 ],
            [ -80.5241, 28.4861 ],
            [ -80.5678, 28.4265 ],
            [ -80.5812, 28.3647 ],
            [ -80.585, 28.2716 ],
            [ -80.5729, 28.1809 ],
            [ -80.5332, 28.0701 ],
            [ -80.4569, 27.9007 ],
            [ -80.4995, 27.9345 ],
            [ -80.61, 28.1776 ],
            [ -80.6229, 28.3204 ],
            [ -80.6069, 28.5229 ],
            [ -80.6329, 28.518 ],
            [ -80.6539, 28.4522 ],
            [ -80.6655, 28.3749 ],
            [ -80.6935, 28.345 ],
            [ -80.7318, 28.4629 ],
            [ -80.7291, 28.5162 ],
            [ -80.6885, 28.5785 ],
            [ -80.7003, 28.6009 ],
            [ -80.7659, 28.6328 ],
            [ -80.7799, 28.683 ],
            [ -80.771, 28.7325 ],
            [ -80.8087, 28.7589 ],
            [ -80.8382, 28.7576 ],
            [ -80.8184, 28.6356 ],
            [ -80.7872, 28.5606 ],
            [ -80.7486, 28.381 ],
            [ -80.6864, 28.2722 ],
            [ -80.6501, 28.1809 ],
            [ -80.2261, 27.2071 ],
            [ -80.1258, 27.083 ],
            [ -80.0886, 26.994 ],
            [ -80.05, 26.8077 ],
            [ -80.0413, 26.5686 ],
            [ -80.1106, 26.1316 ],
            [ -80.1264, 25.8335 ],
            [ -80.1363, 25.8426 ],
            [ -80.1429, 25.874 ],
            [ -80.1589, 25.8783 ],
            [ -80.2191, 25.7417 ],
            [ -80.3008, 25.6185 ],
            [ -80.3278, 25.4271 ],
            [ -80.3669, 25.3313 ],
            [ -80.4846, 25.2298 ],
            [ -80.5576, 25.2324 ],
            [ -80.7365, 25.1563 ],
            [ -80.8622, 25.1762 ],
            [ -81.012, 25.1332 ],
            [ -81.1105, 25.1381 ],
            [ -81.1674, 25.2285 ],
            [ -81.1587, 25.269 ],
            [ -81.136, 25.3096 ],
            [ -81.0977, 25.3191 ],
            [ -80.9654, 25.2243 ],
            [ -80.9404, 25.2642 ],
            [ -80.9804, 25.3117 ],
            [ -81.0569, 25.3381 ],
            [ -81.1133, 25.3672 ],
            [ -81.2271, 25.5834 ],
            [ -81.3451, 25.7318 ],
            [ -81.3649, 25.831 ],
            [ -81.5682, 25.8915 ],
            [ -81.7155, 25.9832 ],
            [ -81.8115, 26.1461 ],
            [ -81.8666, 26.435 ],
            [ -81.9315, 26.4675 ],
            [ -81.9589, 26.4899 ],
            [ -81.8955, 26.5972 ],
            [ -81.8286, 26.6871 ],
            [ -81.8816, 26.6647 ],
            [ -81.9206, 26.6314 ],
            [ -81.9702, 26.552 ],
            [ -82.0064, 26.5399 ],
            [ -82.0396, 26.552 ],
            [ -82.0779, 26.7043 ],
            [ -82.0669, 26.8916 ],
            [ -82.0133, 26.9616 ],
            [ -82.0957, 26.9634 ],
            [ -82.1811, 26.9368 ],
            [ -82.1686, 26.8744 ],
            [ -82.1807, 26.8401 ],
            [ -82.2429, 26.8489 ],
            [ -82.2901, 26.8708 ],
            [ -82.354, 26.9357 ],
            [ -82.4414, 27.0597 ],
            [ -82.6205, 27.4011 ],
            [ -82.6554, 27.4492 ],
            [ -82.7146, 27.4996 ],
            [ -82.6867, 27.5153 ],
            [ -82.6358, 27.5246 ],
            [ -82.5208, 27.6783 ],
            [ -82.4305, 27.7711 ],
            [ -82.4005, 27.8354 ],
            [ -82.4058, 27.8629 ],
            [ -82.4457, 27.9028 ],
            [ -82.4981, 27.8679 ],
            [ -82.5206, 27.8779 ],
            [ -82.5796, 27.9584 ],
            [ -82.6359, 27.9812 ],
            [ -82.6752, 27.9638 ],
            [ -82.6338, 27.8978 ],
            [ -82.5966, 27.8732 ],
            [ -82.611, 27.7772 ],
            [ -82.626, 27.746 ],
            [ -82.6609, 27.7184 ],
            [ -82.7153, 27.7331 ],
            [ -82.7429, 27.7094 ],
            [ -82.7753, 27.7344 ],
            [ -82.8076, 27.7765 ],
            [ -82.8435, 27.846 ],
            [ -82.7485, 28.2368 ],
            [ -82.6606, 28.4859 ],
            [ -82.6506, 28.7699 ],
            [ -82.644, 28.812 ],
            [ -82.6515, 28.8875 ],
            [ -82.7693, 29.0516 ],
            [ -83.2905, 29.4519 ],
            [ -83.6944, 29.926 ],
            [ -84.0442, 30.1038 ],
            [ -84.3097, 30.0648 ],
            [ -84.3556, 30.029 ],
            [ -84.3753, 29.9823 ],
            [ -84.3587, 29.9294 ],
            [ -84.3828, 29.9074 ],
            [ -84.4541, 29.9102 ],
            [ -84.55, 29.8979 ],
            [ -84.8006, 29.7731 ],
            [ -84.8889, 29.7776 ],
            [ -84.9692, 29.7453 ],
            [ -85.0293, 29.7211 ],
            [ -85.186, 29.7079 ],
            [ -85.3189, 29.6802 ],
            [ -85.3764, 29.6952 ],
            [ -85.4138, 29.7676 ],
            [ -85.4138, 29.8425 ],
            [ -85.3834, 29.7851 ],
            [ -85.3364, 29.7401 ],
            [ -85.3149, 29.7581 ],
            [ -85.3069, 29.7978 ],
            [ -85.3536, 29.8758 ],
            [ -85.5043, 29.9758 ],
            [ -85.6758, 30.1219 ],
            [ -85.6235, 30.1171 ],
            [ -85.6103, 30.1484 ],
            [ -85.6634, 30.1895 ],
            [ -85.641, 30.2369 ],
            [ -85.6035, 30.2868 ],
            [ -85.6759, 30.2793 ],
            [ -85.7408, 30.2444 ],
            [ -85.7429, 30.2013 ],
            [ -85.7558, 30.167 ],
            [ -85.7907, 30.172 ],
            [ -85.8557, 30.2144 ],
            [ -86.1752, 30.3325 ],
            [ -86.4544, 30.3991 ],
            [ -86.2401, 30.4291 ],
            [ -86.1238, 30.4058 ],
            [ -86.1377, 30.4416 ],
            [ -86.1657, 30.4642 ],
            [ -86.2574, 30.493 ],
            [ -86.3742, 30.4821 ],
            [ -86.448, 30.4956 ],
            [ -86.5234, 30.4671 ],
            [ -86.6061, 30.4247 ],
            [ -86.6796, 30.4029 ],
            [ -86.9676, 30.3724 ],
            [ -87.2012, 30.3392 ],
            [ -87.1637, 30.3742 ],
            [ -87.1238, 30.3967 ],
            [ -86.9858, 30.4309 ],
            [ -86.9652, 30.5019 ],
            [ -86.9976, 30.5703 ],
            [ -87.0339, 30.5539 ],
            [ -87.072, 30.5004 ],
            [ -87.1188, 30.539 ],
            [ -87.1706, 30.5388 ],
            [ -87.1847, 30.4537 ],
            [ -87.2511, 30.3967 ],
            [ -87.281, 30.3392 ],
            [ -87.4758, 30.2943 ],
            [ -87.5007, 30.3093 ],
            [ -87.4437, 30.3638 ],
            [ -87.4483, 30.3942 ],
            [ -87.4895, 30.3777 ],
            [ -87.4801, 30.4117 ],
            [ -87.4448, 30.4426 ],
            [ -87.4294, 30.4779 ],
            [ -87.4338, 30.5459 ],
            [ -87.4083, 30.6415 ],
            [ -87.4217, 30.6716 ],
            [ -87.5662, 30.7956 ],
            [ -87.6011, 30.8606 ],
            [ -87.6074, 30.9293 ],
            [ -87.5937, 31.0007 ],
            [ -87.2703, 31.0008 ],
            [ -86.9469, 31.0008 ],
            [ -86.6236, 31.0009 ],
            [ -86.3002, 31.0009 ],
            [ -85.9768, 31.001 ],
            [ -85.6534, 31.0011 ],
            [ -85.33, 31.0011 ],
            [ -85.0073, 31.0017 ],
            [ -84.9663, 30.9226 ],
            [ -84.8869, 30.7593 ],
            [ -84.8839, 30.7209 ],
            [ -84.7904, 30.7151 ],
            [ -84.631, 30.7058 ],
            [ -84.4716, 30.6965 ],
            [ -84.3122, 30.6871 ],
            [ -84.1528, 30.6778 ],
            [ -83.9933, 30.6684 ],
            [ -83.8339, 30.6591 ],
            [ -83.6746, 30.6498 ],
            [ -83.5151, 30.6404 ],
            [ -83.3557, 30.631 ],
            [ -83.1963, 30.6217 ],
            [ -83.0369, 30.6124 ],
            [ -82.8775, 30.603 ],
            [ -82.7181, 30.5937 ],
            [ -82.5587, 30.5844 ],
            [ -82.3993, 30.575 ]
          ]
        ]
      },
      "properties": {
        "featurecla": "Admin-1 scale rank",
        "scalerank": 2,
        "adm1_code": "USA-3542",
        "diss_me": 3542,
        "adm1_cod_1": "USA-3542",
        "iso_3166_2": "US-FL",
        "wikipedia": "http://en.wikipedia.org/wiki/Florida",
        "sr_sov_a3": "US1",
        "sr_adm0_a3": "USA",
        "iso_a2": "US",
        "adm0_sr": 5,
        "admin0_lab": 2,
        "name": "Florida",
        "name_alt": "FL|Fla.",
        "name_local": "",
        "type": "State",
        "type_en": "State",
        "code_local": "US12",
        "code_hasc": "US.FL",
        "note": "",
        "hasc_maybe": "",
        "region": "South",
        "region_cod": "",
        "region_big": "South Atlantic",
        "big_code": "",
        "provnum_ne": 0,
        "gadm_level": 1,
        "check_me": 0,
        "scaleran_1": 2,
        "datarank": 8,
        "abbrev": "Fla.",
        "postal": "FL",
        "area_sqkm": 0,
        "sameascity": -99,
        "labelrank": 0,
        "featurec_1": "Admin-1 scale rank",
        "admin": "United States of America",
        "name_len": 7,
        "mapcolor9": 1,
        "mapcolor13": 1
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [ -81.419, 30.9714 ],
            [ -81.4635, 30.7278 ],
            [ -81.4827, 30.8141 ],
            [ -81.4846, 30.8978 ],
            [ -81.4509, 30.9474 ],
            [ -81.419, 30.9714 ]
          ],
          [
            [ -83.1214, 35.0006 ],
            [ -83.1704, 34.9329 ],
            [ -83.3167, 34.8057 ],
            [ -83.3556, 34.7083 ],
            [ -83.1665, 34.5996 ],
            [ -83.1659, 34.5985 ],
            [ -83.0528, 34.5109 ],
            [ -82.9757, 34.4764 ],
            [ -82.8968, 34.4658 ],
            [ -82.8477, 34.4369 ],
            [ -82.8186, 34.3661 ],
            [ -82.8186, 34.366 ],
            [ -82.5893, 34.0174 ],
            [ -82.5893, 34.0176 ],
            [ -82.3519, 33.8377 ],
            [ -82.2566, 33.7492 ],
            [ -82.2084, 33.6636 ],
            [ -82.0057, 33.5229 ],
            [ -81.9364, 33.4473 ],
            [ -81.9328, 33.3899 ],
            [ -81.9087, 33.3493 ],
            [ -81.8641, 33.3254 ],
            [ -81.8213, 33.2741 ],
            [ -81.7803, 33.1953 ],
            [ -81.6993, 33.1268 ],
            [ -81.5782, 33.0686 ],
            [ -81.4898, 32.9357 ],
            [ -81.4338, 32.728 ],
            [ -81.377, 32.6075 ],
            [ -81.2903, 32.5572 ],
            [ -81.1715, 32.3801 ],
            [ -81.133, 32.2747 ],
            [ -81.135, 32.1819 ],
            [ -81.0748, 32.1097 ],
            [ -80.8723, 32.0296 ],
            [ -80.9234, 31.9449 ],
            [ -81.0455, 31.892 ],
            [ -81.0829, 31.8941 ],
            [ -81.1133, 31.8786 ],
            [ -81.0955, 31.8409 ],
            [ -81.065, 31.8135 ],
            [ -81.0661, 31.788 ],
            [ -81.0984, 31.7534 ],
            [ -81.1621, 31.7437 ],
            [ -81.1979, 31.7042 ],
            [ -81.1866, 31.667 ],
            [ -81.1655, 31.6462 ],
            [ -81.1699, 31.6103 ],
            [ -81.2424, 31.5743 ],
            [ -81.2594, 31.5389 ],
            [ -81.2234, 31.5285 ],
            [ -81.1957, 31.5389 ],
            [ -81.1754, 31.5313 ],
            [ -81.2189, 31.4721 ],
            [ -81.2579, 31.436 ],
            [ -81.295, 31.3712 ],
            [ -81.3809, 31.3533 ],
            [ -81.3777, 31.3323 ],
            [ -81.3291, 31.3138 ],
            [ -81.2885, 31.2639 ],
            [ -81.3649, 31.1719 ],
            [ -81.4126, 31.1794 ],
            [ -81.4418, 31.1997 ],
            [ -81.4603, 31.1271 ],
            [ -81.4532, 31.0883 ],
            [ -81.4714, 31.009 ],
            [ -81.5006, 30.9138 ],
            [ -81.5204, 30.8746 ],
            [ -81.5162, 30.8018 ],
            [ -81.5039, 30.7314 ],
            [ -81.6734, 30.7402 ],
            [ -81.8805, 30.8063 ],
            [ -81.9356, 30.8195 ],
            [ -81.9571, 30.8143 ],
            [ -81.9831, 30.7895 ],
            [ -82.0129, 30.7781 ],
            [ -82.0382, 30.732 ],
            [ -82.0412, 30.6532 ],
            [ -82.0218, 30.5599 ],
            [ -82.0298, 30.4777 ],
            [ -82.0618, 30.4046 ],
            [ -82.1123, 30.3714 ],
            [ -82.1626, 30.3757 ],
            [ -82.1942, 30.3934 ],
            [ -82.2062, 30.4216 ],
            [ -82.2127, 30.4807 ],
            [ -82.2389, 30.5326 ],
            [ -82.2399, 30.5657 ],
            [ -82.3993, 30.575 ],
            [ -82.5587, 30.5844 ],
            [ -82.7181, 30.5937 ],
            [ -82.8775, 30.603 ],
            [ -83.0369, 30.6124 ],
            [ -83.1963, 30.6217 ],
            [ -83.3557, 30.631 ],
            [ -83.5151, 30.6404 ],
            [ -83.6746, 30.6498 ],
            [ -83.8339, 30.6591 ],
            [ -83.9933, 30.6684 ],
            [ -84.1528, 30.6778 ],
            [ -84.3122, 30.6871 ],
            [ -84.4716, 30.6965 ],
            [ -84.631, 30.7058 ],
            [ -84.7904, 30.7151 ],
            [ -84.8839, 30.7209 ],
            [ -84.8869, 30.7593 ],
            [ -84.9663, 30.9226 ],
            [ -85.0073, 31.0017 ],
            [ -85.0674, 31.1176 ],
            [ -85.0926, 31.2957 ],
            [ -85.0549, 31.5727 ],
            [ -85.067, 31.6352 ],
            [ -85.0672, 31.6354 ],
            [ -85.1248, 31.7768 ],
            [ -85.1241, 31.8805 ],
            [ -85.0644, 32.0505 ],
            [ -85.0646, 32.051 ],
            [ -85.0346, 32.1474 ],
            [ -84.993, 32.2018 ],
            [ -84.9297, 32.2466 ],
            [ -84.9215, 32.2859 ],
            [ -84.9685, 32.3198 ],
            [ -84.986, 32.3609 ],
            [ -84.9739, 32.4093 ],
            [ -85.015, 32.5262 ],
            [ -85.1565, 32.8043 ],
            [ -85.1763, 32.8982 ],
            [ -85.201, 32.9562 ],
            [ -85.2274, 33.084 ],
            [ -85.2538, 33.2118 ],
            [ -85.2802, 33.3396 ],
            [ -85.3066, 33.4674 ],
            [ -85.3331, 33.5952 ],
            [ -85.3595, 33.723 ],
            [ -85.3859, 33.8507 ],
            [ -85.4123, 33.9786 ],
            [ -85.4387, 34.1063 ],
            [ -85.4651, 34.2341 ],
            [ -85.4915, 34.3619 ],
            [ -85.5179, 34.4897 ],
            [ -85.5444, 34.6175 ],
            [ -85.5708, 34.7453 ],
            [ -85.5972, 34.8731 ],
            [ -85.6236, 35.0009 ],
            [ -85.2989, 34.9977 ],
            [ -84.9742, 34.9945 ],
            [ -84.6494, 34.9913 ],
            [ -84.3247, 34.9881 ],
            [ -84.0222, 34.9915 ],
            [ -83.7198, 34.9948 ],
            [ -83.4173, 34.9981 ],
            [ -83.1148, 35.0015 ],
            [ -83.1214, 35.0006 ]
          ]
        ]
      },
      "properties": {
        "featurecla": "Admin-1 scale rank",
        "scalerank": 2,
        "adm1_code": "USA-3543",
        "diss_me": 3543,
        "adm1_cod_1": "USA-3543",
        "iso_3166_2": "US-GA",
        "wikipedia": "http://en.wikipedia.org/wiki/Georgia_(U.S._state)",
        "sr_sov_a3": "US1",
        "sr_adm0_a3": "USA",
        "iso_a2": "US",
        "adm0_sr": 6,
        "admin0_lab": 2,
        "name": "Georgia",
        "name_alt": "GA|Ga.",
        "name_local": "",
        "type": "State",
        "type_en": "State",
        "code_local": "US13",
        "code_hasc": "US.GA",
        "note": "",
        "hasc_maybe": "",
        "region": "South",
        "region_cod": "",
        "region_big": "South Atlantic",
        "big_code": "",
        "provnum_ne": 0,
        "gadm_level": 1,
        "check_me": 0,
        "scaleran_1": 2,
        "datarank": 1,
        "abbrev": "Ga.",
        "postal": "GA",
        "area_sqkm": 0,
        "sameascity": -99,
        "labelrank": 0,
        "featurec_1": "Admin-1 scale rank",
        "admin": "United States of America",
        "name_len": 7,
        "mapcolor9": 1,
        "mapcolor13": 1
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -128.97241328124997,
              30.1942726454507
            ],
            [
              -128.92631328124997,
              30.28302679615266
            ],
            [
              -128.70071328125,
              30.421083604255745
            ],
            [
              -128.44461328125,
              30.474972149816825
            ],
            [
              -128.24141328124998,
              30.598146172029843
            ],
            [
              -128.19531328124998,
              30.66231399962143
            ],
            [
              -128.23241328124996,
              30.702285961949325
            ],
            [
              -128.34371328124996,
              30.771995114888142
            ],
            [
              -128.38011328125,
              30.851719695378478
            ],
            [
              -128.45701328124997,
              30.86649453334469
            ],
            [
              -128.47721328125,
              30.982659694276933
            ],
            [
              -128.58991328124998,
              31.090939999869168
            ],
            [
              -129.01321328125,
              31.244903318853268
            ],
            [
              -129.22271328125,
              31.347255982590177
            ],
            [
              -129.26541328125,
              31.332688478671752
            ],
            [
              -129.28391328125,
              31.248546400877714
            ],
            [
              -129.21141328125,
              31.108982663992233
            ],
            [
              -129.30001328125,
              31.000071210770937
            ],
            [
              -129.37951328125,
              30.94254528863526
            ],
            [
              -129.43981328124997,
              30.86813613401712
            ],
            [
              -129.35691328125,
              30.722908536533847
            ],
            [
              -129.28181328125,
              30.532776637161252
            ],
            [
              -129.29671328125,
              30.298288574603763
            ],
            [
              -129.27241328125,
              30.24774788119364
            ],
            [
              -129.07191328125,
              30.153770915619535
            ],
            [
              -129.01671328125002,
              30.15029645324948
            ],
            [
              -128.97241328124997,
              30.1942726454507
            ]
          ],
          [
            [
              -130.24071328125,
              31.79920297945187
            ],
            [
              -130.30001328125,
              31.773659249318133
            ],
            [
              -130.36451328124997,
              31.785476920340322
            ],
            [
              -130.37951328125,
              31.84746614662648
            ],
            [
              -130.44171328125003,
              31.926341875809275
            ],
            [
              -130.33291328125,
              31.942241576768254
            ],
            [
              -130.27161328124998,
              31.919345724300292
            ],
            [
              -130.23941328125002,
              31.89481239729901
            ],
            [
              -130.20051328125,
              31.85237380381326
            ],
            [
              -130.24071328125,
              31.79920297945187
            ]
          ],
          [
            [
              -129.87791328124996,
              31.94460374182019
            ],
            [
              -129.85191328125003,
              31.9283407444632
            ],
            [
              -129.74551328125003,
              31.95268946521543
            ],
            [
              -129.66861328125,
              31.961592578763888
            ],
            [
              -129.53941328124998,
              31.901809155586733
            ],
            [
              -129.49461328125,
              31.860734801364064
            ],
            [
              -129.40971328125,
              31.81692769877498
            ],
            [
              -129.38101328124998,
              31.78511330706207
            ],
            [
              -129.40471328125003,
              31.74665856183435
            ],
            [
              -129.49821328124997,
              31.683010367574195
            ],
            [
              -129.62581328125,
              31.668278312879508
            ],
            [
              -129.70111328124997,
              31.64117659982718
            ],
            [
              -129.79991328124999,
              31.646997321316682
            ],
            [
              -129.82931328125,
              31.658547460207252
            ],
            [
              -129.84001328125004,
              31.73883969919169
            ],
            [
              -129.87121328125,
              31.82519885413137
            ],
            [
              -129.93491328124998,
              31.81501893624777
            ],
            [
              -130.00651328125,
              31.843921674570446
            ],
            [
              -130.08081328124996,
              31.916256459476926
            ],
            [
              -130.08891328125,
              31.959593945003267
            ],
            [
              -130.04801328125,
              32.02808452890614
            ],
            [
              -129.97651328124996,
              32.036985271341166
            ],
            [
              -129.92341328125,
              31.99920060054326
            ],
            [
              -129.87791328124996,
              31.94460374182019
            ]
          ],
          [
            [
              -130.60471328125004,
              32.201417037223415
            ],
            [
              -130.39341328125,
              32.1765450269634
            ],
            [
              -130.34351328124998,
              32.18716582387706
            ],
            [
              -130.30831328125,
              32.16683164204743
            ],
            [
              -130.13331328124997,
              32.15430360731137
            ],
            [
              -130.10331328125,
              32.146677575869475
            ],
            [
              -130.13901328125,
              32.09991825299251
            ],
            [
              -130.25101328125004,
              32.056965510854305
            ],
            [
              -130.41201328125,
              32.0946516709297
            ],
            [
              -130.68141328125,
              32.10809034165795
            ],
            [
              -130.67061328125,
              32.144226307892126
            ],
            [
              -130.64491328125004,
              32.16982739439294
            ],
            [
              -130.64101328125003,
              32.214487583926115
            ],
            [
              -130.60471328125004,
              32.201417037223415
            ]
          ],
          [
            [
              -131.19051328125,
              32.420359988604396
            ],
            [
              -131.15611328124996,
              32.41509935385061
            ],
            [
              -131.11201328125,
              32.421266984746076
            ],
            [
              -131.09661328125003,
              32.34906102580204
            ],
            [
              -131.04531328125003,
              32.30895882872729
            ],
            [
              -131.02651328124998,
              32.28509442418749
            ],
            [
              -131.08201328125,
              32.259775997942135
            ],
            [
              -131.18991328124997,
              32.24970244717074
            ],
            [
              -131.24041328125,
              32.26984919092459
            ],
            [
              -131.29291328125,
              32.31503803301454
            ],
            [
              -131.34951328124998,
              32.302607282120704
            ],
            [
              -131.35941328124997,
              32.338899919177955
            ],
            [
              -131.36951328125,
              32.34942391573857
            ],
            [
              -131.40841328124998,
              32.33962572457391
            ],
            [
              -131.37211328125,
              32.292807474117254
            ],
            [
              -131.47031328124996,
              32.28926857136279
            ],
            [
              -131.50141328125,
              32.29507597830383
            ],
            [
              -131.52891328125003,
              32.348153798930575
            ],
            [
              -131.63021328125,
              32.449926570801914
            ],
            [
              -131.62981328125,
              32.48964615219968
            ],
            [
              -131.66421328124997,
              32.53688527364297
            ],
            [
              -131.51421328125,
              32.55057499093956
            ],
            [
              -131.41151328125,
              32.63351514075632
            ],
            [
              -131.35361328125003,
              32.64221565607977
            ],
            [
              -131.24261328124996,
              32.50805311609714
            ],
            [
              -131.24541328125,
              32.470421842859004
            ],
            [
              -131.22071328125,
              32.43378323566902
            ],
            [
              -131.19051328125,
              32.420359988604396
            ]
          ],
          [
            [
              -133.57111328125004,
              32.76879618276645
            ],
            [
              -133.59131328124997,
              32.72875317097907
            ],
            [
              -133.62581328125,
              32.73491400098118
            ],
            [
              -133.63451328125,
              32.77060795056366
            ],
            [
              -133.61201328125003,
              32.81970246915989
            ],
            [
              -133.55501328125,
              32.86199667987096
            ],
            [
              -133.49171328125,
              32.9264674223261
            ],
            [
              -133.43981328124997,
              32.916960715513056
            ],
            [
              -133.46781328125,
              32.8747652183076
            ],
            [
              -133.47111328125004,
              32.828850143297096
            ],
            [
              -133.54451328124998,
              32.80294606643727
            ],
            [
              -133.57111328125004,
              32.76879618276645
            ]
          ],
          [
            [
              -132.76391328125,
              32.851491637644635
            ],
            [
              -132.85181328124997,
              32.80050045494637
            ],
            [
              -132.90301328125,
              32.82251020237078
            ],
            [
              -133.00001328124998,
              32.83075209805814
            ],
            [
              -133.03751328125,
              32.868969640571535
            ],
            [
              -133.13911328125,
              32.90346970160392
            ],
            [
              -133.18031328125,
              32.95054966077013
            ],
            [
              -133.11771328125,
              33.039618162983324
            ],
            [
              -132.97031328125001,
              33.114634990542925
            ],
            [
              -132.74321328125,
              33.111468213077096
            ],
            [
              -132.69591328125,
              33.05219775262487
            ],
            [
              -132.69181328125003,
              33.00803099302457
            ],
            [
              -132.72131328125,
              32.95860679767833
            ],
            [
              -132.73481328125,
              32.88880089471848
            ],
            [
              -132.76391328125,
              32.851491637644635
            ]
          ],
          [
            [
              -150.76261328125003,
              38.4730798328363
            ],
            [
              -150.78161328125,
              38.4694375836348
            ],
            [
              -150.77991328124997,
              38.48045303116171
            ],
            [
              -150.76171328124997,
              38.491468074090946
            ],
            [
              -150.74521328125,
              38.48773721776085
            ],
            [
              -150.75261328125004,
              38.47894287277338
            ],
            [
              -150.76261328125003,
              38.4730798328363
            ]
          ]
        ]
      },
      "properties": {
        "featurecla": "Admin-1 scale rank",
        "scalerank": 2,
        "adm1_code": "USA-3517",
        "diss_me": 3517,
        "adm1_cod_1": "USA-3517",
        "iso_3166_2": "US-HI",
        "wikipedia": "http://en.wikipedia.org/wiki/Hawaii",
        "sr_sov_a3": "US1",
        "sr_adm0_a3": "USA",
        "iso_a2": "US",
        "adm0_sr": 8,
        "admin0_lab": 2,
        "name": "Hawaii",
        "name_alt": "HI|Hawaii",
        "name_local": "",
        "type": "State",
        "type_en": "State",
        "code_local": "US15",
        "code_hasc": "US.HI",
        "note": "",
        "hasc_maybe": "",
        "region": "West",
        "region_cod": "",
        "region_big": "Pacific",
        "big_code": "",
        "provnum_ne": 0,
        "gadm_level": 1,
        "check_me": 0,
        "scaleran_1": 2,
        "datarank": 1,
        "abbrev": "Hawaii",
        "postal": "HI",
        "area_sqkm": 0,
        "sameascity": -99,
        "labelrank": 0,
        "featurec_1": "Admin-1 scale rank",
        "admin": "United States of America",
        "name_len": 6,
        "mapcolor9": 1,
        "mapcolor13": 1
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [ -90.6506, 42.513 ],
            [ -90.5896, 42.4448 ],
            [ -90.4847, 42.3833 ],
            [ -90.425, 42.3257 ],
            [ -90.4105, 42.2721 ],
            [ -90.3466, 42.2148 ],
            [ -90.2332, 42.154 ],
            [ -90.1675, 42.1003 ],
            [ -90.1494, 42.0537 ],
            [ -90.1524, 41.9815 ],
            [ -90.1766, 41.8836 ],
            [ -90.2178, 41.8131 ],
            [ -90.276, 41.77 ],
            [ -90.3192, 41.7097 ],
            [ -90.3475, 41.632 ],
            [ -90.4367, 41.5604 ],
            [ -90.5867, 41.4947 ],
            [ -90.7541, 41.4498 ],
            [ -90.9388, 41.4256 ],
            [ -91.0481, 41.3691 ],
            [ -91.0821, 41.2803 ],
            [ -91.0665, 41.2059 ],
            [ -91.0013, 41.146 ],
            [ -90.9638, 41.0825 ],
            [ -90.954, 41.0156 ],
            [ -91.0001, 40.9047 ],
            [ -91.1021, 40.7498 ],
            [ -91.2151, 40.6496 ],
            [ -91.339, 40.604 ],
            [ -91.3942, 40.5367 ],
            [ -91.3805, 40.4476 ],
            [ -91.3908, 40.3971 ],
            [ -91.442, 40.3794 ],
            [ -91.5299, 40.4323 ],
            [ -91.5455, 40.4693 ],
            [ -91.6169, 40.5069 ],
            [ -91.6274, 40.5308 ],
            [ -91.682, 40.5519 ],
            [ -91.7315, 40.6247 ],
            [ -91.9838, 40.6232 ],
            [ -92.236, 40.6218 ],
            [ -92.4883, 40.6203 ],
            [ -92.7406, 40.6189 ],
            [ -92.9928, 40.6174 ],
            [ -93.2451, 40.616 ],
            [ -93.4973, 40.6145 ],
            [ -93.7496, 40.6131 ],
            [ -94.0019, 40.6116 ],
            [ -94.2541, 40.6102 ],
            [ -94.5064, 40.6087 ],
            [ -94.7586, 40.6073 ],
            [ -95.0109, 40.6058 ],
            [ -95.2631, 40.6044 ],
            [ -95.5154, 40.6029 ],
            [ -95.765, 40.6019 ],
            [ -95.8261, 40.6762 ],
            [ -95.859, 40.7451 ],
            [ -95.8381, 40.7777 ],
            [ -95.834, 40.8895 ],
            [ -95.8466, 41.0803 ],
            [ -95.8709, 41.1878 ],
            [ -95.9069, 41.2119 ],
            [ -95.9112, 41.2452 ],
            [ -95.8836, 41.2876 ],
            [ -95.8919, 41.3162 ],
            [ -95.936, 41.331 ],
            [ -95.9497, 41.3674 ],
            [ -95.933, 41.4255 ],
            [ -95.9436, 41.4609 ],
            [ -95.9816, 41.4738 ],
            [ -95.9974, 41.4936 ],
            [ -95.991, 41.5205 ],
            [ -96.0114, 41.5379 ],
            [ -96.0586, 41.5458 ],
            [ -96.0778, 41.6113 ],
            [ -96.0688, 41.7343 ],
            [ -96.0866, 41.8214 ],
            [ -96.1312, 41.8724 ],
            [ -96.1538, 41.9204 ],
            [ -96.1542, 41.9653 ],
            [ -96.2014, 42.0361 ],
            [ -96.2953, 42.1329 ],
            [ -96.3561, 42.2601 ],
            [ -96.3838, 42.4178 ],
            [ -96.451, 42.506 ],
            [ -96.481, 42.5113 ],
            [ -96.5063, 42.5936 ],
            [ -96.5336, 42.6302 ],
            [ -96.5387, 42.6586 ],
            [ -96.6218, 42.7295 ],
            [ -96.6268, 42.757 ],
            [ -96.6161, 42.7914 ],
            [ -96.5626, 42.8586 ],
            [ -96.5133, 42.9691 ],
            [ -96.5021, 43.0433 ],
            [ -96.4627, 43.0992 ],
            [ -96.4613, 43.1298 ],
            [ -96.4681, 43.1702 ],
            [ -96.4903, 43.2055 ],
            [ -96.5554, 43.2317 ],
            [ -96.5635, 43.2427 ],
            [ -96.5699, 43.2833 ],
            [ -96.5425, 43.309 ],
            [ -96.535, 43.3381 ],
            [ -96.5416, 43.3735 ],
            [ -96.5813, 43.4349 ],
            [ -96.5986, 43.4975 ],
            [ -96.4536, 43.5012 ],
            [ -96.1284, 43.5012 ],
            [ -95.8032, 43.5013 ],
            [ -95.478, 43.5013 ],
            [ -95.1528, 43.5014 ],
            [ -94.8276, 43.5014 ],
            [ -94.5023, 43.5015 ],
            [ -94.1771, 43.5015 ],
            [ -93.8519, 43.5016 ],
            [ -93.5267, 43.5016 ],
            [ -93.2015, 43.5017 ],
            [ -92.8763, 43.5017 ],
            [ -92.5511, 43.5018 ],
            [ -92.2258, 43.5018 ],
            [ -91.9006, 43.5019 ],
            [ -91.5754, 43.5019 ],
            [ -91.2453, 43.5024 ],
            [ -91.2383, 43.4402 ],
            [ -91.2187, 43.3953 ],
            [ -91.1784, 43.3589 ],
            [ -91.1172, 43.3312 ],
            [ -91.107, 43.278 ],
            [ -91.1476, 43.1996 ],
            [ -91.1613, 43.1023 ],
            [ -91.1482, 42.9862 ],
            [ -91.1176, 42.8817 ],
            [ -91.0696, 42.7886 ],
            [ -90.9599, 42.7203 ],
            [ -90.7887, 42.6769 ],
            [ -90.6879, 42.6103 ],
            [ -90.6573, 42.5205 ],
            [ -90.6506, 42.513 ]
          ]
        ]
      },
      "properties": {
        "featurecla": "Admin-1 scale rank",
        "scalerank": 2,
        "adm1_code": "USA-3529",
        "diss_me": 3529,
        "adm1_cod_1": "USA-3529",
        "iso_3166_2": "US-IA",
        "wikipedia": "http://en.wikipedia.org/wiki/Iowa",
        "sr_sov_a3": "US1",
        "sr_adm0_a3": "USA",
        "iso_a2": "US",
        "adm0_sr": 1,
        "admin0_lab": 2,
        "name": "Iowa",
        "name_alt": "IA|Iowa",
        "name_local": "",
        "type": "State",
        "type_en": "State",
        "code_local": "US19",
        "code_hasc": "US.IA",
        "note": "",
        "hasc_maybe": "",
        "region": "Midwest",
        "region_cod": "",
        "region_big": "West North Central",
        "big_code": "",
        "provnum_ne": 0,
        "gadm_level": 1,
        "check_me": 0,
        "scaleran_1": 2,
        "datarank": 1,
        "abbrev": "Iowa",
        "postal": "IA",
        "area_sqkm": 0,
        "sameascity": -99,
        "labelrank": 0,
        "featurec_1": "Admin-1 scale rank",
        "admin": "United States of America",
        "name_len": 4,
        "mapcolor9": 1,
        "mapcolor13": 1
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [ -111.0514, 44.4989 ],
            [ -111.0514, 44.3428 ],
            [ -111.0513, 44.1867 ],
            [ -111.0512, 44.0305 ],
            [ -111.0511, 43.8744 ],
            [ -111.0511, 43.7183 ],
            [ -111.051, 43.5621 ],
            [ -111.0509, 43.406 ],
            [ -111.0509, 43.2499 ],
            [ -111.0508, 43.0938 ],
            [ -111.0507, 42.9376 ],
            [ -111.0507, 42.7815 ],
            [ -111.0506, 42.6254 ],
            [ -111.0505, 42.4692 ],
            [ -111.0505, 42.3131 ],
            [ -111.0504, 42.157 ],
            [ -111.0503, 42.0009 ],
            [ -111.2373, 42.0009 ],
            [ -111.4243, 42.0009 ],
            [ -111.6113, 42.0009 ],
            [ -111.7984, 42.001 ],
            [ -111.9854, 42.001 ],
            [ -112.1724, 42.001 ],
            [ -112.3594, 42.001 ],
            [ -112.5464, 42.001 ],
            [ -112.7335, 42.001 ],
            [ -112.9205, 42.001 ],
            [ -113.1075, 42.0011 ],
            [ -113.2945, 42.0011 ],
            [ -113.4815, 42.0011 ],
            [ -113.6685, 42.0011 ],
            [ -113.8556, 42.0011 ],
            [ -114.0426, 42.0011 ],
            [ -114.4144, 42.0011 ],
            [ -114.7861, 42.001 ],
            [ -115.1579, 42.0009 ],
            [ -115.5296, 42.0008 ],
            [ -115.9014, 42.0008 ],
            [ -116.2732, 42.0007 ],
            [ -116.6449, 42.0006 ],
            [ -117.0167, 42.0006 ],
            [ -117.0171, 42.2238 ],
            [ -117.0176, 42.447 ],
            [ -117.018, 42.6702 ],
            [ -117.0185, 42.8934 ],
            [ -117.0189, 43.1165 ],
            [ -117.0193, 43.3397 ],
            [ -117.0198, 43.5629 ],
            [ -117.0202, 43.8084 ],
            [ -117.0205, 43.8132 ],
            [ -116.9576, 43.9641 ],
            [ -116.944, 44.0377 ],
            [ -116.9607, 44.0791 ],
            [ -116.9498, 44.119 ],
            [ -116.9113, 44.1574 ],
            [ -116.9124, 44.1995 ],
            [ -116.9532, 44.2453 ],
            [ -117.029, 44.2755 ],
            [ -117.1397, 44.2903 ],
            [ -117.1973, 44.3438 ],
            [ -117.2017, 44.4362 ],
            [ -117.1189, 44.5783 ],
            [ -116.949, 44.7701 ],
            [ -116.8559, 44.9057 ],
            [ -116.8396, 44.9852 ],
            [ -116.7373, 45.1688 ],
            [ -116.5492, 45.4567 ],
            [ -116.477, 45.6411 ],
            [ -116.5209, 45.7219 ],
            [ -116.6168, 45.7992 ],
            [ -116.7647, 45.8729 ],
            [ -116.8692, 45.9585 ],
            [ -116.8965, 46.0021 ],
            [ -116.9302, 46.056 ],
            [ -116.9478, 46.1243 ],
            [ -116.9221, 46.1636 ],
            [ -116.943, 46.2321 ],
            [ -117.0104, 46.3296 ],
            [ -117.039, 46.3966 ],
            [ -117.0325, 46.4198 ],
            [ -117.025, 46.4292 ],
            [ -117.0258, 46.5895 ],
            [ -117.0267, 46.7498 ],
            [ -117.0275, 46.9101 ],
            [ -117.0283, 47.0704 ],
            [ -117.0292, 47.2307 ],
            [ -117.03, 47.391 ],
            [ -117.0308, 47.5513 ],
            [ -117.0316, 47.7116 ],
            [ -117.0325, 47.8719 ],
            [ -117.0333, 48.0322 ],
            [ -117.0341, 48.1925 ],
            [ -117.0349, 48.3528 ],
            [ -117.0357, 48.5131 ],
            [ -117.0365, 48.6734 ],
            [ -117.0374, 48.8337 ],
            [ -117.0391, 48.9931 ],
            [ -116.717, 48.9931 ],
            [ -116.2906, 48.9931 ],
            [ -116.0485, 48.9931 ],
            [ -116.0484, 48.7466 ],
            [ -116.0486, 48.4993 ],
            [ -116.0488, 48.252 ],
            [ -116.049, 48.0047 ],
            [ -115.9414, 47.9041 ],
            [ -115.8621, 47.8424 ],
            [ -115.8112, 47.776 ],
            [ -115.7338, 47.7063 ],
            [ -115.7184, 47.6815 ],
            [ -115.6909, 47.6067 ],
            [ -115.7109, 47.5526 ],
            [ -115.6697, 47.4979 ],
            [ -115.6769, 47.4706 ],
            [ -115.708, 47.4568 ],
            [ -115.7145, 47.4523 ],
            [ -115.7133, 47.4467 ],
            [ -115.7025, 47.4376 ],
            [ -115.5933, 47.3849 ],
            [ -115.486, 47.3116 ],
            [ -115.3495, 47.2612 ],
            [ -115.3067, 47.2312 ],
            [ -115.1266, 47.0846 ],
            [ -115.0335, 46.9909 ],
            [ -114.9357, 46.9228 ],
            [ -114.8869, 46.8449 ],
            [ -114.7861, 46.7768 ],
            [ -114.7607, 46.7423 ],
            [ -114.7537, 46.7346 ],
            [ -114.7403, 46.7336 ],
            [ -114.678, 46.7502 ],
            [ -114.6616, 46.7455 ],
            [ -114.6306, 46.7186 ],
            [ -114.624, 46.6776 ],
            [ -114.6016, 46.6603 ],
            [ -114.563, 46.6504 ],
            [ -114.5187, 46.6477 ],
            [ -114.3809, 46.6676 ],
            [ -114.3509, 46.6676 ],
            [ -114.3369, 46.6592 ],
            [ -114.3301, 46.6376 ],
            [ -114.3321, 46.6014 ],
            [ -114.3458, 46.5506 ],
            [ -114.387, 46.5 ],
            [ -114.3802, 46.453 ],
            [ -114.4128, 46.3436 ],
            [ -114.4442, 46.2707 ],
            [ -114.4466, 46.1993 ],
            [ -114.4854, 46.1582 ],
            [ -114.4636, 46.1098 ],
            [ -114.4783, 46.0356 ],
            [ -114.4648, 46.0164 ],
            [ -114.4159, 45.9822 ],
            [ -114.3968, 45.891 ],
            [ -114.4051, 45.8743 ],
            [ -114.4926, 45.8387 ],
            [ -114.5225, 45.8151 ],
            [ -114.5337, 45.782 ],
            [ -114.4958, 45.6858 ],
            [ -114.5326, 45.633 ],
            [ -114.5373, 45.5874 ],
            [ -114.5292, 45.5757 ],
            [ -114.4484, 45.5513 ],
            [ -114.3506, 45.4971 ],
            [ -114.3192, 45.4857 ],
            [ -114.2976, 45.4876 ],
            [ -114.2561, 45.5056 ],
            [ -114.2102, 45.5424 ],
            [ -114.1166, 45.5791 ],
            [ -114.0064, 45.6585 ],
            [ -114.0007, 45.6806 ],
            [ -113.9919, 45.693 ],
            [ -113.9778, 45.6924 ],
            [ -113.9427, 45.6815 ],
            [ -113.8729, 45.6335 ],
            [ -113.8128, 45.607 ],
            [ -113.8023, 45.6011 ],
            [ -113.7966, 45.5877 ],
            [ -113.7996, 45.5402 ],
            [ -113.7661, 45.5025 ],
            [ -113.7561, 45.4408 ],
            [ -113.7219, 45.3793 ],
            [ -113.6971, 45.305 ],
            [ -113.6066, 45.2091 ],
            [ -113.5574, 45.1404 ],
            [ -113.5036, 45.1093 ],
            [ -113.4711, 45.0729 ],
            [ -113.4471, 45.0291 ],
            [ -113.4381, 44.994 ],
            [ -113.4693, 44.93 ],
            [ -113.4608, 44.9036 ],
            [ -113.4321, 44.8742 ],
            [ -113.3389, 44.8081 ],
            [ -113.3204, 44.8025 ],
            [ -113.2343, 44.8099 ],
            [ -113.1872, 44.7986 ],
            [ -113.1407, 44.7655 ],
            [ -113.0933, 44.7153 ],
            [ -113.0627, 44.6651 ],
            [ -113.0543, 44.6052 ],
            [ -113.0064, 44.5391 ],
            [ -112.9997, 44.4804 ],
            [ -112.9701, 44.4545 ],
            [ -112.9104, 44.4193 ],
            [ -112.8539, 44.3983 ],
            [ -112.8314, 44.3966 ],
            [ -112.8155, 44.406 ],
            [ -112.8102, 44.4382 ],
            [ -112.7871, 44.4631 ],
            [ -112.7159, 44.498 ],
            [ -112.6482, 44.4971 ],
            [ -112.3928, 44.468 ],
            [ -112.3754, 44.47 ],
            [ -112.3639, 44.4796 ],
            [ -112.32, 44.5331 ],
            [ -112.2851, 44.5539 ],
            [ -112.2313, 44.5607 ],
            [ -112.0742, 44.5476 ],
            [ -111.8921, 44.5549 ],
            [ -111.7971, 44.5399 ],
            [ -111.6593, 44.5596 ],
            [ -111.4999, 44.5449 ],
            [ -111.4793, 44.5537 ],
            [ -111.4745, 44.5646 ],
            [ -111.4888, 44.5845 ],
            [ -111.491, 44.6242 ],
            [ -111.4591, 44.671 ],
            [ -111.4481, 44.7111 ],
            [ -111.4156, 44.7336 ],
            [ -111.3725, 44.7462 ],
            [ -111.3375, 44.7448 ],
            [ -111.3041, 44.7233 ],
            [ -111.2651, 44.6876 ],
            [ -111.1976, 44.5906 ],
            [ -111.1609, 44.5558 ],
            [ -111.1172, 44.5253 ],
            [ -111.0514, 44.4989 ]
          ]
        ]
      },
      "properties": {
        "featurecla": "Admin-1 scale rank",
        "scalerank": 2,
        "adm1_code": "USA-3518",
        "diss_me": 3518,
        "adm1_cod_1": "USA-3518",
        "iso_3166_2": "US-ID",
        "wikipedia": "http://en.wikipedia.org/wiki/Idaho",
        "sr_sov_a3": "US1",
        "sr_adm0_a3": "USA",
        "iso_a2": "US",
        "adm0_sr": 1,
        "admin0_lab": 2,
        "name": "Idaho",
        "name_alt": "ID|Idaho",
        "name_local": "",
        "type": "State",
        "type_en": "State",
        "code_local": "US16",
        "code_hasc": "US.ID",
        "note": "",
        "hasc_maybe": "",
        "region": "West",
        "region_cod": "",
        "region_big": "Mountain",
        "big_code": "",
        "provnum_ne": 0,
        "gadm_level": 1,
        "check_me": 0,
        "scaleran_1": 2,
        "datarank": 1,
        "abbrev": "Idaho",
        "postal": "ID",
        "area_sqkm": 0,
        "sameascity": -99,
        "labelrank": 0,
        "featurec_1": "Admin-1 scale rank",
        "admin": "United States of America",
        "name_len": 5,
        "mapcolor9": 1,
        "mapcolor13": 1
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [ -87.8121, 42.4971 ],
            [ -87.8125, 42.3411 ],
            [ -87.7975, 42.2114 ],
            [ -87.7668, 42.1539 ],
            [ -87.7325, 42.1115 ],
            [ -87.6946, 42.0844 ],
            [ -87.6511, 42.0002 ],
            [ -87.6021, 41.8591 ],
            [ -87.5566, 41.766 ],
            [ -87.5212, 41.7278 ],
            [ -87.5225, 41.461 ],
            [ -87.524, 41.1612 ],
            [ -87.5255, 40.8615 ],
            [ -87.5269, 40.5617 ],
            [ -87.5284, 40.2619 ],
            [ -87.5298, 39.9622 ],
            [ -87.5313, 39.6624 ],
            [ -87.5327, 39.3791 ],
            [ -87.5329, 39.3749 ],
            [ -87.5791, 39.344 ],
            [ -87.6111, 39.2914 ],
            [ -87.6029, 39.2341 ],
            [ -87.615, 39.1933 ],
            [ -87.6473, 39.1687 ],
            [ -87.6317, 39.1067 ],
            [ -87.5683, 39.0072 ],
            [ -87.5303, 38.9089 ],
            [ -87.5177, 38.8118 ],
            [ -87.5295, 38.7423 ],
            [ -87.5838, 38.6794 ],
            [ -87.636, 38.5426 ],
            [ -87.6807, 38.488 ],
            [ -87.7352, 38.4699 ],
            [ -87.7841, 38.4191 ],
            [ -87.8272, 38.3356 ],
            [ -87.873, 38.295 ],
            [ -87.9214, 38.2975 ],
            [ -87.9573, 38.2822 ],
            [ -87.9804, 38.2492 ],
            [ -87.9775, 38.2144 ],
            [ -87.9486, 38.178 ],
            [ -87.9581, 38.1443 ],
            [ -88.006, 38.1133 ],
            [ -88.0051, 38.0984 ],
            [ -87.9903, 38.0893 ],
            [ -87.996, 38.0744 ],
            [ -88.0261, 38.0596 ],
            [ -88.0445, 38.0133 ],
            [ -88.0425, 37.9367 ],
            [ -88.0591, 37.8984 ],
            [ -88.0911, 37.8966 ],
            [ -88.0953, 37.8756 ],
            [ -88.042, 37.7889 ],
            [ -88.0732, 37.7709 ],
            [ -88.129, 37.6995 ],
            [ -88.1404, 37.6207 ],
            [ -88.1075, 37.5344 ],
            [ -88.1905, 37.4646 ],
            [ -88.3893, 37.4113 ],
            [ -88.4947, 37.3643 ],
            [ -88.5066, 37.3236 ],
            [ -88.4928, 37.2616 ],
            [ -88.4533, 37.1781 ],
            [ -88.4462, 37.1204 ],
            [ -88.4717, 37.0884 ],
            [ -88.6138, 37.1101 ],
            [ -88.8726, 37.1855 ],
            [ -89.0462, 37.183 ],
            [ -89.1346, 37.1025 ],
            [ -89.1651, 37.0416 ],
            [ -89.1543, 36.9921 ],
            [ -89.2249, 37.0527 ],
            [ -89.2724, 37.08 ],
            [ -89.2815, 37.0778 ],
            [ -89.2917, 37.0707 ],
            [ -89.2958, 37.0516 ],
            [ -89.2932, 37.0382 ],
            [ -89.2859, 37.0227 ],
            [ -89.29, 37.0128 ],
            [ -89.3008, 37.0121 ],
            [ -89.3519, 37.0355 ],
            [ -89.4139, 37.1024 ],
            [ -89.4869, 37.2127 ],
            [ -89.5029, 37.3005 ],
            [ -89.462, 37.3657 ],
            [ -89.462, 37.4341 ],
            [ -89.5029, 37.5058 ],
            [ -89.5234, 37.5759 ],
            [ -89.5234, 37.6445 ],
            [ -89.6233, 37.7473 ],
            [ -89.823, 37.8841 ],
            [ -89.9698, 37.9685 ],
            [ -90.0639, 38.0005 ],
            [ -90.1736, 38.069 ],
            [ -90.299, 38.174 ],
            [ -90.3658, 38.2543 ],
            [ -90.374, 38.3098 ],
            [ -90.3166, 38.4578 ],
            [ -90.1508, 38.7805 ],
            [ -90.1322, 38.8186 ],
            [ -90.1268, 38.8326 ],
            [ -90.1342, 38.8467 ],
            [ -90.1499, 38.8599 ],
            [ -90.2201, 38.8977 ],
            [ -90.3543, 38.9302 ],
            [ -90.478, 38.9481 ],
            [ -90.5771, 38.9096 ],
            [ -90.6635, 38.9875 ],
            [ -90.7372, 39.1818 ],
            [ -90.9194, 39.3869 ],
            [ -91.2099, 39.6028 ],
            [ -91.3787, 39.7494 ],
            [ -91.4259, 39.8268 ],
            [ -91.4668, 39.9429 ],
            [ -91.5017, 40.0975 ],
            [ -91.4998, 40.226 ],
            [ -91.442, 40.3794 ],
            [ -91.3908, 40.3971 ],
            [ -91.3805, 40.4476 ],
            [ -91.3942, 40.5367 ],
            [ -91.339, 40.604 ],
            [ -91.2151, 40.6496 ],
            [ -91.1021, 40.7498 ],
            [ -91.0001, 40.9047 ],
            [ -90.954, 41.0156 ],
            [ -90.9638, 41.0825 ],
            [ -91.0013, 41.146 ],
            [ -91.0665, 41.2059 ],
            [ -91.0821, 41.2803 ],
            [ -91.0481, 41.3691 ],
            [ -90.9388, 41.4256 ],
            [ -90.7541, 41.4498 ],
            [ -90.5867, 41.4947 ],
            [ -90.4367, 41.5604 ],
            [ -90.3475, 41.632 ],
            [ -90.3192, 41.7097 ],
            [ -90.276, 41.77 ],
            [ -90.2178, 41.8131 ],
            [ -90.1766, 41.8836 ],
            [ -90.1524, 41.9815 ],
            [ -90.1494, 42.0537 ],
            [ -90.1675, 42.1003 ],
            [ -90.2332, 42.154 ],
            [ -90.3466, 42.2148 ],
            [ -90.4105, 42.2721 ],
            [ -90.425, 42.3257 ],
            [ -90.4847, 42.3833 ],
            [ -90.5896, 42.4448 ],
            [ -90.6506, 42.513 ],
            [ -90.191, 42.5103 ],
            [ -89.7408, 42.5078 ],
            [ -89.2905, 42.5053 ],
            [ -88.8402, 42.5028 ],
            [ -88.39, 42.5003 ],
            [ -87.9397, 42.4978 ],
            [ -87.8121, 42.4971 ]
          ]
        ]
      },
      "properties": {
        "featurecla": "Admin-1 scale rank",
        "scalerank": 2,
        "adm1_code": "USA-3546",
        "diss_me": 3546,
        "adm1_cod_1": "USA-3546",
        "iso_3166_2": "US-IL",
        "wikipedia": "http://en.wikipedia.org/wiki/Illinois",
        "sr_sov_a3": "US1",
        "sr_adm0_a3": "USA",
        "iso_a2": "US",
        "adm0_sr": 1,
        "admin0_lab": 2,
        "name": "Illinois",
        "name_alt": "IL|Ill.",
        "name_local": "",
        "type": "State",
        "type_en": "State",
        "code_local": "US17",
        "code_hasc": "US.IL",
        "note": "",
        "hasc_maybe": "",
        "region": "Midwest",
        "region_cod": "",
        "region_big": "East North Central",
        "big_code": "",
        "provnum_ne": 0,
        "gadm_level": 1,
        "check_me": 0,
        "scaleran_1": 2,
        "datarank": 1,
        "abbrev": "Ill.",
        "postal": "IL",
        "area_sqkm": 0,
        "sameascity": -99,
        "labelrank": 0,
        "featurec_1": "Admin-1 scale rank",
        "admin": "United States of America",
        "name_len": 8,
        "mapcolor9": 1,
        "mapcolor13": 1
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [ -84.7961, 41.7014 ],
            [ -84.7996, 41.3761 ],
            [ -84.803, 41.0507 ],
            [ -84.8064, 40.7253 ],
            [ -84.8098, 40.3999 ],
            [ -84.8133, 40.0746 ],
            [ -84.8167, 39.7492 ],
            [ -84.8201, 39.4238 ],
            [ -84.8217, 39.092 ],
            [ -84.8374, 39.0827 ],
            [ -84.8606, 39.0397 ],
            [ -84.8355, 38.996 ],
            [ -84.8366, 38.9606 ],
            [ -84.8639, 38.9332 ],
            [ -84.8542, 38.9129 ],
            [ -84.8075, 38.8995 ],
            [ -84.7896, 38.8684 ],
            [ -84.8007, 38.8194 ],
            [ -84.9012, 38.7696 ],
            [ -85.0939, 38.7136 ],
            [ -85.1355, 38.6973 ],
            [ -85.1699, 38.6904 ],
            [ -85.1861, 38.6937 ],
            [ -85.186, 38.6937 ],
            [ -85.2111, 38.7041 ],
            [ -85.2466, 38.727 ],
            [ -85.3067, 38.7372 ],
            [ -85.4054, 38.73 ],
            [ -85.4448, 38.6831 ],
            [ -85.4248, 38.5966 ],
            [ -85.4587, 38.5302 ],
            [ -85.5463, 38.484 ],
            [ -85.6089, 38.423 ],
            [ -85.6464, 38.3473 ],
            [ -85.7063, 38.3014 ],
            [ -85.7885, 38.2852 ],
            [ -85.8549, 38.215 ],
            [ -85.9057, 38.0909 ],
            [ -85.9612, 38.014 ],
            [ -86.0213, 37.9844 ],
            [ -86.1034, 37.9919 ],
            [ -86.2075, 38.0366 ],
            [ -86.2676, 38.0826 ],
            [ -86.2838, 38.1299 ],
            [ -86.3146, 38.1638 ],
            [ -86.3427, 38.1787 ],
            [ -86.3614, 38.179 ],
            [ -86.3625, 38.1721 ],
            [ -86.355, 38.1589 ],
            [ -86.3651, 38.1446 ],
            [ -86.4296, 38.1397 ],
            [ -86.4574, 38.1202 ],
            [ -86.4483, 38.086 ],
            [ -86.4625, 38.0618 ],
            [ -86.5, 38.0475 ],
            [ -86.5199, 38.0148 ],
            [ -86.5222, 37.9637 ],
            [ -86.5486, 37.9171 ],
            [ -86.5992, 37.8748 ],
            [ -86.6731, 37.889 ],
            [ -86.7703, 37.9598 ],
            [ -86.8691, 37.9761 ],
            [ -86.9694, 37.938 ],
            [ -87.0443, 37.8864 ],
            [ -87.0936, 37.8213 ],
            [ -87.141, 37.8052 ],
            [ -87.2094, 37.8548 ],
            [ -87.3724, 37.9235 ],
            [ -87.4573, 37.9381 ],
            [ -87.5184, 37.9216 ],
            [ -87.5614, 37.9291 ],
            [ -87.5762, 37.9478 ],
            [ -87.5874, 37.9557 ],
            [ -87.5994, 37.9465 ],
            [ -87.6008, 37.8867 ],
            [ -87.6154, 37.8489 ],
            [ -87.6433, 37.833 ],
            [ -87.6646, 37.8455 ],
            [ -87.6794, 37.8864 ],
            [ -87.7145, 37.8996 ],
            [ -87.7697, 37.8852 ],
            [ -87.8253, 37.8914 ],
            [ -87.8744, 37.9157 ],
            [ -87.8921, 37.913 ],
            [ -87.906, 37.9018 ],
            [ -87.9021, 37.8551 ],
            [ -87.9125, 37.8177 ],
            [ -87.9381, 37.7938 ],
            [ -87.9745, 37.788 ],
            [ -88.0218, 37.8004 ],
            [ -88.042, 37.7889 ],
            [ -88.0953, 37.8756 ],
            [ -88.0911, 37.8966 ],
            [ -88.0591, 37.8984 ],
            [ -88.0425, 37.9367 ],
            [ -88.0445, 38.0133 ],
            [ -88.0261, 38.0596 ],
            [ -87.996, 38.0744 ],
            [ -87.9903, 38.0893 ],
            [ -88.0051, 38.0984 ],
            [ -88.006, 38.1133 ],
            [ -87.9581, 38.1443 ],
            [ -87.9486, 38.178 ],
            [ -87.9775, 38.2144 ],
            [ -87.9804, 38.2492 ],
            [ -87.9573, 38.2822 ],
            [ -87.9214, 38.2975 ],
            [ -87.873, 38.295 ],
            [ -87.8272, 38.3356 ],
            [ -87.7841, 38.4191 ],
            [ -87.7352, 38.4699 ],
            [ -87.6807, 38.488 ],
            [ -87.636, 38.5426 ],
            [ -87.5838, 38.6794 ],
            [ -87.5295, 38.7423 ],
            [ -87.5177, 38.8118 ],
            [ -87.5303, 38.9089 ],
            [ -87.5683, 39.0072 ],
            [ -87.6317, 39.1067 ],
            [ -87.6473, 39.1687 ],
            [ -87.615, 39.1933 ],
            [ -87.6029, 39.2341 ],
            [ -87.6111, 39.2914 ],
            [ -87.5791, 39.344 ],
            [ -87.5329, 39.3749 ],
            [ -87.5327, 39.3791 ],
            [ -87.5313, 39.6624 ],
            [ -87.5298, 39.9622 ],
            [ -87.5284, 40.2619 ],
            [ -87.5269, 40.5617 ],
            [ -87.5255, 40.8615 ],
            [ -87.524, 41.1612 ],
            [ -87.5225, 41.461 ],
            [ -87.5212, 41.7278 ],
            [ -87.5146, 41.7207 ],
            [ -87.477, 41.6955 ],
            [ -87.447, 41.6808 ],
            [ -87.425, 41.6786 ],
            [ -87.4125, 41.6565 ],
            [ -87.3562, 41.6433 ],
            [ -87.2532, 41.6376 ],
            [ -87.1587, 41.6464 ],
            [ -87.0726, 41.6695 ],
            [ -86.8626, 41.7606 ],
            [ -86.615, 41.7605 ],
            [ -86.3119, 41.7604 ],
            [ -86.0088, 41.7602 ],
            [ -85.7057, 41.7601 ],
            [ -85.4026, 41.76 ],
            [ -85.0995, 41.7599 ],
            [ -84.7964, 41.7597 ],
            [ -84.7961, 41.7014 ]
          ]
        ]
      },
      "properties": {
        "featurecla": "Admin-1 scale rank",
        "scalerank": 2,
        "adm1_code": "USA-3547",
        "diss_me": 3547,
        "adm1_cod_1": "USA-3547",
        "iso_3166_2": "US-IN",
        "wikipedia": "http://en.wikipedia.org/wiki/Indiana",
        "sr_sov_a3": "US1",
        "sr_adm0_a3": "USA",
        "iso_a2": "US",
        "adm0_sr": 1,
        "admin0_lab": 2,
        "name": "Indiana",
        "name_alt": "IN|Ind.",
        "name_local": "",
        "type": "State",
        "type_en": "State",
        "code_local": "US18",
        "code_hasc": "US.IN",
        "note": "",
        "hasc_maybe": "",
        "region": "Midwest",
        "region_cod": "",
        "region_big": "East North Central",
        "big_code": "",
        "provnum_ne": 0,
        "gadm_level": 1,
        "check_me": 0,
        "scaleran_1": 2,
        "datarank": 1,
        "abbrev": "Ind.",
        "postal": "IN",
        "area_sqkm": 0,
        "sameascity": -99,
        "labelrank": 0,
        "featurec_1": "Admin-1 scale rank",
        "admin": "United States of America",
        "name_len": 7,
        "mapcolor9": 1,
        "mapcolor13": 1
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [ -94.6181, 37.0008 ],
            [ -94.8492, 37.0008 ],
            [ -95.0802, 37.0008 ],
            [ -95.3113, 37.0008 ],
            [ -95.5424, 37.0008 ],
            [ -95.7735, 37.0008 ],
            [ -96.0046, 37.0008 ],
            [ -96.2356, 37.0008 ],
            [ -96.4667, 37.0008 ],
            [ -96.6978, 37.0008 ],
            [ -96.9289, 37.0008 ],
            [ -97.16, 37.0008 ],
            [ -97.3911, 37.0008 ],
            [ -97.6222, 37.0008 ],
            [ -97.8532, 37.0008 ],
            [ -98.0843, 37.0008 ],
            [ -98.3154, 37.0008 ],
            [ -98.5465, 37.0008 ],
            [ -98.7776, 37.0008 ],
            [ -99.0087, 37.0008 ],
            [ -99.2398, 37.0008 ],
            [ -99.4708, 37.0008 ],
            [ -99.7019, 37.0008 ],
            [ -99.933, 37.0008 ],
            [ -100.1641, 37.0008 ],
            [ -100.3952, 37.0008 ],
            [ -100.6263, 37.0008 ],
            [ -100.8573, 37.0008 ],
            [ -101.0884, 37.0008 ],
            [ -101.3195, 37.0008 ],
            [ -101.5506, 37.0008 ],
            [ -101.7817, 37.0008 ],
            [ -102.0128, 37.0008 ],
            [ -102.0135, 37.1884 ],
            [ -102.0143, 37.3759 ],
            [ -102.015, 37.5634 ],
            [ -102.0157, 37.7509 ],
            [ -102.0164, 37.9384 ],
            [ -102.0172, 38.1259 ],
            [ -102.0179, 38.3135 ],
            [ -102.0186, 38.501 ],
            [ -102.0194, 38.6885 ],
            [ -102.0201, 38.876 ],
            [ -102.0208, 39.0635 ],
            [ -102.0216, 39.251 ],
            [ -102.0223, 39.4386 ],
            [ -102.023, 39.6261 ],
            [ -102.0238, 39.8136 ],
            [ -102.0245, 40.0011 ],
            [ -101.8149, 40.0011 ],
            [ -101.6053, 40.0011 ],
            [ -101.3957, 40.0011 ],
            [ -101.1861, 40.0011 ],
            [ -100.9765, 40.0011 ],
            [ -100.7669, 40.0011 ],
            [ -100.5573, 40.0011 ],
            [ -100.3477, 40.0011 ],
            [ -100.1381, 40.0011 ],
            [ -99.9285, 40.0011 ],
            [ -99.7189, 40.0011 ],
            [ -99.5093, 40.0011 ],
            [ -99.2997, 40.0011 ],
            [ -99.0901, 40.0011 ],
            [ -98.8805, 40.0011 ],
            [ -98.6709, 40.0011 ],
            [ -98.4613, 40.0011 ],
            [ -98.2517, 40.0011 ],
            [ -98.0421, 40.0011 ],
            [ -97.8325, 40.0011 ],
            [ -97.6229, 40.0011 ],
            [ -97.4133, 40.0011 ],
            [ -97.2037, 40.0011 ],
            [ -96.9941, 40.0011 ],
            [ -96.7845, 40.0011 ],
            [ -96.5749, 40.0011 ],
            [ -96.3653, 40.0011 ],
            [ -96.1557, 40.0011 ],
            [ -95.9461, 40.0011 ],
            [ -95.7365, 40.0011 ],
            [ -95.5269, 40.0011 ],
            [ -95.3467, 40.0015 ],
            [ -95.1162, 39.8721 ],
            [ -95.0555, 39.8708 ],
            [ -94.984, 39.8912 ],
            [ -94.9299, 39.8615 ],
            [ -94.8933, 39.7818 ],
            [ -94.8986, 39.7411 ],
            [ -94.9458, 39.7395 ],
            [ -95.0048, 39.6916 ],
            [ -95.0754, 39.5974 ],
            [ -95.0579, 39.509 ],
            [ -94.9525, 39.4264 ],
            [ -94.8823, 39.3431 ],
            [ -94.8472, 39.2592 ],
            [ -94.7779, 39.194 ],
            [ -94.6224, 39.1244 ],
            [ -94.6245, 39.0861 ],
            [ -94.6241, 38.9558 ],
            [ -94.6237, 38.8254 ],
            [ -94.6233, 38.6951 ],
            [ -94.6229, 38.5648 ],
            [ -94.6225, 38.4345 ],
            [ -94.6221, 38.3041 ],
            [ -94.6217, 38.1738 ],
            [ -94.6213, 38.0435 ],
            [ -94.6209, 37.9131 ],
            [ -94.6205, 37.7828 ],
            [ -94.6201, 37.6525 ],
            [ -94.6197, 37.5222 ],
            [ -94.6193, 37.3918 ],
            [ -94.6189, 37.2615 ],
            [ -94.6185, 37.1312 ],
            [ -94.6181, 37.0008 ]
          ]
        ]
      },
      "properties": {
        "featurecla": "Admin-1 scale rank",
        "scalerank": 2,
        "adm1_code": "USA-3530",
        "diss_me": 3530,
        "adm1_cod_1": "USA-3530",
        "iso_3166_2": "US-KS",
        "wikipedia": "http://en.wikipedia.org/wiki/Kansas",
        "sr_sov_a3": "US1",
        "sr_adm0_a3": "USA",
        "iso_a2": "US",
        "adm0_sr": 1,
        "admin0_lab": 2,
        "name": "Kansas",
        "name_alt": "KS|Kans.",
        "name_local": "",
        "type": "State",
        "type_en": "State",
        "code_local": "US20",
        "code_hasc": "US.KS",
        "note": "",
        "hasc_maybe": "",
        "region": "Midwest",
        "region_cod": "",
        "region_big": "West North Central",
        "big_code": "",
        "provnum_ne": 0,
        "gadm_level": 1,
        "check_me": 0,
        "scaleran_1": 2,
        "datarank": 1,
        "abbrev": "Kans.",
        "postal": "KS",
        "area_sqkm": 0,
        "sameascity": -99,
        "labelrank": 0,
        "featurec_1": "Admin-1 scale rank",
        "admin": "United States of America",
        "name_len": 6,
        "mapcolor9": 1,
        "mapcolor13": 1
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [ -89.4872, 36.5031 ],
            [ -89.5573, 36.5011 ],
            [ -89.56, 36.5131 ],
            [ -89.5555, 36.5408 ],
            [ -89.5496, 36.5531 ],
            [ -89.5356, 36.5553 ],
            [ -89.5195, 36.5548 ],
            [ -89.4968, 36.5288 ],
            [ -89.4872, 36.5031 ]
          ],
          [
            [ -84.6605, 39.0945 ],
            [ -84.5945, 39.0858 ],
            [ -84.5089, 39.1028 ],
            [ -84.4301, 39.0909 ],
            [ -84.358, 39.0499 ],
            [ -84.2904, 38.9747 ],
            [ -84.2273, 38.8652 ],
            [ -84.1132, 38.7984 ],
            [ -83.9484, 38.7742 ],
            [ -83.8281, 38.7312 ],
            [ -83.7523, 38.6694 ],
            [ -83.6899, 38.6495 ],
            [ -83.6163, 38.6828 ],
            [ -83.5384, 38.6999 ],
            [ -83.4606, 38.6795 ],
            [ -83.357, 38.6274 ],
            [ -83.2035, 38.6389 ],
            [ -83.0001, 38.714 ],
            [ -82.8804, 38.7103 ],
            [ -82.8446, 38.6277 ],
            [ -82.7582, 38.5412 ],
            [ -82.6213, 38.4507 ],
            [ -82.6128, 38.4482 ],
            [ -82.5895, 38.4203 ],
            [ -82.5784, 38.2721 ],
            [ -82.5854, 38.2427 ],
            [ -82.6195, 38.182 ],
            [ -82.6177, 38.1499 ],
            [ -82.5888, 38.0997 ],
            [ -82.4822, 37.9836 ],
            [ -82.4719, 37.9384 ],
            [ -82.4299, 37.8942 ],
            [ -82.3939, 37.8283 ],
            [ -82.2802, 37.6872 ],
            [ -82.1035, 37.5706 ],
            [ -81.9653, 37.5397 ],
            [ -82.3432, 37.2969 ],
            [ -82.5165, 37.2088 ],
            [ -82.6816, 37.1381 ],
            [ -82.6949, 37.1262 ],
            [ -82.7319, 37.0481 ],
            [ -82.832, 36.9793 ],
            [ -82.8945, 36.9064 ],
            [ -83.0438, 36.8456 ],
            [ -83.1502, 36.7623 ],
            [ -83.4169, 36.681 ],
            [ -83.5662, 36.6526 ],
            [ -83.6675, 36.605 ],
            [ -83.6754, 36.6027 ],
            [ -83.6832, 36.6004 ],
            [ -83.6911, 36.5982 ],
            [ -83.6989, 36.5959 ],
            [ -83.7068, 36.5936 ],
            [ -83.7147, 36.5914 ],
            [ -83.7225, 36.5891 ],
            [ -83.7304, 36.5868 ],
            [ -84.0775, 36.5966 ],
            [ -84.4247, 36.6063 ],
            [ -84.7718, 36.6161 ],
            [ -85.119, 36.6258 ],
            [ -85.4661, 36.6356 ],
            [ -85.8133, 36.6453 ],
            [ -86.1605, 36.6551 ],
            [ -86.5076, 36.6648 ],
            [ -86.8405, 36.6596 ],
            [ -87.1734, 36.6544 ],
            [ -87.5063, 36.6492 ],
            [ -87.8392, 36.644 ],
            [ -87.8687, 36.675 ],
            [ -87.9563, 36.682 ],
            [ -88.0911, 36.6928 ],
            [ -88.0963, 36.693 ],
            [ -88.0567, 36.5903 ],
            [ -88.056, 36.5009 ],
            [ -88.0591, 36.4997 ],
            [ -88.2155, 36.4997 ],
            [ -88.3882, 36.4998 ],
            [ -88.5609, 36.4998 ],
            [ -88.7336, 36.4998 ],
            [ -88.9064, 36.4999 ],
            [ -89.0791, 36.4999 ],
            [ -89.2518, 36.4999 ],
            [ -89.4503, 36.5 ],
            [ -89.3975, 36.5878 ],
            [ -89.3513, 36.6112 ],
            [ -89.3305, 36.6159 ],
            [ -89.2801, 36.6 ],
            [ -89.2561, 36.5944 ],
            [ -89.203, 36.6255 ],
            [ -89.1563, 36.7157 ],
            [ -89.1295, 36.8111 ],
            [ -89.1225, 36.9116 ],
            [ -89.1543, 36.9921 ],
            [ -89.1651, 37.0416 ],
            [ -89.1346, 37.1025 ],
            [ -89.0462, 37.183 ],
            [ -88.8726, 37.1855 ],
            [ -88.6138, 37.1101 ],
            [ -88.4717, 37.0884 ],
            [ -88.4462, 37.1204 ],
            [ -88.4533, 37.1781 ],
            [ -88.4928, 37.2616 ],
            [ -88.5066, 37.3236 ],
            [ -88.4947, 37.3643 ],
            [ -88.3893, 37.4113 ],
            [ -88.1905, 37.4646 ],
            [ -88.1075, 37.5344 ],
            [ -88.1404, 37.6207 ],
            [ -88.129, 37.6995 ],
            [ -88.0732, 37.7709 ],
            [ -88.042, 37.7889 ],
            [ -88.0218, 37.8004 ],
            [ -87.9745, 37.788 ],
            [ -87.9381, 37.7938 ],
            [ -87.9125, 37.8177 ],
            [ -87.9021, 37.8551 ],
            [ -87.906, 37.9018 ],
            [ -87.8921, 37.913 ],
            [ -87.8744, 37.9157 ],
            [ -87.8253, 37.8914 ],
            [ -87.7697, 37.8852 ],
            [ -87.7145, 37.8996 ],
            [ -87.6794, 37.8864 ],
            [ -87.6646, 37.8455 ],
            [ -87.6433, 37.833 ],
            [ -87.6154, 37.8489 ],
            [ -87.6008, 37.8867 ],
            [ -87.5994, 37.9465 ],
            [ -87.5874, 37.9557 ],
            [ -87.5762, 37.9478 ],
            [ -87.5614, 37.9291 ],
            [ -87.5184, 37.9216 ],
            [ -87.4573, 37.9381 ],
            [ -87.3724, 37.9235 ],
            [ -87.2094, 37.8548 ],
            [ -87.141, 37.8052 ],
            [ -87.0936, 37.8213 ],
            [ -87.0443, 37.8864 ],
            [ -86.9694, 37.938 ],
            [ -86.8691, 37.9761 ],
            [ -86.7703, 37.9598 ],
            [ -86.6731, 37.889 ],
            [ -86.5992, 37.8748 ],
            [ -86.5486, 37.9171 ],
            [ -86.5222, 37.9637 ],
            [ -86.5199, 38.0148 ],
            [ -86.5, 38.0475 ],
            [ -86.4625, 38.0618 ],
            [ -86.4483, 38.086 ],
            [ -86.4574, 38.1202 ],
            [ -86.4296, 38.1397 ],
            [ -86.3651, 38.1446 ],
            [ -86.355, 38.1589 ],
            [ -86.3625, 38.1721 ],
            [ -86.3614, 38.179 ],
            [ -86.3427, 38.1787 ],
            [ -86.3146, 38.1638 ],
            [ -86.2838, 38.1299 ],
            [ -86.2676, 38.0826 ],
            [ -86.2075, 38.0366 ],
            [ -86.1034, 37.9919 ],
            [ -86.0213, 37.9844 ],
            [ -85.9612, 38.014 ],
            [ -85.9057, 38.0909 ],
            [ -85.8549, 38.215 ],
            [ -85.7885, 38.2852 ],
            [ -85.7063, 38.3014 ],
            [ -85.6464, 38.3473 ],
            [ -85.6089, 38.423 ],
            [ -85.5463, 38.484 ],
            [ -85.4587, 38.5302 ],
            [ -85.4248, 38.5966 ],
            [ -85.4448, 38.6831 ],
            [ -85.4054, 38.73 ],
            [ -85.3067, 38.7372 ],
            [ -85.2466, 38.727 ],
            [ -85.2111, 38.7041 ],
            [ -85.186, 38.6937 ],
            [ -85.1861, 38.6937 ],
            [ -85.1699, 38.6904 ],
            [ -85.1355, 38.6973 ],
            [ -85.0939, 38.7136 ],
            [ -84.9012, 38.7696 ],
            [ -84.8007, 38.8194 ],
            [ -84.7896, 38.8684 ],
            [ -84.8075, 38.8995 ],
            [ -84.8542, 38.9129 ],
            [ -84.8639, 38.9332 ],
            [ -84.8366, 38.9606 ],
            [ -84.8355, 38.996 ],
            [ -84.8606, 39.0397 ],
            [ -84.8374, 39.0827 ],
            [ -84.8217, 39.092 ],
            [ -84.7659, 39.125 ],
            [ -84.7069, 39.1289 ],
            [ -84.6605, 39.0945 ]
          ]
        ]
      },
      "properties": {
        "featurecla": "Admin-1 scale rank",
        "scalerank": 2,
        "adm1_code": "USA-3548",
        "diss_me": 3548,
        "adm1_cod_1": "USA-3548",
        "iso_3166_2": "US-KY",
        "wikipedia": "http://en.wikipedia.org/wiki/Kentucky",
        "sr_sov_a3": "US1",
        "sr_adm0_a3": "USA",
        "iso_a2": "US",
        "adm0_sr": 1,
        "admin0_lab": 2,
        "name": "Kentucky",
        "name_alt": "Commonwealth of Kentucky|KY",
        "name_local": "",
        "type": "State",
        "type_en": "State",
        "code_local": "US21",
        "code_hasc": "US.KY",
        "note": "",
        "hasc_maybe": "US.IN|USA-KEN",
        "region": "South",
        "region_cod": "",
        "region_big": "East South Central",
        "big_code": "",
        "provnum_ne": 0,
        "gadm_level": 1,
        "check_me": 10,
        "scaleran_1": 2,
        "datarank": 1,
        "abbrev": "Ky.",
        "postal": "KY",
        "area_sqkm": 0,
        "sameascity": -99,
        "labelrank": 0,
        "featurec_1": "Admin-1 scale rank",
        "admin": "United States of America",
        "name_len": 8,
        "mapcolor9": 1,
        "mapcolor13": 1
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [ -91.7937, 29.5007 ],
            [ -91.8308, 29.4865 ],
            [ -91.9962, 29.5731 ],
            [ -92.0066, 29.6103 ],
            [ -91.925, 29.6439 ],
            [ -91.8752, 29.641 ],
            [ -91.7965, 29.597 ],
            [ -91.7677, 29.5847 ],
            [ -91.7543, 29.5669 ],
            [ -91.7619, 29.539 ],
            [ -91.7937, 29.5007 ]
          ],
          [
            [ -88.8893, 29.7126 ],
            [ -88.9436, 29.6602 ],
            [ -88.9411, 29.6802 ],
            [ -88.9012, 29.7326 ],
            [ -88.8727, 29.753 ],
            [ -88.8893, 29.7126 ]
          ],
          [
            [ -88.8275, 29.8077 ],
            [ -88.8557, 29.7759 ],
            [ -88.828, 29.9284 ],
            [ -88.8669, 30.0567 ],
            [ -88.8259, 30.0004 ],
            [ -88.8126, 29.9334 ],
            [ -88.8275, 29.8077 ]
          ],
          [
            [ -89.224, 30.0841 ],
            [ -89.2204, 30.0376 ],
            [ -89.2694, 30.0607 ],
            [ -89.342, 30.0628 ],
            [ -89.3101, 30.0787 ],
            [ -89.2876, 30.0942 ],
            [ -89.2765, 30.1108 ],
            [ -89.1847, 30.1687 ],
            [ -89.2107, 30.1262 ],
            [ -89.224, 30.0841 ]
          ],
          [
            [ -91.1769, 31.0012 ],
            [ -90.9366, 31.0012 ],
            [ -90.6963, 31.0012 ],
            [ -90.4561, 31.0012 ],
            [ -90.2158, 31.0012 ],
            [ -89.9756, 31.0012 ],
            [ -89.7353, 31.0012 ],
            [ -89.7649, 30.8861 ],
            [ -89.8354, 30.7308 ],
            [ -89.8381, 30.6904 ],
            [ -89.8197, 30.6399 ],
            [ -89.82, 30.6112 ],
            [ -89.794, 30.5689 ],
            [ -89.7366, 30.5266 ],
            [ -89.6858, 30.4627 ],
            [ -89.6408, 30.3489 ],
            [ -89.629, 30.2962 ],
            [ -89.5917, 30.223 ],
            [ -89.5725, 30.2092 ],
            [ -89.5451, 30.2007 ],
            [ -89.5209, 30.1926 ],
            [ -89.5885, 30.166 ],
            [ -89.9542, 30.2687 ],
            [ -90.0452, 30.3514 ],
            [ -90.126, 30.3691 ],
            [ -90.2253, 30.3793 ],
            [ -90.332, 30.2776 ],
            [ -90.4131, 30.1403 ],
            [ -90.285, 30.0651 ],
            [ -90.1753, 30.0291 ],
            [ -89.9942, 30.0593 ],
            [ -89.894, 30.1259 ],
            [ -89.8122, 30.1237 ],
            [ -89.7731, 30.1372 ],
            [ -89.7374, 30.172 ],
            [ -89.6676, 30.1445 ],
            [ -89.6651, 30.1171 ],
            [ -89.7147, 30.0783 ],
            [ -89.7773, 30.0457 ],
            [ -89.8152, 30.0073 ],
            [ -89.7438, 29.9299 ],
            [ -89.6317, 29.9038 ],
            [ -89.5895, 29.915 ],
            [ -89.5634, 30.0021 ],
            [ -89.4944, 30.0582 ],
            [ -89.4007, 30.046 ],
            [ -89.4141, 30.0109 ],
            [ -89.4009, 29.9777 ],
            [ -89.3578, 29.921 ],
            [ -89.3628, 29.8398 ],
            [ -89.3545, 29.8202 ],
            [ -89.4554, 29.7844 ],
            [ -89.5307, 29.7722 ],
            [ -89.5909, 29.7253 ],
            [ -89.5593, 29.698 ],
            [ -89.6206, 29.6741 ],
            [ -89.6621, 29.6837 ],
            [ -89.6829, 29.6749 ],
            [ -89.6892, 29.646 ],
            [ -89.7209, 29.6193 ],
            [ -89.6748, 29.5387 ],
            [ -89.5803, 29.4861 ],
            [ -89.5137, 29.4201 ],
            [ -89.2457, 29.3332 ],
            [ -89.1808, 29.3357 ],
            [ -89.1168, 29.2482 ],
            [ -89.0653, 29.2181 ],
            [ -89.0158, 29.2029 ],
            [ -89.0214, 29.1427 ],
            [ -89.1095, 29.0987 ],
            [ -89.1333, 29.0461 ],
            [ -89.1555, 29.0166 ],
            [ -89.1952, 29.054 ],
            [ -89.2361, 29.0811 ],
            [ -89.3306, 28.9987 ],
            [ -89.3761, 28.9813 ],
            [ -89.3535, 29.0702 ],
            [ -89.3892, 29.105 ],
            [ -89.4431, 29.1941 ],
            [ -89.5218, 29.2493 ],
            [ -89.5772, 29.2675 ],
            [ -89.6203, 29.3024 ],
            [ -89.6725, 29.3165 ],
            [ -89.717, 29.3129 ],
            [ -89.7924, 29.3332 ],
            [ -89.7974, 29.3806 ],
            [ -89.8183, 29.4161 ],
            [ -89.8772, 29.458 ],
            [ -90.1591, 29.5371 ],
            [ -90.1608, 29.5044 ],
            [ -90.1413, 29.4797 ],
            [ -90.1008, 29.4633 ],
            [ -90.0523, 29.4314 ],
            [ -90.0528, 29.3368 ],
            [ -90.0737, 29.2968 ],
            [ -90.0827, 29.2398 ],
            [ -90.1014, 29.1818 ],
            [ -90.1359, 29.1361 ],
            [ -90.2128, 29.1049 ],
            [ -90.2467, 29.131 ],
            [ -90.3016, 29.2558 ],
            [ -90.3792, 29.2951 ],
            [ -90.5025, 29.2998 ],
            [ -90.5862, 29.2715 ],
            [ -90.6775, 29.1506 ],
            [ -90.751, 29.1309 ],
            [ -91.0028, 29.1935 ],
            [ -91.2901, 29.289 ],
            [ -91.2827, 29.3207 ],
            [ -91.2375, 29.331 ],
            [ -91.1508, 29.3179 ],
            [ -91.1554, 29.3507 ],
            [ -91.244, 29.4573 ],
            [ -91.2602, 29.5055 ],
            [ -91.2488, 29.5642 ],
            [ -91.2777, 29.5629 ],
            [ -91.3309, 29.5136 ],
            [ -91.5142, 29.5554 ],
            [ -91.5648, 29.6053 ],
            [ -91.6725, 29.7461 ],
            [ -91.8244, 29.7507 ],
            [ -91.8932, 29.836 ],
            [ -92.0173, 29.8003 ],
            [ -92.0802, 29.7607 ],
            [ -92.1355, 29.6995 ],
            [ -92.114, 29.6677 ],
            [ -92.0589, 29.6172 ],
            [ -92.084, 29.5928 ],
            [ -92.2608, 29.5569 ],
            [ -92.6713, 29.5971 ],
            [ -92.7913, 29.6347 ],
            [ -92.9524, 29.7142 ],
            [ -93.1757, 29.779 ],
            [ -93.2832, 29.7894 ],
            [ -93.3885, 29.7766 ],
            [ -93.6948, 29.7699 ],
            [ -93.7659, 29.7527 ],
            [ -93.8265, 29.7251 ],
            [ -93.8657, 29.7556 ],
            [ -93.8839, 29.81 ],
            [ -93.8483, 29.8188 ],
            [ -93.8088, 29.8508 ],
            [ -93.7731, 29.914 ],
            [ -93.769, 29.9523 ],
            [ -93.794, 29.9773 ],
            [ -93.7269, 30.0771 ],
            [ -93.7106, 30.1128 ],
            [ -93.721, 30.2829 ],
            [ -93.7504, 30.3447 ],
            [ -93.7466, 30.3804 ],
            [ -93.7152, 30.4733 ],
            [ -93.7202, 30.5583 ],
            [ -93.6652, 30.6608 ],
            [ -93.6247, 30.7143 ],
            [ -93.5792, 30.8238 ],
            [ -93.5687, 30.8947 ],
            [ -93.5492, 30.9477 ],
            [ -93.5627, 31.0049 ],
            [ -93.5306, 31.0462 ],
            [ -93.5514, 31.1041 ],
            [ -93.5577, 31.1804 ],
            [ -93.597, 31.2098 ],
            [ -93.6659, 31.3226 ],
            [ -93.6637, 31.3722 ],
            [ -93.7361, 31.4777 ],
            [ -93.7376, 31.5138 ],
            [ -93.8069, 31.5688 ],
            [ -93.8207, 31.604 ],
            [ -93.8268, 31.7503 ],
            [ -93.8456, 31.7929 ],
            [ -93.9051, 31.877 ],
            [ -94.0433, 31.9992 ],
            [ -94.0431, 32.1258 ],
            [ -94.0428, 32.2524 ],
            [ -94.0425, 32.379 ],
            [ -94.0423, 32.5056 ],
            [ -94.042, 32.6322 ],
            [ -94.0418, 32.7588 ],
            [ -94.0416, 32.8854 ],
            [ -94.0413, 33.012 ],
            [ -93.8616, 33.0122 ],
            [ -93.6819, 33.0124 ],
            [ -93.5023, 33.0126 ],
            [ -93.3226, 33.0128 ],
            [ -93.143, 33.0131 ],
            [ -92.9633, 33.0133 ],
            [ -92.7836, 33.0135 ],
            [ -92.6039, 33.0137 ],
            [ -92.4243, 33.0139 ],
            [ -92.2446, 33.0141 ],
            [ -92.0649, 33.0143 ],
            [ -91.8852, 33.0145 ],
            [ -91.7055, 33.0148 ],
            [ -91.5259, 33.015 ],
            [ -91.3462, 33.0152 ],
            [ -91.15, 33.0159 ],
            [ -91.1442, 32.9669 ],
            [ -91.0961, 32.9377 ],
            [ -91.0934, 32.885 ],
            [ -91.1361, 32.8088 ],
            [ -91.1356, 32.7558 ],
            [ -91.0921, 32.7259 ],
            [ -91.0944, 32.6943 ],
            [ -91.1424, 32.661 ],
            [ -91.1496, 32.625 ],
            [ -91.1161, 32.5862 ],
            [ -91.1008, 32.5414 ],
            [ -91.1038, 32.4905 ],
            [ -91.0593, 32.4238 ],
            [ -90.99, 32.3811 ],
            [ -90.9447, 32.3307 ],
            [ -90.9404, 32.3031 ],
            [ -90.9376, 32.2773 ],
            [ -90.9477, 32.2401 ],
            [ -91.0046, 32.1856 ],
            [ -91.0482, 32.1459 ],
            [ -91.0746, 32.1313 ],
            [ -91.0887, 32.1041 ],
            [ -91.0925, 32.0458 ],
            [ -91.1565, 31.9707 ],
            [ -91.2865, 31.884 ],
            [ -91.3725, 31.7737 ],
            [ -91.4147, 31.64 ],
            [ -91.4591, 31.555 ],
            [ -91.5057, 31.5187 ],
            [ -91.529, 31.4488 ],
            [ -91.529, 31.3452 ],
            [ -91.5587, 31.2879 ],
            [ -91.6182, 31.277 ],
            [ -91.6308, 31.2176 ],
            [ -91.5964, 31.1099 ],
            [ -91.611, 31.0649 ],
            [ -91.6526, 31.0296 ],
            [ -91.6564, 31.0018 ],
            [ -91.4171, 31.0013 ],
            [ -91.1769, 31.0012 ]
          ]
        ]
      },
      "properties": {
        "featurecla": "Admin-1 scale rank",
        "scalerank": 2,
        "adm1_code": "USA-3535",
        "diss_me": 3535,
        "adm1_cod_1": "USA-3535",
        "iso_3166_2": "US-LA",
        "wikipedia": "http://en.wikipedia.org/wiki/Louisiana",
        "sr_sov_a3": "US1",
        "sr_adm0_a3": "USA",
        "iso_a2": "US",
        "adm0_sr": 5,
        "admin0_lab": 2,
        "name": "Louisiana",
        "name_alt": "LA",
        "name_local": "",
        "type": "State",
        "type_en": "State",
        "code_local": "US22",
        "code_hasc": "US.LA",
        "note": "",
        "hasc_maybe": "",
        "region": "South",
        "region_cod": "",
        "region_big": "West South Central",
        "big_code": "",
        "provnum_ne": 0,
        "gadm_level": 1,
        "check_me": 0,
        "scaleran_1": 2,
        "datarank": 1,
        "abbrev": "La.",
        "postal": "LA",
        "area_sqkm": 0,
        "sameascity": -99,
        "labelrank": 0,
        "featurec_1": "Admin-1 scale rank",
        "admin": "United States of America",
        "name_len": 9,
        "mapcolor9": 1,
        "mapcolor13": 1
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [ -69.9779, 41.2656 ],
            [ -70.0551, 41.2495 ],
            [ -70.2331, 41.2863 ],
            [ -70.0866, 41.3176 ],
            [ -70.0627, 41.3285 ],
            [ -70.0436, 41.3744 ],
            [ -70.0412, 41.3975 ],
            [ -69.9856, 41.2986 ],
            [ -69.9779, 41.2656 ]
          ],
          [
            [ -70.5099, 41.3763 ],
            [ -70.7853, 41.3274 ],
            [ -70.8292, 41.359 ],
            [ -70.7605, 41.3736 ],
            [ -70.6737, 41.4485 ],
            [ -70.616, 41.4572 ],
            [ -70.5254, 41.4148 ],
            [ -70.5099, 41.3763 ]
          ],
          [
            [ -70.7813, 42.7212 ],
            [ -70.7357, 42.6693 ],
            [ -70.6969, 42.6646 ],
            [ -70.6548, 42.674 ],
            [ -70.624, 42.6718 ],
            [ -70.6041, 42.6497 ],
            [ -70.6129, 42.6233 ],
            [ -70.6614, 42.6167 ],
            [ -70.7519, 42.5703 ],
            [ -70.8312, 42.5526 ],
            [ -70.8709, 42.4966 ],
            [ -70.9304, 42.432 ],
            [ -71.0462, 42.3311 ],
            [ -70.9967, 42.3 ],
            [ -70.8179, 42.265 ],
            [ -70.7383, 42.2289 ],
            [ -70.6177, 42.0404 ],
            [ -70.6452, 42.0216 ],
            [ -70.6561, 41.987 ],
            [ -70.5489, 41.9386 ],
            [ -70.5147, 41.8033 ],
            [ -70.4267, 41.7573 ],
            [ -70.2955, 41.729 ],
            [ -70.135, 41.7699 ],
            [ -70.0014, 41.8262 ],
            [ -70.0061, 41.8723 ],
            [ -70.09, 41.9797 ],
            [ -70.1102, 42.0301 ],
            [ -70.1726, 42.0628 ],
            [ -70.1962, 42.0351 ],
            [ -70.2365, 42.071 ],
            [ -70.2411, 42.0912 ],
            [ -70.2035, 42.101 ],
            [ -70.1599, 42.0971 ],
            [ -70.1089, 42.0783 ],
            [ -69.9779, 41.9613 ],
            [ -69.9416, 41.8079 ],
            [ -69.9338, 41.7104 ],
            [ -69.9486, 41.6771 ],
            [ -69.9868, 41.684 ],
            [ -70.0595, 41.6774 ],
            [ -70.4047, 41.6269 ],
            [ -70.4814, 41.5825 ],
            [ -70.6571, 41.5342 ],
            [ -70.6681, 41.5583 ],
            [ -70.6553, 41.6081 ],
            [ -70.6665, 41.7101 ],
            [ -70.7011, 41.7148 ],
            [ -70.9742, 41.5485 ],
            [ -71.0798, 41.5381 ],
            [ -71.1685, 41.4894 ],
            [ -71.1884, 41.5164 ],
            [ -71.2043, 41.6411 ],
            [ -71.1487, 41.7457 ],
            [ -71.1783, 41.7441 ],
            [ -71.2338, 41.7066 ],
            [ -71.2679, 41.7508 ],
            [ -71.3047, 41.7747 ],
            [ -71.3407, 41.7979 ],
            [ -71.3395, 41.8352 ],
            [ -71.3376, 41.8914 ],
            [ -71.3791, 41.9024 ],
            [ -71.3839, 41.9717 ],
            [ -71.3871, 42.0169 ],
            [ -71.4625, 42.016 ],
            [ -71.5241, 42.0152 ],
            [ -71.6232, 42.014 ],
            [ -71.7258, 42.0129 ],
            [ -71.8008, 42.012 ],
            [ -71.8016, 42.0227 ],
            [ -71.9211, 42.0241 ],
            [ -72.0406, 42.0256 ],
            [ -72.1601, 42.027 ],
            [ -72.2796, 42.0284 ],
            [ -72.3991, 42.0298 ],
            [ -72.5186, 42.0312 ],
            [ -72.6381, 42.0327 ],
            [ -72.7576, 42.0341 ],
            [ -72.7633, 42.0112 ],
            [ -72.8065, 42.008 ],
            [ -72.8077, 42.0341 ],
            [ -72.8918, 42.0368 ],
            [ -72.9759, 42.0395 ],
            [ -73.06, 42.0421 ],
            [ -73.1441, 42.0448 ],
            [ -73.2282, 42.0475 ],
            [ -73.3123, 42.0502 ],
            [ -73.3965, 42.0529 ],
            [ -73.4806, 42.0556 ],
            [ -73.5073, 42.08 ],
            [ -73.4755, 42.164 ],
            [ -73.4438, 42.2481 ],
            [ -73.412, 42.3321 ],
            [ -73.3803, 42.4161 ],
            [ -73.3486, 42.5001 ],
            [ -73.3168, 42.5842 ],
            [ -73.2851, 42.6682 ],
            [ -73.2533, 42.7522 ],
            [ -73.155, 42.7495 ],
            [ -73.0567, 42.7467 ],
            [ -72.9584, 42.744 ],
            [ -72.8601, 42.7413 ],
            [ -72.7618, 42.7385 ],
            [ -72.6635, 42.7358 ],
            [ -72.5652, 42.7331 ],
            [ -72.4669, 42.7303 ],
            [ -72.3247, 42.7269 ],
            [ -72.1825, 42.7234 ],
            [ -72.0404, 42.7199 ],
            [ -71.8982, 42.7164 ],
            [ -71.7561, 42.7129 ],
            [ -71.6139, 42.7094 ],
            [ -71.4718, 42.706 ],
            [ -71.3296, 42.7025 ],
            [ -71.2423, 42.7295 ],
            [ -71.1393, 42.8081 ],
            [ -71.0762, 42.8251 ],
            [ -70.9741, 42.8717 ],
            [ -70.9235, 42.8816 ],
            [ -70.8061, 42.8768 ],
            [ -70.8291, 42.8253 ],
            [ -70.8003, 42.774 ],
            [ -70.7813, 42.7212 ]
          ]
        ]
      },
      "properties": {
        "featurecla": "Admin-1 scale rank",
        "scalerank": 2,
        "adm1_code": "USA-3513",
        "diss_me": 3513,
        "adm1_cod_1": "USA-3513",
        "iso_3166_2": "US-MA",
        "wikipedia": "http://en.wikipedia.org/wiki/Massachusetts",
        "sr_sov_a3": "US1",
        "sr_adm0_a3": "USA",
        "iso_a2": "US",
        "adm0_sr": 6,
        "admin0_lab": 2,
        "name": "Massachusetts",
        "name_alt": "Commonwealth of Massachusetts|MA|Mass.",
        "name_local": "",
        "type": "State",
        "type_en": "State",
        "code_local": "US25",
        "code_hasc": "US.MA",
        "note": "",
        "hasc_maybe": "",
        "region": "Northeast",
        "region_cod": "",
        "region_big": "New England",
        "big_code": "",
        "provnum_ne": 0,
        "gadm_level": 1,
        "check_me": 0,
        "scaleran_1": 2,
        "datarank": 1,
        "abbrev": "Mass.",
        "postal": "MA",
        "area_sqkm": 0,
        "sameascity": -99,
        "labelrank": 0,
        "featurec_1": "Admin-1 scale rank",
        "admin": "United States of America",
        "name_len": 13,
        "mapcolor9": 1,
        "mapcolor13": 1
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [ -75.2258, 38.0403 ],
            [ -75.2525, 38.0374 ],
            [ -75.226, 38.0723 ],
            [ -75.1374, 38.2401 ],
            [ -75.0979, 38.2981 ],
            [ -75.1362, 38.1805 ],
            [ -75.2032, 38.0724 ],
            [ -75.2258, 38.0403 ]
          ],
          [
            [ -75.7847, 39.7224 ],
            [ -75.775, 39.5639 ],
            [ -75.7653, 39.4056 ],
            [ -75.7556, 39.2471 ],
            [ -75.7459, 39.0887 ],
            [ -75.7362, 38.9303 ],
            [ -75.7265, 38.7719 ],
            [ -75.7167, 38.6135 ],
            [ -75.707, 38.4551 ],
            [ -75.7047, 38.4551 ],
            [ -75.7024, 38.455 ],
            [ -75.7001, 38.455 ],
            [ -75.6978, 38.455 ],
            [ -75.6955, 38.455 ],
            [ -75.6932, 38.455 ],
            [ -75.6909, 38.455 ],
            [ -75.6886, 38.455 ],
            [ -75.5879, 38.455 ],
            [ -75.3663, 38.4549 ],
            [ -75.1447, 38.4549 ],
            [ -75.0377, 38.4556 ],
            [ -75.0387, 38.4264 ],
            [ -75.0513, 38.383 ],
            [ -75.0744, 38.3657 ],
            [ -75.0734, 38.41 ],
            [ -75.0897, 38.4254 ],
            [ -75.1168, 38.4062 ],
            [ -75.1342, 38.3843 ],
            [ -75.1415, 38.2981 ],
            [ -75.16, 38.2551 ],
            [ -75.2254, 38.2423 ],
            [ -75.2918, 38.1292 ],
            [ -75.3535, 38.065 ],
            [ -75.376, 38.025 ],
            [ -75.4694, 38.0149 ],
            [ -75.62, 37.9992 ],
            [ -75.6593, 37.954 ],
            [ -75.7352, 37.9737 ],
            [ -75.8508, 37.9716 ],
            [ -75.829, 38.0328 ],
            [ -75.7953, 38.0867 ],
            [ -75.8556, 38.1404 ],
            [ -75.8913, 38.1472 ],
            [ -75.9281, 38.1692 ],
            [ -75.885, 38.2139 ],
            [ -75.8639, 38.2612 ],
            [ -75.8768, 38.3187 ],
            [ -75.8587, 38.3621 ],
            [ -75.8888, 38.3555 ],
            [ -75.9373, 38.3097 ],
            [ -75.9674, 38.2914 ],
            [ -75.9857, 38.3319 ],
            [ -76.0067, 38.3228 ],
            [ -76.0203, 38.2949 ],
            [ -76.0512, 38.2795 ],
            [ -76.1165, 38.3177 ],
            [ -76.2117, 38.3613 ],
            [ -76.2646, 38.4364 ],
            [ -76.2949, 38.4947 ],
            [ -76.2642, 38.6 ],
            [ -76.1984, 38.6187 ],
            [ -76.1129, 38.6016 ],
            [ -76.0009, 38.6017 ],
            [ -76.0169, 38.6251 ],
            [ -76.057, 38.6213 ],
            [ -76.175, 38.7067 ],
            [ -76.213, 38.7583 ],
            [ -76.2783, 38.7725 ],
            [ -76.3081, 38.7229 ],
            [ -76.3412, 38.7096 ],
            [ -76.3003, 38.8182 ],
            [ -76.247, 38.8226 ],
            [ -76.1681, 38.8527 ],
            [ -76.191, 38.9156 ],
            [ -76.2408, 38.9431 ],
            [ -76.3307, 38.9086 ],
            [ -76.3296, 38.9528 ],
            [ -76.3128, 39.0094 ],
            [ -76.245, 39.0092 ],
            [ -76.1857, 38.9907 ],
            [ -76.1352, 39.0821 ],
            [ -76.1329, 39.123 ],
            [ -76.2168, 39.0636 ],
            [ -76.2357, 39.1916 ],
            [ -76.1531, 39.315 ],
            [ -76.0744, 39.3689 ],
            [ -75.976, 39.3673 ],
            [ -75.876, 39.376 ],
            [ -75.9387, 39.3986 ],
            [ -76.0031, 39.4109 ],
            [ -75.9547, 39.4596 ],
            [ -75.9134, 39.4683 ],
            [ -75.8729, 39.5109 ],
            [ -75.9704, 39.5046 ],
            [ -75.9589, 39.5851 ],
            [ -76.0063, 39.5687 ],
            [ -76.063, 39.5611 ],
            [ -76.0851, 39.527 ],
            [ -76.0807, 39.4703 ],
            [ -76.0973, 39.4331 ],
            [ -76.1414, 39.4032 ],
            [ -76.2158, 39.3799 ],
            [ -76.223, 39.4203 ],
            [ -76.2477, 39.4386 ],
            [ -76.2568, 39.3522 ],
            [ -76.2764, 39.3227 ],
            [ -76.3308, 39.4039 ],
            [ -76.3472, 39.3875 ],
            [ -76.345, 39.3645 ],
            [ -76.359, 39.3247 ],
            [ -76.4057, 39.3039 ],
            [ -76.4028, 39.2528 ],
            [ -76.4209, 39.225 ],
            [ -76.5704, 39.2693 ],
            [ -76.5739, 39.2543 ],
            [ -76.4894, 39.1587 ],
            [ -76.4276, 39.126 ],
            [ -76.4201, 39.0739 ],
            [ -76.4731, 39.0306 ],
            [ -76.5462, 39.068 ],
            [ -76.5586, 39.0652 ],
            [ -76.5188, 39.0012 ],
            [ -76.4938, 38.9452 ],
            [ -76.5195, 38.8983 ],
            [ -76.5156, 38.8406 ],
            [ -76.5211, 38.7883 ],
            [ -76.5369, 38.7426 ],
            [ -76.5013, 38.5322 ],
            [ -76.4585, 38.475 ],
            [ -76.4164, 38.4202 ],
            [ -76.3941, 38.369 ],
            [ -76.4387, 38.3615 ],
            [ -76.5099, 38.4036 ],
            [ -76.5724, 38.4358 ],
            [ -76.6469, 38.5385 ],
            [ -76.6592, 38.5796 ],
            [ -76.6773, 38.612 ],
            [ -76.6685, 38.5375 ],
            [ -76.642, 38.4543 ],
            [ -76.4088, 38.2683 ],
            [ -76.3657, 38.1969 ],
            [ -76.3329, 38.1408 ],
            [ -76.3412, 38.087 ],
            [ -76.4019, 38.1251 ],
            [ -76.4544, 38.1735 ],
            [ -76.5936, 38.2283 ],
            [ -76.7692, 38.2629 ],
            [ -76.8681, 38.3903 ],
            [ -76.8678, 38.3371 ],
            [ -76.8897, 38.2921 ],
            [ -76.9503, 38.347 ],
            [ -76.9884, 38.3939 ],
            [ -77.0012, 38.4453 ],
            [ -77.0767, 38.4418 ],
            [ -77.1559, 38.3971 ],
            [ -77.2325, 38.4077 ],
            [ -77.2416, 38.4948 ],
            [ -77.2209, 38.541 ],
            [ -77.1349, 38.6501 ],
            [ -77.0539, 38.7058 ],
            [ -77.0182, 38.7777 ],
            [ -77.0304, 38.8893 ],
            [ -77.0197, 38.8065 ],
            [ -76.9312, 38.8882 ],
            [ -76.9888, 38.9523 ],
            [ -77.0421, 39.0118 ],
            [ -77.1221, 38.9435 ],
            [ -77.1903, 38.969 ],
            [ -77.3011, 39.0534 ],
            [ -77.4809, 39.113 ],
            [ -77.5065, 39.1426 ],
            [ -77.5029, 39.1753 ],
            [ -77.4789, 39.2209 ],
            [ -77.5342, 39.2656 ],
            [ -77.6688, 39.3095 ],
            [ -77.7266, 39.3464 ],
            [ -77.739, 39.3543 ],
            [ -77.7448, 39.4001 ],
            [ -77.7624, 39.4292 ],
            [ -77.7917, 39.4418 ],
            [ -77.7974, 39.4615 ],
            [ -77.7796, 39.4883 ],
            [ -77.7981, 39.5173 ],
            [ -77.8531, 39.5483 ],
            [ -77.8722, 39.5758 ],
            [ -77.8554, 39.5997 ],
            [ -77.8833, 39.6107 ],
            [ -77.9557, 39.6088 ],
            [ -78.0272, 39.6312 ],
            [ -78.0978, 39.6779 ],
            [ -78.1811, 39.6857 ],
            [ -78.3254, 39.6392 ],
            [ -78.4068, 39.6279 ],
            [ -78.4427, 39.6015 ],
            [ -78.4603, 39.5561 ],
            [ -78.4955, 39.5333 ],
            [ -78.575, 39.5329 ],
            [ -78.5875, 39.5344 ],
            [ -78.6777, 39.5495 ],
            [ -78.7417, 39.5779 ],
            [ -78.7534, 39.5895 ],
            [ -78.7465, 39.6137 ],
            [ -78.7582, 39.6248 ],
            [ -78.7778, 39.6266 ],
            [ -78.7962, 39.6126 ],
            [ -78.8148, 39.5701 ],
            [ -78.9715, 39.4536 ],
            [ -79.0467, 39.4768 ],
            [ -79.0753, 39.476 ],
            [ -79.2936, 39.3116 ],
            [ -79.3598, 39.2854 ],
            [ -79.488, 39.2109 ],
            [ -79.4853, 39.3389 ],
            [ -79.4827, 39.4668 ],
            [ -79.4801, 39.5948 ],
            [ -79.4775, 39.7228 ],
            [ -79.2467, 39.7228 ],
            [ -79.0159, 39.7227 ],
            [ -78.7851, 39.7227 ],
            [ -78.5543, 39.7227 ],
            [ -78.3235, 39.7227 ],
            [ -78.0927, 39.7226 ],
            [ -77.8619, 39.7226 ],
            [ -77.6311, 39.7226 ],
            [ -77.4003, 39.7226 ],
            [ -77.1695, 39.7225 ],
            [ -76.9387, 39.7225 ],
            [ -76.7079, 39.7225 ],
            [ -76.4771, 39.7225 ],
            [ -76.2463, 39.7224 ],
            [ -76.0155, 39.7224 ],
            [ -75.7847, 39.7224 ]
          ]
        ]
      },
      "properties": {
        "featurecla": "Admin-1 scale rank",
        "scalerank": 2,
        "adm1_code": "USA-3557",
        "diss_me": 3557,
        "adm1_cod_1": "USA-3557",
        "iso_3166_2": "US-MD",
        "wikipedia": "http://en.wikipedia.org/wiki/Maryland",
        "sr_sov_a3": "US1",
        "sr_adm0_a3": "USA",
        "iso_a2": "US",
        "adm0_sr": 1,
        "admin0_lab": 2,
        "name": "Maryland",
        "name_alt": "MD",
        "name_local": "",
        "type": "State",
        "type_en": "State",
        "code_local": "US24",
        "code_hasc": "US.MD",
        "note": "",
        "hasc_maybe": "",
        "region": "South",
        "region_cod": "",
        "region_big": "South Atlantic",
        "big_code": "",
        "provnum_ne": 0,
        "gadm_level": 1,
        "check_me": 0,
        "scaleran_1": 2,
        "datarank": 1,
        "abbrev": "Md.",
        "postal": "MD",
        "area_sqkm": 0,
        "sameascity": -99,
        "labelrank": 0,
        "featurec_1": "Admin-1 scale rank",
        "admin": "United States of America",
        "name_len": 8,
        "mapcolor9": 1,
        "mapcolor13": 1
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [ -68.6232, 44.1961 ],
            [ -68.6612, 44.1763 ],
            [ -68.7017, 44.1827 ],
            [ -68.703, 44.232 ],
            [ -68.6908, 44.2487 ],
            [ -68.6767, 44.2562 ],
            [ -68.656, 44.2423 ],
            [ -68.6232, 44.1961 ]
          ],
          [
            [ -68.1873, 44.3325 ],
            [ -68.2454, 44.313 ],
            [ -68.3093, 44.3215 ],
            [ -68.308, 44.2687 ],
            [ -68.3151, 44.2497 ],
            [ -68.3858, 44.2769 ],
            [ -68.4117, 44.2944 ],
            [ -68.4095, 44.3643 ],
            [ -68.347, 44.4304 ],
            [ -68.2994, 44.4565 ],
            [ -68.238, 44.4384 ],
            [ -68.1909, 44.3644 ],
            [ -68.1873, 44.3325 ]
          ],
          [
            [ -68.9372, 47.2113 ],
            [ -68.8874, 47.2028 ],
            [ -68.8287, 47.2033 ],
            [ -68.6685, 47.2534 ],
            [ -68.4804, 47.2858 ],
            [ -68.3769, 47.3162 ],
            [ -68.358, 47.3445 ],
            [ -68.3109, 47.3545 ],
            [ -68.2355, 47.3459 ],
            [ -68.0968, 47.2748 ],
            [ -67.9348, 47.1676 ],
            [ -67.8068, 47.0828 ],
            [ -67.8029, 46.9357 ],
            [ -67.8004, 46.7799 ],
            [ -67.7977, 46.6156 ],
            [ -67.7958, 46.4984 ],
            [ -67.7925, 46.3374 ],
            [ -67.7899, 46.2093 ],
            [ -67.7865, 46.0422 ],
            [ -67.7846, 45.9528 ],
            [ -67.7671, 45.927 ],
            [ -67.7776, 45.8918 ],
            [ -67.7823, 45.8742 ],
            [ -67.7811, 45.8601 ],
            [ -67.7741, 45.8425 ],
            [ -67.7753, 45.8179 ],
            [ -67.7917, 45.7956 ],
            [ -67.7999, 45.7698 ],
            [ -67.8007, 45.7555 ],
            [ -67.863, 45.7396 ],
            [ -67.779, 45.6701 ],
            [ -67.6255, 45.6022 ],
            [ -67.5124, 45.5894 ],
            [ -67.4494, 45.6071 ],
            [ -67.4497, 45.6079 ],
            [ -67.4326, 45.6031 ],
            [ -67.4139, 45.5656 ],
            [ -67.4244, 45.5304 ],
            [ -67.4549, 45.514 ],
            [ -67.4878, 45.501 ],
            [ -67.4937, 45.4741 ],
            [ -67.4772, 45.4459 ],
            [ -67.4538, 45.4213 ],
            [ -67.4279, 45.378 ],
            [ -67.4385, 45.3404 ],
            [ -67.462, 45.3087 ],
            [ -67.4725, 45.2759 ],
            [ -67.4526, 45.2477 ],
            [ -67.3998, 45.2102 ],
            [ -67.3669, 45.1738 ],
            [ -67.3153, 45.1538 ],
            [ -67.2907, 45.1679 ],
            [ -67.2707, 45.1867 ],
            [ -67.2496, 45.2008 ],
            [ -67.2132, 45.1925 ],
            [ -67.171, 45.182 ],
            [ -67.1248, 45.1694 ],
            [ -67.1304, 45.139 ],
            [ -67.1023, 45.0877 ],
            [ -67.0804, 44.9892 ],
            [ -67.1139, 44.9444 ],
            [ -67.1067, 44.885 ],
            [ -67.014, 44.8677 ],
            [ -66.9915, 44.8496 ],
            [ -66.987, 44.8277 ],
            [ -67.1912, 44.6756 ],
            [ -67.3641, 44.6969 ],
            [ -67.4578, 44.6565 ],
            [ -67.556, 44.6448 ],
            [ -67.5991, 44.5768 ],
            [ -67.653, 44.5624 ],
            [ -67.7268, 44.5665 ],
            [ -67.7905, 44.5857 ],
            [ -67.8391, 44.5762 ],
            [ -67.907, 44.4536 ],
            [ -67.9627, 44.4643 ],
            [ -67.9849, 44.4202 ],
            [ -68.014, 44.4009 ],
            [ -68.0566, 44.3843 ],
            [ -68.0937, 44.4388 ],
            [ -68.1173, 44.4906 ],
            [ -68.152, 44.502 ],
            [ -68.1983, 44.5152 ],
            [ -68.2457, 44.5148 ],
            [ -68.2774, 44.5074 ],
            [ -68.3168, 44.4739 ],
            [ -68.3737, 44.4451 ],
            [ -68.4168, 44.4691 ],
            [ -68.4506, 44.5076 ],
            [ -68.4795, 44.4457 ],
            [ -68.5214, 44.3802 ],
            [ -68.5145, 44.3039 ],
            [ -68.5325, 44.2586 ],
            [ -68.5723, 44.2708 ],
            [ -68.612, 44.3105 ],
            [ -68.7233, 44.3423 ],
            [ -68.8119, 44.3394 ],
            [ -68.7939, 44.3817 ],
            [ -68.7101, 44.4426 ],
            [ -68.7359, 44.4545 ],
            [ -68.777, 44.4461 ],
            [ -68.7949, 44.4545 ],
            [ -68.7655, 44.5098 ],
            [ -68.7627, 44.5708 ],
            [ -68.8002, 44.5494 ],
            [ -68.8474, 44.485 ],
            [ -68.9615, 44.4339 ],
            [ -68.9562, 44.3481 ],
            [ -69.0636, 44.1723 ],
            [ -69.0684, 44.0976 ],
            [ -69.1372, 44.0378 ],
            [ -69.2261, 43.9865 ],
            [ -69.3445, 44.0009 ],
            [ -69.435, 43.9563 ],
            [ -69.4809, 43.9051 ],
            [ -69.5207, 43.8974 ],
            [ -69.5415, 43.9626 ],
            [ -69.5567, 43.9828 ],
            [ -69.59, 43.8866 ],
            [ -69.6239, 43.8806 ],
            [ -69.6367, 43.9488 ],
            [ -69.6529, 43.9939 ],
            [ -69.6991, 43.955 ],
            [ -69.7298, 43.852 ],
            [ -69.762, 43.8607 ],
            [ -69.7723, 43.899 ],
            [ -69.7953, 43.9106 ],
            [ -69.8033, 43.8668 ],
            [ -69.7916, 43.8052 ],
            [ -69.8083, 43.7723 ],
            [ -69.8403, 43.7899 ],
            [ -69.8725, 43.8195 ],
            [ -69.9256, 43.797 ],
            [ -69.9743, 43.7879 ],
            [ -69.9745, 43.8181 ],
            [ -69.9652, 43.8551 ],
            [ -70.0624, 43.8346 ],
            [ -70.1788, 43.7664 ],
            [ -70.2692, 43.6719 ],
            [ -70.2379, 43.6562 ],
            [ -70.2026, 43.6261 ],
            [ -70.3597, 43.4802 ],
            [ -70.5207, 43.3488 ],
            [ -70.6423, 43.1344 ],
            [ -70.6912, 43.1093 ],
            [ -70.7331, 43.07 ],
            [ -70.8128, 43.1636 ],
            [ -70.829, 43.2391 ],
            [ -70.9197, 43.3281 ],
            [ -70.9556, 43.3894 ],
            [ -70.9675, 43.4581 ],
            [ -70.9624, 43.5322 ],
            [ -70.9701, 43.643 ],
            [ -70.9778, 43.7539 ],
            [ -70.9854, 43.8647 ],
            [ -70.9931, 43.9756 ],
            [ -71.0008, 44.0864 ],
            [ -71.0084, 44.1973 ],
            [ -71.016, 44.3081 ],
            [ -71.0237, 44.4189 ],
            [ -71.0314, 44.5298 ],
            [ -71.039, 44.6406 ],
            [ -71.0467, 44.7515 ],
            [ -71.0544, 44.8623 ],
            [ -71.062, 44.9732 ],
            [ -71.0697, 45.084 ],
            [ -71.0773, 45.1949 ],
            [ -71.0845, 45.294 ],
            [ -71.0602, 45.3091 ],
            [ -70.9999, 45.3372 ],
            [ -70.9602, 45.3331 ],
            [ -70.9262, 45.2907 ],
            [ -70.898, 45.2625 ],
            [ -70.8651, 45.2707 ],
            [ -70.8368, 45.3107 ],
            [ -70.8378, 45.3662 ],
            [ -70.7992, 45.4048 ],
            [ -70.7533, 45.4107 ],
            [ -70.7109, 45.4095 ],
            [ -70.6898, 45.4283 ],
            [ -70.6921, 45.4554 ],
            [ -70.7074, 45.4989 ],
            [ -70.7022, 45.5514 ],
            [ -70.5964, 45.644 ],
            [ -70.4666, 45.7068 ],
            [ -70.4211, 45.7382 ],
            [ -70.4079, 45.8019 ],
            [ -70.3335, 45.8681 ],
            [ -70.2962, 45.9061 ],
            [ -70.2872, 45.9392 ],
            [ -70.3064, 45.9798 ],
            [ -70.3045, 46.0574 ],
            [ -70.2789, 46.15 ],
            [ -70.2483, 46.2509 ],
            [ -70.1797, 46.3418 ],
            [ -70.0672, 46.441 ],
            [ -70.0382, 46.5714 ],
            [ -70.0077, 46.7089 ],
            [ -69.8717, 46.8429 ],
            [ -69.7175, 46.9949 ],
            [ -69.6298, 47.0814 ],
            [ -69.4715, 47.2387 ],
            [ -69.3589, 47.3506 ],
            [ -69.3021, 47.402 ],
            [ -69.2429, 47.463 ],
            [ -69.1463, 47.4448 ],
            [ -69.0502, 47.4266 ],
            [ -69.0643, 47.3381 ],
            [ -69.0537, 47.2946 ],
            [ -69.0486, 47.2737 ],
            [ -69.0031, 47.2364 ],
            [ -68.9372, 47.2113 ]
          ]
        ]
      },
      "properties": {
        "featurecla": "Admin-1 scale rank",
        "scalerank": 2,
        "adm1_code": "USA-3561",
        "diss_me": 3561,
        "adm1_cod_1": "USA-3561",
        "iso_3166_2": "US-ME",
        "wikipedia": "http://en.wikipedia.org/wiki/Maine",
        "sr_sov_a3": "US1",
        "sr_adm0_a3": "USA",
        "iso_a2": "US",
        "adm0_sr": 6,
        "admin0_lab": 2,
        "name": "Maine",
        "name_alt": "ME|Maine",
        "name_local": "",
        "type": "State",
        "type_en": "State",
        "code_local": "US23",
        "code_hasc": "US.ME",
        "note": "",
        "hasc_maybe": "",
        "region": "Northeast",
        "region_cod": "",
        "region_big": "New England",
        "big_code": "",
        "provnum_ne": 0,
        "gadm_level": 1,
        "check_me": 0,
        "scaleran_1": 2,
        "datarank": 1,
        "abbrev": "Maine",
        "postal": "ME",
        "area_sqkm": 0,
        "sameascity": -99,
        "labelrank": 0,
        "featurec_1": "Admin-1 scale rank",
        "admin": "United States of America",
        "name_len": 5,
        "mapcolor9": 1,
        "mapcolor13": 1
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [ -85.9762, 45.1021 ],
            [ -85.9882, 45.088 ],
            [ -86.0158, 45.0892 ],
            [ -86.0379, 45.1028 ],
            [ -86.0596, 45.1468 ],
            [ -86.0524, 45.1564 ],
            [ -85.9985, 45.1501 ],
            [ -85.9798, 45.1316 ],
            [ -85.9762, 45.1021 ]
          ],
          [
            [ -85.5517, 45.6026 ],
            [ -85.5859, 45.5975 ],
            [ -85.6121, 45.6093 ],
            [ -85.6077, 45.6561 ],
            [ -85.5729, 45.7379 ],
            [ -85.5385, 45.7754 ],
            [ -85.4923, 45.7602 ],
            [ -85.5015, 45.7502 ],
            [ -85.4923, 45.6629 ],
            [ -85.5091, 45.6245 ],
            [ -85.5517, 45.6026 ]
          ],
          [
            [ -84.6909, 45.7738 ],
            [ -84.5629, 45.7122 ],
            [ -84.4414, 45.6763 ],
            [ -84.3263, 45.6662 ],
            [ -84.2423, 45.6444 ],
            [ -84.1893, 45.6111 ],
            [ -84.1511, 45.5738 ],
            [ -84.1277, 45.5325 ],
            [ -84.0728, 45.5091 ],
            [ -83.9863, 45.5038 ],
            [ -83.9183, 45.4863 ],
            [ -83.8687, 45.4565 ],
            [ -83.5937, 45.3794 ],
            [ -83.4785, 45.3388 ],
            [ -83.4153, 45.299 ],
            [ -83.3973, 45.2736 ],
            [ -83.4026, 45.2483 ],
            [ -83.3962, 45.2214 ],
            [ -83.349, 45.169 ],
            [ -83.3311, 45.1642 ],
            [ -83.3202, 45.139 ],
            [ -83.3161, 45.0932 ],
            [ -83.3023, 45.0624 ],
            [ -83.2787, 45.0468 ],
            [ -83.2931, 45.0404 ],
            [ -83.3778, 45.0669 ],
            [ -83.4259, 45.0589 ],
            [ -83.4481, 45.0246 ],
            [ -83.4516, 44.992 ],
            [ -83.4362, 44.9614 ],
            [ -83.3278, 44.8692 ],
            [ -83.2996, 44.7852 ],
            [ -83.2942, 44.6833 ],
            [ -83.3079, 44.6438 ],
            [ -83.3193, 44.5565 ],
            [ -83.3284, 44.4214 ],
            [ -83.3306, 44.3751 ],
            [ -83.3662, 44.33 ],
            [ -83.4628, 44.2649 ],
            [ -83.4642, 44.2772 ],
            [ -83.4874, 44.2806 ],
            [ -83.5125, 44.2708 ],
            [ -83.5475, 44.215 ],
            [ -83.5775, 44.1134 ],
            [ -83.614, 44.0583 ],
            [ -83.657, 44.0496 ],
            [ -83.6828, 44.035 ],
            [ -83.6915, 44.0145 ],
            [ -83.7377, 44.0006 ],
            [ -83.8214, 43.9935 ],
            [ -83.8788, 43.9625 ],
            [ -83.9216, 43.8755 ],
            [ -83.9198, 43.8339 ],
            [ -83.9396, 43.7819 ],
            [ -83.9383, 43.7375 ],
            [ -83.9157, 43.7006 ],
            [ -83.848, 43.6636 ],
            [ -83.7352, 43.6267 ],
            [ -83.6679, 43.621 ],
            [ -83.6216, 43.6365 ],
            [ -83.5731, 43.6971 ],
            [ -83.526, 43.7209 ],
            [ -83.4689, 43.7309 ],
            [ -83.4474, 43.7584 ],
            [ -83.353, 43.8793 ],
            [ -83.3531, 43.9063 ],
            [ -83.3875, 43.9166 ],
            [ -83.3826, 43.9241 ],
            [ -83.3381, 43.9289 ],
            [ -83.2995, 43.9451 ],
            [ -83.2666, 43.9729 ],
            [ -83.2093, 43.9936 ],
            [ -83.0695, 44.025 ],
            [ -82.9946, 44.0611 ],
            [ -82.9472, 44.067 ],
            [ -82.8782, 44.0478 ],
            [ -82.7877, 44.0035 ],
            [ -82.7161, 43.939 ],
            [ -82.6633, 43.8542 ],
            [ -82.5967, 43.6344 ],
            [ -82.5162, 43.2796 ],
            [ -82.4613, 43.081 ],
            [ -82.4319, 43.0386 ],
            [ -82.4172, 43.0174 ],
            [ -82.4172, 43.0174 ],
            [ -82.4172, 43.0174 ],
            [ -82.4883, 42.7395 ],
            [ -82.5453, 42.6247 ],
            [ -82.6451, 42.5581 ],
            [ -82.6391, 42.5744 ],
            [ -82.63, 42.5945 ],
            [ -82.6328, 42.661 ],
            [ -82.6499, 42.6866 ],
            [ -82.6868, 42.6969 ],
            [ -82.7326, 42.6896 ],
            [ -82.7874, 42.6646 ],
            [ -82.8044, 42.6389 ],
            [ -82.7838, 42.6127 ],
            [ -82.796, 42.5891 ],
            [ -82.841, 42.5681 ],
            [ -82.8701, 42.519 ],
            [ -82.8834, 42.4418 ],
            [ -82.902, 42.394 ],
            [ -82.926, 42.3755 ],
            [ -83.0165, 42.3471 ],
            [ -83.0634, 42.3227 ],
            [ -83.1048, 42.2864 ],
            [ -83.1421, 42.2276 ],
            [ -83.1752, 42.1463 ],
            [ -83.1884, 42.0834 ],
            [ -83.1766, 42.0489 ],
            [ -83.2048, 42.0271 ],
            [ -83.2556, 41.9856 ],
            [ -83.2652, 41.9706 ],
            [ -83.2618, 41.9464 ],
            [ -83.2725, 41.9346 ],
            [ -83.2972, 41.9351 ],
            [ -83.3162, 41.9233 ],
            [ -83.3621, 41.8799 ],
            [ -83.4412, 41.7662 ],
            [ -83.4543, 41.7455 ],
            [ -83.4642, 41.7394 ],
            [ -83.7972, 41.73 ],
            [ -84.1302, 41.7205 ],
            [ -84.4631, 41.7109 ],
            [ -84.7961, 41.7014 ],
            [ -84.7964, 41.7597 ],
            [ -85.0995, 41.7599 ],
            [ -85.4026, 41.76 ],
            [ -85.7057, 41.7601 ],
            [ -86.0088, 41.7602 ],
            [ -86.3119, 41.7604 ],
            [ -86.615, 41.7605 ],
            [ -86.8626, 41.7606 ],
            [ -86.7982, 41.7885 ],
            [ -86.6916, 41.8534 ],
            [ -86.6325, 41.9113 ],
            [ -86.5753, 41.9877 ],
            [ -86.5202, 42.0823 ],
            [ -86.4074, 42.2237 ],
            [ -86.3525, 42.3093 ],
            [ -86.2996, 42.4176 ],
            [ -86.2596, 42.5312 ],
            [ -86.2327, 42.65 ],
            [ -86.22, 42.7731 ],
            [ -86.2215, 42.9004 ],
            [ -86.2485, 43.0288 ],
            [ -86.3009, 43.1581 ],
            [ -86.3292, 43.2241 ],
            [ -86.3402, 43.2417 ],
            [ -86.435, 43.4071 ],
            [ -86.5421, 43.6373 ],
            [ -86.5405, 43.6569 ],
            [ -86.4406, 43.7943 ],
            [ -86.438, 43.8127 ],
            [ -86.4486, 43.924 ],
            [ -86.4699, 43.9798 ],
            [ -86.5209, 44.0547 ],
            [ -86.5192, 44.0737 ],
            [ -86.4154, 44.1695 ],
            [ -86.3527, 44.2424 ],
            [ -86.2959, 44.3306 ],
            [ -86.2591, 44.4336 ],
            [ -86.2422, 44.5513 ],
            [ -86.2427, 44.6297 ],
            [ -86.2607, 44.6688 ],
            [ -86.2587, 44.699 ],
            [ -86.237, 44.7202 ],
            [ -86.1258, 44.7478 ],
            [ -86.0884, 44.7942 ],
            [ -86.0805, 44.8759 ],
            [ -86.0577, 44.9164 ],
            [ -86.0199, 44.9157 ],
            [ -85.985, 44.9325 ],
            [ -85.9529, 44.9667 ],
            [ -85.9105, 44.9763 ],
            [ -85.8578, 44.9615 ],
            [ -85.7841, 45.0122 ],
            [ -85.6894, 45.1281 ],
            [ -85.6166, 45.1929 ],
            [ -85.5659, 45.2065 ],
            [ -85.5562, 45.196 ],
            [ -85.5877, 45.1613 ],
            [ -85.5974, 45.1233 ],
            [ -85.5853, 45.082 ],
            [ -85.5957, 45.0419 ],
            [ -85.6192, 44.9871 ],
            [ -85.6047, 44.9699 ],
            [ -85.6453, 44.8816 ],
            [ -85.6472, 44.8375 ],
            [ -85.6225, 44.804 ],
            [ -85.5933, 44.8157 ],
            [ -85.5593, 44.8727 ],
            [ -85.5492, 44.903 ],
            [ -85.5628, 44.9067 ],
            [ -85.5578, 44.931 ],
            [ -85.5339, 44.9756 ],
            [ -85.5126, 44.9968 ],
            [ -85.4941, 44.9944 ],
            [ -85.4889, 44.9701 ],
            [ -85.4971, 44.9238 ],
            [ -85.5509, 44.8146 ],
            [ -85.5615, 44.7813 ],
            [ -85.5494, 44.7719 ],
            [ -85.4847, 44.8403 ],
            [ -85.4304, 44.9493 ],
            [ -85.389, 45.0328 ],
            [ -85.3816, 45.0783 ],
            [ -85.394, 45.1957 ],
            [ -85.3915, 45.2438 ],
            [ -85.3757, 45.277 ],
            [ -85.3195, 45.3145 ],
            [ -85.2229, 45.3562 ],
            [ -85.1273, 45.3785 ],
            [ -85.033, 45.3812 ],
            [ -84.9671, 45.3927 ],
            [ -84.9298, 45.4126 ],
            [ -84.9429, 45.4286 ],
            [ -85.0064, 45.4405 ],
            [ -85.0547, 45.4667 ],
            [ -85.0877, 45.5069 ],
            [ -85.0987, 45.5531 ],
            [ -85.0878, 45.6053 ],
            [ -85.0474, 45.6564 ],
            [ -84.9775, 45.7065 ],
            [ -84.9555, 45.7434 ],
            [ -84.9814, 45.767 ],
            [ -84.9515, 45.7754 ],
            [ -84.8659, 45.7686 ],
            [ -84.806, 45.775 ],
            [ -84.772, 45.7948 ],
            [ -84.6909, 45.7738 ]
          ],
          [
            [ -84.5572, 45.8205 ],
            [ -84.429, 45.8065 ],
            [ -84.4167, 45.8143 ],
            [ -84.3803, 45.7877 ],
            [ -84.3748, 45.7654 ],
            [ -84.3901, 45.7466 ],
            [ -84.4123, 45.7363 ],
            [ -84.4412, 45.7345 ],
            [ -84.4875, 45.7535 ],
            [ -84.5631, 45.8039 ],
            [ -84.5572, 45.8205 ]
          ],
          [
            [ -83.5035, 46.0131 ],
            [ -83.4937, 45.9908 ],
            [ -83.518, 45.9579 ],
            [ -83.5883, 45.9411 ],
            [ -83.7308, 45.943 ],
            [ -83.8232, 45.9557 ],
            [ -83.8657, 45.9791 ],
            [ -83.8751, 45.9913 ],
            [ -83.8711, 46.0174 ],
            [ -83.8506, 46.0191 ],
            [ -83.8203, 46.005 ],
            [ -83.775, 46.0111 ],
            [ -83.7148, 46.0375 ],
            [ -83.6833, 46.0572 ],
            [ -83.6802, 46.0704 ],
            [ -83.6994, 46.0956 ],
            [ -83.6839, 46.1062 ],
            [ -83.6082, 46.0966 ],
            [ -83.5801, 46.0801 ],
            [ -83.529, 46.0236 ],
            [ -83.5035, 46.0131 ]
          ],
          [
            [ -84.1207, 46.2459 ],
            [ -84.1349, 46.2404 ],
            [ -84.1849, 46.2794 ],
            [ -84.1955, 46.3034 ],
            [ -84.1881, 46.3235 ],
            [ -84.1688, 46.3245 ],
            [ -84.1373, 46.3063 ],
            [ -84.1196, 46.285 ],
            [ -84.1156, 46.2608 ],
            [ -84.1207, 46.2459 ]
          ],
          [
            [ -84.1328, 46.3622 ],
            [ -84.1327, 46.3407 ],
            [ -84.1634, 46.3456 ],
            [ -84.189, 46.3601 ],
            [ -84.2095, 46.3843 ],
            [ -84.2351, 46.4445 ],
            [ -84.2742, 46.4875 ],
            [ -84.2155, 46.5361 ],
            [ -84.1803, 46.5418 ],
            [ -84.1424, 46.5309 ],
            [ -84.1374, 46.5026 ],
            [ -84.1651, 46.4568 ],
            [ -84.1636, 46.41 ],
            [ -84.1328, 46.3622 ]
          ],
          [
            [ -88.4627, 46.8142 ],
            [ -88.4491, 46.8015 ],
            [ -88.4273, 46.8139 ],
            [ -88.4, 46.8409 ],
            [ -88.3899, 46.8574 ],
            [ -88.383, 46.8743 ],
            [ -88.2163, 46.9516 ],
            [ -88.1837, 46.9553 ],
            [ -88.1292, 46.9355 ],
            [ -87.8771, 46.9077 ],
            [ -87.7776, 46.8879 ],
            [ -87.6729, 46.8436 ],
            [ -87.6375, 46.8265 ],
            [ -87.5095, 46.6834 ],
            [ -87.4512, 46.6274 ],
            [ -87.4149, 46.6121 ],
            [ -87.3945, 46.5901 ],
            [ -87.3778, 46.5396 ],
            [ -87.3581, 46.5244 ],
            [ -87.1707, 46.5135 ],
            [ -87.0857, 46.5227 ],
            [ -87.0341, 46.5432 ],
            [ -86.9768, 46.5301 ],
            [ -86.9136, 46.4833 ],
            [ -86.8515, 46.4702 ],
            [ -86.7904, 46.4908 ],
            [ -86.7329, 46.4901 ],
            [ -86.6791, 46.4682 ],
            [ -86.6539, 46.4522 ],
            [ -86.6375, 46.453 ],
            [ -86.531, 46.5244 ],
            [ -86.4027, 46.5877 ],
            [ -86.2313, 46.6563 ],
            [ -86.132, 46.6868 ],
            [ -86.1046, 46.6792 ],
            [ -85.9468, 46.7021 ],
            [ -85.8045, 46.7042 ],
            [ -85.6161, 46.6906 ],
            [ -85.4415, 46.7066 ],
            [ -85.2807, 46.7524 ],
            [ -85.1384, 46.778 ],
            [ -85.0146, 46.7835 ],
            [ -84.9679, 46.7707 ],
            [ -84.9982, 46.7397 ],
            [ -85.0145, 46.6865 ],
            [ -85.0167, 46.6109 ],
            [ -85.0274, 46.5631 ],
            [ -85.0463, 46.543 ],
            [ -85.0486, 46.5239 ],
            [ -85.0343, 46.5058 ],
            [ -84.9143, 46.494 ],
            [ -84.8512, 46.4695 ],
            [ -84.7788, 46.4684 ],
            [ -84.6973, 46.4907 ],
            [ -84.6349, 46.4823 ],
            [ -84.5915, 46.4431 ],
            [ -84.5284, 46.4361 ],
            [ -84.4672, 46.4642 ],
            [ -84.4242, 46.4907 ],
            [ -84.387, 46.5022 ],
            [ -84.358, 46.5047 ],
            [ -84.3274, 46.4915 ],
            [ -84.3067, 46.4691 ],
            [ -84.2548, 46.4076 ],
            [ -84.2291, 46.3658 ],
            [ -84.2133, 46.3038 ],
            [ -84.2022, 46.2832 ],
            [ -84.2037, 46.247 ],
            [ -84.2385, 46.2225 ],
            [ -84.2479, 46.203 ],
            [ -84.2271, 46.1836 ],
            [ -84.1088, 46.1782 ],
            [ -84.0549, 46.1589 ],
            [ -84.0347, 46.1374 ],
            [ -84.0484, 46.1135 ],
            [ -84.0408, 46.0882 ],
            [ -84.012, 46.0614 ],
            [ -83.9174, 46.0207 ],
            [ -83.8941, 46.0013 ],
            [ -83.901, 45.9809 ],
            [ -83.9292, 45.9676 ],
            [ -83.9788, 45.9615 ],
            [ -84.3409, 45.9998 ],
            [ -84.4473, 46.0062 ],
            [ -84.4629, 45.9921 ],
            [ -84.4731, 45.99 ],
            [ -84.4903, 45.9938 ],
            [ -84.5213, 45.9946 ],
            [ -84.5369, 46.0037 ],
            [ -84.5499, 46.0292 ],
            [ -84.5815, 46.0456 ],
            [ -84.6315, 46.0526 ],
            [ -84.6747, 46.0333 ],
            [ -84.7249, 45.9575 ],
            [ -84.7171, 45.9435 ],
            [ -84.7254, 45.8949 ],
            [ -84.7127, 45.8816 ],
            [ -84.7133, 45.8705 ],
            [ -84.7274, 45.8615 ],
            [ -84.7569, 45.8628 ],
            [ -84.8019, 45.8744 ],
            [ -84.9718, 45.989 ],
            [ -85.1006, 46.0462 ],
            [ -85.2599, 46.0882 ],
            [ -85.3859, 46.1086 ],
            [ -85.4788, 46.1076 ],
            [ -85.5551, 46.0782 ],
            [ -85.6148, 46.0205 ],
            [ -85.7078, 45.9876 ],
            [ -85.8342, 45.9797 ],
            [ -85.9029, 45.9642 ],
            [ -85.9137, 45.9412 ],
            [ -85.9593, 45.9407 ],
            [ -86.0397, 45.9627 ],
            [ -86.1229, 45.9689 ],
            [ -86.2089, 45.9593 ],
            [ -86.2718, 45.9367 ],
            [ -86.3381, 45.8657 ],
            [ -86.3513, 45.831 ],
            [ -86.3996, 45.8007 ],
            [ -86.5275, 45.7532 ],
            [ -86.5339, 45.7356 ],
            [ -86.6012, 45.6816 ],
            [ -86.6224, 45.652 ],
            [ -86.622, 45.6228 ],
            [ -86.6444, 45.6245 ],
            [ -86.6897, 45.6573 ],
            [ -86.6914, 45.7014 ],
            [ -86.6495, 45.7568 ],
            [ -86.6123, 45.7836 ],
            [ -86.5795, 45.7818 ],
            [ -86.5593, 45.8063 ],
            [ -86.5515, 45.8571 ],
            [ -86.5633, 45.8825 ],
            [ -86.6272, 45.8725 ],
            [ -86.6606, 45.8523 ],
            [ -86.7028, 45.8479 ],
            [ -86.7536, 45.8595 ],
            [ -86.7985, 45.8318 ],
            [ -86.8375, 45.7648 ],
            [ -86.8839, 45.7209 ],
            [ -86.9379, 45.7002 ],
            [ -86.9742, 45.7231 ],
            [ -86.9928, 45.7896 ],
            [ -86.9929, 45.8419 ],
            [ -86.9711, 45.905 ],
            [ -86.9823, 45.9173 ],
            [ -87.005, 45.8972 ],
            [ -87.0393, 45.8446 ],
            [ -87.0849, 45.7298 ],
            [ -87.1142, 45.6925 ],
            [ -87.1538, 45.6768 ],
            [ -87.2164, 45.6073 ],
            [ -87.3021, 45.4841 ],
            [ -87.3988, 45.3646 ],
            [ -87.5065, 45.2489 ],
            [ -87.5712, 45.1866 ],
            [ -87.5928, 45.1778 ],
            [ -87.6022, 45.157 ],
            [ -87.6058, 45.1086 ],
            [ -87.6536, 45.1218 ],
            [ -87.6942, 45.1611 ],
            [ -87.7189, 45.2013 ],
            [ -87.7209, 45.2428 ],
            [ -87.6627, 45.3452 ],
            [ -87.6576, 45.3618 ],
            [ -87.6642, 45.3713 ],
            [ -87.6964, 45.3828 ],
            [ -87.7686, 45.3644 ],
            [ -87.8418, 45.3608 ],
            [ -87.8654, 45.3678 ],
            [ -87.8749, 45.3854 ],
            [ -87.874, 45.4128 ],
            [ -87.8591, 45.4455 ],
            [ -87.8152, 45.5058 ],
            [ -87.8147, 45.5632 ],
            [ -87.7946, 45.596 ],
            [ -87.8141, 45.657 ],
            [ -87.8091, 45.686 ],
            [ -87.8398, 45.718 ],
            [ -87.9225, 45.76 ],
            [ -88.1161, 45.8158 ],
            [ -88.0965, 45.8784 ],
            [ -88.1044, 45.9052 ],
            [ -88.1517, 45.9454 ],
            [ -88.3547, 45.9923 ],
            [ -88.493, 46.0135 ],
            [ -88.6295, 46.014 ],
            [ -88.7272, 46.0311 ],
            [ -88.8373, 46.0366 ],
            [ -88.9078, 46.0648 ],
            [ -88.9783, 46.0929 ],
            [ -89.0488, 46.1211 ],
            [ -89.1193, 46.1492 ],
            [ -89.2442, 46.1733 ],
            [ -89.3691, 46.1973 ],
            [ -89.494, 46.2214 ],
            [ -89.6189, 46.2454 ],
            [ -89.7438, 46.2695 ],
            [ -89.8688, 46.2936 ],
            [ -89.9936, 46.3176 ],
            [ -90.1186, 46.3417 ],
            [ -90.1465, 46.3837 ],
            [ -90.1745, 46.4257 ],
            [ -90.2024, 46.4678 ],
            [ -90.2304, 46.5098 ],
            [ -90.2879, 46.5274 ],
            [ -90.3182, 46.5366 ],
            [ -90.3409, 46.5584 ],
            [ -90.3923, 46.549 ],
            [ -90.4126, 46.5853 ],
            [ -90.4076, 46.5929 ],
            [ -90.3414, 46.6025 ],
            [ -90.1536, 46.6545 ],
            [ -89.9933, 46.7179 ],
            [ -89.8606, 46.7928 ],
            [ -89.6951, 46.8386 ],
            [ -89.4968, 46.8554 ],
            [ -89.355, 46.8819 ],
            [ -89.2694, 46.9182 ],
            [ -89.1548, 46.9886 ],
            [ -89.0902, 47.0093 ],
            [ -89.0091, 47.0157 ],
            [ -88.9481, 47.043 ],
            [ -88.9071, 47.0911 ],
            [ -88.8296, 47.1458 ],
            [ -88.7156, 47.2072 ],
            [ -88.6505, 47.232 ],
            [ -88.6341, 47.2203 ],
            [ -88.6282, 47.1986 ],
            [ -88.6327, 47.1669 ],
            [ -88.6044, 47.1413 ],
            [ -88.5433, 47.1216 ],
            [ -88.5154, 47.0955 ],
            [ -88.5208, 47.0631 ],
            [ -88.5044, 47.0354 ],
            [ -88.466, 47.0125 ],
            [ -88.4559, 46.9628 ],
            [ -88.4737, 46.8863 ],
            [ -88.4761, 46.8367 ],
            [ -88.4627, 46.8142 ]
          ],
          [
            [ -88.2219, 47.2106 ],
            [ -88.2404, 47.1783 ],
            [ -88.2368, 47.1589 ],
            [ -88.3582, 47.0734 ],
            [ -88.4022, 47.0193 ],
            [ -88.4391, 47.0107 ],
            [ -88.4687, 47.0476 ],
            [ -88.4685, 47.0772 ],
            [ -88.4384, 47.0996 ],
            [ -88.4091, 47.1314 ],
            [ -88.4054, 47.1755 ],
            [ -88.4167, 47.1915 ],
            [ -88.4538, 47.1519 ],
            [ -88.4332, 47.1434 ],
            [ -88.4271, 47.1366 ],
            [ -88.4341, 47.1223 ],
            [ -88.5737, 47.1433 ],
            [ -88.6157, 47.1742 ],
            [ -88.6089, 47.2172 ],
            [ -88.562, 47.2722 ],
            [ -88.3943, 47.3887 ],
            [ -88.3203, 47.4211 ],
            [ -88.1102, 47.4725 ],
            [ -87.9943, 47.4842 ],
            [ -87.8779, 47.4842 ],
            [ -87.7935, 47.4673 ],
            [ -87.741, 47.4336 ],
            [ -87.7905, 47.4114 ],
            [ -88.0207, 47.3924 ],
            [ -88.027, 47.3863 ],
            [ -87.9831, 47.3679 ],
            [ -87.9749, 47.3549 ],
            [ -88.0155, 47.3208 ],
            [ -88.2219, 47.2106 ]
          ],
          [
            [ -88.9552, 47.926 ],
            [ -88.9601, 47.9095 ],
            [ -88.9237, 47.9045 ],
            [ -88.9304, 47.8962 ],
            [ -88.9699, 47.8813 ],
            [ -89.0816, 47.8506 ],
            [ -89.1568, 47.8408 ],
            [ -89.1952, 47.8518 ],
            [ -89.1992, 47.8723 ],
            [ -89.1688, 47.9021 ],
            [ -89.1691, 47.9171 ],
            [ -89.2001, 47.9171 ],
            [ -89.1926, 47.929 ],
            [ -89.1466, 47.9526 ],
            [ -88.7555, 48.1035 ],
            [ -88.5883, 48.1585 ],
            [ -88.4992, 48.1759 ],
            [ -88.4849, 48.1674 ],
            [ -88.5813, 48.1107 ],
            [ -88.5968, 48.0875 ],
            [ -88.5931, 48.072 ],
            [ -88.6248, 48.042 ],
            [ -88.911, 47.9362 ],
            [ -88.9552, 47.926 ]
          ]
        ]
      },
      "properties": {
        "featurecla": "Admin-1 scale rank",
        "scalerank": 2,
        "adm1_code": "USA-3562",
        "diss_me": 3562,
        "adm1_cod_1": "USA-3562",
        "iso_3166_2": "US-MI",
        "wikipedia": "http://en.wikipedia.org/wiki/Michigan",
        "sr_sov_a3": "US1",
        "sr_adm0_a3": "USA",
        "iso_a2": "US",
        "adm0_sr": 1,
        "admin0_lab": 2,
        "name": "Michigan",
        "name_alt": "MI|Mich.",
        "name_local": "",
        "type": "State",
        "type_en": "State",
        "code_local": "US26",
        "code_hasc": "US.MI",
        "note": "",
        "hasc_maybe": "",
        "region": "Midwest",
        "region_cod": "",
        "region_big": "East North Central",
        "big_code": "",
        "provnum_ne": 0,
        "gadm_level": 1,
        "check_me": 0,
        "scaleran_1": 2,
        "datarank": 1,
        "abbrev": "Mich.",
        "postal": "MI",
        "area_sqkm": 0,
        "sameascity": -99,
        "labelrank": 0,
        "featurec_1": "Admin-1 scale rank",
        "admin": "United States of America",
        "name_len": 8,
        "mapcolor9": 1,
        "mapcolor13": 1
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [ -89.5775, 48.0018 ],
            [ -89.6047, 47.9917 ],
            [ -89.6338, 47.9937 ],
            [ -89.6721, 47.9787 ],
            [ -89.7195, 47.9467 ],
            [ -89.8288, 47.9009 ],
            [ -89.9999, 47.8412 ],
            [ -90.1973, 47.7864 ],
            [ -90.5975, 47.6877 ],
            [ -90.8467, 47.5853 ],
            [ -90.9571, 47.5237 ],
            [ -91.3863, 47.2147 ],
            [ -91.6452, 47.05 ],
            [ -92.0646, 46.8188 ],
            [ -92.1042, 46.7894 ],
            [ -92.107, 46.7624 ],
            [ -92.1253, 46.763 ],
            [ -92.1945, 46.707 ],
            [ -92.224, 46.671 ],
            [ -92.2916, 46.6607 ],
            [ -92.2919, 46.5166 ],
            [ -92.2921, 46.3725 ],
            [ -92.2924, 46.2285 ],
            [ -92.2926, 46.0844 ],
            [ -92.3255, 46.0696 ],
            [ -92.3673, 46.036 ],
            [ -92.4246, 46.0278 ],
            [ -92.6939, 45.909 ],
            [ -92.7381, 45.8747 ],
            [ -92.7864, 45.7955 ],
            [ -92.8747, 45.7061 ],
            [ -92.8965, 45.6586 ],
            [ -92.8925, 45.5948 ],
            [ -92.7575, 45.5432 ],
            [ -92.707, 45.4938 ],
            [ -92.6826, 45.4331 ],
            [ -92.6858, 45.3805 ],
            [ -92.7539, 45.2776 ],
            [ -92.7661, 45.2365 ],
            [ -92.7591, 45.1106 ],
            [ -92.793, 45.0714 ],
            [ -92.7652, 44.9694 ],
            [ -92.7634, 44.9343 ],
            [ -92.7847, 44.8226 ],
            [ -92.7992, 44.79 ],
            [ -92.7726, 44.732 ],
            [ -92.7698, 44.7258 ],
            [ -92.6435, 44.6453 ],
            [ -92.537, 44.6008 ],
            [ -92.4416, 44.5866 ],
            [ -92.3669, 44.5523 ],
            [ -92.3131, 44.4978 ],
            [ -92.2403, 44.4621 ],
            [ -92.1486, 44.4452 ],
            [ -92.0551, 44.3998 ],
            [ -91.9123, 44.2889 ],
            [ -91.841, 44.1942 ],
            [ -91.7164, 44.1265 ],
            [ -91.5148, 44.0542 ],
            [ -91.3827, 43.9908 ],
            [ -91.3199, 43.9363 ],
            [ -91.2784, 43.7974 ],
            [ -91.2453, 43.5024 ],
            [ -91.5754, 43.5019 ],
            [ -91.9006, 43.5019 ],
            [ -92.2258, 43.5018 ],
            [ -92.5511, 43.5018 ],
            [ -92.8763, 43.5017 ],
            [ -93.2015, 43.5017 ],
            [ -93.5267, 43.5016 ],
            [ -93.8519, 43.5016 ],
            [ -94.1771, 43.5015 ],
            [ -94.5023, 43.5015 ],
            [ -94.8276, 43.5014 ],
            [ -95.1528, 43.5014 ],
            [ -95.478, 43.5013 ],
            [ -95.8032, 43.5013 ],
            [ -96.1284, 43.5012 ],
            [ -96.4536, 43.5012 ],
            [ -96.4536, 43.7257 ],
            [ -96.4536, 43.9502 ],
            [ -96.4536, 44.1747 ],
            [ -96.4536, 44.3993 ],
            [ -96.4537, 44.6238 ],
            [ -96.4537, 44.8483 ],
            [ -96.4537, 45.0728 ],
            [ -96.4537, 45.2973 ],
            [ -96.5298, 45.3715 ],
            [ -96.6961, 45.4318 ],
            [ -96.7375, 45.4678 ],
            [ -96.8149, 45.5574 ],
            [ -96.8455, 45.5959 ],
            [ -96.8511, 45.626 ],
            [ -96.8136, 45.6592 ],
            [ -96.6627, 45.7557 ],
            [ -96.6147, 45.8 ],
            [ -96.5911, 45.8433 ],
            [ -96.5564, 45.9428 ],
            [ -96.5705, 46.0192 ],
            [ -96.5608, 46.1382 ],
            [ -96.5919, 46.2275 ],
            [ -96.5986, 46.2719 ],
            [ -96.6174, 46.3271 ],
            [ -96.7309, 46.4728 ],
            [ -96.7582, 46.5903 ],
            [ -96.7866, 46.6482 ],
            [ -96.796, 46.7971 ],
            [ -96.7928, 46.839 ],
            [ -96.7701, 46.9197 ],
            [ -96.8183, 46.9741 ],
            [ -96.8253, 47.0189 ],
            [ -96.8475, 47.3733 ],
            [ -96.8629, 47.4239 ],
            [ -96.8587, 47.5883 ],
            [ -96.9463, 47.7615 ],
            [ -96.988, 47.8203 ],
            [ -97.009, 47.8915 ],
            [ -97.0074, 47.9256 ],
            [ -97.0785, 48.0434 ],
            [ -97.1259, 48.1734 ],
            [ -97.1216, 48.286 ],
            [ -97.1368, 48.3712 ],
            [ -97.131, 48.4374 ],
            [ -97.144, 48.5368 ],
            [ -97.1291, 48.5934 ],
            [ -97.128, 48.6811 ],
            [ -97.2257, 48.9932 ],
            [ -97.1034, 48.9932 ],
            [ -96.6771, 48.9932 ],
            [ -96.2507, 48.9932 ],
            [ -95.8243, 48.9932 ],
            [ -95.3979, 48.9932 ],
            [ -95.162, 48.9918 ],
            [ -95.1582, 49.2031 ],
            [ -95.1553, 49.3697 ],
            [ -94.9393, 49.3494 ],
            [ -94.8748, 49.319 ],
            [ -94.8543, 49.3046 ],
            [ -94.8604, 49.2586 ],
            [ -94.8426, 49.1192 ],
            [ -94.8035, 49.0029 ],
            [ -94.7128, 48.8634 ],
            [ -94.7126, 48.863 ],
            [ -94.7051, 48.8085 ],
            [ -94.6754, 48.7744 ],
            [ -94.6209, 48.7426 ],
            [ -94.4142, 48.7041 ],
            [ -94.0552, 48.659 ],
            [ -93.8516, 48.6073 ],
            [ -93.8035, 48.5489 ],
            [ -93.7077, 48.5255 ],
            [ -93.5643, 48.5369 ],
            [ -93.4636, 48.5613 ],
            [ -93.3779, 48.6165 ],
            [ -93.2579, 48.6289 ],
            [ -93.1552, 48.6253 ],
            [ -93.0517, 48.6199 ],
            [ -92.9963, 48.6118 ],
            [ -92.8367, 48.5678 ],
            [ -92.7327, 48.5318 ],
            [ -92.5833, 48.4651 ],
            [ -92.5006, 48.4353 ],
            [ -92.4609, 48.3659 ],
            [ -92.4146, 48.2766 ],
            [ -92.3484, 48.2766 ],
            [ -92.2987, 48.3289 ],
            [ -92.1718, 48.3384 ],
            [ -92.0052, 48.3018 ],
            [ -91.8584, 48.1976 ],
            [ -91.6473, 48.1046 ],
            [ -91.5183, 48.0583 ],
            [ -91.3872, 48.0585 ],
            [ -91.2207, 48.1046 ],
            [ -91.0435, 48.1937 ],
            [ -90.916, 48.2092 ],
            [ -90.8403, 48.2005 ],
            [ -90.7973, 48.1311 ],
            [ -90.7444, 48.1046 ],
            [ -90.6071, 48.1126 ],
            [ -90.3201, 48.0992 ],
            [ -90.0918, 48.1181 ],
            [ -90.0399, 48.0782 ],
            [ -89.9936, 48.0153 ],
            [ -89.901, 47.9955 ],
            [ -89.7754, 48.0153 ],
            [ -89.5775, 48.0018 ]
          ]
        ]
      },
      "properties": {
        "featurecla": "Admin-1 scale rank",
        "scalerank": 2,
        "adm1_code": "USA-3514",
        "diss_me": 3514,
        "adm1_cod_1": "USA-3514",
        "iso_3166_2": "US-MN",
        "wikipedia": "http://en.wikipedia.org/wiki/Minnesota",
        "sr_sov_a3": "US1",
        "sr_adm0_a3": "USA",
        "iso_a2": "US",
        "adm0_sr": 1,
        "admin0_lab": 2,
        "name": "Minnesota",
        "name_alt": "MN|Minn.",
        "name_local": "",
        "type": "State",
        "type_en": "State",
        "code_local": "US32",
        "code_hasc": "US.MN",
        "note": "",
        "hasc_maybe": "",
        "region": "Midwest",
        "region_cod": "",
        "region_big": "West North Central",
        "big_code": "",
        "provnum_ne": 0,
        "gadm_level": 1,
        "check_me": 10,
        "scaleran_1": 2,
        "datarank": 1,
        "abbrev": "Minn.",
        "postal": "MN",
        "area_sqkm": 0,
        "sameascity": -99,
        "labelrank": 0,
        "featurec_1": "Admin-1 scale rank",
        "admin": "United States of America",
        "name_len": 9,
        "mapcolor9": 1,
        "mapcolor13": 1
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [ -91.442, 40.3794 ],
            [ -91.4998, 40.226 ],
            [ -91.5017, 40.0975 ],
            [ -91.4668, 39.9429 ],
            [ -91.4259, 39.8268 ],
            [ -91.3787, 39.7494 ],
            [ -91.2099, 39.6028 ],
            [ -90.9194, 39.3869 ],
            [ -90.7372, 39.1818 ],
            [ -90.6635, 38.9875 ],
            [ -90.5771, 38.9096 ],
            [ -90.478, 38.9481 ],
            [ -90.3543, 38.9302 ],
            [ -90.2201, 38.8977 ],
            [ -90.1499, 38.8599 ],
            [ -90.1342, 38.8467 ],
            [ -90.1268, 38.8326 ],
            [ -90.1322, 38.8186 ],
            [ -90.1508, 38.7805 ],
            [ -90.3166, 38.4578 ],
            [ -90.374, 38.3098 ],
            [ -90.3658, 38.2543 ],
            [ -90.299, 38.174 ],
            [ -90.1736, 38.069 ],
            [ -90.0639, 38.0005 ],
            [ -89.9698, 37.9685 ],
            [ -89.823, 37.8841 ],
            [ -89.6233, 37.7473 ],
            [ -89.5234, 37.6445 ],
            [ -89.5234, 37.5759 ],
            [ -89.5029, 37.5058 ],
            [ -89.462, 37.4341 ],
            [ -89.462, 37.3657 ],
            [ -89.5029, 37.3005 ],
            [ -89.4869, 37.2127 ],
            [ -89.4139, 37.1024 ],
            [ -89.3519, 37.0355 ],
            [ -89.3008, 37.0121 ],
            [ -89.29, 37.0128 ],
            [ -89.2859, 37.0227 ],
            [ -89.2932, 37.0382 ],
            [ -89.2958, 37.0516 ],
            [ -89.2917, 37.0707 ],
            [ -89.2815, 37.0778 ],
            [ -89.2724, 37.08 ],
            [ -89.2249, 37.0527 ],
            [ -89.1543, 36.9921 ],
            [ -89.1225, 36.9116 ],
            [ -89.1295, 36.8111 ],
            [ -89.1563, 36.7157 ],
            [ -89.203, 36.6255 ],
            [ -89.2561, 36.5944 ],
            [ -89.2801, 36.6 ],
            [ -89.3305, 36.6159 ],
            [ -89.3513, 36.6112 ],
            [ -89.3975, 36.5878 ],
            [ -89.4503, 36.5 ],
            [ -89.4518, 36.4975 ],
            [ -89.4715, 36.4889 ],
            [ -89.4854, 36.4981 ],
            [ -89.4872, 36.5031 ],
            [ -89.4968, 36.5288 ],
            [ -89.5195, 36.5548 ],
            [ -89.5356, 36.5553 ],
            [ -89.5496, 36.5531 ],
            [ -89.5555, 36.5408 ],
            [ -89.56, 36.5131 ],
            [ -89.5573, 36.5011 ],
            [ -89.5406, 36.4267 ],
            [ -89.5553, 36.3729 ],
            [ -89.6041, 36.3519 ],
            [ -89.6117, 36.322 ],
            [ -89.5835, 36.2877 ],
            [ -89.5835, 36.2722 ],
            [ -89.5946, 36.2594 ],
            [ -89.628, 36.2553 ],
            [ -89.6541, 36.248 ],
            [ -89.6745, 36.2206 ],
            [ -89.6341, 36.1679 ],
            [ -89.6419, 36.1045 ],
            [ -89.6977, 36.0303 ],
            [ -89.7048, 36.0016 ],
            [ -89.8882, 35.9993 ],
            [ -90.0525, 35.9971 ],
            [ -90.2168, 35.9949 ],
            [ -90.3811, 35.9927 ],
            [ -90.303, 36.0994 ],
            [ -90.2526, 36.1377 ],
            [ -90.2162, 36.1784 ],
            [ -90.1493, 36.2159 ],
            [ -90.0757, 36.2967 ],
            [ -90.0671, 36.3343 ],
            [ -90.0745, 36.3718 ],
            [ -90.1181, 36.4225 ],
            [ -90.1622, 36.5009 ],
            [ -90.4407, 36.5009 ],
            [ -90.7192, 36.5009 ],
            [ -90.9978, 36.5009 ],
            [ -91.2763, 36.5009 ],
            [ -91.5548, 36.5009 ],
            [ -91.8333, 36.5009 ],
            [ -92.1118, 36.5009 ],
            [ -92.3903, 36.5009 ],
            [ -92.6688, 36.5009 ],
            [ -92.9473, 36.5009 ],
            [ -93.2258, 36.5009 ],
            [ -93.5043, 36.5009 ],
            [ -93.7828, 36.5009 ],
            [ -94.0614, 36.5009 ],
            [ -94.3399, 36.5009 ],
            [ -94.6184, 36.5009 ],
            [ -94.6183, 36.6259 ],
            [ -94.6182, 36.7509 ],
            [ -94.6181, 36.8758 ],
            [ -94.6181, 37.0008 ],
            [ -94.6185, 37.1312 ],
            [ -94.6189, 37.2615 ],
            [ -94.6193, 37.3918 ],
            [ -94.6197, 37.5222 ],
            [ -94.6201, 37.6525 ],
            [ -94.6205, 37.7828 ],
            [ -94.6209, 37.9131 ],
            [ -94.6213, 38.0435 ],
            [ -94.6217, 38.1738 ],
            [ -94.6221, 38.3041 ],
            [ -94.6225, 38.4345 ],
            [ -94.6229, 38.5648 ],
            [ -94.6233, 38.6951 ],
            [ -94.6237, 38.8254 ],
            [ -94.6241, 38.9558 ],
            [ -94.6245, 39.0861 ],
            [ -94.6224, 39.1244 ],
            [ -94.7779, 39.194 ],
            [ -94.8472, 39.2592 ],
            [ -94.8823, 39.3431 ],
            [ -94.9525, 39.4264 ],
            [ -95.0579, 39.509 ],
            [ -95.0754, 39.5974 ],
            [ -95.0048, 39.6916 ],
            [ -94.9458, 39.7395 ],
            [ -94.8986, 39.7411 ],
            [ -94.8933, 39.7818 ],
            [ -94.9299, 39.8615 ],
            [ -94.984, 39.8912 ],
            [ -95.0555, 39.8708 ],
            [ -95.1162, 39.8721 ],
            [ -95.3467, 40.0015 ],
            [ -95.3625, 40.0103 ],
            [ -95.4343, 40.096 ],
            [ -95.4637, 40.1981 ],
            [ -95.5212, 40.2646 ],
            [ -95.6071, 40.2955 ],
            [ -95.6616, 40.3628 ],
            [ -95.6847, 40.4664 ],
            [ -95.7396, 40.5709 ],
            [ -95.765, 40.6019 ],
            [ -95.5154, 40.6029 ],
            [ -95.2631, 40.6044 ],
            [ -95.0109, 40.6058 ],
            [ -94.7586, 40.6073 ],
            [ -94.5064, 40.6087 ],
            [ -94.2541, 40.6102 ],
            [ -94.0019, 40.6116 ],
            [ -93.7496, 40.6131 ],
            [ -93.4973, 40.6145 ],
            [ -93.2451, 40.616 ],
            [ -92.9928, 40.6174 ],
            [ -92.7406, 40.6189 ],
            [ -92.4883, 40.6203 ],
            [ -92.236, 40.6218 ],
            [ -91.9838, 40.6232 ],
            [ -91.7315, 40.6247 ],
            [ -91.682, 40.5519 ],
            [ -91.6274, 40.5308 ],
            [ -91.6169, 40.5069 ],
            [ -91.5455, 40.4693 ],
            [ -91.5299, 40.4323 ],
            [ -91.442, 40.3794 ]
          ]
        ]
      },
      "properties": {
        "featurecla": "Admin-1 scale rank",
        "scalerank": 2,
        "adm1_code": "USA-3531",
        "diss_me": 3531,
        "adm1_cod_1": "USA-3531",
        "iso_3166_2": "US-MO",
        "wikipedia": "http://en.wikipedia.org/wiki/Missouri",
        "sr_sov_a3": "US1",
        "sr_adm0_a3": "USA",
        "iso_a2": "US",
        "adm0_sr": 1,
        "admin0_lab": 2,
        "name": "Missouri",
        "name_alt": "MO",
        "name_local": "",
        "type": "State",
        "type_en": "State",
        "code_local": "US29",
        "code_hasc": "US.MO",
        "note": "",
        "hasc_maybe": "US.IL|USA-MOS",
        "region": "Midwest",
        "region_cod": "",
        "region_big": "West North Central",
        "big_code": "",
        "provnum_ne": 0,
        "gadm_level": 1,
        "check_me": 10,
        "scaleran_1": 2,
        "datarank": 1,
        "abbrev": "Mo.",
        "postal": "MO",
        "area_sqkm": 0,
        "sameascity": -99,
        "labelrank": 0,
        "featurec_1": "Admin-1 scale rank",
        "admin": "United States of America",
        "name_len": 8,
        "mapcolor9": 1,
        "mapcolor13": 1
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [ -88.5581, 30.2159 ],
            [ -88.5707, 30.2048 ],
            [ -88.6592, 30.2256 ],
            [ -88.7131, 30.2449 ],
            [ -88.7228, 30.2642 ],
            [ -88.574, 30.2292 ],
            [ -88.5581, 30.2159 ]
          ],
          [
            [ -88.4442, 31.1397 ],
            [ -88.4337, 30.952 ],
            [ -88.4233, 30.7643 ],
            [ -88.4128, 30.5766 ],
            [ -88.3996, 30.3708 ],
            [ -88.6921, 30.3554 ],
            [ -88.8199, 30.4065 ],
            [ -88.8729, 30.4163 ],
            [ -88.9052, 30.4151 ],
            [ -89.054, 30.3682 ],
            [ -89.2236, 30.3324 ],
            [ -89.2636, 30.3436 ],
            [ -89.3205, 30.3453 ],
            [ -89.4435, 30.2231 ],
            [ -89.5209, 30.1926 ],
            [ -89.5451, 30.2007 ],
            [ -89.5725, 30.2092 ],
            [ -89.5917, 30.223 ],
            [ -89.629, 30.2962 ],
            [ -89.6408, 30.3489 ],
            [ -89.6858, 30.4627 ],
            [ -89.7366, 30.5266 ],
            [ -89.794, 30.5689 ],
            [ -89.82, 30.6112 ],
            [ -89.8197, 30.6399 ],
            [ -89.8381, 30.6904 ],
            [ -89.8354, 30.7308 ],
            [ -89.7649, 30.8861 ],
            [ -89.7353, 31.0012 ],
            [ -89.9756, 31.0012 ],
            [ -90.2158, 31.0012 ],
            [ -90.4561, 31.0012 ],
            [ -90.6963, 31.0012 ],
            [ -90.9366, 31.0012 ],
            [ -91.1769, 31.0012 ],
            [ -91.4171, 31.0013 ],
            [ -91.6564, 31.0018 ],
            [ -91.6526, 31.0296 ],
            [ -91.611, 31.0649 ],
            [ -91.5964, 31.1099 ],
            [ -91.6308, 31.2176 ],
            [ -91.6182, 31.277 ],
            [ -91.5587, 31.2879 ],
            [ -91.529, 31.3452 ],
            [ -91.529, 31.4488 ],
            [ -91.5057, 31.5187 ],
            [ -91.4591, 31.555 ],
            [ -91.4147, 31.64 ],
            [ -91.3725, 31.7737 ],
            [ -91.2865, 31.884 ],
            [ -91.1565, 31.9707 ],
            [ -91.0925, 32.0458 ],
            [ -91.0887, 32.1041 ],
            [ -91.0746, 32.1313 ],
            [ -91.0482, 32.1459 ],
            [ -91.0046, 32.1856 ],
            [ -90.9477, 32.2401 ],
            [ -90.9376, 32.2773 ],
            [ -90.9404, 32.3031 ],
            [ -90.9447, 32.3307 ],
            [ -90.99, 32.3811 ],
            [ -91.0593, 32.4238 ],
            [ -91.1038, 32.4905 ],
            [ -91.1008, 32.5414 ],
            [ -91.1161, 32.5862 ],
            [ -91.1496, 32.625 ],
            [ -91.1424, 32.661 ],
            [ -91.0944, 32.6943 ],
            [ -91.0921, 32.7259 ],
            [ -91.1356, 32.7558 ],
            [ -91.1361, 32.8088 ],
            [ -91.0934, 32.885 ],
            [ -91.0961, 32.9377 ],
            [ -91.1442, 32.9669 ],
            [ -91.15, 33.0159 ],
            [ -91.1529, 33.0406 ],
            [ -91.1068, 33.2179 ],
            [ -91.1173, 33.2408 ],
            [ -91.1633, 33.2945 ],
            [ -91.1685, 33.3595 ],
            [ -91.141, 33.4385 ],
            [ -91.1543, 33.5002 ],
            [ -91.193, 33.5225 ],
            [ -91.2027, 33.547 ],
            [ -91.2146, 33.5834 ],
            [ -91.1727, 33.6167 ],
            [ -91.1704, 33.6475 ],
            [ -91.2075, 33.6757 ],
            [ -91.1841, 33.7157 ],
            [ -91.1003, 33.7674 ],
            [ -91.0772, 33.7967 ],
            [ -91.0527, 33.8276 ],
            [ -91.0382, 33.9014 ],
            [ -91.0501, 33.9452 ],
            [ -91.0702, 33.9742 ],
            [ -91.0604, 33.9893 ],
            [ -91.0431, 34.0029 ],
            [ -90.9431, 34.0297 ],
            [ -90.9147, 34.0486 ],
            [ -90.9088, 34.0716 ],
            [ -90.9403, 34.1286 ],
            [ -90.9097, 34.1888 ],
            [ -90.8172, 34.2522 ],
            [ -90.7681, 34.3081 ],
            [ -90.7623, 34.3564 ],
            [ -90.7181, 34.3917 ],
            [ -90.6354, 34.4139 ],
            [ -90.584, 34.5037 ],
            [ -90.5638, 34.6612 ],
            [ -90.5392, 34.7282 ],
            [ -90.4972, 34.7381 ],
            [ -90.4748, 34.7601 ],
            [ -90.4676, 34.8053 ],
            [ -90.4159, 34.8516 ],
            [ -90.3199, 34.8992 ],
            [ -90.2821, 34.9453 ],
            [ -90.2934, 34.9701 ],
            [ -90.2937, 35.0011 ],
            [ -90.0386, 35.0008 ],
            [ -89.773, 35.0006 ],
            [ -89.5073, 35.0003 ],
            [ -89.2417, 35 ],
            [ -88.9761, 34.9997 ],
            [ -88.7104, 34.9994 ],
            [ -88.4448, 34.9991 ],
            [ -88.1733, 34.999 ],
            [ -88.0848, 34.9331 ],
            [ -88.0882, 34.9091 ],
            [ -88.0895, 34.8931 ],
            [ -88.0956, 34.8462 ],
            [ -88.1201, 34.6615 ],
            [ -88.1445, 34.4767 ],
            [ -88.1689, 34.292 ],
            [ -88.1933, 34.1073 ],
            [ -88.2177, 33.9225 ],
            [ -88.2421, 33.7378 ],
            [ -88.2665, 33.5531 ],
            [ -88.2909, 33.3683 ],
            [ -88.3153, 33.1836 ],
            [ -88.3397, 32.9989 ],
            [ -88.3641, 32.8142 ],
            [ -88.3886, 32.6294 ],
            [ -88.413, 32.4447 ],
            [ -88.4374, 32.26 ],
            [ -88.4618, 32.0752 ],
            [ -88.4862, 31.8905 ],
            [ -88.4757, 31.7028 ],
            [ -88.4652, 31.5151 ],
            [ -88.4547, 31.3274 ],
            [ -88.4442, 31.1397 ]
          ]
        ]
      },
      "properties": {
        "featurecla": "Admin-1 scale rank",
        "scalerank": 2,
        "adm1_code": "USA-3544",
        "diss_me": 3544,
        "adm1_cod_1": "USA-3544",
        "iso_3166_2": "US-MS",
        "wikipedia": "http://en.wikipedia.org/wiki/Mississippi",
        "sr_sov_a3": "US1",
        "sr_adm0_a3": "USA",
        "iso_a2": "US",
        "adm0_sr": 5,
        "admin0_lab": 2,
        "name": "Mississippi",
        "name_alt": "MS|Miss.",
        "name_local": "",
        "type": "State",
        "type_en": "State",
        "code_local": "US28",
        "code_hasc": "US.MS",
        "note": "",
        "hasc_maybe": "",
        "region": "South",
        "region_cod": "",
        "region_big": "East South Central",
        "big_code": "",
        "provnum_ne": 0,
        "gadm_level": 1,
        "check_me": 0,
        "scaleran_1": 2,
        "datarank": 1,
        "abbrev": "Miss.",
        "postal": "MS",
        "area_sqkm": 0,
        "sameascity": -99,
        "labelrank": 0,
        "featurec_1": "Admin-1 scale rank",
        "admin": "United States of America",
        "name_len": 11,
        "mapcolor9": 1,
        "mapcolor13": 1
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [ -104.0111, 45.9431 ],
            [ -104.0095, 45.7106 ],
            [ -104.0079, 45.4783 ],
            [ -104.0064, 45.2459 ],
            [ -104.0048, 45.0135 ],
            [ -104.005, 45.0104 ],
            [ -104.0051, 45.0072 ],
            [ -104.0053, 45.0041 ],
            [ -104.0055, 45.001 ],
            [ -104.0134, 45.001 ],
            [ -104.0213, 45.0011 ],
            [ -104.0293, 45.0011 ],
            [ -104.0372, 45.0011 ],
            [ -104.2564, 45.0011 ],
            [ -104.4756, 45.0011 ],
            [ -104.6947, 45.0011 ],
            [ -104.9139, 45.0011 ],
            [ -105.1331, 45.0011 ],
            [ -105.3523, 45.0011 ],
            [ -105.5715, 45.0011 ],
            [ -105.7906, 45.0011 ],
            [ -106.0098, 45.0011 ],
            [ -106.229, 45.0011 ],
            [ -106.4482, 45.0011 ],
            [ -106.6673, 45.0011 ],
            [ -106.8865, 45.0011 ],
            [ -107.1057, 45.0011 ],
            [ -107.3249, 45.0011 ],
            [ -107.544, 45.0011 ],
            [ -107.7632, 45.0011 ],
            [ -107.9824, 45.0011 ],
            [ -108.2016, 45.0011 ],
            [ -108.4207, 45.0011 ],
            [ -108.6399, 45.0011 ],
            [ -108.8591, 45.0011 ],
            [ -109.0783, 45.0011 ],
            [ -109.2975, 45.0011 ],
            [ -109.5166, 45.0011 ],
            [ -109.7358, 45.0011 ],
            [ -109.955, 45.0011 ],
            [ -110.1742, 45.0011 ],
            [ -110.3933, 45.0011 ],
            [ -110.6125, 45.0011 ],
            [ -110.8317, 45.0011 ],
            [ -111.0509, 45.0011 ],
            [ -111.051, 44.8755 ],
            [ -111.0511, 44.75 ],
            [ -111.0513, 44.6245 ],
            [ -111.0514, 44.4989 ],
            [ -111.1172, 44.5253 ],
            [ -111.1609, 44.5558 ],
            [ -111.1976, 44.5906 ],
            [ -111.2651, 44.6876 ],
            [ -111.3041, 44.7233 ],
            [ -111.3375, 44.7448 ],
            [ -111.3725, 44.7462 ],
            [ -111.4156, 44.7336 ],
            [ -111.4481, 44.7111 ],
            [ -111.4591, 44.671 ],
            [ -111.491, 44.6242 ],
            [ -111.4888, 44.5845 ],
            [ -111.4745, 44.5646 ],
            [ -111.4793, 44.5537 ],
            [ -111.4999, 44.5449 ],
            [ -111.6593, 44.5596 ],
            [ -111.7971, 44.5399 ],
            [ -111.8921, 44.5549 ],
            [ -112.0742, 44.5476 ],
            [ -112.2313, 44.5607 ],
            [ -112.2851, 44.5539 ],
            [ -112.32, 44.5331 ],
            [ -112.3639, 44.4796 ],
            [ -112.3754, 44.47 ],
            [ -112.3928, 44.468 ],
            [ -112.6482, 44.4971 ],
            [ -112.7159, 44.498 ],
            [ -112.7871, 44.4631 ],
            [ -112.8102, 44.4382 ],
            [ -112.8155, 44.406 ],
            [ -112.8314, 44.3966 ],
            [ -112.8539, 44.3983 ],
            [ -112.9104, 44.4193 ],
            [ -112.9701, 44.4545 ],
            [ -112.9997, 44.4804 ],
            [ -113.0064, 44.5391 ],
            [ -113.0543, 44.6052 ],
            [ -113.0627, 44.6651 ],
            [ -113.0933, 44.7153 ],
            [ -113.1407, 44.7655 ],
            [ -113.1872, 44.7986 ],
            [ -113.2343, 44.8099 ],
            [ -113.3204, 44.8025 ],
            [ -113.3389, 44.8081 ],
            [ -113.4321, 44.8742 ],
            [ -113.4608, 44.9036 ],
            [ -113.4693, 44.93 ],
            [ -113.4381, 44.994 ],
            [ -113.4471, 45.0291 ],
            [ -113.4711, 45.0729 ],
            [ -113.5036, 45.1093 ],
            [ -113.5574, 45.1404 ],
            [ -113.6066, 45.2091 ],
            [ -113.6971, 45.305 ],
            [ -113.7219, 45.3793 ],
            [ -113.7561, 45.4408 ],
            [ -113.7661, 45.5025 ],
            [ -113.7996, 45.5402 ],
            [ -113.7966, 45.5877 ],
            [ -113.8023, 45.6011 ],
            [ -113.8128, 45.607 ],
            [ -113.8729, 45.6335 ],
            [ -113.9427, 45.6815 ],
            [ -113.9778, 45.6924 ],
            [ -113.9919, 45.693 ],
            [ -114.0007, 45.6806 ],
            [ -114.0064, 45.6585 ],
            [ -114.1166, 45.5791 ],
            [ -114.2102, 45.5424 ],
            [ -114.2561, 45.5056 ],
            [ -114.2976, 45.4876 ],
            [ -114.3192, 45.4857 ],
            [ -114.3506, 45.4971 ],
            [ -114.4484, 45.5513 ],
            [ -114.5292, 45.5757 ],
            [ -114.5373, 45.5874 ],
            [ -114.5326, 45.633 ],
            [ -114.4958, 45.6858 ],
            [ -114.5337, 45.782 ],
            [ -114.5225, 45.8151 ],
            [ -114.4926, 45.8387 ],
            [ -114.4051, 45.8743 ],
            [ -114.3968, 45.891 ],
            [ -114.4159, 45.9822 ],
            [ -114.4648, 46.0164 ],
            [ -114.4783, 46.0356 ],
            [ -114.4636, 46.1098 ],
            [ -114.4854, 46.1582 ],
            [ -114.4466, 46.1993 ],
            [ -114.4442, 46.2707 ],
            [ -114.4128, 46.3436 ],
            [ -114.3802, 46.453 ],
            [ -114.387, 46.5 ],
            [ -114.3458, 46.5506 ],
            [ -114.3321, 46.6014 ],
            [ -114.3301, 46.6376 ],
            [ -114.3369, 46.6592 ],
            [ -114.3509, 46.6676 ],
            [ -114.3809, 46.6676 ],
            [ -114.5187, 46.6477 ],
            [ -114.563, 46.6504 ],
            [ -114.6016, 46.6603 ],
            [ -114.624, 46.6776 ],
            [ -114.6306, 46.7186 ],
            [ -114.6616, 46.7455 ],
            [ -114.678, 46.7502 ],
            [ -114.7403, 46.7336 ],
            [ -114.7537, 46.7346 ],
            [ -114.7607, 46.7423 ],
            [ -114.7861, 46.7768 ],
            [ -114.8869, 46.8449 ],
            [ -114.9357, 46.9228 ],
            [ -115.0335, 46.9909 ],
            [ -115.1266, 47.0846 ],
            [ -115.3067, 47.2312 ],
            [ -115.3495, 47.2612 ],
            [ -115.486, 47.3116 ],
            [ -115.5933, 47.3849 ],
            [ -115.7025, 47.4376 ],
            [ -115.7133, 47.4467 ],
            [ -115.7145, 47.4523 ],
            [ -115.708, 47.4568 ],
            [ -115.6769, 47.4706 ],
            [ -115.6697, 47.4979 ],
            [ -115.7109, 47.5526 ],
            [ -115.6909, 47.6067 ],
            [ -115.7184, 47.6815 ],
            [ -115.7338, 47.7063 ],
            [ -115.8112, 47.776 ],
            [ -115.8621, 47.8424 ],
            [ -115.9414, 47.9041 ],
            [ -116.049, 48.0047 ],
            [ -116.0488, 48.252 ],
            [ -116.0486, 48.4993 ],
            [ -116.0484, 48.7466 ],
            [ -116.0485, 48.9931 ],
            [ -115.8643, 48.9931 ],
            [ -115.4379, 48.9931 ],
            [ -115.0115, 48.9931 ],
            [ -114.5851, 48.9931 ],
            [ -114.1587, 48.9931 ],
            [ -114.0625, 48.9931 ],
            [ -113.7324, 48.9931 ],
            [ -113.306, 48.9931 ],
            [ -112.8796, 48.9931 ],
            [ -112.4532, 48.9931 ],
            [ -112.0268, 48.9931 ],
            [ -111.6004, 48.9931 ],
            [ -111.1741, 48.9931 ],
            [ -110.7477, 48.9931 ],
            [ -110.3213, 48.9931 ],
            [ -109.9994, 48.9931 ],
            [ -109.8949, 48.9931 ],
            [ -109.4685, 48.9931 ],
            [ -109.0421, 48.9931 ],
            [ -108.6158, 48.9931 ],
            [ -108.1894, 48.9931 ],
            [ -107.763, 48.9931 ],
            [ -107.3366, 48.9931 ],
            [ -106.9102, 48.9931 ],
            [ -106.4839, 48.9931 ],
            [ -106.0575, 48.9931 ],
            [ -105.6311, 48.9931 ],
            [ -105.2047, 48.9931 ],
            [ -104.7783, 48.9931 ],
            [ -104.3519, 48.9931 ],
            [ -104.0339, 48.9931 ],
            [ -104.0319, 48.8033 ],
            [ -104.0305, 48.6126 ],
            [ -104.0291, 48.422 ],
            [ -104.0277, 48.2313 ],
            [ -104.0263, 48.0406 ],
            [ -104.025, 47.8499 ],
            [ -104.0236, 47.6592 ],
            [ -104.0222, 47.4685 ],
            [ -104.0208, 47.2778 ],
            [ -104.0194, 47.0872 ],
            [ -104.018, 46.8965 ],
            [ -104.0166, 46.7058 ],
            [ -104.0153, 46.5151 ],
            [ -104.0139, 46.3244 ],
            [ -104.0125, 46.1337 ],
            [ -104.0111, 45.9431 ]
          ]
        ]
      },
      "properties": {
        "featurecla": "Admin-1 scale rank",
        "scalerank": 2,
        "adm1_code": "USA-3515",
        "diss_me": 3515,
        "adm1_cod_1": "USA-3515",
        "iso_3166_2": "US-MT",
        "wikipedia": "http://en.wikipedia.org/wiki/Montana",
        "sr_sov_a3": "US1",
        "sr_adm0_a3": "USA",
        "iso_a2": "US",
        "adm0_sr": 1,
        "admin0_lab": 2,
        "name": "Montana",
        "name_alt": "MT|Mont.",
        "name_local": "",
        "type": "State",
        "type_en": "State",
        "code_local": "US30",
        "code_hasc": "US.MT",
        "note": "",
        "hasc_maybe": "",
        "region": "West",
        "region_cod": "",
        "region_big": "Mountain",
        "big_code": "",
        "provnum_ne": 0,
        "gadm_level": 1,
        "check_me": 0,
        "scaleran_1": 2,
        "datarank": 1,
        "abbrev": "Mont.",
        "postal": "MT",
        "area_sqkm": 0,
        "sameascity": -99,
        "labelrank": 0,
        "featurec_1": "Admin-1 scale rank",
        "admin": "United States of America",
        "name_len": 7,
        "mapcolor9": 1,
        "mapcolor13": 1
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [ -76.5462, 34.6549 ],
            [ -76.5685, 34.6526 ],
            [ -76.6078, 34.6636 ],
            [ -76.662, 34.6847 ],
            [ -76.6739, 34.7002 ],
            [ -76.6223, 34.6946 ],
            [ -76.5462, 34.6549 ]
          ],
          [
            [ -76.5036, 34.6429 ],
            [ -76.5286, 34.6315 ],
            [ -76.437, 34.7563 ],
            [ -76.2562, 34.9147 ],
            [ -76.2074, 34.9389 ],
            [ -76.3577, 34.8037 ],
            [ -76.5036, 34.6429 ]
          ],
          [
            [ -75.782, 35.1902 ],
            [ -75.9637, 35.1188 ],
            [ -75.9842, 35.1231 ],
            [ -75.8649, 35.1741 ],
            [ -75.782, 35.1902 ]
          ],
          [
            [ -75.5441, 35.2401 ],
            [ -75.6783, 35.2128 ],
            [ -75.6901, 35.2216 ],
            [ -75.5364, 35.2786 ],
            [ -75.4879, 35.4795 ],
            [ -75.4813, 35.5721 ],
            [ -75.5043, 35.7354 ],
            [ -75.5035, 35.7692 ],
            [ -75.4785, 35.7165 ],
            [ -75.4565, 35.5642 ],
            [ -75.4647, 35.4486 ],
            [ -75.5093, 35.2803 ],
            [ -75.5441, 35.2401 ]
          ],
          [
            [ -75.6357, 35.8559 ],
            [ -75.6508, 35.8356 ],
            [ -75.7172, 35.9461 ],
            [ -75.6489, 35.9104 ],
            [ -75.6367, 35.8807 ],
            [ -75.6357, 35.8559 ]
          ],
          [
            [ -75.5587, 35.8794 ],
            [ -75.5342, 35.8191 ],
            [ -75.5805, 35.872 ],
            [ -75.7282, 36.1037 ],
            [ -75.8098, 36.271 ],
            [ -75.8891, 36.5505 ],
            [ -75.8574, 36.5506 ],
            [ -75.7579, 36.2292 ],
            [ -75.5587, 35.8794 ]
          ],
          [
            [ -75.9249, 36.383 ],
            [ -75.8666, 36.2679 ],
            [ -75.8201, 36.1128 ],
            [ -75.883, 36.1757 ],
            [ -75.9502, 36.209 ],
            [ -76.0547, 36.2345 ],
            [ -76.1478, 36.2793 ],
            [ -76.1411, 36.2151 ],
            [ -76.15, 36.1458 ],
            [ -76.2217, 36.1669 ],
            [ -76.2706, 36.1899 ],
            [ -76.2274, 36.116 ],
            [ -76.3212, 36.1382 ],
            [ -76.3837, 36.1335 ],
            [ -76.4243, 36.068 ],
            [ -76.4788, 36.0282 ],
            [ -76.5594, 36.0154 ],
            [ -76.6789, 36.0753 ],
            [ -76.7176, 36.1481 ],
            [ -76.7336, 36.2292 ],
            [ -76.7401, 36.1333 ],
            [ -76.7188, 36.0335 ],
            [ -76.7262, 35.9576 ],
            [ -76.6112, 35.9436 ],
            [ -76.5035, 35.956 ],
            [ -76.3583, 35.9529 ],
            [ -76.2636, 35.9671 ],
            [ -76.2066, 35.9912 ],
            [ -76.0698, 35.9703 ],
            [ -76.06, 35.8787 ],
            [ -76.0757, 35.7875 ],
            [ -76.0836, 35.6905 ],
            [ -76.0457, 35.6912 ],
            [ -76.0012, 35.7222 ],
            [ -75.9789, 35.896 ],
            [ -75.8539, 35.9602 ],
            [ -75.812, 35.9557 ],
            [ -75.7722, 35.8999 ],
            [ -75.7588, 35.8432 ],
            [ -75.7448, 35.7655 ],
            [ -75.7739, 35.647 ],
            [ -75.966, 35.5084 ],
            [ -76.1035, 35.3803 ],
            [ -76.1738, 35.3541 ],
            [ -76.2752, 35.3691 ],
            [ -76.3902, 35.4012 ],
            [ -76.4466, 35.4078 ],
            [ -76.4895, 35.397 ],
            [ -76.5156, 35.4365 ],
            [ -76.5325, 35.5084 ],
            [ -76.5772, 35.5323 ],
            [ -76.6111, 35.5297 ],
            [ -76.6341, 35.4532 ],
            [ -76.7414, 35.4315 ],
            [ -76.8872, 35.4631 ],
            [ -77.04, 35.5274 ],
            [ -76.9745, 35.4584 ],
            [ -76.5954, 35.3297 ],
            [ -76.5528, 35.3056 ],
            [ -76.5129, 35.2704 ],
            [ -76.566, 35.2152 ],
            [ -76.6075, 35.153 ],
            [ -76.6134, 35.1042 ],
            [ -76.628, 35.0734 ],
            [ -76.7791, 34.9903 ],
            [ -76.861, 35.005 ],
            [ -77.0703, 35.1546 ],
            [ -76.975, 35.0252 ],
            [ -76.8987, 34.9702 ],
            [ -76.745, 34.941 ],
            [ -76.4568, 34.9893 ],
            [ -76.3622, 34.9365 ],
            [ -76.4398, 34.8429 ],
            [ -76.5169, 34.7773 ],
            [ -76.618, 34.7699 ],
            [ -76.7071, 34.7521 ],
            [ -76.7332, 34.707 ],
            [ -76.7966, 34.7042 ],
            [ -76.8959, 34.7015 ],
            [ -77.0495, 34.6974 ],
            [ -77.1339, 34.7079 ],
            [ -77.2518, 34.6156 ],
            [ -77.2962, 34.6029 ],
            [ -77.3584, 34.6203 ],
            [ -77.3845, 34.6944 ],
            [ -77.4123, 34.7308 ],
            [ -77.4129, 34.5921 ],
            [ -77.4021, 34.5548 ],
            [ -77.3798, 34.5266 ],
            [ -77.5177, 34.4514 ],
            [ -77.6497, 34.3575 ],
            [ -77.697, 34.332 ],
            [ -77.7508, 34.285 ],
            [ -77.8608, 34.1492 ],
            [ -77.8881, 34.0501 ],
            [ -77.9278, 33.9397 ],
            [ -77.9329, 33.9895 ],
            [ -77.926, 34.0732 ],
            [ -77.9533, 34.169 ],
            [ -77.9706, 33.9934 ],
            [ -78.0133, 33.9118 ],
            [ -78.4059, 33.9176 ],
            [ -78.5643, 33.8767 ],
            [ -78.7082, 33.9978 ],
            [ -78.8433, 34.1119 ],
            [ -78.9783, 34.2261 ],
            [ -79.1134, 34.3402 ],
            [ -79.2484, 34.4544 ],
            [ -79.3835, 34.5685 ],
            [ -79.5185, 34.6826 ],
            [ -79.6536, 34.7968 ],
            [ -79.7949, 34.8008 ],
            [ -79.9362, 34.8047 ],
            [ -80.0775, 34.8087 ],
            [ -80.2188, 34.8127 ],
            [ -80.3601, 34.8167 ],
            [ -80.5015, 34.8207 ],
            [ -80.6428, 34.8246 ],
            [ -80.7841, 34.8286 ],
            [ -80.7893, 34.9072 ],
            [ -80.793, 34.9628 ],
            [ -80.8817, 35.0579 ],
            [ -80.9337, 35.1137 ],
            [ -81.0452, 35.0656 ],
            [ -81.0512, 35.089 ],
            [ -81.0469, 35.1311 ],
            [ -81.0566, 35.1455 ],
            [ -81.0873, 35.1557 ],
            [ -81.2459, 35.1615 ],
            [ -81.4045, 35.1672 ],
            [ -81.5631, 35.1729 ],
            [ -81.7217, 35.1787 ],
            [ -81.8803, 35.1844 ],
            [ -82.0389, 35.1902 ],
            [ -82.1975, 35.1959 ],
            [ -82.3561, 35.2016 ],
            [ -82.3925, 35.2109 ],
            [ -82.464, 35.178 ],
            [ -82.6515, 35.128 ],
            [ -82.744, 35.0841 ],
            [ -82.7775, 35.0866 ],
            [ -82.937, 35.0442 ],
            [ -83.0966, 35.0016 ],
            [ -83.1148, 35.0015 ],
            [ -83.4173, 34.9981 ],
            [ -83.7198, 34.9948 ],
            [ -84.0222, 34.9915 ],
            [ -84.3247, 34.9881 ],
            [ -84.287, 35.2008 ],
            [ -84.2611, 35.2496 ],
            [ -84.2325, 35.2606 ],
            [ -84.1286, 35.2614 ],
            [ -84.0623, 35.286 ],
            [ -84.0037, 35.4141 ],
            [ -83.8713, 35.5149 ],
            [ -83.8117, 35.5403 ],
            [ -83.7227, 35.5599 ],
            [ -83.5111, 35.5841 ],
            [ -83.2842, 35.6821 ],
            [ -83.1204, 35.7746 ],
            [ -82.9902, 35.8004 ],
            [ -82.9495, 35.8345 ],
            [ -82.9203, 35.8789 ],
            [ -82.9019, 35.9392 ],
            [ -82.8877, 35.9517 ],
            [ -82.8128, 35.9474 ],
            [ -82.7556, 35.9999 ],
            [ -82.7001, 36.0298 ],
            [ -82.6449, 36.0468 ],
            [ -82.6111, 36.0474 ],
            [ -82.5981, 36.0316 ],
            [ -82.5888, 35.987 ],
            [ -82.5768, 35.9723 ],
            [ -82.5534, 35.971 ],
            [ -82.5211, 35.9812 ],
            [ -82.4784, 36.0101 ],
            [ -82.3682, 36.0995 ],
            [ -82.2949, 36.134 ],
            [ -82.1825, 36.1538 ],
            [ -82.1006, 36.1065 ],
            [ -82.0514, 36.1229 ],
            [ -81.9082, 36.3064 ],
            [ -81.8512, 36.3397 ],
            [ -81.8083, 36.3527 ],
            [ -81.7341, 36.3555 ],
            [ -81.7333, 36.4059 ],
            [ -81.7076, 36.482 ],
            [ -81.7044, 36.534 ],
            [ -81.6589, 36.6106 ],
            [ -81.6416, 36.5951 ],
            [ -81.2798, 36.5923 ],
            [ -80.918, 36.5895 ],
            [ -80.5563, 36.5866 ],
            [ -80.1945, 36.5838 ],
            [ -79.8327, 36.581 ],
            [ -79.4709, 36.5782 ],
            [ -79.1091, 36.5754 ],
            [ -78.7473, 36.5726 ],
            [ -78.3855, 36.5698 ],
            [ -78.0238, 36.567 ],
            [ -77.662, 36.5642 ],
            [ -77.3002, 36.5613 ],
            [ -76.9384, 36.5585 ],
            [ -76.5766, 36.5557 ],
            [ -76.2148, 36.5529 ],
            [ -75.9664, 36.5514 ],
            [ -75.9928, 36.4738 ],
            [ -75.9785, 36.4292 ],
            [ -75.9249, 36.383 ]
          ]
        ]
      },
      "properties": {
        "featurecla": "Admin-1 scale rank",
        "scalerank": 2,
        "adm1_code": "USA-3549",
        "diss_me": 3549,
        "adm1_cod_1": "USA-3549",
        "iso_3166_2": "US-NC",
        "wikipedia": "http://en.wikipedia.org/wiki/North_Carolina",
        "sr_sov_a3": "US1",
        "sr_adm0_a3": "USA",
        "iso_a2": "US",
        "adm0_sr": 5,
        "admin0_lab": 2,
        "name": "North Carolina",
        "name_alt": "NC|N.C.",
        "name_local": "",
        "type": "State",
        "type_en": "State",
        "code_local": "US37",
        "code_hasc": "US.NC",
        "note": "",
        "hasc_maybe": "",
        "region": "South",
        "region_cod": "",
        "region_big": "South Atlantic",
        "big_code": "",
        "provnum_ne": 0,
        "gadm_level": 1,
        "check_me": 0,
        "scaleran_1": 2,
        "datarank": 1,
        "abbrev": "N.C.",
        "postal": "NC",
        "area_sqkm": 0,
        "sameascity": -99,
        "labelrank": 0,
        "featurec_1": "Admin-1 scale rank",
        "admin": "United States of America",
        "name_len": 14,
        "mapcolor9": 1,
        "mapcolor13": 1
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [ -96.5564, 45.9428 ],
            [ -96.7894, 45.9428 ],
            [ -97.0223, 45.9428 ],
            [ -97.2553, 45.9428 ],
            [ -97.4882, 45.9428 ],
            [ -97.7212, 45.9428 ],
            [ -97.9541, 45.9428 ],
            [ -98.1871, 45.9428 ],
            [ -98.4201, 45.9429 ],
            [ -98.653, 45.9429 ],
            [ -98.886, 45.9429 ],
            [ -99.1189, 45.9429 ],
            [ -99.3519, 45.9429 ],
            [ -99.5848, 45.9429 ],
            [ -99.8178, 45.9429 ],
            [ -100.0508, 45.9429 ],
            [ -100.2837, 45.9429 ],
            [ -100.5167, 45.9429 ],
            [ -100.7497, 45.9429 ],
            [ -100.9826, 45.9429 ],
            [ -101.2156, 45.943 ],
            [ -101.4486, 45.943 ],
            [ -101.6815, 45.943 ],
            [ -101.9145, 45.943 ],
            [ -102.1474, 45.943 ],
            [ -102.3804, 45.943 ],
            [ -102.6133, 45.943 ],
            [ -102.8463, 45.943 ],
            [ -103.0793, 45.943 ],
            [ -103.3122, 45.943 ],
            [ -103.5452, 45.943 ],
            [ -103.7781, 45.943 ],
            [ -104.0111, 45.9431 ],
            [ -104.0125, 46.1337 ],
            [ -104.0139, 46.3244 ],
            [ -104.0153, 46.5151 ],
            [ -104.0166, 46.7058 ],
            [ -104.018, 46.8965 ],
            [ -104.0194, 47.0872 ],
            [ -104.0208, 47.2778 ],
            [ -104.0222, 47.4685 ],
            [ -104.0236, 47.6592 ],
            [ -104.025, 47.8499 ],
            [ -104.0263, 48.0406 ],
            [ -104.0277, 48.2313 ],
            [ -104.0291, 48.422 ],
            [ -104.0305, 48.6126 ],
            [ -104.0319, 48.8033 ],
            [ -104.0339, 48.9931 ],
            [ -103.9256, 48.9931 ],
            [ -103.4992, 48.9931 ],
            [ -103.0728, 48.9931 ],
            [ -102.6464, 48.9931 ],
            [ -102.22, 48.9931 ],
            [ -101.7936, 48.9931 ],
            [ -101.3673, 48.9931 ],
            [ -100.9409, 48.9931 ],
            [ -100.5145, 48.9931 ],
            [ -100.0881, 48.9931 ],
            [ -99.6617, 48.9931 ],
            [ -99.2354, 48.9931 ],
            [ -98.809, 48.9932 ],
            [ -98.3826, 48.9932 ],
            [ -97.9562, 48.9932 ],
            [ -97.5298, 48.9932 ],
            [ -97.2257, 48.9932 ],
            [ -97.128, 48.6811 ],
            [ -97.1291, 48.5934 ],
            [ -97.144, 48.5368 ],
            [ -97.131, 48.4374 ],
            [ -97.1368, 48.3712 ],
            [ -97.1216, 48.286 ],
            [ -97.1259, 48.1734 ],
            [ -97.0785, 48.0434 ],
            [ -97.0074, 47.9256 ],
            [ -97.009, 47.8915 ],
            [ -96.988, 47.8203 ],
            [ -96.9463, 47.7615 ],
            [ -96.8587, 47.5883 ],
            [ -96.8629, 47.4239 ],
            [ -96.8475, 47.3733 ],
            [ -96.8253, 47.0189 ],
            [ -96.8183, 46.9741 ],
            [ -96.7701, 46.9197 ],
            [ -96.7928, 46.839 ],
            [ -96.796, 46.7971 ],
            [ -96.7866, 46.6482 ],
            [ -96.7582, 46.5903 ],
            [ -96.7309, 46.4728 ],
            [ -96.6174, 46.3271 ],
            [ -96.5986, 46.2719 ],
            [ -96.5919, 46.2275 ],
            [ -96.5608, 46.1382 ],
            [ -96.5705, 46.0192 ],
            [ -96.5564, 45.9428 ]
          ]
        ]
      },
      "properties": {
        "featurecla": "Admin-1 scale rank",
        "scalerank": 2,
        "adm1_code": "USA-3516",
        "diss_me": 3516,
        "adm1_cod_1": "USA-3516",
        "iso_3166_2": "US-ND",
        "wikipedia": "http://en.wikipedia.org/wiki/North_Dakota",
        "sr_sov_a3": "US1",
        "sr_adm0_a3": "USA",
        "iso_a2": "US",
        "adm0_sr": 1,
        "admin0_lab": 2,
        "name": "North Dakota",
        "name_alt": "ND|N.D.",
        "name_local": "",
        "type": "State",
        "type_en": "State",
        "code_local": "US38",
        "code_hasc": "US.ND",
        "note": "",
        "hasc_maybe": "",
        "region": "Midwest",
        "region_cod": "",
        "region_big": "West North Central",
        "big_code": "",
        "provnum_ne": 0,
        "gadm_level": 1,
        "check_me": 0,
        "scaleran_1": 2,
        "datarank": 1,
        "abbrev": "N.D.",
        "postal": "ND",
        "area_sqkm": 0,
        "sameascity": -99,
        "labelrank": 0,
        "featurec_1": "Admin-1 scale rank",
        "admin": "United States of America",
        "name_len": 12,
        "mapcolor9": 1,
        "mapcolor13": 1
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [ -96.481, 42.5113 ],
            [ -96.451, 42.506 ],
            [ -96.3838, 42.4178 ],
            [ -96.3561, 42.2601 ],
            [ -96.2953, 42.1329 ],
            [ -96.2014, 42.0361 ],
            [ -96.1542, 41.9653 ],
            [ -96.1538, 41.9204 ],
            [ -96.1312, 41.8724 ],
            [ -96.0866, 41.8214 ],
            [ -96.0688, 41.7343 ],
            [ -96.0778, 41.6113 ],
            [ -96.0586, 41.5458 ],
            [ -96.0114, 41.5379 ],
            [ -95.991, 41.5205 ],
            [ -95.9974, 41.4936 ],
            [ -95.9816, 41.4738 ],
            [ -95.9436, 41.4609 ],
            [ -95.933, 41.4255 ],
            [ -95.9497, 41.3674 ],
            [ -95.936, 41.331 ],
            [ -95.8919, 41.3162 ],
            [ -95.8836, 41.2876 ],
            [ -95.9112, 41.2452 ],
            [ -95.9069, 41.2119 ],
            [ -95.8709, 41.1878 ],
            [ -95.8466, 41.0803 ],
            [ -95.834, 40.8895 ],
            [ -95.8381, 40.7777 ],
            [ -95.859, 40.7451 ],
            [ -95.8261, 40.6762 ],
            [ -95.765, 40.6019 ],
            [ -95.7396, 40.5709 ],
            [ -95.6847, 40.4664 ],
            [ -95.6616, 40.3628 ],
            [ -95.6071, 40.2955 ],
            [ -95.5212, 40.2646 ],
            [ -95.4637, 40.1981 ],
            [ -95.4343, 40.096 ],
            [ -95.3625, 40.0103 ],
            [ -95.3467, 40.0015 ],
            [ -95.5269, 40.0011 ],
            [ -95.7365, 40.0011 ],
            [ -95.9461, 40.0011 ],
            [ -96.1557, 40.0011 ],
            [ -96.3653, 40.0011 ],
            [ -96.5749, 40.0011 ],
            [ -96.7845, 40.0011 ],
            [ -96.9941, 40.0011 ],
            [ -97.2037, 40.0011 ],
            [ -97.4133, 40.0011 ],
            [ -97.6229, 40.0011 ],
            [ -97.8325, 40.0011 ],
            [ -98.0421, 40.0011 ],
            [ -98.2517, 40.0011 ],
            [ -98.4613, 40.0011 ],
            [ -98.6709, 40.0011 ],
            [ -98.8805, 40.0011 ],
            [ -99.0901, 40.0011 ],
            [ -99.2997, 40.0011 ],
            [ -99.5093, 40.0011 ],
            [ -99.7189, 40.0011 ],
            [ -99.9285, 40.0011 ],
            [ -100.1381, 40.0011 ],
            [ -100.3477, 40.0011 ],
            [ -100.5573, 40.0011 ],
            [ -100.7669, 40.0011 ],
            [ -100.9765, 40.0011 ],
            [ -101.1861, 40.0011 ],
            [ -101.3957, 40.0011 ],
            [ -101.6053, 40.0011 ],
            [ -101.8149, 40.0011 ],
            [ -102.0245, 40.0011 ],
            [ -102.0245, 40.1261 ],
            [ -102.0246, 40.251 ],
            [ -102.0247, 40.3759 ],
            [ -102.0247, 40.5009 ],
            [ -102.0248, 40.6258 ],
            [ -102.0249, 40.7507 ],
            [ -102.025, 40.8757 ],
            [ -102.025, 41.0006 ],
            [ -102.2746, 41.0006 ],
            [ -102.5242, 41.0007 ],
            [ -102.7737, 41.0007 ],
            [ -103.0233, 41.0007 ],
            [ -103.2729, 41.0008 ],
            [ -103.5225, 41.0008 ],
            [ -103.7721, 41.0008 ],
            [ -104.0217, 41.0009 ],
            [ -104.0226, 41.2509 ],
            [ -104.0234, 41.501 ],
            [ -104.0243, 41.751 ],
            [ -104.0252, 42.0011 ],
            [ -104.0261, 42.2512 ],
            [ -104.0271, 42.5013 ],
            [ -104.028, 42.7513 ],
            [ -104.0289, 43.0014 ],
            [ -103.6827, 43.0014 ],
            [ -103.3366, 43.0014 ],
            [ -102.9905, 43.0014 ],
            [ -102.6444, 43.0014 ],
            [ -102.2983, 43.0014 ],
            [ -101.9522, 43.0013 ],
            [ -101.6061, 43.0013 ],
            [ -101.2599, 43.0013 ],
            [ -100.9138, 43.0013 ],
            [ -100.5677, 43.0013 ],
            [ -100.2216, 43.0012 ],
            [ -99.8755, 43.0012 ],
            [ -99.5294, 43.0012 ],
            [ -99.1833, 43.0012 ],
            [ -98.8371, 43.0012 ],
            [ -98.4418, 43.0011 ],
            [ -98.1433, 42.8523 ],
            [ -97.9649, 42.8059 ],
            [ -97.8809, 42.8496 ],
            [ -97.6981, 42.8746 ],
            [ -97.4167, 42.881 ],
            [ -97.2388, 42.8605 ],
            [ -97.1645, 42.8132 ],
            [ -97.0197, 42.7602 ],
            [ -96.8045, 42.7014 ],
            [ -96.6755, 42.6376 ],
            [ -96.6328, 42.5687 ],
            [ -96.558, 42.5248 ],
            [ -96.481, 42.5113 ]
          ]
        ]
      },
      "properties": {
        "featurecla": "Admin-1 scale rank",
        "scalerank": 2,
        "adm1_code": "USA-3532",
        "diss_me": 3532,
        "adm1_cod_1": "USA-3532",
        "iso_3166_2": "US-NE",
        "wikipedia": "http://en.wikipedia.org/wiki/Nebraska",
        "sr_sov_a3": "US1",
        "sr_adm0_a3": "USA",
        "iso_a2": "US",
        "adm0_sr": 1,
        "admin0_lab": 2,
        "name": "Nebraska",
        "name_alt": "NE|Nebr.",
        "name_local": "",
        "type": "State",
        "type_en": "State",
        "code_local": "US31",
        "code_hasc": "US.NE",
        "note": "",
        "hasc_maybe": "",
        "region": "Midwest",
        "region_cod": "",
        "region_big": "West North Central",
        "big_code": "",
        "provnum_ne": 0,
        "gadm_level": 1,
        "check_me": 0,
        "scaleran_1": 2,
        "datarank": 1,
        "abbrev": "Nebr.",
        "postal": "NE",
        "area_sqkm": 0,
        "sameascity": -99,
        "labelrank": 0,
        "featurec_1": "Admin-1 scale rank",
        "admin": "United States of America",
        "name_len": 8,
        "mapcolor9": 1,
        "mapcolor13": 1
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [ -70.7331, 43.07 ],
            [ -70.7776, 42.9406 ],
            [ -70.8061, 42.8768 ],
            [ -70.9235, 42.8816 ],
            [ -70.9741, 42.8717 ],
            [ -71.0762, 42.8251 ],
            [ -71.1393, 42.8081 ],
            [ -71.2423, 42.7295 ],
            [ -71.3296, 42.7025 ],
            [ -71.4718, 42.706 ],
            [ -71.6139, 42.7094 ],
            [ -71.7561, 42.7129 ],
            [ -71.8982, 42.7164 ],
            [ -72.0404, 42.7199 ],
            [ -72.1825, 42.7234 ],
            [ -72.3247, 42.7269 ],
            [ -72.4669, 42.7303 ],
            [ -72.4837, 42.7662 ],
            [ -72.5396, 42.8296 ],
            [ -72.5528, 42.8564 ],
            [ -72.5498, 42.8867 ],
            [ -72.5194, 42.9667 ],
            [ -72.4965, 42.9917 ],
            [ -72.4737, 43.0385 ],
            [ -72.4382, 43.2246 ],
            [ -72.4071, 43.332 ],
            [ -72.385, 43.5292 ],
            [ -72.3624, 43.5866 ],
            [ -72.3377, 43.622 ],
            [ -72.2967, 43.715 ],
            [ -72.2224, 43.7909 ],
            [ -72.1739, 43.8841 ],
            [ -72.1149, 43.9654 ],
            [ -72.1062, 44.0131 ],
            [ -72.0622, 44.1164 ],
            [ -72.0312, 44.3007 ],
            [ -72.0018, 44.3295 ],
            [ -71.8677, 44.3549 ],
            [ -71.8255, 44.3741 ],
            [ -71.683, 44.4503 ],
            [ -71.6382, 44.4817 ],
            [ -71.6093, 44.5141 ],
            [ -71.5878, 44.5653 ],
            [ -71.5715, 44.5792 ],
            [ -71.5684, 44.6076 ],
            [ -71.6183, 44.7278 ],
            [ -71.6207, 44.7719 ],
            [ -71.5102, 44.9083 ],
            [ -71.5335, 44.988 ],
            [ -71.5175, 45.0076 ],
            [ -71.419, 45.2003 ],
            [ -71.3273, 45.2901 ],
            [ -71.2016, 45.2603 ],
            [ -71.1346, 45.2628 ],
            [ -71.0845, 45.294 ],
            [ -71.0773, 45.1949 ],
            [ -71.0697, 45.084 ],
            [ -71.062, 44.9732 ],
            [ -71.0544, 44.8623 ],
            [ -71.0467, 44.7515 ],
            [ -71.039, 44.6406 ],
            [ -71.0314, 44.5298 ],
            [ -71.0237, 44.4189 ],
            [ -71.016, 44.3081 ],
            [ -71.0084, 44.1973 ],
            [ -71.0008, 44.0864 ],
            [ -70.9931, 43.9756 ],
            [ -70.9854, 43.8647 ],
            [ -70.9778, 43.7539 ],
            [ -70.9701, 43.643 ],
            [ -70.9624, 43.5322 ],
            [ -70.9675, 43.4581 ],
            [ -70.9556, 43.3894 ],
            [ -70.9197, 43.3281 ],
            [ -70.829, 43.2391 ],
            [ -70.8128, 43.1636 ],
            [ -70.7331, 43.07 ]
          ]
        ]
      },
      "properties": {
        "featurecla": "Admin-1 scale rank",
        "scalerank": 2,
        "adm1_code": "USA-3538",
        "diss_me": 3538,
        "adm1_cod_1": "USA-3538",
        "iso_3166_2": "US-NH",
        "wikipedia": "http://en.wikipedia.org/wiki/New_Hampshire",
        "sr_sov_a3": "US1",
        "sr_adm0_a3": "USA",
        "iso_a2": "US",
        "adm0_sr": 1,
        "admin0_lab": 2,
        "name": "New Hampshire",
        "name_alt": "NH|N.H.",
        "name_local": "",
        "type": "State",
        "type_en": "State",
        "code_local": "US33",
        "code_hasc": "US.NH",
        "note": "",
        "hasc_maybe": "",
        "region": "Northeast",
        "region_cod": "",
        "region_big": "New England",
        "big_code": "",
        "provnum_ne": 0,
        "gadm_level": 1,
        "check_me": 0,
        "scaleran_1": 2,
        "datarank": 1,
        "abbrev": "N.H.",
        "postal": "NH",
        "area_sqkm": 0,
        "sameascity": -99,
        "labelrank": 0,
        "featurec_1": "Admin-1 scale rank",
        "admin": "United States of America",
        "name_len": 13,
        "mapcolor9": 1,
        "mapcolor13": 1
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [ -74.1332, 39.6808 ],
            [ -74.2505, 39.5294 ],
            [ -74.2532, 39.5585 ],
            [ -74.1068, 39.7464 ],
            [ -74.1332, 39.6808 ]
          ],
          [
            [ -74.2415, 40.4563 ],
            [ -74.0498, 40.4298 ],
            [ -73.9985, 40.4522 ],
            [ -73.9723, 40.4003 ],
            [ -73.9576, 40.3284 ],
            [ -73.972, 40.2505 ],
            [ -74.004, 40.1713 ],
            [ -74.0283, 40.073 ],
            [ -74.0489, 39.9231 ],
            [ -74.0799, 39.7881 ],
            [ -74.084, 39.8291 ],
            [ -74.0646, 39.9931 ],
            [ -74.096, 39.976 ],
            [ -74.1176, 39.9381 ],
            [ -74.1761, 39.7266 ],
            [ -74.2566, 39.6139 ],
            [ -74.3306, 39.5359 ],
            [ -74.407, 39.5488 ],
            [ -74.3899, 39.4868 ],
            [ -74.4109, 39.4545 ],
            [ -74.4288, 39.3872 ],
            [ -74.4744, 39.3426 ],
            [ -74.5172, 39.3468 ],
            [ -74.5787, 39.3161 ],
            [ -74.603, 39.2926 ],
            [ -74.6048, 39.2475 ],
            [ -74.6459, 39.2079 ],
            [ -74.7945, 39.0019 ],
            [ -74.9234, 38.9411 ],
            [ -74.9543, 38.95 ],
            [ -74.9203, 39.0472 ],
            [ -74.897, 39.1455 ],
            [ -74.9753, 39.1883 ],
            [ -75.0502, 39.2108 ],
            [ -75.1361, 39.2079 ],
            [ -75.231, 39.2843 ],
            [ -75.3534, 39.3398 ],
            [ -75.5242, 39.4902 ],
            [ -75.5193, 39.5319 ],
            [ -75.5236, 39.6018 ],
            [ -75.4716, 39.7124 ],
            [ -75.4219, 39.7897 ],
            [ -75.3532, 39.8297 ],
            [ -75.1538, 39.8705 ],
            [ -75.1038, 39.9318 ],
            [ -75.0742, 39.9835 ],
            [ -75.0235, 40.0175 ],
            [ -74.9093, 40.0795 ],
            [ -74.7349, 40.1545 ],
            [ -74.9764, 40.4058 ],
            [ -75.034, 40.4204 ],
            [ -75.0974, 40.5431 ],
            [ -75.1705, 40.5768 ],
            [ -75.189, 40.5958 ],
            [ -75.1923, 40.6899 ],
            [ -75.1857, 40.7438 ],
            [ -75.1747, 40.7755 ],
            [ -75.1118, 40.8021 ],
            [ -75.0756, 40.8563 ],
            [ -75.0749, 40.8845 ],
            [ -75.1227, 40.9718 ],
            [ -75.123, 40.999 ],
            [ -75.0315, 41.0518 ],
            [ -74.9123, 41.1553 ],
            [ -74.8414, 41.2686 ],
            [ -74.8125, 41.3015 ],
            [ -74.7778, 41.3251 ],
            [ -74.6991, 41.3573 ],
            [ -74.6001, 41.3116 ],
            [ -74.5011, 41.2659 ],
            [ -74.402, 41.2202 ],
            [ -74.3031, 41.1745 ],
            [ -74.2041, 41.1289 ],
            [ -74.1051, 41.0832 ],
            [ -74.006, 41.0375 ],
            [ -73.9101, 40.9923 ],
            [ -73.9272, 40.9142 ],
            [ -74.0255, 40.7564 ],
            [ -74.0673, 40.7196 ],
            [ -74.1162, 40.6873 ],
            [ -74.1531, 40.6733 ],
            [ -74.1871, 40.648 ],
            [ -74.2267, 40.608 ],
            [ -74.2642, 40.5286 ],
            [ -74.2415, 40.4563 ]
          ]
        ]
      },
      "properties": {
        "featurecla": "Admin-1 scale rank",
        "scalerank": 2,
        "adm1_code": "USA-3558",
        "diss_me": 3558,
        "adm1_cod_1": "USA-3558",
        "iso_3166_2": "US-NJ",
        "wikipedia": "http://en.wikipedia.org/wiki/New_Jersey",
        "sr_sov_a3": "US1",
        "sr_adm0_a3": "USA",
        "iso_a2": "US",
        "adm0_sr": 5,
        "admin0_lab": 2,
        "name": "New Jersey",
        "name_alt": "NJ|N.J.",
        "name_local": "",
        "type": "State",
        "type_en": "State",
        "code_local": "US34",
        "code_hasc": "US.NJ",
        "note": "",
        "hasc_maybe": "",
        "region": "Northeast",
        "region_cod": "",
        "region_big": "Middle Atlantic",
        "big_code": "",
        "provnum_ne": 0,
        "gadm_level": 1,
        "check_me": 0,
        "scaleran_1": 2,
        "datarank": 1,
        "abbrev": "N.J.",
        "postal": "NJ",
        "area_sqkm": 0,
        "sameascity": -99,
        "labelrank": 0,
        "featurec_1": "Admin-1 scale rank",
        "admin": "United States of America",
        "name_len": 10,
        "mapcolor9": 1,
        "mapcolor13": 1
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [ -103.0003, 36.5012 ],
            [ -103.0422, 36.5006 ],
            [ -103.0436, 36.2195 ],
            [ -103.0451, 35.9384 ],
            [ -103.0465, 35.6573 ],
            [ -103.048, 35.3761 ],
            [ -103.0495, 35.095 ],
            [ -103.0509, 34.8139 ],
            [ -103.0524, 34.5328 ],
            [ -103.0539, 34.2517 ],
            [ -103.0554, 33.9706 ],
            [ -103.0568, 33.6895 ],
            [ -103.0583, 33.4083 ],
            [ -103.0598, 33.1272 ],
            [ -103.0612, 32.8461 ],
            [ -103.0627, 32.565 ],
            [ -103.0642, 32.2839 ],
            [ -103.0656, 32.0027 ],
            [ -103.2904, 32.0026 ],
            [ -103.5152, 32.0026 ],
            [ -103.74, 32.0025 ],
            [ -103.9648, 32.0024 ],
            [ -104.1896, 32.0023 ],
            [ -104.4144, 32.0022 ],
            [ -104.6392, 32.0021 ],
            [ -104.8639, 32.002 ],
            [ -105.0887, 32.0019 ],
            [ -105.3135, 32.0018 ],
            [ -105.5383, 32.0018 ],
            [ -105.7631, 32.0017 ],
            [ -105.9879, 32.0016 ],
            [ -106.2127, 32.0015 ],
            [ -106.4375, 32.0014 ],
            [ -106.6622, 32.0013 ],
            [ -106.6683, 32.0009 ],
            [ -106.5663, 31.8195 ],
            [ -106.5664, 31.8195 ],
            [ -106.4454, 31.7684 ],
            [ -106.4532, 31.7702 ],
            [ -106.673, 31.7713 ],
            [ -106.8929, 31.7725 ],
            [ -107.1127, 31.7736 ],
            [ -107.3325, 31.7747 ],
            [ -107.5524, 31.7759 ],
            [ -107.7722, 31.777 ],
            [ -107.992, 31.7782 ],
            [ -108.2118, 31.7793 ],
            [ -108.2125, 31.6669 ],
            [ -108.2132, 31.5544 ],
            [ -108.2138, 31.4419 ],
            [ -108.2145, 31.3294 ],
            [ -108.5679, 31.3288 ],
            [ -108.9213, 31.3281 ],
            [ -109.0478, 31.3279 ],
            [ -109.0474, 31.6832 ],
            [ -109.0474, 32.0377 ],
            [ -109.0473, 32.3922 ],
            [ -109.0473, 32.7468 ],
            [ -109.0472, 33.1013 ],
            [ -109.0472, 33.4558 ],
            [ -109.0471, 33.8103 ],
            [ -109.0471, 34.1648 ],
            [ -109.047, 34.5193 ],
            [ -109.047, 34.8738 ],
            [ -109.0469, 35.2283 ],
            [ -109.0469, 35.5828 ],
            [ -109.0468, 35.9373 ],
            [ -109.0467, 36.2918 ],
            [ -109.0467, 36.6463 ],
            [ -109.0467, 37.0008 ],
            [ -108.6688, 37.0008 ],
            [ -108.2909, 37.0008 ],
            [ -107.9131, 37.0008 ],
            [ -107.5352, 37.0008 ],
            [ -107.1574, 37.0008 ],
            [ -106.7795, 37.0008 ],
            [ -106.4016, 37.0008 ],
            [ -106.0238, 37.0008 ],
            [ -105.6459, 37.0008 ],
            [ -105.268, 37.0008 ],
            [ -104.8902, 37.0008 ],
            [ -104.5123, 37.0008 ],
            [ -104.1344, 37.0008 ],
            [ -103.7566, 37.0008 ],
            [ -103.3787, 37.0008 ],
            [ -103.0008, 37.0008 ],
            [ -103.0007, 36.8759 ],
            [ -103.0006, 36.751 ],
            [ -103.0004, 36.6261 ],
            [ -103.0003, 36.5012 ]
          ]
        ]
      },
      "properties": {
        "featurecla": "Admin-1 scale rank",
        "scalerank": 2,
        "adm1_code": "USA-3524",
        "diss_me": 3524,
        "adm1_cod_1": "USA-3524",
        "iso_3166_2": "US-NM",
        "wikipedia": "http://en.wikipedia.org/wiki/New_Mexico",
        "sr_sov_a3": "US1",
        "sr_adm0_a3": "USA",
        "iso_a2": "US",
        "adm0_sr": 1,
        "admin0_lab": 2,
        "name": "New Mexico",
        "name_alt": "NM|N.M.",
        "name_local": "",
        "type": "State",
        "type_en": "State",
        "code_local": "US35",
        "code_hasc": "US.NM",
        "note": "",
        "hasc_maybe": "",
        "region": "West",
        "region_cod": "",
        "region_big": "Mountain",
        "big_code": "",
        "provnum_ne": 0,
        "gadm_level": 1,
        "check_me": 0,
        "scaleran_1": 2,
        "datarank": 1,
        "abbrev": "N.M.",
        "postal": "NM",
        "area_sqkm": 0,
        "sameascity": -99,
        "labelrank": 0,
        "featurec_1": "Admin-1 scale rank",
        "admin": "United States of America",
        "name_len": 10,
        "mapcolor9": 1,
        "mapcolor13": 1
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [ -114.0403, 37.0042 ],
            [ -114.0412, 36.6125 ],
            [ -114.0429, 36.1818 ],
            [ -114.0619, 36.1752 ],
            [ -114.1194, 36.0767 ],
            [ -114.1832, 36.0303 ],
            [ -114.2321, 36.0317 ],
            [ -114.2816, 36.0603 ],
            [ -114.3315, 36.1163 ],
            [ -114.4061, 36.1483 ],
            [ -114.5053, 36.1564 ],
            [ -114.593, 36.1476 ],
            [ -114.6691, 36.1217 ],
            [ -114.7158, 36.085 ],
            [ -114.7414, 36.0135 ],
            [ -114.7323, 35.9837 ],
            [ -114.6871, 35.9173 ],
            [ -114.6837, 35.8136 ],
            [ -114.6771, 35.7298 ],
            [ -114.6501, 35.6835 ],
            [ -114.6452, 35.6305 ],
            [ -114.6621, 35.5454 ],
            [ -114.6485, 35.4759 ],
            [ -114.591, 35.3528 ],
            [ -114.6105, 34.9976 ],
            [ -114.6105, 34.9911 ],
            [ -114.8822, 35.2028 ],
            [ -115.1361, 35.401 ],
            [ -115.39, 35.5991 ],
            [ -115.6439, 35.7973 ],
            [ -115.8978, 35.9955 ],
            [ -116.1517, 36.1936 ],
            [ -116.4057, 36.3918 ],
            [ -116.6596, 36.59 ],
            [ -116.8429, 36.7278 ],
            [ -117.0263, 36.8655 ],
            [ -117.2096, 37.0034 ],
            [ -117.3929, 37.1412 ],
            [ -117.5763, 37.279 ],
            [ -117.7596, 37.4168 ],
            [ -117.9429, 37.5546 ],
            [ -118.1263, 37.6924 ],
            [ -118.3605, 37.8559 ],
            [ -118.5947, 38.0193 ],
            [ -118.8289, 38.1828 ],
            [ -119.0632, 38.3463 ],
            [ -119.2974, 38.5098 ],
            [ -119.5316, 38.6733 ],
            [ -119.7658, 38.8368 ],
            [ -120.0001, 39.0003 ],
            [ -120.0001, 39.1878 ],
            [ -120.0001, 39.3753 ],
            [ -120.0002, 39.5628 ],
            [ -120.0002, 39.7503 ],
            [ -120.0003, 39.9379 ],
            [ -120.0003, 40.1254 ],
            [ -120.0004, 40.3129 ],
            [ -120.0004, 40.5004 ],
            [ -120.0005, 40.688 ],
            [ -120.0006, 40.8755 ],
            [ -120.0006, 41.063 ],
            [ -120.0006, 41.2505 ],
            [ -120.0007, 41.438 ],
            [ -120.0007, 41.6255 ],
            [ -120.0008, 41.8131 ],
            [ -120.0008, 42.0006 ],
            [ -119.6278, 42.0006 ],
            [ -119.2548, 42.0006 ],
            [ -118.8818, 42.0006 ],
            [ -118.5088, 42.0006 ],
            [ -118.1357, 42.0006 ],
            [ -117.7627, 42.0006 ],
            [ -117.3897, 42.0006 ],
            [ -117.0167, 42.0006 ],
            [ -116.6449, 42.0006 ],
            [ -116.2732, 42.0007 ],
            [ -115.9014, 42.0008 ],
            [ -115.5296, 42.0008 ],
            [ -115.1579, 42.0009 ],
            [ -114.7861, 42.001 ],
            [ -114.4144, 42.0011 ],
            [ -114.0426, 42.0011 ],
            [ -114.0425, 41.8449 ],
            [ -114.0425, 41.6888 ],
            [ -114.0424, 41.5327 ],
            [ -114.0423, 41.3765 ],
            [ -114.0422, 41.2203 ],
            [ -114.0422, 41.0642 ],
            [ -114.0421, 40.908 ],
            [ -114.042, 40.7519 ],
            [ -114.0419, 40.5957 ],
            [ -114.0418, 40.4396 ],
            [ -114.0418, 40.2834 ],
            [ -114.0417, 40.1273 ],
            [ -114.0416, 39.9711 ],
            [ -114.0416, 39.8149 ],
            [ -114.0415, 39.6588 ],
            [ -114.0414, 39.5026 ],
            [ -114.0414, 39.3465 ],
            [ -114.0413, 39.1903 ],
            [ -114.0412, 39.0342 ],
            [ -114.0411, 38.878 ],
            [ -114.0411, 38.7218 ],
            [ -114.041, 38.5657 ],
            [ -114.0409, 38.4095 ],
            [ -114.0409, 38.2534 ],
            [ -114.0408, 38.0972 ],
            [ -114.0407, 37.9411 ],
            [ -114.0406, 37.7849 ],
            [ -114.0406, 37.6288 ],
            [ -114.0405, 37.4726 ],
            [ -114.0404, 37.3165 ],
            [ -114.0403, 37.1603 ],
            [ -114.0403, 37.0042 ]
          ]
        ]
      },
      "properties": {
        "featurecla": "Admin-1 scale rank",
        "scalerank": 2,
        "adm1_code": "USA-3523",
        "diss_me": 3523,
        "adm1_cod_1": "USA-3523",
        "iso_3166_2": "US-NV",
        "wikipedia": "http://en.wikipedia.org/wiki/Nevada",
        "sr_sov_a3": "US1",
        "sr_adm0_a3": "USA",
        "iso_a2": "US",
        "adm0_sr": 1,
        "admin0_lab": 2,
        "name": "Nevada",
        "name_alt": "NV|Nev.",
        "name_local": "",
        "type": "State",
        "type_en": "State",
        "code_local": "US32",
        "code_hasc": "US.NV",
        "note": "",
        "hasc_maybe": "",
        "region": "West",
        "region_cod": "",
        "region_big": "Mountain",
        "big_code": "",
        "provnum_ne": 0,
        "gadm_level": 1,
        "check_me": 0,
        "scaleran_1": 2,
        "datarank": 1,
        "abbrev": "Nev.",
        "postal": "NV",
        "area_sqkm": 0,
        "sameascity": -99,
        "labelrank": 0,
        "featurec_1": "Admin-1 scale rank",
        "admin": "United States of America",
        "name_len": 6,
        "mapcolor9": 1,
        "mapcolor13": 1
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [ -74.1881, 40.5229 ],
            [ -74.2359, 40.5187 ],
            [ -74.1882, 40.6146 ],
            [ -74.1005, 40.6584 ],
            [ -74.0688, 40.6493 ],
            [ -74.0674, 40.6155 ],
            [ -74.0797, 40.5865 ],
            [ -74.1385, 40.5418 ],
            [ -74.1881, 40.5229 ]
          ],
          [
            [ -72.5098, 40.986 ],
            [ -72.5809, 40.9213 ],
            [ -72.5166, 40.9148 ],
            [ -72.4613, 40.9338 ],
            [ -72.409, 40.9722 ],
            [ -72.2874, 41.0241 ],
            [ -72.1839, 41.0468 ],
            [ -72.1512, 41.0515 ],
            [ -72.1019, 41.015 ],
            [ -72.004, 41.0443 ],
            [ -71.9032, 41.0607 ],
            [ -72.339, 40.8941 ],
            [ -72.4281, 40.8754 ],
            [ -72.5555, 40.8258 ],
            [ -72.6761, 40.7906 ],
            [ -72.7628, 40.7778 ],
            [ -73.1943, 40.6542 ],
            [ -73.2285, 40.6515 ],
            [ -73.2655, 40.6636 ],
            [ -73.6209, 40.5999 ],
            [ -73.7667, 40.5927 ],
            [ -73.8996, 40.5705 ],
            [ -73.8013, 40.6218 ],
            [ -73.7992, 40.641 ],
            [ -73.8227, 40.656 ],
            [ -73.8752, 40.6516 ],
            [ -73.929, 40.5988 ],
            [ -74.0149, 40.5812 ],
            [ -74.032, 40.6387 ],
            [ -74.0034, 40.6832 ],
            [ -73.9646, 40.7253 ],
            [ -73.8793, 40.7917 ],
            [ -73.7572, 40.8337 ],
            [ -73.6952, 40.87 ],
            [ -73.6522, 40.838 ],
            [ -73.6428, 40.8812 ],
            [ -73.6098, 40.9062 ],
            [ -73.5738, 40.9196 ],
            [ -73.4874, 40.92 ],
            [ -73.4409, 40.9268 ],
            [ -73.4072, 40.9411 ],
            [ -73.3727, 40.9438 ],
            [ -73.2782, 40.9242 ],
            [ -73.1858, 40.9299 ],
            [ -73.1113, 40.9569 ],
            [ -73.0338, 40.966 ],
            [ -72.8288, 40.9721 ],
            [ -72.6251, 40.9918 ],
            [ -72.5437, 41.027 ],
            [ -72.3726, 41.1256 ],
            [ -72.2741, 41.153 ],
            [ -72.4274, 41.0385 ],
            [ -72.5098, 40.986 ]
          ],
          [
            [ -78.9299, 43.0225 ],
            [ -78.9605, 42.9882 ],
            [ -78.9903, 42.9916 ],
            [ -79.012, 43.0027 ],
            [ -79.0194, 43.0242 ],
            [ -79.0142, 43.0515 ],
            [ -78.988, 43.0635 ],
            [ -78.9162, 43.0532 ],
            [ -78.9139, 43.0423 ],
            [ -78.9299, 43.0225 ]
          ],
          [
            [ -76.262, 43.9901 ],
            [ -76.2767, 43.9871 ],
            [ -76.2751, 44.0086 ],
            [ -76.2598, 44.0224 ],
            [ -76.2306, 44.0285 ],
            [ -76.2313, 44.0178 ],
            [ -76.262, 43.9901 ]
          ],
          [
            [ -76.1112, 44.2773 ],
            [ -76.1427, 44.2692 ],
            [ -76.1503, 44.2811 ],
            [ -76.1452, 44.2921 ],
            [ -76.1191, 44.3059 ],
            [ -76.0754, 44.3058 ],
            [ -76.0806, 44.2947 ],
            [ -76.1112, 44.2773 ]
          ],
          [
            [ -73.3522, 45.0054 ],
            [ -73.3451, 44.9389 ],
            [ -73.3658, 44.8604 ],
            [ -73.3486, 44.7753 ],
            [ -73.3721, 44.5973 ],
            [ -73.3098, 44.4596 ],
            [ -73.3246, 44.3679 ],
            [ -73.3209, 44.2689 ],
            [ -73.3318, 44.2446 ],
            [ -73.3811, 44.1874 ],
            [ -73.4098, 44.1314 ],
            [ -73.4261, 44.0749 ],
            [ -73.4249, 44.0383 ],
            [ -73.383, 43.8758 ],
            [ -73.375, 43.8042 ],
            [ -73.3758, 43.7622 ],
            [ -73.4134, 43.6279 ],
            [ -73.4159, 43.5896 ],
            [ -73.4049, 43.5788 ],
            [ -73.3914, 43.5785 ],
            [ -73.3492, 43.6204 ],
            [ -73.3305, 43.6267 ],
            [ -73.3062, 43.6163 ],
            [ -73.2471, 43.553 ],
            [ -73.2503, 43.4397 ],
            [ -73.2527, 43.3572 ],
            [ -73.2552, 43.2654 ],
            [ -73.2591, 43.1279 ],
            [ -73.2619, 43.0271 ],
            [ -73.2645, 42.9352 ],
            [ -73.2666, 42.8648 ],
            [ -73.2802, 42.8132 ],
            [ -73.2533, 42.7522 ],
            [ -73.2851, 42.6682 ],
            [ -73.3168, 42.5842 ],
            [ -73.3486, 42.5001 ],
            [ -73.3803, 42.4161 ],
            [ -73.412, 42.3321 ],
            [ -73.4438, 42.2481 ],
            [ -73.4755, 42.164 ],
            [ -73.5073, 42.08 ],
            [ -73.4806, 42.0556 ],
            [ -73.4886, 41.9606 ],
            [ -73.4966, 41.8657 ],
            [ -73.5046, 41.7707 ],
            [ -73.5126, 41.6757 ],
            [ -73.5206, 41.5808 ],
            [ -73.5287, 41.4858 ],
            [ -73.5367, 41.3909 ],
            [ -73.5447, 41.296 ],
            [ -73.5145, 41.2575 ],
            [ -73.4841, 41.219 ],
            [ -73.5218, 41.2009 ],
            [ -73.5798, 41.1731 ],
            [ -73.6419, 41.1434 ],
            [ -73.723, 41.1045 ],
            [ -73.6821, 41.0547 ],
            [ -73.6305, 40.9919 ],
            [ -73.6714, 40.9659 ],
            [ -73.779, 40.8784 ],
            [ -73.8512, 40.8314 ],
            [ -73.9107, 40.8161 ],
            [ -73.9472, 40.7769 ],
            [ -73.9871, 40.7514 ],
            [ -73.9486, 40.8387 ],
            [ -73.9068, 40.9125 ],
            [ -73.872, 41.0552 ],
            [ -73.8823, 41.1706 ],
            [ -73.9253, 41.2181 ],
            [ -73.97, 41.2497 ],
            [ -73.9176, 41.1358 ],
            [ -73.9092, 40.9961 ],
            [ -73.9101, 40.9923 ],
            [ -74.006, 41.0375 ],
            [ -74.1051, 41.0832 ],
            [ -74.2041, 41.1289 ],
            [ -74.3031, 41.1745 ],
            [ -74.402, 41.2202 ],
            [ -74.5011, 41.2659 ],
            [ -74.6001, 41.3116 ],
            [ -74.6991, 41.3573 ],
            [ -74.7204, 41.3949 ],
            [ -74.7566, 41.4239 ],
            [ -74.9354, 41.4744 ],
            [ -74.9813, 41.5077 ],
            [ -75.0227, 41.5529 ],
            [ -75.0514, 41.6084 ],
            [ -75.0662, 41.6666 ],
            [ -75.0669, 41.7132 ],
            [ -75.0537, 41.765 ],
            [ -75.0948, 41.7995 ],
            [ -75.0955, 41.8317 ],
            [ -75.1219, 41.8534 ],
            [ -75.2389, 41.8922 ],
            [ -75.274, 41.9467 ],
            [ -75.3513, 41.9984 ],
            [ -75.4892, 41.9985 ],
            [ -75.6271, 41.9986 ],
            [ -75.7649, 41.9986 ],
            [ -75.9028, 41.9987 ],
            [ -76.0406, 41.9988 ],
            [ -76.1785, 41.9989 ],
            [ -76.3164, 41.999 ],
            [ -76.4542, 41.999 ],
            [ -76.5921, 41.9991 ],
            [ -76.73, 41.9992 ],
            [ -76.8678, 41.9993 ],
            [ -77.0057, 41.9994 ],
            [ -77.1436, 41.9994 ],
            [ -77.2814, 41.9995 ],
            [ -77.4193, 41.9996 ],
            [ -77.5571, 41.9997 ],
            [ -77.695, 41.9997 ],
            [ -77.8329, 41.9998 ],
            [ -77.9707, 41.9999 ],
            [ -78.1086, 42 ],
            [ -78.2465, 42 ],
            [ -78.3843, 42.0001 ],
            [ -78.5222, 42.0002 ],
            [ -78.6601, 42.0003 ],
            [ -78.7979, 42.0003 ],
            [ -78.9358, 42.0004 ],
            [ -79.0736, 42.0005 ],
            [ -79.2115, 42.0006 ],
            [ -79.3494, 42.0007 ],
            [ -79.4872, 42.0007 ],
            [ -79.6251, 42.0008 ],
            [ -79.763, 42.0009 ],
            [ -79.763, 42.1355 ],
            [ -79.763, 42.2701 ],
            [ -79.763, 42.2757 ],
            [ -79.7041, 42.3001 ],
            [ -79.5123, 42.391 ],
            [ -79.4164, 42.4569 ],
            [ -79.3154, 42.5116 ],
            [ -79.2092, 42.5552 ],
            [ -79.125, 42.6112 ],
            [ -79.0625, 42.6798 ],
            [ -78.9936, 42.7307 ],
            [ -78.9183, 42.7641 ],
            [ -78.8778, 42.7991 ],
            [ -78.8723, 42.8359 ],
            [ -78.8862, 42.8856 ],
            [ -78.9197, 42.9482 ],
            [ -78.9243, 42.9975 ],
            [ -78.9001, 43.0335 ],
            [ -78.8947, 43.0578 ],
            [ -78.9082, 43.0703 ],
            [ -79.066, 43.1061 ],
            [ -79.0661, 43.1061 ],
            [ -79.0592, 43.2781 ],
            [ -79.0614, 43.2829 ],
            [ -79.0532, 43.2851 ],
            [ -78.6895, 43.3615 ],
            [ -78.4575, 43.3875 ],
            [ -78.175, 43.3947 ],
            [ -77.8382, 43.3571 ],
            [ -77.7074, 43.3229 ],
            [ -77.6246, 43.2791 ],
            [ -77.5291, 43.2674 ],
            [ -77.4208, 43.2877 ],
            [ -77.2708, 43.2945 ],
            [ -77.079, 43.2877 ],
            [ -76.9764, 43.2774 ],
            [ -76.9631, 43.2638 ],
            [ -76.9498, 43.2679 ],
            [ -76.9367, 43.2897 ],
            [ -76.8853, 43.314 ],
            [ -76.7414, 43.35 ],
            [ -76.7223, 43.3426 ],
            [ -76.6929, 43.3609 ],
            [ -76.6531, 43.405 ],
            [ -76.5797, 43.4538 ],
            [ -76.4727, 43.5073 ],
            [ -76.376, 43.5351 ],
            [ -76.2896, 43.5373 ],
            [ -76.2318, 43.5504 ],
            [ -76.2026, 43.5745 ],
            [ -76.1936, 43.5958 ],
            [ -76.2048, 43.6143 ],
            [ -76.1999, 43.6347 ],
            [ -76.195, 43.6448 ],
            [ -76.1993, 43.6531 ],
            [ -76.2097, 43.6703 ],
            [ -76.2181, 43.7578 ],
            [ -76.2349, 43.7988 ],
            [ -76.2582, 43.8291 ],
            [ -76.2882, 43.8487 ],
            [ -76.2846, 43.8692 ],
            [ -76.2325, 43.8945 ],
            [ -76.2364, 43.8709 ],
            [ -76.2228, 43.8638 ],
            [ -76.1983, 43.8745 ],
            [ -76.1427, 43.9269 ],
            [ -76.1365, 43.9466 ],
            [ -76.0987, 43.967 ],
            [ -76.0707, 43.9985 ],
            [ -76.1019, 44.0032 ],
            [ -76.1754, 43.9938 ],
            [ -76.1923, 44.0034 ],
            [ -76.1542, 44.0454 ],
            [ -76.1612, 44.0693 ],
            [ -76.1733, 44.0794 ],
            [ -76.1976, 44.0835 ],
            [ -76.2806, 44.0465 ],
            [ -76.3061, 44.0432 ],
            [ -76.3097, 44.0627 ],
            [ -76.3524, 44.1061 ],
            [ -76.2378, 44.1832 ],
            [ -75.8322, 44.3973 ],
            [ -75.7909, 44.4299 ],
            [ -75.7757, 44.4589 ],
            [ -75.7866, 44.4843 ],
            [ -75.798, 44.4907 ],
            [ -75.792, 44.497 ],
            [ -75.4013, 44.7723 ],
            [ -75.1794, 44.8994 ],
            [ -74.9961, 44.9701 ],
            [ -74.8566, 45.0039 ],
            [ -74.7625, 44.9991 ],
            [ -74.7089, 45.0039 ],
            [ -74.6632, 45.0039 ],
            [ -74.4304, 45.0042 ],
            [ -74.0143, 45.0047 ],
            [ -73.5981, 45.0052 ],
            [ -73.3522, 45.0054 ]
          ]
        ]
      },
      "properties": {
        "featurecla": "Admin-1 scale rank",
        "scalerank": 2,
        "adm1_code": "USA-3559",
        "diss_me": 3559,
        "adm1_cod_1": "USA-3559",
        "iso_3166_2": "US-NY",
        "wikipedia": "http://en.wikipedia.org/wiki/New_York",
        "sr_sov_a3": "US1",
        "sr_adm0_a3": "USA",
        "iso_a2": "US",
        "adm0_sr": 3,
        "admin0_lab": 2,
        "name": "New York",
        "name_alt": "NY|N.Y.",
        "name_local": "",
        "type": "State",
        "type_en": "State",
        "code_local": "US36",
        "code_hasc": "US.NY",
        "note": "",
        "hasc_maybe": "",
        "region": "Northeast",
        "region_cod": "",
        "region_big": "Middle Atlantic",
        "big_code": "",
        "provnum_ne": 0,
        "gadm_level": 1,
        "check_me": 0,
        "scaleran_1": 2,
        "datarank": 1,
        "abbrev": "N.Y.",
        "postal": "NY",
        "area_sqkm": 0,
        "sameascity": -99,
        "labelrank": 0,
        "featurec_1": "Admin-1 scale rank",
        "admin": "United States of America",
        "name_len": 8,
        "mapcolor9": 1,
        "mapcolor13": 1
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [ -80.5191, 40.647 ],
            [ -80.6375, 40.6033 ],
            [ -80.659, 40.563 ],
            [ -80.6232, 40.5116 ],
            [ -80.6041, 40.4452 ],
            [ -80.6018, 40.3639 ],
            [ -80.6683, 40.1852 ],
            [ -80.8035, 39.9091 ],
            [ -80.8722, 39.7355 ],
            [ -80.8743, 39.6643 ],
            [ -80.9633, 39.5711 ],
            [ -81.1391, 39.456 ],
            [ -81.2625, 39.3865 ],
            [ -81.3334, 39.3628 ],
            [ -81.3924, 39.3648 ],
            [ -81.4396, 39.3926 ],
            [ -81.4927, 39.3736 ],
            [ -81.5516, 39.308 ],
            [ -81.6065, 39.2741 ],
            [ -81.6572, 39.272 ],
            [ -81.7006, 39.2295 ],
            [ -81.7367, 39.1466 ],
            [ -81.7707, 39.0988 ],
            [ -81.8026, 39.0861 ],
            [ -81.805, 39.0441 ],
            [ -81.7777, 38.9728 ],
            [ -81.7801, 38.947 ],
            [ -81.795, 38.9459 ],
            [ -81.8093, 38.95 ],
            [ -81.8438, 38.9343 ],
            [ -81.8824, 38.8942 ],
            [ -81.8967, 38.8935 ],
            [ -81.9074, 38.9002 ],
            [ -81.9185, 38.9523 ],
            [ -81.9498, 38.9893 ],
            [ -82.0011, 39.0111 ],
            [ -82.0723, 38.9629 ],
            [ -82.1633, 38.8449 ],
            [ -82.2035, 38.7682 ],
            [ -82.1876, 38.7152 ],
            [ -82.1801, 38.6376 ],
            [ -82.2025, 38.6058 ],
            [ -82.2523, 38.5941 ],
            [ -82.2909, 38.552 ],
            [ -82.3181, 38.4797 ],
            [ -82.3871, 38.434 ],
            [ -82.4975, 38.415 ],
            [ -82.6128, 38.4482 ],
            [ -82.6213, 38.4507 ],
            [ -82.7582, 38.5412 ],
            [ -82.8446, 38.6277 ],
            [ -82.8804, 38.7103 ],
            [ -83.0001, 38.714 ],
            [ -83.2035, 38.6389 ],
            [ -83.357, 38.6274 ],
            [ -83.4606, 38.6795 ],
            [ -83.5384, 38.6999 ],
            [ -83.6163, 38.6828 ],
            [ -83.6899, 38.6495 ],
            [ -83.7523, 38.6694 ],
            [ -83.8281, 38.7312 ],
            [ -83.9484, 38.7742 ],
            [ -84.1132, 38.7984 ],
            [ -84.2273, 38.8652 ],
            [ -84.2904, 38.9747 ],
            [ -84.358, 39.0499 ],
            [ -84.4301, 39.0909 ],
            [ -84.5089, 39.1028 ],
            [ -84.5945, 39.0858 ],
            [ -84.6605, 39.0945 ],
            [ -84.7069, 39.1289 ],
            [ -84.7659, 39.125 ],
            [ -84.8217, 39.092 ],
            [ -84.8201, 39.4238 ],
            [ -84.8167, 39.7492 ],
            [ -84.8133, 40.0746 ],
            [ -84.8098, 40.3999 ],
            [ -84.8064, 40.7253 ],
            [ -84.803, 41.0507 ],
            [ -84.7996, 41.3761 ],
            [ -84.7961, 41.7014 ],
            [ -84.4631, 41.7109 ],
            [ -84.1302, 41.7205 ],
            [ -83.7972, 41.73 ],
            [ -83.4642, 41.7394 ],
            [ -83.4543, 41.7455 ],
            [ -83.4562, 41.7425 ],
            [ -83.443, 41.7249 ],
            [ -83.3522, 41.714 ],
            [ -83.2907, 41.6933 ],
            [ -83.2426, 41.6619 ],
            [ -83.0691, 41.6006 ],
            [ -83.016, 41.5628 ],
            [ -82.9633, 41.5419 ],
            [ -82.9108, 41.5382 ],
            [ -82.8749, 41.5501 ],
            [ -82.8555, 41.5778 ],
            [ -82.8308, 41.5797 ],
            [ -82.8008, 41.5557 ],
            [ -82.7031, 41.5295 ],
            [ -82.7, 41.5213 ],
            [ -82.9707, 41.4757 ],
            [ -83.0275, 41.4545 ],
            [ -82.9596, 41.4397 ],
            [ -82.8911, 41.4433 ],
            [ -82.8223, 41.4652 ],
            [ -82.7431, 41.4641 ],
            [ -82.6735, 41.4537 ],
            [ -82.6515, 41.4625 ],
            [ -82.6426, 41.4669 ],
            [ -82.5244, 41.407 ],
            [ -82.4803, 41.3981 ],
            [ -82.4344, 41.4049 ],
            [ -82.3869, 41.4275 ],
            [ -82.2825, 41.4568 ],
            [ -82.1213, 41.493 ],
            [ -81.9663, 41.5077 ],
            [ -81.8175, 41.5009 ],
            [ -81.7232, 41.5109 ],
            [ -81.6372, 41.5484 ],
            [ -81.4471, 41.6715 ],
            [ -81.2286, 41.7704 ],
            [ -80.8692, 41.8933 ],
            [ -80.5203, 41.9896 ],
            [ -80.5203, 41.9059 ],
            [ -80.5203, 41.8011 ],
            [ -80.5203, 41.6962 ],
            [ -80.5203, 41.5914 ],
            [ -80.5203, 41.4866 ],
            [ -80.5203, 41.3817 ],
            [ -80.5203, 41.2769 ],
            [ -80.5203, 41.172 ],
            [ -80.5203, 41.0672 ],
            [ -80.5203, 40.9624 ],
            [ -80.5203, 40.8575 ],
            [ -80.5203, 40.7527 ],
            [ -80.5191, 40.647 ]
          ]
        ]
      },
      "properties": {
        "featurecla": "Admin-1 scale rank",
        "scalerank": 2,
        "adm1_code": "USA-3550",
        "diss_me": 3550,
        "adm1_cod_1": "USA-3550",
        "iso_3166_2": "US-OH",
        "wikipedia": "http://en.wikipedia.org/wiki/Ohio",
        "sr_sov_a3": "US1",
        "sr_adm0_a3": "USA",
        "iso_a2": "US",
        "adm0_sr": 1,
        "admin0_lab": 2,
        "name": "Ohio",
        "name_alt": "OH|Ohio",
        "name_local": "",
        "type": "State",
        "type_en": "State",
        "code_local": "US39",
        "code_hasc": "US.OH",
        "note": "",
        "hasc_maybe": "",
        "region": "Midwest",
        "region_cod": "",
        "region_big": "East North Central",
        "big_code": "",
        "provnum_ne": 0,
        "gadm_level": 1,
        "check_me": 0,
        "scaleran_1": 2,
        "datarank": 1,
        "abbrev": "Ohio",
        "postal": "OH",
        "area_sqkm": 0,
        "sameascity": -99,
        "labelrank": 0,
        "featurec_1": "Admin-1 scale rank",
        "admin": "United States of America",
        "name_len": 4,
        "mapcolor9": 1,
        "mapcolor13": 1
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [ -94.6184, 36.5009 ],
            [ -94.596, 36.3617 ],
            [ -94.5736, 36.2225 ],
            [ -94.5512, 36.0833 ],
            [ -94.5288, 35.9441 ],
            [ -94.5064, 35.8048 ],
            [ -94.484, 35.6657 ],
            [ -94.4615, 35.5265 ],
            [ -94.4391, 35.3873 ],
            [ -94.442, 35.2786 ],
            [ -94.4447, 35.1699 ],
            [ -94.4476, 35.0612 ],
            [ -94.4504, 34.9525 ],
            [ -94.4532, 34.8439 ],
            [ -94.456, 34.7352 ],
            [ -94.4588, 34.6265 ],
            [ -94.4616, 34.5178 ],
            [ -94.4645, 34.4092 ],
            [ -94.4673, 34.3005 ],
            [ -94.4701, 34.1918 ],
            [ -94.4729, 34.0831 ],
            [ -94.4757, 33.9745 ],
            [ -94.4785, 33.8658 ],
            [ -94.4813, 33.7571 ],
            [ -94.4841, 33.6484 ],
            [ -94.7092, 33.6993 ],
            [ -94.7657, 33.7316 ],
            [ -94.8694, 33.7682 ],
            [ -94.9624, 33.8434 ],
            [ -95.1461, 33.9366 ],
            [ -95.2159, 33.959 ],
            [ -95.238, 33.9565 ],
            [ -95.276, 33.9106 ],
            [ -95.3739, 33.8743 ],
            [ -95.4271, 33.8728 ],
            [ -95.5235, 33.8866 ],
            [ -95.5418, 33.8982 ],
            [ -95.5557, 33.9261 ],
            [ -95.5945, 33.9452 ],
            [ -95.6228, 33.9303 ],
            [ -95.7632, 33.8915 ],
            [ -95.7839, 33.8645 ],
            [ -95.8631, 33.8633 ],
            [ -95.9416, 33.8828 ],
            [ -96.1393, 33.822 ],
            [ -96.2073, 33.7741 ],
            [ -96.2786, 33.7576 ],
            [ -96.315, 33.7111 ],
            [ -96.3368, 33.7177 ],
            [ -96.4111, 33.7752 ],
            [ -96.4872, 33.7923 ],
            [ -96.5916, 33.8493 ],
            [ -96.5954, 33.8994 ],
            [ -96.6063, 33.9056 ],
            [ -96.6251, 33.9114 ],
            [ -96.6485, 33.9064 ],
            [ -96.694, 33.8638 ],
            [ -96.7202, 33.8528 ],
            [ -96.7463, 33.8542 ],
            [ -96.8476, 33.8832 ],
            [ -96.89, 33.9346 ],
            [ -96.911, 33.9504 ],
            [ -96.9341, 33.9535 ],
            [ -96.9777, 33.938 ],
            [ -97.0022, 33.8816 ],
            [ -97.0216, 33.8665 ],
            [ -97.0638, 33.8568 ],
            [ -97.0612, 33.8285 ],
            [ -97.099, 33.7504 ],
            [ -97.119, 33.7348 ],
            [ -97.1451, 33.7377 ],
            [ -97.1724, 33.7569 ],
            [ -97.1925, 33.7846 ],
            [ -97.201, 33.8082 ],
            [ -97.1862, 33.8701 ],
            [ -97.1948, 33.8906 ],
            [ -97.2149, 33.8971 ],
            [ -97.2647, 33.8678 ],
            [ -97.3082, 33.8692 ],
            [ -97.3636, 33.8402 ],
            [ -97.3985, 33.8313 ],
            [ -97.4302, 33.8385 ],
            [ -97.4816, 33.8857 ],
            [ -97.5712, 33.9159 ],
            [ -97.6059, 33.9717 ],
            [ -97.6218, 33.9878 ],
            [ -97.6409, 33.9917 ],
            [ -97.6604, 33.99 ],
            [ -97.6919, 33.9721 ],
            [ -97.7953, 33.8991 ],
            [ -97.8424, 33.8758 ],
            [ -97.8829, 33.8711 ],
            [ -97.9216, 33.8784 ],
            [ -97.9462, 33.8971 ],
            [ -97.9511, 33.9712 ],
            [ -97.974, 33.9937 ],
            [ -98.0694, 34.0403 ],
            [ -98.0896, 34.0841 ],
            [ -98.0986, 34.145 ],
            [ -98.2141, 34.1353 ],
            [ -98.356, 34.1415 ],
            [ -98.4204, 34.0881 ],
            [ -98.4537, 34.0781 ],
            [ -98.4939, 34.0888 ],
            [ -98.6084, 34.1613 ],
            [ -98.7301, 34.1466 ],
            [ -98.799, 34.1547 ],
            [ -98.9688, 34.2086 ],
            [ -99.1023, 34.2135 ],
            [ -99.1575, 34.2233 ],
            [ -99.1866, 34.2355 ],
            [ -99.1999, 34.3183 ],
            [ -99.2529, 34.3881 ],
            [ -99.2703, 34.4072 ],
            [ -99.3604, 34.4561 ],
            [ -99.3749, 34.4579 ],
            [ -99.3847, 34.4468 ],
            [ -99.405, 34.3921 ],
            [ -99.4323, 34.3892 ],
            [ -99.5362, 34.4047 ],
            [ -99.632, 34.3885 ],
            [ -99.6856, 34.4158 ],
            [ -99.867, 34.5434 ],
            [ -99.9407, 34.5763 ],
            [ -99.9993, 34.5867 ],
            [ -99.9995, 34.7064 ],
            [ -99.9997, 34.826 ],
            [ -99.9999, 34.9456 ],
            [ -100.0001, 35.0653 ],
            [ -100.0003, 35.1849 ],
            [ -100.0005, 35.3046 ],
            [ -100.0007, 35.4242 ],
            [ -100.0009, 35.5438 ],
            [ -100.0011, 35.6635 ],
            [ -100.0013, 35.7831 ],
            [ -100.0015, 35.9027 ],
            [ -100.0017, 36.0223 ],
            [ -100.0019, 36.142 ],
            [ -100.0021, 36.2616 ],
            [ -100.0022, 36.3812 ],
            [ -100.0024, 36.5009 ],
            [ -100.1898, 36.5009 ],
            [ -100.3772, 36.5009 ],
            [ -100.5645, 36.5009 ],
            [ -100.7519, 36.501 ],
            [ -100.9393, 36.501 ],
            [ -101.1266, 36.501 ],
            [ -101.314, 36.5011 ],
            [ -101.5014, 36.5011 ],
            [ -101.6887, 36.5011 ],
            [ -101.8761, 36.5011 ],
            [ -102.0635, 36.5011 ],
            [ -102.2508, 36.5012 ],
            [ -102.4382, 36.5012 ],
            [ -102.6256, 36.5012 ],
            [ -102.8129, 36.5012 ],
            [ -103.0003, 36.5012 ],
            [ -103.0004, 36.6261 ],
            [ -103.0006, 36.751 ],
            [ -103.0007, 36.8759 ],
            [ -103.0008, 37.0008 ],
            [ -102.7538, 37.0008 ],
            [ -102.5068, 37.0008 ],
            [ -102.2598, 37.0008 ],
            [ -102.0128, 37.0008 ],
            [ -101.7817, 37.0008 ],
            [ -101.5506, 37.0008 ],
            [ -101.3195, 37.0008 ],
            [ -101.0884, 37.0008 ],
            [ -100.8573, 37.0008 ],
            [ -100.6263, 37.0008 ],
            [ -100.3952, 37.0008 ],
            [ -100.1641, 37.0008 ],
            [ -99.933, 37.0008 ],
            [ -99.7019, 37.0008 ],
            [ -99.4708, 37.0008 ],
            [ -99.2398, 37.0008 ],
            [ -99.0087, 37.0008 ],
            [ -98.7776, 37.0008 ],
            [ -98.5465, 37.0008 ],
            [ -98.3154, 37.0008 ],
            [ -98.0843, 37.0008 ],
            [ -97.8532, 37.0008 ],
            [ -97.6222, 37.0008 ],
            [ -97.3911, 37.0008 ],
            [ -97.16, 37.0008 ],
            [ -96.9289, 37.0008 ],
            [ -96.6978, 37.0008 ],
            [ -96.4667, 37.0008 ],
            [ -96.2356, 37.0008 ],
            [ -96.0046, 37.0008 ],
            [ -95.7735, 37.0008 ],
            [ -95.5424, 37.0008 ],
            [ -95.3113, 37.0008 ],
            [ -95.0802, 37.0008 ],
            [ -94.8492, 37.0008 ],
            [ -94.6181, 37.0008 ],
            [ -94.6181, 36.8758 ],
            [ -94.6182, 36.7509 ],
            [ -94.6183, 36.6259 ],
            [ -94.6184, 36.5009 ]
          ]
        ]
      },
      "properties": {
        "featurecla": "Admin-1 scale rank",
        "scalerank": 2,
        "adm1_code": "USA-3533",
        "diss_me": 3533,
        "adm1_cod_1": "USA-3533",
        "iso_3166_2": "US-OK",
        "wikipedia": "http://en.wikipedia.org/wiki/Oklahoma",
        "sr_sov_a3": "US1",
        "sr_adm0_a3": "USA",
        "iso_a2": "US",
        "adm0_sr": 1,
        "admin0_lab": 2,
        "name": "Oklahoma",
        "name_alt": "OK|Okla.",
        "name_local": "",
        "type": "State",
        "type_en": "State",
        "code_local": "US40",
        "code_hasc": "US.OK",
        "note": "",
        "hasc_maybe": "",
        "region": "South",
        "region_cod": "",
        "region_big": "West South Central",
        "big_code": "",
        "provnum_ne": 0,
        "gadm_level": 1,
        "check_me": 0,
        "scaleran_1": 2,
        "datarank": 1,
        "abbrev": "Okla.",
        "postal": "OK",
        "area_sqkm": 0,
        "sameascity": -99,
        "labelrank": 0,
        "featurec_1": "Admin-1 scale rank",
        "admin": "United States of America",
        "name_len": 8,
        "mapcolor9": 1,
        "mapcolor13": 1
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [ -123.2206, 46.1536 ],
            [ -123.1209, 46.1788 ],
            [ -123.0423, 46.16 ],
            [ -122.942, 46.1149 ],
            [ -122.8434, 45.9781 ],
            [ -122.7464, 45.7497 ],
            [ -122.7259, 45.6738 ],
            [ -122.6498, 45.6274 ],
            [ -122.561, 45.6251 ],
            [ -122.2025, 45.5911 ],
            [ -122.1499, 45.5938 ],
            [ -122.1499, 45.5939 ],
            [ -122.0851, 45.6026 ],
            [ -121.882, 45.6895 ],
            [ -121.6625, 45.7181 ],
            [ -121.4021, 45.7118 ],
            [ -121.2427, 45.687 ],
            [ -121.1843, 45.6438 ],
            [ -121.0452, 45.639 ],
            [ -120.7158, 45.6898 ],
            [ -120.3514, 45.7252 ],
            [ -120.156, 45.7622 ],
            [ -119.9343, 45.8379 ],
            [ -119.4291, 45.9342 ],
            [ -119.1773, 45.9451 ],
            [ -119.0499, 45.9815 ],
            [ -119.0197, 46.0003 ],
            [ -119.0024, 46.0005 ],
            [ -118.737, 46.0008 ],
            [ -118.4716, 46.001 ],
            [ -118.2061, 46.0013 ],
            [ -117.9407, 46.0015 ],
            [ -117.6752, 46.0018 ],
            [ -117.4098, 46.002 ],
            [ -117.1443, 46.0023 ],
            [ -116.8965, 46.0021 ],
            [ -116.8692, 45.9585 ],
            [ -116.7647, 45.8729 ],
            [ -116.6168, 45.7992 ],
            [ -116.5209, 45.7219 ],
            [ -116.477, 45.6411 ],
            [ -116.5492, 45.4567 ],
            [ -116.7373, 45.1688 ],
            [ -116.8396, 44.9852 ],
            [ -116.8559, 44.9057 ],
            [ -116.949, 44.7701 ],
            [ -117.1189, 44.5783 ],
            [ -117.2017, 44.4362 ],
            [ -117.1973, 44.3438 ],
            [ -117.1397, 44.2903 ],
            [ -117.029, 44.2755 ],
            [ -116.9532, 44.2453 ],
            [ -116.9124, 44.1995 ],
            [ -116.9113, 44.1574 ],
            [ -116.9498, 44.119 ],
            [ -116.9607, 44.0791 ],
            [ -116.944, 44.0377 ],
            [ -116.9576, 43.9641 ],
            [ -117.0205, 43.8132 ],
            [ -117.0202, 43.8084 ],
            [ -117.0198, 43.5629 ],
            [ -117.0193, 43.3397 ],
            [ -117.0189, 43.1165 ],
            [ -117.0185, 42.8934 ],
            [ -117.018, 42.6702 ],
            [ -117.0176, 42.447 ],
            [ -117.0171, 42.2238 ],
            [ -117.0167, 42.0006 ],
            [ -117.3897, 42.0006 ],
            [ -117.7627, 42.0006 ],
            [ -118.1357, 42.0006 ],
            [ -118.5088, 42.0006 ],
            [ -118.8818, 42.0006 ],
            [ -119.2548, 42.0006 ],
            [ -119.6278, 42.0006 ],
            [ -120.0008, 42.0006 ],
            [ -120.2645, 42.0006 ],
            [ -120.5281, 42.0006 ],
            [ -120.7918, 42.0006 ],
            [ -121.0554, 42.0006 ],
            [ -121.3191, 42.0006 ],
            [ -121.5827, 42.0006 ],
            [ -121.8464, 42.0006 ],
            [ -122.1101, 42.0006 ],
            [ -122.3737, 42.0006 ],
            [ -122.6374, 42.0006 ],
            [ -122.901, 42.0006 ],
            [ -123.1647, 42.0006 ],
            [ -123.4284, 42.0006 ],
            [ -123.692, 42.0006 ],
            [ -123.9557, 42.0006 ],
            [ -124.2284, 42.0008 ],
            [ -124.3553, 42.1229 ],
            [ -124.41, 42.3043 ],
            [ -124.4205, 42.381 ],
            [ -124.4062, 42.5837 ],
            [ -124.4438, 42.6702 ],
            [ -124.5396, 42.8129 ],
            [ -124.4986, 42.9369 ],
            [ -124.4544, 43.0124 ],
            [ -124.3466, 43.3416 ],
            [ -124.3206, 43.3682 ],
            [ -124.2755, 43.3674 ],
            [ -124.1969, 43.4233 ],
            [ -124.2332, 43.4364 ],
            [ -124.288, 43.4097 ],
            [ -124.2392, 43.54 ],
            [ -124.1844, 43.6516 ],
            [ -124.1487, 43.6917 ],
            [ -124.1307, 44.0557 ],
            [ -124.0992, 44.3338 ],
            [ -124.0475, 44.4255 ],
            [ -124.0654, 44.5201 ],
            [ -124.0445, 44.6482 ],
            [ -124.0592, 44.7777 ],
            [ -123.9486, 45.4008 ],
            [ -123.9631, 45.4761 ],
            [ -123.9294, 45.577 ],
            [ -123.9612, 45.843 ],
            [ -123.9471, 46.1406 ],
            [ -123.9752, 46.1783 ],
            [ -123.9893, 46.2194 ],
            [ -123.9629, 46.2255 ],
            [ -123.9117, 46.1822 ],
            [ -123.6736, 46.1826 ],
            [ -123.5216, 46.2227 ],
            [ -123.4664, 46.2094 ],
            [ -123.4023, 46.155 ],
            [ -123.3216, 46.144 ],
            [ -123.2206, 46.1536 ]
          ]
        ]
      },
      "properties": {
        "featurecla": "Admin-1 scale rank",
        "scalerank": 2,
        "adm1_code": "USA-3525",
        "diss_me": 3525,
        "adm1_cod_1": "USA-3525",
        "iso_3166_2": "US-OR",
        "wikipedia": "http://en.wikipedia.org/wiki/Oregon",
        "sr_sov_a3": "US1",
        "sr_adm0_a3": "USA",
        "iso_a2": "US",
        "adm0_sr": 6,
        "admin0_lab": 2,
        "name": "Oregon",
        "name_alt": "OR|Ore.",
        "name_local": "",
        "type": "State",
        "type_en": "State",
        "code_local": "US41",
        "code_hasc": "US.OR",
        "note": "",
        "hasc_maybe": "",
        "region": "West",
        "region_cod": "",
        "region_big": "Pacific",
        "big_code": "",
        "provnum_ne": 0,
        "gadm_level": 1,
        "check_me": 0,
        "scaleran_1": 2,
        "datarank": 1,
        "abbrev": "Ore.",
        "postal": "OR",
        "area_sqkm": 0,
        "sameascity": -99,
        "labelrank": 0,
        "featurec_1": "Admin-1 scale rank",
        "admin": "United States of America",
        "name_len": 6,
        "mapcolor9": 1,
        "mapcolor13": 1
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [ -74.6991, 41.3573 ],
            [ -74.7778, 41.3251 ],
            [ -74.8125, 41.3015 ],
            [ -74.8414, 41.2686 ],
            [ -74.9123, 41.1553 ],
            [ -75.0315, 41.0518 ],
            [ -75.123, 40.999 ],
            [ -75.1227, 40.9718 ],
            [ -75.0749, 40.8845 ],
            [ -75.0756, 40.8563 ],
            [ -75.1118, 40.8021 ],
            [ -75.1747, 40.7755 ],
            [ -75.1857, 40.7438 ],
            [ -75.1923, 40.6899 ],
            [ -75.189, 40.5958 ],
            [ -75.1705, 40.5768 ],
            [ -75.0974, 40.5431 ],
            [ -75.034, 40.4204 ],
            [ -74.9764, 40.4058 ],
            [ -74.7349, 40.1545 ],
            [ -74.9093, 40.0795 ],
            [ -75.0235, 40.0175 ],
            [ -75.0742, 39.9835 ],
            [ -75.1729, 39.8948 ],
            [ -75.3209, 39.8647 ],
            [ -75.4006, 39.8316 ],
            [ -75.421, 39.8154 ],
            [ -75.5104, 39.8434 ],
            [ -75.6346, 39.8395 ],
            [ -75.6768, 39.8272 ],
            [ -75.7091, 39.8029 ],
            [ -75.7847, 39.7224 ],
            [ -76.0155, 39.7224 ],
            [ -76.2463, 39.7224 ],
            [ -76.4771, 39.7225 ],
            [ -76.7079, 39.7225 ],
            [ -76.9387, 39.7225 ],
            [ -77.1695, 39.7225 ],
            [ -77.4003, 39.7226 ],
            [ -77.6311, 39.7226 ],
            [ -77.8619, 39.7226 ],
            [ -78.0927, 39.7226 ],
            [ -78.3235, 39.7227 ],
            [ -78.5543, 39.7227 ],
            [ -78.7851, 39.7227 ],
            [ -79.0159, 39.7227 ],
            [ -79.2467, 39.7228 ],
            [ -79.4775, 39.7228 ],
            [ -79.6077, 39.7227 ],
            [ -79.738, 39.7227 ],
            [ -79.8682, 39.7227 ],
            [ -79.9985, 39.7226 ],
            [ -80.1287, 39.7226 ],
            [ -80.2589, 39.7226 ],
            [ -80.3892, 39.7225 ],
            [ -80.5194, 39.7225 ],
            [ -80.5196, 39.8382 ],
            [ -80.5197, 39.9538 ],
            [ -80.5198, 40.0695 ],
            [ -80.5199, 40.1851 ],
            [ -80.52, 40.3008 ],
            [ -80.5201, 40.4165 ],
            [ -80.5202, 40.5321 ],
            [ -80.5191, 40.647 ],
            [ -80.5203, 40.7527 ],
            [ -80.5203, 40.8575 ],
            [ -80.5203, 40.9624 ],
            [ -80.5203, 41.0672 ],
            [ -80.5203, 41.172 ],
            [ -80.5203, 41.2769 ],
            [ -80.5203, 41.3817 ],
            [ -80.5203, 41.4866 ],
            [ -80.5203, 41.5914 ],
            [ -80.5203, 41.6962 ],
            [ -80.5203, 41.8011 ],
            [ -80.5203, 41.9059 ],
            [ -80.5203, 41.9896 ],
            [ -80.3345, 42.0408 ],
            [ -80.252, 42.0753 ],
            [ -80.1682, 42.109 ],
            [ -80.1247, 42.1283 ],
            [ -80.0762, 42.146 ],
            [ -79.763, 42.2757 ],
            [ -79.763, 42.2701 ],
            [ -79.763, 42.1355 ],
            [ -79.763, 42.0009 ],
            [ -79.6251, 42.0008 ],
            [ -79.4872, 42.0007 ],
            [ -79.3494, 42.0007 ],
            [ -79.2115, 42.0006 ],
            [ -79.0736, 42.0005 ],
            [ -78.9358, 42.0004 ],
            [ -78.7979, 42.0003 ],
            [ -78.6601, 42.0003 ],
            [ -78.5222, 42.0002 ],
            [ -78.3843, 42.0001 ],
            [ -78.2465, 42 ],
            [ -78.1086, 42 ],
            [ -77.9707, 41.9999 ],
            [ -77.8329, 41.9998 ],
            [ -77.695, 41.9997 ],
            [ -77.5571, 41.9997 ],
            [ -77.4193, 41.9996 ],
            [ -77.2814, 41.9995 ],
            [ -77.1436, 41.9994 ],
            [ -77.0057, 41.9994 ],
            [ -76.8678, 41.9993 ],
            [ -76.73, 41.9992 ],
            [ -76.5921, 41.9991 ],
            [ -76.4542, 41.999 ],
            [ -76.3164, 41.999 ],
            [ -76.1785, 41.9989 ],
            [ -76.0406, 41.9988 ],
            [ -75.9028, 41.9987 ],
            [ -75.7649, 41.9986 ],
            [ -75.6271, 41.9986 ],
            [ -75.4892, 41.9985 ],
            [ -75.3513, 41.9984 ],
            [ -75.274, 41.9467 ],
            [ -75.2389, 41.8922 ],
            [ -75.1219, 41.8534 ],
            [ -75.0955, 41.8317 ],
            [ -75.0948, 41.7995 ],
            [ -75.0537, 41.765 ],
            [ -75.0669, 41.7132 ],
            [ -75.0662, 41.6666 ],
            [ -75.0514, 41.6084 ],
            [ -75.0227, 41.5529 ],
            [ -74.9813, 41.5077 ],
            [ -74.9354, 41.4744 ],
            [ -74.7566, 41.4239 ],
            [ -74.7204, 41.3949 ],
            [ -74.6991, 41.3573 ]
          ]
        ]
      },
      "properties": {
        "featurecla": "Admin-1 scale rank",
        "scalerank": 2,
        "adm1_code": "USA-3560",
        "diss_me": 3560,
        "adm1_cod_1": "USA-3560",
        "iso_3166_2": "US-PA",
        "wikipedia": "http://en.wikipedia.org/wiki/Pennsylvania",
        "sr_sov_a3": "US1",
        "sr_adm0_a3": "USA",
        "iso_a2": "US",
        "adm0_sr": 1,
        "admin0_lab": 2,
        "name": "Pennsylvania",
        "name_alt": "Commonwealth of Pennsylvania|PA",
        "name_local": "",
        "type": "State",
        "type_en": "State",
        "code_local": "US42",
        "code_hasc": "US.PA",
        "note": "",
        "hasc_maybe": "",
        "region": "Northeast",
        "region_cod": "",
        "region_big": "Middle Atlantic",
        "big_code": "",
        "provnum_ne": 0,
        "gadm_level": 1,
        "check_me": 0,
        "scaleran_1": 2,
        "datarank": 1,
        "abbrev": "Pa.",
        "postal": "PA",
        "area_sqkm": 0,
        "sameascity": -99,
        "labelrank": 0,
        "featurec_1": "Admin-1 scale rank",
        "admin": "United States of America",
        "name_len": 12,
        "mapcolor9": 1,
        "mapcolor13": 1
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [ -71.3654, 41.4853 ],
            [ -71.3931, 41.4667 ],
            [ -71.4034, 41.515 ],
            [ -71.384, 41.5705 ],
            [ -71.3643, 41.5718 ],
            [ -71.3545, 41.5423 ],
            [ -71.3654, 41.4853 ]
          ],
          [
            [ -71.2414, 41.492 ],
            [ -71.2909, 41.4646 ],
            [ -71.3462, 41.4694 ],
            [ -71.3182, 41.5063 ],
            [ -71.3075, 41.5605 ],
            [ -71.2802, 41.62 ],
            [ -71.2645, 41.6382 ],
            [ -71.2321, 41.6543 ],
            [ -71.2414, 41.492 ]
          ],
          [
            [ -71.3407, 41.7979 ],
            [ -71.3047, 41.7747 ],
            [ -71.2679, 41.7508 ],
            [ -71.2338, 41.7066 ],
            [ -71.2711, 41.6812 ],
            [ -71.3108, 41.7199 ],
            [ -71.3306, 41.7623 ],
            [ -71.3592, 41.7862 ],
            [ -71.3902, 41.7953 ],
            [ -71.3637, 41.7027 ],
            [ -71.4265, 41.6333 ],
            [ -71.4438, 41.4537 ],
            [ -71.5229, 41.379 ],
            [ -71.7693, 41.3309 ],
            [ -71.8424, 41.3355 ],
            [ -71.8299, 41.3927 ],
            [ -71.8045, 41.4167 ],
            [ -71.7992, 41.4792 ],
            [ -71.7958, 41.52 ],
            [ -71.7965, 41.5889 ],
            [ -71.7973, 41.6676 ],
            [ -71.7982, 41.7531 ],
            [ -71.799, 41.8285 ],
            [ -71.7996, 41.883 ],
            [ -71.8003, 41.9582 ],
            [ -71.8008, 42.012 ],
            [ -71.7258, 42.0129 ],
            [ -71.6232, 42.014 ],
            [ -71.5241, 42.0152 ],
            [ -71.4625, 42.016 ],
            [ -71.3871, 42.0169 ],
            [ -71.3839, 41.9717 ],
            [ -71.3791, 41.9024 ],
            [ -71.3376, 41.8914 ],
            [ -71.3395, 41.8352 ],
            [ -71.3407, 41.7979 ]
          ]
        ]
      },
      "properties": {
        "featurecla": "Admin-1 scale rank",
        "scalerank": 2,
        "adm1_code": "USA-3539",
        "diss_me": 3539,
        "adm1_cod_1": "USA-3539",
        "iso_3166_2": "US-RI",
        "wikipedia": "http://en.wikipedia.org/wiki/Rhode_Island",
        "sr_sov_a3": "US1",
        "sr_adm0_a3": "USA",
        "iso_a2": "US",
        "adm0_sr": 6,
        "admin0_lab": 2,
        "name": "Rhode Island",
        "name_alt": "State of Rhode Island and Providence Plantations|RI|R.I.",
        "name_local": "",
        "type": "State",
        "type_en": "State",
        "code_local": "US44",
        "code_hasc": "US.RI",
        "note": "",
        "hasc_maybe": "",
        "region": "Northeast",
        "region_cod": "",
        "region_big": "New England",
        "big_code": "",
        "provnum_ne": 0,
        "gadm_level": 1,
        "check_me": 0,
        "scaleran_1": 2,
        "datarank": 1,
        "abbrev": "R.I.",
        "postal": "RI",
        "area_sqkm": 0,
        "sameascity": -99,
        "labelrank": 0,
        "featurec_1": "Admin-1 scale rank",
        "admin": "United States of America",
        "name_len": 12,
        "mapcolor9": 1,
        "mapcolor13": 1
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [ -78.5643, 33.8767 ],
            [ -78.5777, 33.8732 ],
            [ -78.8414, 33.7241 ],
            [ -78.9203, 33.6587 ],
            [ -79.1382, 33.4059 ],
            [ -79.1938, 33.2441 ],
            [ -79.2384, 33.3122 ],
            [ -79.2273, 33.3632 ],
            [ -79.2265, 33.4049 ],
            [ -79.2813, 33.3154 ],
            [ -79.2292, 33.1851 ],
            [ -79.276, 33.1354 ],
            [ -79.4199, 33.0425 ],
            [ -79.4987, 33.0273 ],
            [ -79.5871, 33.0009 ],
            [ -79.6149, 32.9093 ],
            [ -79.735, 32.8248 ],
            [ -79.805, 32.7874 ],
            [ -79.9331, 32.81 ],
            [ -79.8936, 32.7287 ],
            [ -79.9407, 32.6672 ],
            [ -80.0218, 32.6199 ],
            [ -80.1226, 32.5891 ],
            [ -80.1803, 32.5929 ],
            [ -80.2297, 32.5765 ],
            [ -80.2684, 32.5373 ],
            [ -80.3628, 32.5007 ],
            [ -80.461, 32.5213 ],
            [ -80.5722, 32.5337 ],
            [ -80.6342, 32.5117 ],
            [ -80.53, 32.4754 ],
            [ -80.4743, 32.4228 ],
            [ -80.4857, 32.3518 ],
            [ -80.5136, 32.3244 ],
            [ -80.5793, 32.2873 ],
            [ -80.6082, 32.2928 ],
            [ -80.6258, 32.3263 ],
            [ -80.6472, 32.3959 ],
            [ -80.6778, 32.3811 ],
            [ -80.6831, 32.3486 ],
            [ -80.7093, 32.337 ],
            [ -80.8026, 32.448 ],
            [ -80.7979, 32.3634 ],
            [ -80.7653, 32.2983 ],
            [ -80.7338, 32.2653 ],
            [ -80.702, 32.2459 ],
            [ -80.6942, 32.2157 ],
            [ -80.758, 32.1422 ],
            [ -80.7908, 32.1258 ],
            [ -80.8492, 32.1139 ],
            [ -80.8821, 32.0686 ],
            [ -80.8723, 32.0296 ],
            [ -81.0748, 32.1097 ],
            [ -81.135, 32.1819 ],
            [ -81.133, 32.2747 ],
            [ -81.1715, 32.3801 ],
            [ -81.2903, 32.5572 ],
            [ -81.377, 32.6075 ],
            [ -81.4338, 32.728 ],
            [ -81.4898, 32.9357 ],
            [ -81.5782, 33.0686 ],
            [ -81.6993, 33.1268 ],
            [ -81.7803, 33.1953 ],
            [ -81.8213, 33.2741 ],
            [ -81.8641, 33.3254 ],
            [ -81.9087, 33.3493 ],
            [ -81.9328, 33.3899 ],
            [ -81.9364, 33.4473 ],
            [ -82.0057, 33.5229 ],
            [ -82.2084, 33.6636 ],
            [ -82.2566, 33.7492 ],
            [ -82.3519, 33.8377 ],
            [ -82.5893, 34.0176 ],
            [ -82.5893, 34.0174 ],
            [ -82.8186, 34.366 ],
            [ -82.8186, 34.3661 ],
            [ -82.8477, 34.4369 ],
            [ -82.8968, 34.4658 ],
            [ -82.9757, 34.4764 ],
            [ -83.0528, 34.5109 ],
            [ -83.1659, 34.5985 ],
            [ -83.1665, 34.5996 ],
            [ -83.3556, 34.7083 ],
            [ -83.3167, 34.8057 ],
            [ -83.1704, 34.9329 ],
            [ -83.1214, 35.0006 ],
            [ -83.1148, 35.0015 ],
            [ -83.0966, 35.0016 ],
            [ -82.937, 35.0442 ],
            [ -82.7775, 35.0866 ],
            [ -82.744, 35.0841 ],
            [ -82.6515, 35.128 ],
            [ -82.464, 35.178 ],
            [ -82.3925, 35.2109 ],
            [ -82.3561, 35.2016 ],
            [ -82.1975, 35.1959 ],
            [ -82.0389, 35.1902 ],
            [ -81.8803, 35.1844 ],
            [ -81.7217, 35.1787 ],
            [ -81.5631, 35.1729 ],
            [ -81.4045, 35.1672 ],
            [ -81.2459, 35.1615 ],
            [ -81.0873, 35.1557 ],
            [ -81.0566, 35.1455 ],
            [ -81.0469, 35.1311 ],
            [ -81.0512, 35.089 ],
            [ -81.0452, 35.0656 ],
            [ -80.9337, 35.1137 ],
            [ -80.8817, 35.0579 ],
            [ -80.793, 34.9628 ],
            [ -80.7893, 34.9072 ],
            [ -80.7841, 34.8286 ],
            [ -80.6428, 34.8246 ],
            [ -80.5015, 34.8207 ],
            [ -80.3601, 34.8167 ],
            [ -80.2188, 34.8127 ],
            [ -80.0775, 34.8087 ],
            [ -79.9362, 34.8047 ],
            [ -79.7949, 34.8008 ],
            [ -79.6536, 34.7968 ],
            [ -79.5185, 34.6826 ],
            [ -79.3835, 34.5685 ],
            [ -79.2484, 34.4544 ],
            [ -79.1134, 34.3402 ],
            [ -78.9783, 34.2261 ],
            [ -78.8433, 34.1119 ],
            [ -78.7082, 33.9978 ],
            [ -78.5643, 33.8767 ]
          ]
        ]
      },
      "properties": {
        "featurecla": "Admin-1 scale rank",
        "scalerank": 2,
        "adm1_code": "USA-3545",
        "diss_me": 3545,
        "adm1_cod_1": "USA-3545",
        "iso_3166_2": "US-SC",
        "wikipedia": "http://en.wikipedia.org/wiki/South_Carolina",
        "sr_sov_a3": "US1",
        "sr_adm0_a3": "USA",
        "iso_a2": "US",
        "adm0_sr": 1,
        "admin0_lab": 2,
        "name": "South Carolina",
        "name_alt": "SC|S.C.",
        "name_local": "",
        "type": "State",
        "type_en": "State",
        "code_local": "US45",
        "code_hasc": "US.SC",
        "note": "",
        "hasc_maybe": "",
        "region": "South",
        "region_cod": "",
        "region_big": "South Atlantic",
        "big_code": "",
        "provnum_ne": 0,
        "gadm_level": 1,
        "check_me": 0,
        "scaleran_1": 2,
        "datarank": 1,
        "abbrev": "S.C.",
        "postal": "SC",
        "area_sqkm": 0,
        "sameascity": -99,
        "labelrank": 0,
        "featurec_1": "Admin-1 scale rank",
        "admin": "United States of America",
        "name_len": 14,
        "mapcolor9": 1,
        "mapcolor13": 1
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [ -96.5564, 45.9428 ],
            [ -96.5911, 45.8433 ],
            [ -96.6147, 45.8 ],
            [ -96.6627, 45.7557 ],
            [ -96.8136, 45.6592 ],
            [ -96.8511, 45.626 ],
            [ -96.8455, 45.5959 ],
            [ -96.8149, 45.5574 ],
            [ -96.7375, 45.4678 ],
            [ -96.6961, 45.4318 ],
            [ -96.5298, 45.3715 ],
            [ -96.4537, 45.2973 ],
            [ -96.4537, 45.0728 ],
            [ -96.4537, 44.8483 ],
            [ -96.4537, 44.6238 ],
            [ -96.4536, 44.3993 ],
            [ -96.4536, 44.1747 ],
            [ -96.4536, 43.9502 ],
            [ -96.4536, 43.7257 ],
            [ -96.4536, 43.5012 ],
            [ -96.5986, 43.4975 ],
            [ -96.5813, 43.4349 ],
            [ -96.5416, 43.3735 ],
            [ -96.535, 43.3381 ],
            [ -96.5425, 43.309 ],
            [ -96.5699, 43.2833 ],
            [ -96.5635, 43.2427 ],
            [ -96.5554, 43.2317 ],
            [ -96.4903, 43.2055 ],
            [ -96.4681, 43.1702 ],
            [ -96.4613, 43.1298 ],
            [ -96.4627, 43.0992 ],
            [ -96.5021, 43.0433 ],
            [ -96.5133, 42.9691 ],
            [ -96.5626, 42.8586 ],
            [ -96.6161, 42.7914 ],
            [ -96.6268, 42.757 ],
            [ -96.6218, 42.7295 ],
            [ -96.5387, 42.6586 ],
            [ -96.5336, 42.6302 ],
            [ -96.5063, 42.5936 ],
            [ -96.481, 42.5113 ],
            [ -96.558, 42.5248 ],
            [ -96.6328, 42.5687 ],
            [ -96.6755, 42.6376 ],
            [ -96.8045, 42.7014 ],
            [ -97.0197, 42.7602 ],
            [ -97.1645, 42.8132 ],
            [ -97.2388, 42.8605 ],
            [ -97.4167, 42.881 ],
            [ -97.6981, 42.8746 ],
            [ -97.8809, 42.8496 ],
            [ -97.9649, 42.8059 ],
            [ -98.1433, 42.8523 ],
            [ -98.4418, 43.0011 ],
            [ -98.8371, 43.0012 ],
            [ -99.1833, 43.0012 ],
            [ -99.5294, 43.0012 ],
            [ -99.8755, 43.0012 ],
            [ -100.2216, 43.0012 ],
            [ -100.5677, 43.0013 ],
            [ -100.9138, 43.0013 ],
            [ -101.2599, 43.0013 ],
            [ -101.6061, 43.0013 ],
            [ -101.9522, 43.0013 ],
            [ -102.2983, 43.0014 ],
            [ -102.6444, 43.0014 ],
            [ -102.9905, 43.0014 ],
            [ -103.3366, 43.0014 ],
            [ -103.6827, 43.0014 ],
            [ -104.0289, 43.0014 ],
            [ -104.0299, 43.2514 ],
            [ -104.031, 43.5013 ],
            [ -104.032, 43.7513 ],
            [ -104.033, 44.0013 ],
            [ -104.0341, 44.2513 ],
            [ -104.0351, 44.5012 ],
            [ -104.0362, 44.7512 ],
            [ -104.0372, 45.0011 ],
            [ -104.0293, 45.0011 ],
            [ -104.0213, 45.0011 ],
            [ -104.0134, 45.001 ],
            [ -104.0055, 45.001 ],
            [ -104.0053, 45.0041 ],
            [ -104.0051, 45.0072 ],
            [ -104.005, 45.0104 ],
            [ -104.0048, 45.0135 ],
            [ -104.0064, 45.2459 ],
            [ -104.0079, 45.4783 ],
            [ -104.0095, 45.7106 ],
            [ -104.0111, 45.9431 ],
            [ -103.7781, 45.943 ],
            [ -103.5452, 45.943 ],
            [ -103.3122, 45.943 ],
            [ -103.0793, 45.943 ],
            [ -102.8463, 45.943 ],
            [ -102.6133, 45.943 ],
            [ -102.3804, 45.943 ],
            [ -102.1474, 45.943 ],
            [ -101.9145, 45.943 ],
            [ -101.6815, 45.943 ],
            [ -101.4486, 45.943 ],
            [ -101.2156, 45.943 ],
            [ -100.9826, 45.9429 ],
            [ -100.7497, 45.9429 ],
            [ -100.5167, 45.9429 ],
            [ -100.2837, 45.9429 ],
            [ -100.0508, 45.9429 ],
            [ -99.8178, 45.9429 ],
            [ -99.5848, 45.9429 ],
            [ -99.3519, 45.9429 ],
            [ -99.1189, 45.9429 ],
            [ -98.886, 45.9429 ],
            [ -98.653, 45.9429 ],
            [ -98.4201, 45.9429 ],
            [ -98.1871, 45.9428 ],
            [ -97.9541, 45.9428 ],
            [ -97.7212, 45.9428 ],
            [ -97.4882, 45.9428 ],
            [ -97.2553, 45.9428 ],
            [ -97.0223, 45.9428 ],
            [ -96.7894, 45.9428 ],
            [ -96.5564, 45.9428 ]
          ]
        ]
      },
      "properties": {
        "featurecla": "Admin-1 scale rank",
        "scalerank": 2,
        "adm1_code": "USA-3534",
        "diss_me": 3534,
        "adm1_cod_1": "USA-3534",
        "iso_3166_2": "US-SD",
        "wikipedia": "http://en.wikipedia.org/wiki/South_Dakota",
        "sr_sov_a3": "US1",
        "sr_adm0_a3": "USA",
        "iso_a2": "US",
        "adm0_sr": 1,
        "admin0_lab": 2,
        "name": "South Dakota",
        "name_alt": "SD|S.D.",
        "name_local": "",
        "type": "State",
        "type_en": "State",
        "code_local": "US46",
        "code_hasc": "US.SD",
        "note": "",
        "hasc_maybe": "",
        "region": "Midwest",
        "region_cod": "",
        "region_big": "West North Central",
        "big_code": "",
        "provnum_ne": 0,
        "gadm_level": 1,
        "check_me": 0,
        "scaleran_1": 2,
        "datarank": 1,
        "abbrev": "S.D.",
        "postal": "SD",
        "area_sqkm": 0,
        "sameascity": -99,
        "labelrank": 0,
        "featurec_1": "Admin-1 scale rank",
        "admin": "United States of America",
        "name_len": 12,
        "mapcolor9": 1,
        "mapcolor13": 1
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [ -83.6675, 36.605 ],
            [ -83.4408, 36.6041 ],
            [ -82.9558, 36.6021 ],
            [ -82.6118, 36.6007 ],
            [ -82.3294, 36.5995 ],
            [ -82.1622, 36.5989 ],
            [ -81.9525, 36.598 ],
            [ -81.9053, 36.6185 ],
            [ -81.8007, 36.6152 ],
            [ -81.6589, 36.6106 ],
            [ -81.7044, 36.534 ],
            [ -81.7076, 36.482 ],
            [ -81.7333, 36.4059 ],
            [ -81.7341, 36.3555 ],
            [ -81.8083, 36.3527 ],
            [ -81.8512, 36.3397 ],
            [ -81.9082, 36.3064 ],
            [ -82.0514, 36.1229 ],
            [ -82.1006, 36.1065 ],
            [ -82.1825, 36.1538 ],
            [ -82.2949, 36.134 ],
            [ -82.3682, 36.0995 ],
            [ -82.4784, 36.0101 ],
            [ -82.5211, 35.9812 ],
            [ -82.5534, 35.971 ],
            [ -82.5768, 35.9723 ],
            [ -82.5888, 35.987 ],
            [ -82.5981, 36.0316 ],
            [ -82.6111, 36.0474 ],
            [ -82.6449, 36.0468 ],
            [ -82.7001, 36.0298 ],
            [ -82.7556, 35.9999 ],
            [ -82.8128, 35.9474 ],
            [ -82.8877, 35.9517 ],
            [ -82.9019, 35.9392 ],
            [ -82.9203, 35.8789 ],
            [ -82.9495, 35.8345 ],
            [ -82.9902, 35.8004 ],
            [ -83.1204, 35.7746 ],
            [ -83.2842, 35.6821 ],
            [ -83.5111, 35.5841 ],
            [ -83.7227, 35.5599 ],
            [ -83.8117, 35.5403 ],
            [ -83.8713, 35.5149 ],
            [ -84.0037, 35.4141 ],
            [ -84.0623, 35.286 ],
            [ -84.1286, 35.2614 ],
            [ -84.2325, 35.2606 ],
            [ -84.2611, 35.2496 ],
            [ -84.287, 35.2008 ],
            [ -84.3247, 34.9881 ],
            [ -84.6494, 34.9913 ],
            [ -84.9742, 34.9945 ],
            [ -85.2989, 34.9977 ],
            [ -85.6236, 35.0009 ],
            [ -85.784, 35.0024 ],
            [ -85.9444, 35.0039 ],
            [ -86.1049, 35.0054 ],
            [ -86.2653, 35.0069 ],
            [ -86.4257, 35.0084 ],
            [ -86.5862, 35.0099 ],
            [ -86.7466, 35.0114 ],
            [ -86.907, 35.0129 ],
            [ -87.0674, 35.0145 ],
            [ -87.2279, 35.0159 ],
            [ -87.3883, 35.0175 ],
            [ -87.5487, 35.0189 ],
            [ -87.7092, 35.0205 ],
            [ -87.8696, 35.022 ],
            [ -88.03, 35.0235 ],
            [ -88.1904, 35.025 ],
            [ -88.2031, 35.0242 ],
            [ -88.1908, 35.012 ],
            [ -88.1733, 34.999 ],
            [ -88.4448, 34.9991 ],
            [ -88.7104, 34.9994 ],
            [ -88.9761, 34.9997 ],
            [ -89.2417, 35 ],
            [ -89.5073, 35.0003 ],
            [ -89.773, 35.0006 ],
            [ -90.0386, 35.0008 ],
            [ -90.2937, 35.0011 ],
            [ -90.2938, 35.0045 ],
            [ -90.256, 35.0464 ],
            [ -90.1423, 35.1143 ],
            [ -90.0929, 35.2036 ],
            [ -90.1079, 35.3142 ],
            [ -90.066, 35.4141 ],
            [ -89.9673, 35.5033 ],
            [ -89.9265, 35.5917 ],
            [ -89.9435, 35.6791 ],
            [ -89.8946, 35.7505 ],
            [ -89.7797, 35.8057 ],
            [ -89.7636, 35.828 ],
            [ -89.7681, 35.8452 ],
            [ -89.7699, 35.8643 ],
            [ -89.7689, 35.8721 ],
            [ -89.7636, 35.8888 ],
            [ -89.7382, 35.8987 ],
            [ -89.7038, 35.9069 ],
            [ -89.6889, 35.921 ],
            [ -89.6892, 35.9436 ],
            [ -89.7093, 35.9831 ],
            [ -89.7048, 36.0016 ],
            [ -89.6977, 36.0303 ],
            [ -89.6419, 36.1045 ],
            [ -89.6341, 36.1679 ],
            [ -89.6745, 36.2206 ],
            [ -89.6541, 36.248 ],
            [ -89.628, 36.2553 ],
            [ -89.5946, 36.2594 ],
            [ -89.5835, 36.2722 ],
            [ -89.5835, 36.2877 ],
            [ -89.6117, 36.322 ],
            [ -89.6041, 36.3519 ],
            [ -89.5553, 36.3729 ],
            [ -89.5406, 36.4267 ],
            [ -89.5573, 36.5011 ],
            [ -89.4872, 36.5031 ],
            [ -89.4854, 36.4981 ],
            [ -89.4715, 36.4889 ],
            [ -89.4518, 36.4975 ],
            [ -89.4503, 36.5 ],
            [ -89.2518, 36.4999 ],
            [ -89.0791, 36.4999 ],
            [ -88.9064, 36.4999 ],
            [ -88.7336, 36.4998 ],
            [ -88.5609, 36.4998 ],
            [ -88.3882, 36.4998 ],
            [ -88.2155, 36.4997 ],
            [ -88.0591, 36.4997 ],
            [ -88.056, 36.5009 ],
            [ -88.0567, 36.5903 ],
            [ -88.0963, 36.693 ],
            [ -88.0911, 36.6928 ],
            [ -87.9563, 36.682 ],
            [ -87.8687, 36.675 ],
            [ -87.8392, 36.644 ],
            [ -87.5063, 36.6492 ],
            [ -87.1734, 36.6544 ],
            [ -86.8405, 36.6596 ],
            [ -86.5076, 36.6648 ],
            [ -86.1605, 36.6551 ],
            [ -85.8133, 36.6453 ],
            [ -85.4661, 36.6356 ],
            [ -85.119, 36.6258 ],
            [ -84.7718, 36.6161 ],
            [ -84.4247, 36.6063 ],
            [ -84.0775, 36.5966 ],
            [ -83.7304, 36.5868 ],
            [ -83.7225, 36.5891 ],
            [ -83.7147, 36.5914 ],
            [ -83.7068, 36.5936 ],
            [ -83.6989, 36.5959 ],
            [ -83.6911, 36.5982 ],
            [ -83.6832, 36.6004 ],
            [ -83.6754, 36.6027 ],
            [ -83.6675, 36.605 ]
          ]
        ]
      },
      "properties": {
        "featurecla": "Admin-1 scale rank",
        "scalerank": 2,
        "adm1_code": "USA-3551",
        "diss_me": 3551,
        "adm1_cod_1": "USA-3551",
        "iso_3166_2": "US-TN",
        "wikipedia": "http://en.wikipedia.org/wiki/Tennessee",
        "sr_sov_a3": "US1",
        "sr_adm0_a3": "USA",
        "iso_a2": "US",
        "adm0_sr": 1,
        "admin0_lab": 2,
        "name": "Tennessee",
        "name_alt": "TN|Tenn.",
        "name_local": "",
        "type": "State",
        "type_en": "State",
        "code_local": "US47",
        "code_hasc": "US.TN",
        "note": "",
        "hasc_maybe": "",
        "region": "South",
        "region_cod": "",
        "region_big": "East South Central",
        "big_code": "",
        "provnum_ne": 0,
        "gadm_level": 1,
        "check_me": 0,
        "scaleran_1": 2,
        "datarank": 1,
        "abbrev": "Tenn.",
        "postal": "TN",
        "area_sqkm": 0,
        "sameascity": -99,
        "labelrank": 0,
        "featurec_1": "Admin-1 scale rank",
        "admin": "United States of America",
        "name_len": 9,
        "mapcolor9": 1,
        "mapcolor13": 1
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [ -97.1707, 26.1594 ],
            [ -97.1845, 26.1129 ],
            [ -97.2673, 26.3298 ],
            [ -97.4021, 26.8205 ],
            [ -97.4072, 27.1002 ],
            [ -97.386, 27.1965 ],
            [ -97.3512, 26.8015 ],
            [ -97.2022, 26.2998 ],
            [ -97.1707, 26.1594 ]
          ],
          [
            [ -97.3536, 27.3001 ],
            [ -97.3848, 27.2425 ],
            [ -97.3762, 27.3283 ],
            [ -97.295, 27.5231 ],
            [ -97.13, 27.7791 ],
            [ -97.0606, 27.822 ],
            [ -97.2509, 27.5412 ],
            [ -97.3536, 27.3001 ]
          ],
          [
            [ -97.0144, 27.9016 ],
            [ -97.036, 27.8992 ],
            [ -96.9876, 27.981 ],
            [ -96.9787, 28.0138 ],
            [ -96.8993, 28.1175 ],
            [ -96.8574, 28.1329 ],
            [ -96.8398, 28.0888 ],
            [ -96.9213, 28.016 ],
            [ -97.0144, 27.9016 ]
          ],
          [
            [ -96.7644, 28.1526 ],
            [ -96.8011, 28.1484 ],
            [ -96.7556, 28.2024 ],
            [ -96.6816, 28.2297 ],
            [ -96.5193, 28.3335 ],
            [ -96.4531, 28.3406 ],
            [ -96.4186, 28.3763 ],
            [ -96.4036, 28.3816 ],
            [ -96.4133, 28.3378 ],
            [ -96.5439, 28.2756 ],
            [ -96.7644, 28.1526 ]
          ],
          [
            [ -95.0397, 29.1459 ],
            [ -95.0897, 29.1363 ],
            [ -94.8717, 29.2901 ],
            [ -94.826, 29.3413 ],
            [ -94.7676, 29.339 ],
            [ -94.865, 29.2529 ],
            [ -95.0397, 29.1459 ]
          ],
          [
            [ -102.8129, 36.5012 ],
            [ -102.6256, 36.5012 ],
            [ -102.4382, 36.5012 ],
            [ -102.2508, 36.5012 ],
            [ -102.0635, 36.5011 ],
            [ -101.8761, 36.5011 ],
            [ -101.6887, 36.5011 ],
            [ -101.5014, 36.5011 ],
            [ -101.314, 36.5011 ],
            [ -101.1266, 36.501 ],
            [ -100.9393, 36.501 ],
            [ -100.7519, 36.501 ],
            [ -100.5645, 36.5009 ],
            [ -100.3772, 36.5009 ],
            [ -100.1898, 36.5009 ],
            [ -100.0024, 36.5009 ],
            [ -100.0022, 36.3812 ],
            [ -100.0021, 36.2616 ],
            [ -100.0019, 36.142 ],
            [ -100.0017, 36.0223 ],
            [ -100.0015, 35.9027 ],
            [ -100.0013, 35.7831 ],
            [ -100.0011, 35.6635 ],
            [ -100.0009, 35.5438 ],
            [ -100.0007, 35.4242 ],
            [ -100.0005, 35.3046 ],
            [ -100.0003, 35.1849 ],
            [ -100.0001, 35.0653 ],
            [ -99.9999, 34.9456 ],
            [ -99.9997, 34.826 ],
            [ -99.9995, 34.7064 ],
            [ -99.9993, 34.5867 ],
            [ -99.9407, 34.5763 ],
            [ -99.867, 34.5434 ],
            [ -99.6856, 34.4158 ],
            [ -99.632, 34.3885 ],
            [ -99.5362, 34.4047 ],
            [ -99.4323, 34.3892 ],
            [ -99.405, 34.3921 ],
            [ -99.3847, 34.4468 ],
            [ -99.3749, 34.4579 ],
            [ -99.3604, 34.4561 ],
            [ -99.2703, 34.4072 ],
            [ -99.2529, 34.3881 ],
            [ -99.1999, 34.3183 ],
            [ -99.1866, 34.2355 ],
            [ -99.1575, 34.2233 ],
            [ -99.1023, 34.2135 ],
            [ -98.9688, 34.2086 ],
            [ -98.799, 34.1547 ],
            [ -98.7301, 34.1466 ],
            [ -98.6084, 34.1613 ],
            [ -98.4939, 34.0888 ],
            [ -98.4537, 34.0781 ],
            [ -98.4204, 34.0881 ],
            [ -98.356, 34.1415 ],
            [ -98.2141, 34.1353 ],
            [ -98.0986, 34.145 ],
            [ -98.0896, 34.0841 ],
            [ -98.0694, 34.0403 ],
            [ -97.974, 33.9937 ],
            [ -97.9511, 33.9712 ],
            [ -97.9462, 33.8971 ],
            [ -97.9216, 33.8784 ],
            [ -97.8829, 33.8711 ],
            [ -97.8424, 33.8758 ],
            [ -97.7953, 33.8991 ],
            [ -97.6919, 33.9721 ],
            [ -97.6604, 33.99 ],
            [ -97.6409, 33.9917 ],
            [ -97.6218, 33.9878 ],
            [ -97.6059, 33.9717 ],
            [ -97.5712, 33.9159 ],
            [ -97.4816, 33.8857 ],
            [ -97.4302, 33.8385 ],
            [ -97.3985, 33.8313 ],
            [ -97.3636, 33.8402 ],
            [ -97.3082, 33.8692 ],
            [ -97.2647, 33.8678 ],
            [ -97.2149, 33.8971 ],
            [ -97.1948, 33.8906 ],
            [ -97.1862, 33.8701 ],
            [ -97.201, 33.8082 ],
            [ -97.1925, 33.7846 ],
            [ -97.1724, 33.7569 ],
            [ -97.1451, 33.7377 ],
            [ -97.119, 33.7348 ],
            [ -97.099, 33.7504 ],
            [ -97.0612, 33.8285 ],
            [ -97.0638, 33.8568 ],
            [ -97.0216, 33.8665 ],
            [ -97.0022, 33.8816 ],
            [ -96.9777, 33.938 ],
            [ -96.9341, 33.9535 ],
            [ -96.911, 33.9504 ],
            [ -96.89, 33.9346 ],
            [ -96.8476, 33.8832 ],
            [ -96.7463, 33.8542 ],
            [ -96.7202, 33.8528 ],
            [ -96.694, 33.8638 ],
            [ -96.6485, 33.9064 ],
            [ -96.6251, 33.9114 ],
            [ -96.6063, 33.9056 ],
            [ -96.5954, 33.8994 ],
            [ -96.5916, 33.8493 ],
            [ -96.4872, 33.7923 ],
            [ -96.4111, 33.7752 ],
            [ -96.3368, 33.7177 ],
            [ -96.315, 33.7111 ],
            [ -96.2786, 33.7576 ],
            [ -96.2073, 33.7741 ],
            [ -96.1393, 33.822 ],
            [ -95.9416, 33.8828 ],
            [ -95.8631, 33.8633 ],
            [ -95.7839, 33.8645 ],
            [ -95.7632, 33.8915 ],
            [ -95.6228, 33.9303 ],
            [ -95.5945, 33.9452 ],
            [ -95.5557, 33.9261 ],
            [ -95.5418, 33.8982 ],
            [ -95.5235, 33.8866 ],
            [ -95.4271, 33.8728 ],
            [ -95.3739, 33.8743 ],
            [ -95.276, 33.9106 ],
            [ -95.238, 33.9565 ],
            [ -95.2159, 33.959 ],
            [ -95.1461, 33.9366 ],
            [ -94.9624, 33.8434 ],
            [ -94.8694, 33.7682 ],
            [ -94.7657, 33.7316 ],
            [ -94.7092, 33.6993 ],
            [ -94.4841, 33.6484 ],
            [ -94.432, 33.5997 ],
            [ -94.3901, 33.5856 ],
            [ -94.378, 33.5661 ],
            [ -94.3577, 33.561 ],
            [ -94.3326, 33.565 ],
            [ -94.2947, 33.5875 ],
            [ -94.2385, 33.5812 ],
            [ -94.1915, 33.589 ],
            [ -94.0988, 33.5773 ],
            [ -94.0473, 33.5544 ],
            [ -94.0458, 33.4188 ],
            [ -94.0443, 33.2832 ],
            [ -94.0428, 33.1476 ],
            [ -94.0413, 33.012 ],
            [ -94.0416, 32.8854 ],
            [ -94.0418, 32.7588 ],
            [ -94.042, 32.6322 ],
            [ -94.0423, 32.5056 ],
            [ -94.0425, 32.379 ],
            [ -94.0428, 32.2524 ],
            [ -94.0431, 32.1258 ],
            [ -94.0433, 31.9992 ],
            [ -93.9051, 31.877 ],
            [ -93.8456, 31.7929 ],
            [ -93.8268, 31.7503 ],
            [ -93.8207, 31.604 ],
            [ -93.8069, 31.5688 ],
            [ -93.7376, 31.5138 ],
            [ -93.7361, 31.4777 ],
            [ -93.6637, 31.3722 ],
            [ -93.6659, 31.3226 ],
            [ -93.597, 31.2098 ],
            [ -93.5577, 31.1804 ],
            [ -93.5514, 31.1041 ],
            [ -93.5306, 31.0462 ],
            [ -93.5627, 31.0049 ],
            [ -93.5492, 30.9477 ],
            [ -93.5687, 30.8947 ],
            [ -93.5792, 30.8238 ],
            [ -93.6247, 30.7143 ],
            [ -93.6652, 30.6608 ],
            [ -93.7202, 30.5583 ],
            [ -93.7152, 30.4733 ],
            [ -93.7466, 30.3804 ],
            [ -93.7504, 30.3447 ],
            [ -93.721, 30.2829 ],
            [ -93.7106, 30.1128 ],
            [ -93.7269, 30.0771 ],
            [ -93.794, 29.9773 ],
            [ -93.8414, 29.9797 ],
            [ -93.9463, 29.815 ],
            [ -93.8864, 29.7226 ],
            [ -93.8905, 29.6894 ],
            [ -94.0997, 29.6704 ],
            [ -94.5745, 29.4845 ],
            [ -94.7596, 29.3843 ],
            [ -94.7501, 29.418 ],
            [ -94.5263, 29.548 ],
            [ -94.6053, 29.5678 ],
            [ -94.7326, 29.5354 ],
            [ -94.7783, 29.5479 ],
            [ -94.7244, 29.6553 ],
            [ -94.7419, 29.75 ],
            [ -94.8323, 29.7526 ],
            [ -94.8899, 29.677 ],
            [ -94.9299, 29.6801 ],
            [ -94.9823, 29.7126 ],
            [ -95.0229, 29.7023 ],
            [ -94.9928, 29.5309 ],
            [ -94.9359, 29.4605 ],
            [ -94.8883, 29.3706 ],
            [ -95.0183, 29.2595 ],
            [ -95.139, 29.1678 ],
            [ -95.1521, 29.0792 ],
            [ -95.2735, 28.9639 ],
            [ -95.3876, 28.8984 ],
            [ -95.6559, 28.7446 ],
            [ -95.7324, 28.7117 ],
            [ -95.8534, 28.6403 ],
            [ -96.0204, 28.5868 ],
            [ -96.1805, 28.5019 ],
            [ -96.2345, 28.489 ],
            [ -96.1323, 28.5609 ],
            [ -96.011, 28.6319 ],
            [ -96.115, 28.6222 ],
            [ -96.2754, 28.6551 ],
            [ -96.3734, 28.657 ],
            [ -96.3741, 28.6311 ],
            [ -96.4487, 28.5945 ],
            [ -96.526, 28.6483 ],
            [ -96.5597, 28.6844 ],
            [ -96.5757, 28.7157 ],
            [ -96.6085, 28.7233 ],
            [ -96.64, 28.7088 ],
            [ -96.5246, 28.4887 ],
            [ -96.4755, 28.4792 ],
            [ -96.4211, 28.4573 ],
            [ -96.4888, 28.4061 ],
            [ -96.5617, 28.3672 ],
            [ -96.6763, 28.3413 ],
            [ -96.7735, 28.4216 ],
            [ -96.7946, 28.3209 ],
            [ -96.8069, 28.2202 ],
            [ -96.8395, 28.1944 ],
            [ -96.8916, 28.1576 ],
            [ -96.9199, 28.1853 ],
            [ -96.9333, 28.2243 ],
            [ -96.9666, 28.1895 ],
            [ -97.0155, 28.1635 ],
            [ -97.096, 28.1583 ],
            [ -97.1565, 28.1444 ],
            [ -97.1551, 28.1027 ],
            [ -97.1413, 28.0608 ],
            [ -97.0343, 28.0938 ],
            [ -97.0731, 27.9861 ],
            [ -97.1715, 27.8796 ],
            [ -97.2516, 27.8544 ],
            [ -97.3741, 27.87 ],
            [ -97.4044, 27.8593 ],
            [ -97.4315, 27.8372 ],
            [ -97.2887, 27.6706 ],
            [ -97.3805, 27.4194 ],
            [ -97.4391, 27.3283 ],
            [ -97.4798, 27.3166 ],
            [ -97.5239, 27.314 ],
            [ -97.6821, 27.3949 ],
            [ -97.7684, 27.4575 ],
            [ -97.6924, 27.2871 ],
            [ -97.4851, 27.2374 ],
            [ -97.4745, 27.1729 ],
            [ -97.4757, 27.1179 ],
            [ -97.5165, 27.0532 ],
            [ -97.5547, 26.9674 ],
            [ -97.5265, 26.9075 ],
            [ -97.4938, 26.7596 ],
            [ -97.4658, 26.6918 ],
            [ -97.4351, 26.4859 ],
            [ -97.4023, 26.3965 ],
            [ -97.2139, 26.0679 ],
            [ -97.1504, 26.0653 ],
            [ -97.1402, 26.0297 ],
            [ -97.1462, 25.9615 ],
            [ -97.2818, 25.9416 ],
            [ -97.3386, 25.9112 ],
            [ -97.3497, 25.8848 ],
            [ -97.3582, 25.8705 ],
            [ -97.3756, 25.8718 ],
            [ -97.4403, 25.8908 ],
            [ -97.5872, 25.9842 ],
            [ -97.8014, 26.042 ],
            [ -98.0828, 26.0644 ],
            [ -98.275, 26.1112 ],
            [ -98.3781, 26.1824 ],
            [ -98.4859, 26.2246 ],
            [ -98.5983, 26.2379 ],
            [ -98.6914, 26.2765 ],
            [ -98.7652, 26.3404 ],
            [ -98.8732, 26.3812 ],
            [ -99.0153, 26.399 ],
            [ -99.1078, 26.4469 ],
            [ -99.1721, 26.5641 ],
            [ -99.1724, 26.5659 ],
            [ -99.2299, 26.7619 ],
            [ -99.3025, 26.8847 ],
            [ -99.4435, 27.0367 ],
            [ -99.4565, 27.0566 ],
            [ -99.4565, 27.0567 ],
            [ -99.4577, 27.0817 ],
            [ -99.4403, 27.1701 ],
            [ -99.4551, 27.2337 ],
            [ -99.4998, 27.2855 ],
            [ -99.5101, 27.3403 ],
            [ -99.4858, 27.398 ],
            [ -99.4843, 27.4674 ],
            [ -99.5053, 27.5483 ],
            [ -99.5953, 27.6359 ],
            [ -99.7543, 27.7299 ],
            [ -99.8896, 27.8673 ],
            [ -100.0014, 28.0478 ],
            [ -100.1119, 28.173 ],
            [ -100.2213, 28.2426 ],
            [ -100.296, 28.3277 ],
            [ -100.3363, 28.4281 ],
            [ -100.3482, 28.4864 ],
            [ -100.3317, 28.5025 ],
            [ -100.3989, 28.6142 ],
            [ -100.5497, 28.8213 ],
            [ -100.6363, 28.9728 ],
            [ -100.6586, 29.0685 ],
            [ -100.7546, 29.1825 ],
            [ -100.9241, 29.3147 ],
            [ -101.0163, 29.4007 ],
            [ -101.0386, 29.4603 ],
            [ -101.039, 29.4604 ],
            [ -101.3035, 29.6341 ],
            [ -101.3803, 29.7426 ],
            [ -101.4404, 29.7768 ],
            [ -101.5093, 29.7731 ],
            [ -101.5446, 29.7835 ],
            [ -101.5464, 29.8081 ],
            [ -101.5687, 29.8092 ],
            [ -101.6116, 29.787 ],
            [ -101.7523, 29.7825 ],
            [ -101.9909, 29.7957 ],
            [ -102.1631, 29.8253 ],
            [ -102.2689, 29.8712 ],
            [ -102.3431, 29.865 ],
            [ -102.3857, 29.8067 ],
            [ -102.4762, 29.7691 ],
            [ -102.6149, 29.7523 ],
            [ -102.7342, 29.6439 ],
            [ -102.834, 29.444 ],
            [ -102.8778, 29.3153 ],
            [ -102.8657, 29.258 ],
            [ -102.892, 29.2164 ],
            [ -102.9568, 29.1904 ],
            [ -103.0228, 29.1322 ],
            [ -103.09, 29.0419 ],
            [ -103.1683, 28.9982 ],
            [ -103.2577, 29.0011 ],
            [ -103.4229, 29.0707 ],
            [ -103.664, 29.2069 ],
            [ -103.8529, 29.2911 ],
            [ -103.9897, 29.3232 ],
            [ -104.1106, 29.3861 ],
            [ -104.2155, 29.4799 ],
            [ -104.3122, 29.5424 ],
            [ -104.4006, 29.5737 ],
            [ -104.504, 29.6777 ],
            [ -104.6222, 29.8543 ],
            [ -104.6813, 29.9905 ],
            [ -104.6813, 30.1344 ],
            [ -104.8359, 30.4477 ],
            [ -104.9179, 30.5834 ],
            [ -104.9788, 30.6459 ],
            [ -105.0982, 30.7206 ],
            [ -105.2758, 30.8073 ],
            [ -105.514, 30.9808 ],
            [ -105.8127, 31.241 ],
            [ -106.0241, 31.3978 ],
            [ -106.1481, 31.4509 ],
            [ -106.2557, 31.5447 ],
            [ -106.347, 31.679 ],
            [ -106.436, 31.7645 ],
            [ -106.4454, 31.7684 ],
            [ -106.5664, 31.8195 ],
            [ -106.5663, 31.8195 ],
            [ -106.6683, 32.0009 ],
            [ -106.6622, 32.0013 ],
            [ -106.4375, 32.0014 ],
            [ -106.2127, 32.0015 ],
            [ -105.9879, 32.0016 ],
            [ -105.7631, 32.0017 ],
            [ -105.5383, 32.0018 ],
            [ -105.3135, 32.0018 ],
            [ -105.0887, 32.0019 ],
            [ -104.8639, 32.002 ],
            [ -104.6392, 32.0021 ],
            [ -104.4144, 32.0022 ],
            [ -104.1896, 32.0023 ],
            [ -103.9648, 32.0024 ],
            [ -103.74, 32.0025 ],
            [ -103.5152, 32.0026 ],
            [ -103.2904, 32.0026 ],
            [ -103.0656, 32.0027 ],
            [ -103.0642, 32.2839 ],
            [ -103.0627, 32.565 ],
            [ -103.0612, 32.8461 ],
            [ -103.0598, 33.1272 ],
            [ -103.0583, 33.4083 ],
            [ -103.0568, 33.6895 ],
            [ -103.0554, 33.9706 ],
            [ -103.0539, 34.2517 ],
            [ -103.0524, 34.5328 ],
            [ -103.0509, 34.8139 ],
            [ -103.0495, 35.095 ],
            [ -103.048, 35.3761 ],
            [ -103.0465, 35.6573 ],
            [ -103.0451, 35.9384 ],
            [ -103.0436, 36.2195 ],
            [ -103.0422, 36.5006 ],
            [ -103.0003, 36.5012 ],
            [ -102.8129, 36.5012 ]
          ]
        ]
      },
      "properties": {
        "featurecla": "Admin-1 scale rank",
        "scalerank": 2,
        "adm1_code": "USA-3536",
        "diss_me": 3536,
        "adm1_cod_1": "USA-3536",
        "iso_3166_2": "US-TX",
        "wikipedia": "http://en.wikipedia.org/wiki/Texas",
        "sr_sov_a3": "US1",
        "sr_adm0_a3": "USA",
        "iso_a2": "US",
        "adm0_sr": 4,
        "admin0_lab": 2,
        "name": "Texas",
        "name_alt": "TX|Tex.",
        "name_local": "",
        "type": "State",
        "type_en": "State",
        "code_local": "US48",
        "code_hasc": "US.TX",
        "note": "",
        "hasc_maybe": "",
        "region": "South",
        "region_cod": "",
        "region_big": "West South Central",
        "big_code": "",
        "provnum_ne": 0,
        "gadm_level": 1,
        "check_me": 0,
        "scaleran_1": 2,
        "datarank": 1,
        "abbrev": "Tex.",
        "postal": "TX",
        "area_sqkm": 0,
        "sameascity": -99,
        "labelrank": 0,
        "featurec_1": "Admin-1 scale rank",
        "admin": "United States of America",
        "name_len": 5,
        "mapcolor9": 1,
        "mapcolor13": 1
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [ -111.0503, 42.0009 ],
            [ -111.0502, 41.8759 ],
            [ -111.0502, 41.7509 ],
            [ -111.0502, 41.6259 ],
            [ -111.0501, 41.5009 ],
            [ -111.0501, 41.3759 ],
            [ -111.0501, 41.2509 ],
            [ -111.05, 41.1259 ],
            [ -111.05, 41.0009 ],
            [ -110.7995, 41.0009 ],
            [ -110.5491, 41.0009 ],
            [ -110.2986, 41.0009 ],
            [ -110.0482, 41.0009 ],
            [ -109.7977, 41.0009 ],
            [ -109.5473, 41.0009 ],
            [ -109.2968, 41.0009 ],
            [ -109.0464, 41.0009 ],
            [ -109.0464, 40.7508 ],
            [ -109.0464, 40.5009 ],
            [ -109.0464, 40.2509 ],
            [ -109.0465, 40.0009 ],
            [ -109.0465, 39.7509 ],
            [ -109.0465, 39.5008 ],
            [ -109.0465, 39.2508 ],
            [ -109.0465, 39.0008 ],
            [ -109.0465, 38.7509 ],
            [ -109.0466, 38.5009 ],
            [ -109.0466, 38.2508 ],
            [ -109.0466, 38.0008 ],
            [ -109.0466, 37.7508 ],
            [ -109.0466, 37.5008 ],
            [ -109.0466, 37.2509 ],
            [ -109.0467, 37.0008 ],
            [ -109.3588, 37.0011 ],
            [ -109.6709, 37.0013 ],
            [ -109.983, 37.0015 ],
            [ -110.2951, 37.0017 ],
            [ -110.6072, 37.0019 ],
            [ -110.9193, 37.0021 ],
            [ -111.2314, 37.0023 ],
            [ -111.5435, 37.0025 ],
            [ -111.8556, 37.0027 ],
            [ -112.1677, 37.0029 ],
            [ -112.4798, 37.0031 ],
            [ -112.7919, 37.0033 ],
            [ -113.104, 37.0035 ],
            [ -113.4161, 37.0037 ],
            [ -113.7282, 37.0039 ],
            [ -114.0403, 37.0042 ],
            [ -114.0403, 37.1603 ],
            [ -114.0404, 37.3165 ],
            [ -114.0405, 37.4726 ],
            [ -114.0406, 37.6288 ],
            [ -114.0406, 37.7849 ],
            [ -114.0407, 37.9411 ],
            [ -114.0408, 38.0972 ],
            [ -114.0409, 38.2534 ],
            [ -114.0409, 38.4095 ],
            [ -114.041, 38.5657 ],
            [ -114.0411, 38.7218 ],
            [ -114.0411, 38.878 ],
            [ -114.0412, 39.0342 ],
            [ -114.0413, 39.1903 ],
            [ -114.0414, 39.3465 ],
            [ -114.0414, 39.5026 ],
            [ -114.0415, 39.6588 ],
            [ -114.0416, 39.8149 ],
            [ -114.0416, 39.9711 ],
            [ -114.0417, 40.1273 ],
            [ -114.0418, 40.2834 ],
            [ -114.0418, 40.4396 ],
            [ -114.0419, 40.5957 ],
            [ -114.042, 40.7519 ],
            [ -114.0421, 40.908 ],
            [ -114.0422, 41.0642 ],
            [ -114.0422, 41.2203 ],
            [ -114.0423, 41.3765 ],
            [ -114.0424, 41.5327 ],
            [ -114.0425, 41.6888 ],
            [ -114.0425, 41.8449 ],
            [ -114.0426, 42.0011 ],
            [ -113.8556, 42.0011 ],
            [ -113.6685, 42.0011 ],
            [ -113.4815, 42.0011 ],
            [ -113.2945, 42.0011 ],
            [ -113.1075, 42.0011 ],
            [ -112.9205, 42.001 ],
            [ -112.7335, 42.001 ],
            [ -112.5464, 42.001 ],
            [ -112.3594, 42.001 ],
            [ -112.1724, 42.001 ],
            [ -111.9854, 42.001 ],
            [ -111.7984, 42.001 ],
            [ -111.6113, 42.0009 ],
            [ -111.4243, 42.0009 ],
            [ -111.2373, 42.0009 ],
            [ -111.0503, 42.0009 ]
          ]
        ]
      },
      "properties": {
        "featurecla": "Admin-1 scale rank",
        "scalerank": 2,
        "adm1_code": "USA-3526",
        "diss_me": 3526,
        "adm1_cod_1": "USA-3526",
        "iso_3166_2": "US-UT",
        "wikipedia": "http://en.wikipedia.org/wiki/Utah",
        "sr_sov_a3": "US1",
        "sr_adm0_a3": "USA",
        "iso_a2": "US",
        "adm0_sr": 1,
        "admin0_lab": 2,
        "name": "Utah",
        "name_alt": "UT",
        "name_local": "",
        "type": "State",
        "type_en": "State",
        "code_local": "US49",
        "code_hasc": "US.UT",
        "note": "",
        "hasc_maybe": "",
        "region": "West",
        "region_cod": "",
        "region_big": "Mountain",
        "big_code": "",
        "provnum_ne": 0,
        "gadm_level": 1,
        "check_me": 0,
        "scaleran_1": 2,
        "datarank": 1,
        "abbrev": "Utah",
        "postal": "UT",
        "area_sqkm": 0,
        "sameascity": -99,
        "labelrank": 0,
        "featurec_1": "Admin-1 scale rank",
        "admin": "United States of America",
        "name_len": 4,
        "mapcolor9": 1,
        "mapcolor13": 1
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [ -75.854, 37.2966 ],
            [ -75.9344, 37.1519 ],
            [ -75.9845, 37.2122 ],
            [ -75.9974, 37.2638 ],
            [ -75.975, 37.3984 ],
            [ -75.8882, 37.6192 ],
            [ -75.7924, 37.7564 ],
            [ -75.7194, 37.8214 ],
            [ -75.6593, 37.954 ],
            [ -75.62, 37.9992 ],
            [ -75.4694, 38.0149 ],
            [ -75.376, 38.025 ],
            [ -75.5964, 37.6312 ],
            [ -75.5871, 37.5587 ],
            [ -75.6315, 37.5353 ],
            [ -75.6988, 37.5164 ],
            [ -75.7669, 37.473 ],
            [ -75.8121, 37.4252 ],
            [ -75.854, 37.2966 ]
          ],
          [
            [ -75.3331, 37.8883 ],
            [ -75.3785, 37.8721 ],
            [ -75.2525, 38.0374 ],
            [ -75.2258, 38.0403 ],
            [ -75.2258, 38.0403 ],
            [ -75.3331, 37.8883 ]
          ],
          [
            [ -77.9486, 39.2163 ],
            [ -77.8358, 39.1452 ],
            [ -77.7918, 39.2266 ],
            [ -77.7266, 39.3464 ],
            [ -77.6688, 39.3095 ],
            [ -77.5342, 39.2656 ],
            [ -77.4789, 39.2209 ],
            [ -77.5029, 39.1753 ],
            [ -77.5065, 39.1426 ],
            [ -77.4809, 39.113 ],
            [ -77.3011, 39.0534 ],
            [ -77.1903, 38.969 ],
            [ -77.1221, 38.9435 ],
            [ -77.1018, 38.936 ],
            [ -77.053, 38.9153 ],
            [ -77.0304, 38.8893 ],
            [ -77.0456, 38.7758 ],
            [ -77.0919, 38.7195 ],
            [ -77.1647, 38.6766 ],
            [ -77.2604, 38.6 ],
            [ -77.2838, 38.5292 ],
            [ -77.3137, 38.3966 ],
            [ -77.2733, 38.3518 ],
            [ -77.2319, 38.34 ],
            [ -77.1099, 38.3701 ],
            [ -77.0468, 38.3567 ],
            [ -76.9063, 38.197 ],
            [ -76.6449, 38.134 ],
            [ -76.5495, 38.0945 ],
            [ -76.4718, 38.0112 ],
            [ -76.3549, 37.9632 ],
            [ -76.2643, 37.8936 ],
            [ -76.2618, 37.8481 ],
            [ -76.2932, 37.7943 ],
            [ -76.3056, 37.7216 ],
            [ -76.3441, 37.6757 ],
            [ -76.4366, 37.6704 ],
            [ -76.4925, 37.6822 ],
            [ -76.7928, 37.938 ],
            [ -76.8286, 37.9615 ],
            [ -76.94, 38.0955 ],
            [ -77.0706, 38.1672 ],
            [ -77.1111, 38.1657 ],
            [ -76.9251, 38.033 ],
            [ -76.8492, 37.9402 ],
            [ -76.7154, 37.8102 ],
            [ -76.6198, 37.7551 ],
            [ -76.5495, 37.6691 ],
            [ -76.4841, 37.6289 ],
            [ -76.3056, 37.5715 ],
            [ -76.3676, 37.5303 ],
            [ -76.2686, 37.4952 ],
            [ -76.2544, 37.4306 ],
            [ -76.2635, 37.357 ],
            [ -76.401, 37.3861 ],
            [ -76.4055, 37.3319 ],
            [ -76.3931, 37.2999 ],
            [ -76.4539, 37.2735 ],
            [ -76.5384, 37.3094 ],
            [ -76.7577, 37.5054 ],
            [ -76.7559, 37.4792 ],
            [ -76.7381, 37.4488 ],
            [ -76.6109, 37.3226 ],
            [ -76.4974, 37.2469 ],
            [ -76.4011, 37.2127 ],
            [ -76.3269, 37.1493 ],
            [ -76.3008, 37.1109 ],
            [ -76.2833, 37.0527 ],
            [ -76.3383, 37.0131 ],
            [ -76.4009, 36.9913 ],
            [ -76.462, 37.0308 ],
            [ -76.5069, 37.0723 ],
            [ -76.6023, 37.1428 ],
            [ -76.6309, 37.2217 ],
            [ -76.7035, 37.2177 ],
            [ -77.007, 37.3177 ],
            [ -77.2509, 37.3292 ],
            [ -77.2271, 37.3091 ],
            [ -77.1962, 37.2957 ],
            [ -77.002, 37.2711 ],
            [ -76.9252, 37.225 ],
            [ -76.7654, 37.1841 ],
            [ -76.6719, 37.1729 ],
            [ -76.6339, 37.0474 ],
            [ -76.5046, 36.961 ],
            [ -76.4879, 36.897 ],
            [ -76.3995, 36.8898 ],
            [ -76.2443, 36.9526 ],
            [ -76.144, 36.9306 ],
            [ -75.9994, 36.9127 ],
            [ -75.9663, 36.862 ],
            [ -75.9416, 36.7655 ],
            [ -75.8904, 36.657 ],
            [ -75.8574, 36.5506 ],
            [ -75.8891, 36.5505 ],
            [ -75.9664, 36.5514 ],
            [ -76.2148, 36.5529 ],
            [ -76.5766, 36.5557 ],
            [ -76.9384, 36.5585 ],
            [ -77.3002, 36.5613 ],
            [ -77.662, 36.5642 ],
            [ -78.0238, 36.567 ],
            [ -78.3855, 36.5698 ],
            [ -78.7473, 36.5726 ],
            [ -79.1091, 36.5754 ],
            [ -79.4709, 36.5782 ],
            [ -79.8327, 36.581 ],
            [ -80.1945, 36.5838 ],
            [ -80.5563, 36.5866 ],
            [ -80.918, 36.5895 ],
            [ -81.2798, 36.5923 ],
            [ -81.6416, 36.5951 ],
            [ -81.6589, 36.6106 ],
            [ -81.8007, 36.6152 ],
            [ -81.9053, 36.6185 ],
            [ -81.9525, 36.598 ],
            [ -82.1622, 36.5989 ],
            [ -82.3294, 36.5995 ],
            [ -82.6118, 36.6007 ],
            [ -82.9558, 36.6021 ],
            [ -83.4408, 36.6041 ],
            [ -83.6675, 36.605 ],
            [ -83.5662, 36.6526 ],
            [ -83.4169, 36.681 ],
            [ -83.1502, 36.7623 ],
            [ -83.0438, 36.8456 ],
            [ -82.8945, 36.9064 ],
            [ -82.832, 36.9793 ],
            [ -82.7319, 37.0481 ],
            [ -82.6949, 37.1262 ],
            [ -82.6816, 37.1381 ],
            [ -82.5165, 37.2088 ],
            [ -82.3432, 37.2969 ],
            [ -81.9653, 37.5397 ],
            [ -81.9577, 37.5076 ],
            [ -81.9714, 37.4731 ],
            [ -81.9394, 37.4326 ],
            [ -81.9131, 37.369 ],
            [ -81.8756, 37.3296 ],
            [ -81.8293, 37.2986 ],
            [ -81.7522, 37.2708 ],
            [ -81.6608, 37.2218 ],
            [ -81.589, 37.2081 ],
            [ -81.5648, 37.2098 ],
            [ -81.4855, 37.257 ],
            [ -81.4194, 37.2823 ],
            [ -81.35, 37.3337 ],
            [ -81.2271, 37.2633 ],
            [ -81.1781, 37.2633 ],
            [ -81.0573, 37.2937 ],
            [ -80.9437, 37.3019 ],
            [ -80.9154, 37.3114 ],
            [ -80.8731, 37.3406 ],
            [ -80.8719, 37.3994 ],
            [ -80.8624, 37.4146 ],
            [ -80.8435, 37.4217 ],
            [ -80.8211, 37.4231 ],
            [ -80.77, 37.4016 ],
            [ -80.7198, 37.401 ],
            [ -80.5074, 37.4691 ],
            [ -80.4914, 37.4639 ],
            [ -80.4645, 37.4327 ],
            [ -80.3712, 37.4726 ],
            [ -80.3161, 37.5097 ],
            [ -80.292, 37.5659 ],
            [ -80.2458, 37.6208 ],
            [ -80.2554, 37.6453 ],
            [ -80.2853, 37.6771 ],
            [ -80.2459, 37.751 ],
            [ -80.1881, 37.8242 ],
            [ -79.9717, 38.0462 ],
            [ -79.9027, 38.1807 ],
            [ -79.8129, 38.267 ],
            [ -79.7834, 38.336 ],
            [ -79.7153, 38.404 ],
            [ -79.6687, 38.5443 ],
            [ -79.6396, 38.5725 ],
            [ -79.5977, 38.5771 ],
            [ -79.5553, 38.5594 ],
            [ -79.5247, 38.5335 ],
            [ -79.5048, 38.4914 ],
            [ -79.3959, 38.4544 ],
            [ -79.3042, 38.4499 ],
            [ -79.2403, 38.4765 ],
            [ -79.2029, 38.5258 ],
            [ -79.1525, 38.6183 ],
            [ -79.1042, 38.6729 ],
            [ -79.0733, 38.7419 ],
            [ -79.0412, 38.7897 ],
            [ -78.992, 38.8197 ],
            [ -78.8687, 38.8179 ],
            [ -78.8055, 38.8602 ],
            [ -78.7568, 38.9082 ],
            [ -78.7273, 38.9239 ],
            [ -78.6928, 38.9217 ],
            [ -78.5815, 38.999 ],
            [ -78.4352, 39.1608 ],
            [ -78.4037, 39.2626 ],
            [ -78.3658, 39.3358 ],
            [ -78.351, 39.4109 ],
            [ -78.3222, 39.4519 ],
            [ -78.193, 39.3704 ],
            [ -78.1183, 39.3233 ],
            [ -77.9486, 39.2163 ]
          ]
        ]
      },
      "properties": {
        "featurecla": "Admin-1 scale rank",
        "scalerank": 2,
        "adm1_code": "USA-3552",
        "diss_me": 3552,
        "adm1_cod_1": "USA-3552",
        "iso_3166_2": "US-VA",
        "wikipedia": "http://en.wikipedia.org/wiki/Virginia",
        "sr_sov_a3": "US1",
        "sr_adm0_a3": "USA",
        "iso_a2": "US",
        "adm0_sr": 6,
        "admin0_lab": 2,
        "name": "Virginia",
        "name_alt": "VA",
        "name_local": "",
        "type": "State",
        "type_en": "State",
        "code_local": "US51",
        "code_hasc": "US.VA",
        "note": "",
        "hasc_maybe": "",
        "region": "South",
        "region_cod": "",
        "region_big": "South Atlantic",
        "big_code": "",
        "provnum_ne": 0,
        "gadm_level": 1,
        "check_me": 0,
        "scaleran_1": 2,
        "datarank": 1,
        "abbrev": "Va.",
        "postal": "VA",
        "area_sqkm": 0,
        "sameascity": -99,
        "labelrank": 0,
        "featurec_1": "Admin-1 scale rank",
        "admin": "United States of America",
        "name_len": 8,
        "mapcolor9": 1,
        "mapcolor13": 1
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [ -72.4669, 42.7303 ],
            [ -72.5652, 42.7331 ],
            [ -72.6635, 42.7358 ],
            [ -72.7618, 42.7385 ],
            [ -72.8601, 42.7413 ],
            [ -72.9584, 42.744 ],
            [ -73.0567, 42.7467 ],
            [ -73.155, 42.7495 ],
            [ -73.2533, 42.7522 ],
            [ -73.2802, 42.8132 ],
            [ -73.2666, 42.8648 ],
            [ -73.2645, 42.9352 ],
            [ -73.2619, 43.0271 ],
            [ -73.2591, 43.1279 ],
            [ -73.2552, 43.2654 ],
            [ -73.2527, 43.3572 ],
            [ -73.2503, 43.4397 ],
            [ -73.2471, 43.553 ],
            [ -73.3062, 43.6163 ],
            [ -73.3305, 43.6267 ],
            [ -73.3492, 43.6204 ],
            [ -73.3914, 43.5785 ],
            [ -73.4049, 43.5788 ],
            [ -73.4159, 43.5896 ],
            [ -73.4134, 43.6279 ],
            [ -73.3758, 43.7622 ],
            [ -73.375, 43.8042 ],
            [ -73.383, 43.8758 ],
            [ -73.4249, 44.0383 ],
            [ -73.4261, 44.0749 ],
            [ -73.4098, 44.1314 ],
            [ -73.3811, 44.1874 ],
            [ -73.3318, 44.2446 ],
            [ -73.3209, 44.2689 ],
            [ -73.3246, 44.3679 ],
            [ -73.3098, 44.4596 ],
            [ -73.3721, 44.5973 ],
            [ -73.3486, 44.7753 ],
            [ -73.3658, 44.8604 ],
            [ -73.3451, 44.9389 ],
            [ -73.3522, 45.0054 ],
            [ -73.182, 45.0056 ],
            [ -72.7659, 45.0061 ],
            [ -72.3498, 45.0066 ],
            [ -71.9336, 45.0071 ],
            [ -71.5175, 45.0076 ],
            [ -71.5335, 44.988 ],
            [ -71.5102, 44.9083 ],
            [ -71.6207, 44.7719 ],
            [ -71.6183, 44.7278 ],
            [ -71.5684, 44.6076 ],
            [ -71.5715, 44.5792 ],
            [ -71.5878, 44.5653 ],
            [ -71.6093, 44.5141 ],
            [ -71.6382, 44.4817 ],
            [ -71.683, 44.4503 ],
            [ -71.8255, 44.3741 ],
            [ -71.8677, 44.3549 ],
            [ -72.0018, 44.3295 ],
            [ -72.0312, 44.3007 ],
            [ -72.0622, 44.1164 ],
            [ -72.1062, 44.0131 ],
            [ -72.1149, 43.9654 ],
            [ -72.1739, 43.8841 ],
            [ -72.2224, 43.7909 ],
            [ -72.2967, 43.715 ],
            [ -72.3377, 43.622 ],
            [ -72.3624, 43.5866 ],
            [ -72.385, 43.5292 ],
            [ -72.4071, 43.332 ],
            [ -72.4382, 43.2246 ],
            [ -72.4737, 43.0385 ],
            [ -72.4965, 42.9917 ],
            [ -72.5194, 42.9667 ],
            [ -72.5498, 42.8867 ],
            [ -72.5528, 42.8564 ],
            [ -72.5396, 42.8296 ],
            [ -72.4837, 42.7662 ],
            [ -72.4669, 42.7303 ]
          ]
        ]
      },
      "properties": {
        "featurecla": "Admin-1 scale rank",
        "scalerank": 2,
        "adm1_code": "USA-3540",
        "diss_me": 3540,
        "adm1_cod_1": "USA-3540",
        "iso_3166_2": "US-VT",
        "wikipedia": "http://en.wikipedia.org/wiki/Vermont",
        "sr_sov_a3": "US1",
        "sr_adm0_a3": "USA",
        "iso_a2": "US",
        "adm0_sr": 1,
        "admin0_lab": 2,
        "name": "Vermont",
        "name_alt": "VT",
        "name_local": "",
        "type": "State",
        "type_en": "State",
        "code_local": "US50",
        "code_hasc": "US.VT",
        "note": "",
        "hasc_maybe": "",
        "region": "Northeast",
        "region_cod": "",
        "region_big": "New England",
        "big_code": "",
        "provnum_ne": 0,
        "gadm_level": 1,
        "check_me": 0,
        "scaleran_1": 2,
        "datarank": 1,
        "abbrev": "Vt.",
        "postal": "VT",
        "area_sqkm": 0,
        "sameascity": -99,
        "labelrank": 0,
        "featurec_1": "Admin-1 scale rank",
        "admin": "United States of America",
        "name_len": 7,
        "mapcolor9": 1,
        "mapcolor13": 1
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [ -122.8531, 47.2047 ],
            [ -122.8626, 47.1851 ],
            [ -122.8767, 47.1861 ],
            [ -122.908, 47.2261 ],
            [ -122.9119, 47.2543 ],
            [ -122.8851, 47.2747 ],
            [ -122.8492, 47.2163 ],
            [ -122.8531, 47.2047 ]
          ],
          [
            [ -122.3941, 47.3952 ],
            [ -122.3987, 47.3725 ],
            [ -122.4371, 47.3548 ],
            [ -122.457, 47.3593 ],
            [ -122.4582, 47.3862 ],
            [ -122.4685, 47.3902 ],
            [ -122.5099, 47.358 ],
            [ -122.5068, 47.4217 ],
            [ -122.4865, 47.4888 ],
            [ -122.4686, 47.49 ],
            [ -122.4421, 47.4462 ],
            [ -122.3941, 47.3952 ]
          ],
          [
            [ -122.4973, 47.5946 ],
            [ -122.5026, 47.5754 ],
            [ -122.5578, 47.5983 ],
            [ -122.5759, 47.6195 ],
            [ -122.5738, 47.6669 ],
            [ -122.5601, 47.6978 ],
            [ -122.5498, 47.704 ],
            [ -122.5172, 47.6906 ],
            [ -122.5079, 47.6826 ],
            [ -122.4973, 47.5946 ]
          ],
          [
            [ -122.5728, 48.1566 ],
            [ -122.5238, 48.0254 ],
            [ -122.5029, 48.0801 ],
            [ -122.3667, 47.9854 ],
            [ -122.3666, 47.9388 ],
            [ -122.3831, 47.9232 ],
            [ -122.4114, 47.9178 ],
            [ -122.4376, 47.9313 ],
            [ -122.4616, 47.964 ],
            [ -122.4923, 47.9813 ],
            [ -122.5575, 47.9925 ],
            [ -122.5913, 48.0296 ],
            [ -122.6032, 48.055 ],
            [ -122.6063, 48.1286 ],
            [ -122.6227, 48.1514 ],
            [ -122.6573, 48.1565 ],
            [ -122.6904, 48.1739 ],
            [ -122.7415, 48.2253 ],
            [ -122.7487, 48.239 ],
            [ -122.7245, 48.2809 ],
            [ -122.669, 48.351 ],
            [ -122.6286, 48.3842 ],
            [ -122.6035, 48.3806 ],
            [ -122.5725, 48.3596 ],
            [ -122.5356, 48.3212 ],
            [ -122.5424, 48.294 ],
            [ -122.6921, 48.2411 ],
            [ -122.697, 48.2287 ],
            [ -122.6244, 48.2137 ],
            [ -122.5976, 48.2004 ],
            [ -122.5728, 48.1566 ]
          ],
          [
            [ -122.8209, 48.4314 ],
            [ -122.8366, 48.4215 ],
            [ -122.89, 48.4347 ],
            [ -122.9216, 48.4569 ],
            [ -122.9323, 48.4847 ],
            [ -122.9122, 48.538 ],
            [ -122.8855, 48.5516 ],
            [ -122.8689, 48.5486 ],
            [ -122.8619, 48.5019 ],
            [ -122.8146, 48.4523 ],
            [ -122.8209, 48.4314 ]
          ],
          [
            [ -123.0131, 48.5009 ],
            [ -122.9868, 48.468 ],
            [ -123.0944, 48.4891 ],
            [ -123.1399, 48.5079 ],
            [ -123.1534, 48.5263 ],
            [ -123.1696, 48.5867 ],
            [ -123.1621, 48.6064 ],
            [ -123.1142, 48.6133 ],
            [ -123.0242, 48.5385 ],
            [ -123.0131, 48.5009 ]
          ],
          [
            [ -122.7821, 48.6727 ],
            [ -122.7688, 48.651 ],
            [ -122.809, 48.6299 ],
            [ -122.8376, 48.6265 ],
            [ -122.8831, 48.6606 ],
            [ -122.903, 48.6647 ],
            [ -122.887, 48.6123 ],
            [ -122.8925, 48.5945 ],
            [ -122.9857, 48.6267 ],
            [ -123.0029, 48.6522 ],
            [ -122.9767, 48.6791 ],
            [ -122.918, 48.707 ],
            [ -122.8977, 48.7104 ],
            [ -122.7821, 48.6727 ]
          ],
          [
            [ -123.0492, 48.993 ],
            [ -123.0633, 48.9777 ],
            [ -123.0773, 48.9802 ],
            [ -123.0864, 48.993 ],
            [ -123.0492, 48.993 ]
          ],
          [
            [ -117.0374, 48.8337 ],
            [ -117.0365, 48.6734 ],
            [ -117.0357, 48.5131 ],
            [ -117.0349, 48.3528 ],
            [ -117.0341, 48.1925 ],
            [ -117.0333, 48.0322 ],
            [ -117.0325, 47.8719 ],
            [ -117.0316, 47.7116 ],
            [ -117.0308, 47.5513 ],
            [ -117.03, 47.391 ],
            [ -117.0292, 47.2307 ],
            [ -117.0283, 47.0704 ],
            [ -117.0275, 46.9101 ],
            [ -117.0267, 46.7498 ],
            [ -117.0258, 46.5895 ],
            [ -117.025, 46.4292 ],
            [ -117.0325, 46.4198 ],
            [ -117.039, 46.3966 ],
            [ -117.0104, 46.3296 ],
            [ -116.943, 46.2321 ],
            [ -116.9221, 46.1636 ],
            [ -116.9478, 46.1243 ],
            [ -116.9302, 46.056 ],
            [ -116.8965, 46.0021 ],
            [ -117.1443, 46.0023 ],
            [ -117.4098, 46.002 ],
            [ -117.6752, 46.0018 ],
            [ -117.9407, 46.0015 ],
            [ -118.2061, 46.0013 ],
            [ -118.4716, 46.001 ],
            [ -118.737, 46.0008 ],
            [ -119.0024, 46.0005 ],
            [ -119.0197, 46.0003 ],
            [ -119.0499, 45.9815 ],
            [ -119.1773, 45.9451 ],
            [ -119.4291, 45.9342 ],
            [ -119.9343, 45.8379 ],
            [ -120.156, 45.7622 ],
            [ -120.3514, 45.7252 ],
            [ -120.7158, 45.6898 ],
            [ -121.0452, 45.639 ],
            [ -121.1843, 45.6438 ],
            [ -121.2427, 45.687 ],
            [ -121.4021, 45.7118 ],
            [ -121.6625, 45.7181 ],
            [ -121.882, 45.6895 ],
            [ -122.0851, 45.6026 ],
            [ -122.1499, 45.5939 ],
            [ -122.1499, 45.5938 ],
            [ -122.2025, 45.5911 ],
            [ -122.561, 45.6251 ],
            [ -122.6498, 45.6274 ],
            [ -122.7259, 45.6738 ],
            [ -122.7464, 45.7497 ],
            [ -122.8434, 45.9781 ],
            [ -122.942, 46.1149 ],
            [ -123.0423, 46.16 ],
            [ -123.1209, 46.1788 ],
            [ -123.2206, 46.1536 ],
            [ -123.2513, 46.1673 ],
            [ -123.2987, 46.1708 ],
            [ -123.4047, 46.221 ],
            [ -123.4649, 46.2711 ],
            [ -123.6503, 46.2677 ],
            [ -123.6884, 46.2999 ],
            [ -123.8957, 46.2678 ],
            [ -123.9597, 46.3007 ],
            [ -124.0728, 46.2794 ],
            [ -124.0451, 46.3729 ],
            [ -124.0502, 46.4906 ],
            [ -124.0444, 46.6051 ],
            [ -124.0164, 46.5214 ],
            [ -123.9461, 46.4326 ],
            [ -123.9124, 46.5333 ],
            [ -123.8892, 46.66 ],
            [ -123.9577, 46.7087 ],
            [ -124.0717, 46.7448 ],
            [ -124.1125, 46.8627 ],
            [ -123.8429, 46.9632 ],
            [ -123.986, 46.9845 ],
            [ -124.0422, 47.0297 ],
            [ -124.1117, 47.0352 ],
            [ -124.1168, 47.0003 ],
            [ -124.1392, 46.9547 ],
            [ -124.1636, 47.0153 ],
            [ -124.1705, 47.0867 ],
            [ -124.1988, 47.2085 ],
            [ -124.3093, 47.4046 ],
            [ -124.376, 47.6586 ],
            [ -124.46, 47.7842 ],
            [ -124.6211, 47.9041 ],
            [ -124.6631, 47.9741 ],
            [ -124.7017, 48.1516 ],
            [ -124.68, 48.2859 ],
            [ -124.71, 48.3804 ],
            [ -124.6326, 48.375 ],
            [ -124.429, 48.3008 ],
            [ -124.1755, 48.2424 ],
            [ -124.0988, 48.2 ],
            [ -123.9758, 48.1685 ],
            [ -123.2944, 48.1195 ],
            [ -123.2499, 48.1242 ],
            [ -123.1619, 48.1546 ],
            [ -123.1244, 48.1509 ],
            [ -123.0242, 48.0816 ],
            [ -122.9739, 48.0733 ],
            [ -122.9089, 48.0769 ],
            [ -122.8609, 48.09 ],
            [ -122.7786, 48.1376 ],
            [ -122.7675, 48.12 ],
            [ -122.7691, 48.076 ],
            [ -122.7397, 48.0132 ],
            [ -122.6795, 47.9318 ],
            [ -122.6566, 47.8811 ],
            [ -122.7784, 47.7384 ],
            [ -122.8018, 47.7353 ],
            [ -122.8054, 47.7836 ],
            [ -122.8214, 47.7932 ],
            [ -123.0506, 47.5519 ],
            [ -123.131, 47.4377 ],
            [ -123.139, 47.3861 ],
            [ -123.1364, 47.3558 ],
            [ -123.1042, 47.3484 ],
            [ -123.0309, 47.3602 ],
            [ -122.9222, 47.4076 ],
            [ -122.9169, 47.418 ],
            [ -123.0182, 47.4011 ],
            [ -123.0668, 47.3996 ],
            [ -123.0601, 47.4536 ],
            [ -123.0486, 47.4793 ],
            [ -122.9825, 47.5594 ],
            [ -122.9129, 47.6074 ],
            [ -122.8141, 47.6585 ],
            [ -122.7572, 47.7005 ],
            [ -122.7179, 47.7621 ],
            [ -122.6081, 47.8355 ],
            [ -122.5879, 47.8559 ],
            [ -122.5927, 47.9164 ],
            [ -122.5857, 47.9279 ],
            [ -122.5328, 47.9197 ],
            [ -122.5108, 47.8157 ],
            [ -122.5239, 47.7693 ],
            [ -122.6184, 47.7128 ],
            [ -122.6302, 47.6928 ],
            [ -122.6136, 47.6156 ],
            [ -122.6283, 47.6082 ],
            [ -122.6643, 47.6173 ],
            [ -122.6755, 47.6123 ],
            [ -122.5858, 47.5284 ],
            [ -122.5574, 47.4632 ],
            [ -122.5535, 47.4049 ],
            [ -122.5779, 47.2932 ],
            [ -122.6039, 47.2746 ],
            [ -122.6487, 47.2815 ],
            [ -122.7077, 47.3164 ],
            [ -122.7209, 47.3051 ],
            [ -122.7678, 47.2184 ],
            [ -122.7833, 47.226 ],
            [ -122.8126, 47.329 ],
            [ -122.8285, 47.3366 ],
            [ -122.9195, 47.2897 ],
            [ -122.9562, 47.2446 ],
            [ -122.9876, 47.1726 ],
            [ -123.0276, 47.1389 ],
            [ -122.9141, 47.1315 ],
            [ -122.812, 47.146 ],
            [ -122.7299, 47.1118 ],
            [ -122.7019, 47.1109 ],
            [ -122.6271, 47.1443 ],
            [ -122.6041, 47.167 ],
            [ -122.5422, 47.2756 ],
            [ -122.5111, 47.295 ],
            [ -122.4649, 47.2958 ],
            [ -122.4201, 47.3121 ],
            [ -122.3538, 47.3716 ],
            [ -122.3511, 47.3952 ],
            [ -122.3753, 47.5284 ],
            [ -122.3683, 47.6039 ],
            [ -122.3807, 47.6278 ],
            [ -122.4105, 47.6527 ],
            [ -122.4068, 47.6768 ],
            [ -122.3836, 47.7165 ],
            [ -122.382, 47.7523 ],
            [ -122.4018, 47.7843 ],
            [ -122.3929, 47.8205 ],
            [ -122.3303, 47.8986 ],
            [ -122.3185, 47.933 ],
            [ -122.242, 48.0108 ],
            [ -122.2613, 48.042 ],
            [ -122.3175, 48.0802 ],
            [ -122.353, 48.1138 ],
            [ -122.3886, 48.1664 ],
            [ -122.4158, 48.1839 ],
            [ -122.4247, 48.1759 ],
            [ -122.3866, 48.0899 ],
            [ -122.3948, 48.0842 ],
            [ -122.494, 48.1304 ],
            [ -122.517, 48.1596 ],
            [ -122.5292, 48.1993 ],
            [ -122.5203, 48.2291 ],
            [ -122.467, 48.2585 ],
            [ -122.4034, 48.2692 ],
            [ -122.4085, 48.2939 ],
            [ -122.4884, 48.3743 ],
            [ -122.5417, 48.411 ],
            [ -122.5826, 48.4287 ],
            [ -122.6378, 48.4333 ],
            [ -122.6625, 48.4464 ],
            [ -122.669, 48.4653 ],
            [ -122.6573, 48.49 ],
            [ -122.628, 48.4979 ],
            [ -122.5427, 48.488 ],
            [ -122.4968, 48.5055 ],
            [ -122.5011, 48.5375 ],
            [ -122.5148, 48.5551 ],
            [ -122.5127, 48.6694 ],
            [ -122.5451, 48.7623 ],
            [ -122.562, 48.778 ],
            [ -122.5802, 48.7796 ],
            [ -122.5994, 48.7671 ],
            [ -122.653, 48.7639 ],
            [ -122.6859, 48.7943 ],
            [ -122.7225, 48.853 ],
            [ -122.7888, 48.993 ],
            [ -122.6864, 48.993 ],
            [ -122.26, 48.993 ],
            [ -121.8336, 48.993 ],
            [ -121.4072, 48.993 ],
            [ -120.9809, 48.993 ],
            [ -120.5545, 48.993 ],
            [ -120.1281, 48.993 ],
            [ -119.7017, 48.993 ],
            [ -119.2753, 48.9931 ],
            [ -118.8489, 48.9931 ],
            [ -118.4226, 48.9931 ],
            [ -117.9962, 48.9931 ],
            [ -117.5698, 48.9931 ],
            [ -117.1434, 48.9931 ],
            [ -117.0391, 48.9931 ],
            [ -117.0374, 48.8337 ]
          ]
        ]
      },
      "properties": {
        "featurecla": "Admin-1 scale rank",
        "scalerank": 2,
        "adm1_code": "USA-3519",
        "diss_me": 3519,
        "adm1_cod_1": "USA-3519",
        "iso_3166_2": "US-WA",
        "wikipedia": "http://en.wikipedia.org/wiki/Washington_(state)",
        "sr_sov_a3": "US1",
        "sr_adm0_a3": "USA",
        "iso_a2": "US",
        "adm0_sr": 6,
        "admin0_lab": 2,
        "name": "Washington",
        "name_alt": "WA|Wash.",
        "name_local": "",
        "type": "State",
        "type_en": "State",
        "code_local": "US53",
        "code_hasc": "US.WA",
        "note": "",
        "hasc_maybe": "",
        "region": "West",
        "region_cod": "",
        "region_big": "Pacific",
        "big_code": "",
        "provnum_ne": 0,
        "gadm_level": 1,
        "check_me": 0,
        "scaleran_1": 2,
        "datarank": 1,
        "abbrev": "Wash.",
        "postal": "WA",
        "area_sqkm": 0,
        "sameascity": -99,
        "labelrank": 0,
        "featurec_1": "Admin-1 scale rank",
        "admin": "United States of America",
        "name_len": 10,
        "mapcolor9": 1,
        "mapcolor13": 1
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [ -86.9919, 45.241 ],
            [ -87.0104, 45.2282 ],
            [ -87.0415, 45.2367 ],
            [ -87.0536, 45.2179 ],
            [ -87.0466, 45.1719 ],
            [ -87.0569, 45.1505 ],
            [ -87.0842, 45.154 ],
            [ -87.0857, 45.1454 ],
            [ -87.0615, 45.1249 ],
            [ -87.0589, 45.1024 ],
            [ -87.078, 45.0781 ],
            [ -87.0963, 45.0667 ],
            [ -87.1139, 45.0685 ],
            [ -87.1414, 45.0407 ],
            [ -87.1786, 44.9834 ],
            [ -87.1913, 44.9502 ],
            [ -87.1795, 44.9411 ],
            [ -87.1881, 44.922 ],
            [ -87.2803, 44.8349 ],
            [ -87.3158, 44.8266 ],
            [ -87.3546, 44.8388 ],
            [ -87.382, 44.8643 ],
            [ -87.3982, 44.9029 ],
            [ -87.403, 44.9329 ],
            [ -87.3965, 44.9542 ],
            [ -87.3155, 45.0311 ],
            [ -87.2793, 45.0815 ],
            [ -87.2588, 45.138 ],
            [ -87.2211, 45.174 ],
            [ -87.1664, 45.1895 ],
            [ -87.122, 45.2245 ],
            [ -87.0881, 45.2792 ],
            [ -87.0491, 45.3029 ],
            [ -87.005, 45.2958 ],
            [ -86.9859, 45.2752 ],
            [ -86.9919, 45.241 ]
          ],
          [
            [ -86.8619, 45.3522 ],
            [ -86.8919, 45.3423 ],
            [ -86.9469, 45.3457 ],
            [ -86.9667, 45.3683 ],
            [ -86.938, 45.4256 ],
            [ -86.9263, 45.4149 ],
            [ -86.8785, 45.4142 ],
            [ -86.8619, 45.4086 ],
            [ -86.8566, 45.3944 ],
            [ -86.8619, 45.3522 ]
          ],
          [
            [ -90.7105, 46.7833 ],
            [ -90.7677, 46.7698 ],
            [ -90.7916, 46.7723 ],
            [ -90.7821, 46.7911 ],
            [ -90.7523, 46.8136 ],
            [ -90.6191, 46.87 ],
            [ -90.5961, 46.8688 ],
            [ -90.5889, 46.8554 ],
            [ -90.6534, 46.8277 ],
            [ -90.6775, 46.813 ],
            [ -90.6805, 46.7978 ],
            [ -90.7105, 46.7833 ]
          ],
          [
            [ -90.5467, 46.9193 ],
            [ -90.58, 46.9135 ],
            [ -90.6518, 46.9223 ],
            [ -90.6504, 46.9368 ],
            [ -90.5759, 46.957 ],
            [ -90.5426, 46.9627 ],
            [ -90.5348, 46.9543 ],
            [ -90.5467, 46.9193 ]
          ],
          [
            [ -90.7877, 46.8684 ],
            [ -90.8399, 46.81 ],
            [ -90.8653, 46.7607 ],
            [ -90.8639, 46.7208 ],
            [ -90.8864, 46.6775 ],
            [ -90.9435, 46.619 ],
            [ -90.923, 46.6031 ],
            [ -90.77, 46.6454 ],
            [ -90.7476, 46.6619 ],
            [ -90.745, 46.6717 ],
            [ -90.7543, 46.6835 ],
            [ -90.7368, 46.6889 ],
            [ -90.6165, 46.6313 ],
            [ -90.5361, 46.5994 ],
            [ -90.4688, 46.5841 ],
            [ -90.4076, 46.5929 ],
            [ -90.4126, 46.5853 ],
            [ -90.3923, 46.549 ],
            [ -90.3409, 46.5584 ],
            [ -90.3182, 46.5366 ],
            [ -90.2879, 46.5274 ],
            [ -90.2304, 46.5098 ],
            [ -90.2024, 46.4678 ],
            [ -90.1745, 46.4257 ],
            [ -90.1465, 46.3837 ],
            [ -90.1186, 46.3417 ],
            [ -89.9936, 46.3176 ],
            [ -89.8688, 46.2936 ],
            [ -89.7438, 46.2695 ],
            [ -89.6189, 46.2454 ],
            [ -89.494, 46.2214 ],
            [ -89.3691, 46.1973 ],
            [ -89.2442, 46.1733 ],
            [ -89.1193, 46.1492 ],
            [ -89.0488, 46.1211 ],
            [ -88.9783, 46.0929 ],
            [ -88.9078, 46.0648 ],
            [ -88.8373, 46.0366 ],
            [ -88.7272, 46.0311 ],
            [ -88.6295, 46.014 ],
            [ -88.493, 46.0135 ],
            [ -88.3547, 45.9923 ],
            [ -88.1517, 45.9454 ],
            [ -88.1044, 45.9052 ],
            [ -88.0965, 45.8784 ],
            [ -88.1161, 45.8158 ],
            [ -87.9225, 45.76 ],
            [ -87.8398, 45.718 ],
            [ -87.8091, 45.686 ],
            [ -87.8141, 45.657 ],
            [ -87.7946, 45.596 ],
            [ -87.8147, 45.5632 ],
            [ -87.8152, 45.5058 ],
            [ -87.8591, 45.4455 ],
            [ -87.874, 45.4128 ],
            [ -87.8749, 45.3854 ],
            [ -87.8654, 45.3678 ],
            [ -87.8418, 45.3608 ],
            [ -87.7686, 45.3644 ],
            [ -87.6964, 45.3828 ],
            [ -87.6642, 45.3713 ],
            [ -87.6576, 45.3618 ],
            [ -87.6627, 45.3452 ],
            [ -87.7209, 45.2428 ],
            [ -87.7189, 45.2013 ],
            [ -87.6942, 45.1611 ],
            [ -87.6536, 45.1218 ],
            [ -87.6058, 45.1086 ],
            [ -87.6078, 45.0827 ],
            [ -87.627, 45.0323 ],
            [ -87.6832, 44.9926 ],
            [ -87.8303, 44.9425 ],
            [ -87.8536, 44.9083 ],
            [ -87.8568, 44.8804 ],
            [ -87.9516, 44.7637 ],
            [ -87.9978, 44.6923 ],
            [ -88.0283, 44.6179 ],
            [ -88.0188, 44.5711 ],
            [ -87.9692, 44.552 ],
            [ -87.929, 44.5595 ],
            [ -87.8982, 44.5934 ],
            [ -87.8511, 44.624 ],
            [ -87.7875, 44.6516 ],
            [ -87.7409, 44.692 ],
            [ -87.6766, 44.7903 ],
            [ -87.6044, 44.8469 ],
            [ -87.566, 44.8503 ],
            [ -87.5554, 44.8486 ],
            [ -87.4802, 44.8741 ],
            [ -87.4196, 44.8656 ],
            [ -87.3831, 44.8271 ],
            [ -87.3456, 44.8006 ],
            [ -87.3373, 44.7758 ],
            [ -87.3561, 44.7204 ],
            [ -87.3905, 44.662 ],
            [ -87.4409, 44.6007 ],
            [ -87.4865, 44.5086 ],
            [ -87.5274, 44.3857 ],
            [ -87.5361, 44.293 ],
            [ -87.5125, 44.2303 ],
            [ -87.5349, 44.1743 ],
            [ -87.6034, 44.125 ],
            [ -87.6585, 44.059 ],
            [ -87.7001, 43.9766 ],
            [ -87.7238, 43.9073 ],
            [ -87.7294, 43.8512 ],
            [ -87.7234, 43.8091 ],
            [ -87.6979, 43.7524 ],
            [ -87.6997, 43.7237 ],
            [ -87.774, 43.5989 ],
            [ -87.8009, 43.5381 ],
            [ -87.8056, 43.4901 ],
            [ -87.8239, 43.443 ],
            [ -87.8807, 43.347 ],
            [ -87.8984, 43.2938 ],
            [ -87.9017, 43.2449 ],
            [ -87.8888, 43.1646 ],
            [ -87.8961, 43.1374 ],
            [ -87.8928, 43.1169 ],
            [ -87.8789, 43.1031 ],
            [ -87.879, 43.0778 ],
            [ -87.8934, 43.0411 ],
            [ -87.8877, 43.0125 ],
            [ -87.8621, 42.992 ],
            [ -87.8456, 42.9531 ],
            [ -87.8382, 42.8957 ],
            [ -87.8187, 42.8477 ],
            [ -87.7871, 42.8092 ],
            [ -87.7814, 42.7534 ],
            [ -87.8017, 42.6804 ],
            [ -87.812, 42.543 ],
            [ -87.8121, 42.4971 ],
            [ -87.9397, 42.4978 ],
            [ -88.39, 42.5003 ],
            [ -88.8402, 42.5028 ],
            [ -89.2905, 42.5053 ],
            [ -89.7408, 42.5078 ],
            [ -90.191, 42.5103 ],
            [ -90.6506, 42.513 ],
            [ -90.6573, 42.5205 ],
            [ -90.6879, 42.6103 ],
            [ -90.7887, 42.6769 ],
            [ -90.9599, 42.7203 ],
            [ -91.0696, 42.7886 ],
            [ -91.1176, 42.8817 ],
            [ -91.1482, 42.9862 ],
            [ -91.1613, 43.1023 ],
            [ -91.1476, 43.1996 ],
            [ -91.107, 43.278 ],
            [ -91.1172, 43.3312 ],
            [ -91.1784, 43.3589 ],
            [ -91.2187, 43.3953 ],
            [ -91.2383, 43.4402 ],
            [ -91.2453, 43.5024 ],
            [ -91.2784, 43.7974 ],
            [ -91.3199, 43.9363 ],
            [ -91.3827, 43.9908 ],
            [ -91.5148, 44.0542 ],
            [ -91.7164, 44.1265 ],
            [ -91.841, 44.1942 ],
            [ -91.9123, 44.2889 ],
            [ -92.0551, 44.3998 ],
            [ -92.1486, 44.4452 ],
            [ -92.2403, 44.4621 ],
            [ -92.3131, 44.4978 ],
            [ -92.3669, 44.5523 ],
            [ -92.4416, 44.5866 ],
            [ -92.537, 44.6008 ],
            [ -92.6435, 44.6453 ],
            [ -92.7698, 44.7258 ],
            [ -92.7726, 44.732 ],
            [ -92.7992, 44.79 ],
            [ -92.7847, 44.8226 ],
            [ -92.7634, 44.9343 ],
            [ -92.7652, 44.9694 ],
            [ -92.793, 45.0714 ],
            [ -92.7591, 45.1106 ],
            [ -92.7661, 45.2365 ],
            [ -92.7539, 45.2776 ],
            [ -92.6858, 45.3805 ],
            [ -92.6826, 45.4331 ],
            [ -92.707, 45.4938 ],
            [ -92.7575, 45.5432 ],
            [ -92.8925, 45.5948 ],
            [ -92.8965, 45.6586 ],
            [ -92.8747, 45.7061 ],
            [ -92.7864, 45.7955 ],
            [ -92.7381, 45.8747 ],
            [ -92.6939, 45.909 ],
            [ -92.4246, 46.0278 ],
            [ -92.3673, 46.036 ],
            [ -92.3255, 46.0696 ],
            [ -92.2926, 46.0844 ],
            [ -92.2924, 46.2285 ],
            [ -92.2921, 46.3725 ],
            [ -92.2919, 46.5166 ],
            [ -92.2916, 46.6607 ],
            [ -92.224, 46.671 ],
            [ -92.1945, 46.707 ],
            [ -92.1253, 46.763 ],
            [ -92.107, 46.7624 ],
            [ -92.107, 46.7619 ],
            [ -92.0728, 46.7362 ],
            [ -91.9873, 46.699 ],
            [ -91.9208, 46.6944 ],
            [ -91.8356, 46.7021 ],
            [ -91.4991, 46.7661 ],
            [ -91.357, 46.8107 ],
            [ -91.2176, 46.8856 ],
            [ -91.2034, 46.888 ],
            [ -91.1454, 46.8743 ],
            [ -91.1272, 46.8677 ],
            [ -90.946, 46.9538 ],
            [ -90.8867, 46.9648 ],
            [ -90.8399, 46.9625 ],
            [ -90.7819, 46.9287 ],
            [ -90.7684, 46.908 ],
            [ -90.7877, 46.8684 ]
          ],
          [
            [ -90.708, 46.9273 ],
            [ -90.7228, 46.9201 ],
            [ -90.7608, 46.937 ],
            [ -90.766, 46.9508 ],
            [ -90.7557, 46.9648 ],
            [ -90.7381, 46.9616 ],
            [ -90.7131, 46.9412 ],
            [ -90.708, 46.9273 ]
          ],
          [
            [ -90.4267, 47.0259 ],
            [ -90.4593, 47.0101 ],
            [ -90.4717, 47.0175 ],
            [ -90.4639, 47.0483 ],
            [ -90.4474, 47.0662 ],
            [ -90.4221, 47.0711 ],
            [ -90.4097, 47.0637 ],
            [ -90.4102, 47.0438 ],
            [ -90.4267, 47.0259 ]
          ]
        ]
      },
      "properties": {
        "featurecla": "Admin-1 scale rank",
        "scalerank": 2,
        "adm1_code": "USA-3553",
        "diss_me": 3553,
        "adm1_cod_1": "USA-3553",
        "iso_3166_2": "US-WI",
        "wikipedia": "http://en.wikipedia.org/wiki/Wisconsin",
        "sr_sov_a3": "US1",
        "sr_adm0_a3": "USA",
        "iso_a2": "US",
        "adm0_sr": 1,
        "admin0_lab": 2,
        "name": "Wisconsin",
        "name_alt": "WI|Wis.",
        "name_local": "",
        "type": "State",
        "type_en": "State",
        "code_local": "US55",
        "code_hasc": "US.WI",
        "note": "",
        "hasc_maybe": "",
        "region": "Midwest",
        "region_cod": "",
        "region_big": "East North Central",
        "big_code": "",
        "provnum_ne": 0,
        "gadm_level": 1,
        "check_me": 0,
        "scaleran_1": 2,
        "datarank": 1,
        "abbrev": "Wis.",
        "postal": "WI",
        "area_sqkm": 0,
        "sameascity": -99,
        "labelrank": 0,
        "featurec_1": "Admin-1 scale rank",
        "admin": "United States of America",
        "name_len": 9,
        "mapcolor9": 1,
        "mapcolor13": 1
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [ -79.4775, 39.7228 ],
            [ -79.4801, 39.5948 ],
            [ -79.4827, 39.4668 ],
            [ -79.4853, 39.3389 ],
            [ -79.488, 39.2109 ],
            [ -79.3598, 39.2854 ],
            [ -79.2936, 39.3116 ],
            [ -79.0753, 39.476 ],
            [ -79.0467, 39.4768 ],
            [ -78.9715, 39.4536 ],
            [ -78.8148, 39.5701 ],
            [ -78.7962, 39.6126 ],
            [ -78.7778, 39.6266 ],
            [ -78.7582, 39.6248 ],
            [ -78.7465, 39.6137 ],
            [ -78.7534, 39.5895 ],
            [ -78.7417, 39.5779 ],
            [ -78.6777, 39.5495 ],
            [ -78.5875, 39.5344 ],
            [ -78.575, 39.5329 ],
            [ -78.4955, 39.5333 ],
            [ -78.4603, 39.5561 ],
            [ -78.4427, 39.6015 ],
            [ -78.4068, 39.6279 ],
            [ -78.3254, 39.6392 ],
            [ -78.1811, 39.6857 ],
            [ -78.0978, 39.6779 ],
            [ -78.0272, 39.6312 ],
            [ -77.9557, 39.6088 ],
            [ -77.8833, 39.6107 ],
            [ -77.8554, 39.5997 ],
            [ -77.8722, 39.5758 ],
            [ -77.8531, 39.5483 ],
            [ -77.7981, 39.5173 ],
            [ -77.7796, 39.4883 ],
            [ -77.7974, 39.4615 ],
            [ -77.7917, 39.4418 ],
            [ -77.7624, 39.4292 ],
            [ -77.7448, 39.4001 ],
            [ -77.739, 39.3543 ],
            [ -77.7266, 39.3464 ],
            [ -77.7918, 39.2266 ],
            [ -77.8358, 39.1452 ],
            [ -77.9486, 39.2163 ],
            [ -78.1183, 39.3233 ],
            [ -78.193, 39.3704 ],
            [ -78.3222, 39.4519 ],
            [ -78.351, 39.4109 ],
            [ -78.3658, 39.3358 ],
            [ -78.4037, 39.2626 ],
            [ -78.4352, 39.1608 ],
            [ -78.5815, 38.999 ],
            [ -78.6928, 38.9217 ],
            [ -78.7273, 38.9239 ],
            [ -78.7568, 38.9082 ],
            [ -78.8055, 38.8602 ],
            [ -78.8687, 38.8179 ],
            [ -78.992, 38.8197 ],
            [ -79.0412, 38.7897 ],
            [ -79.0733, 38.7419 ],
            [ -79.1042, 38.6729 ],
            [ -79.1525, 38.6183 ],
            [ -79.2029, 38.5258 ],
            [ -79.2403, 38.4765 ],
            [ -79.3042, 38.4499 ],
            [ -79.3959, 38.4544 ],
            [ -79.5048, 38.4914 ],
            [ -79.5247, 38.5335 ],
            [ -79.5553, 38.5594 ],
            [ -79.5977, 38.5771 ],
            [ -79.6396, 38.5725 ],
            [ -79.6687, 38.5443 ],
            [ -79.7153, 38.404 ],
            [ -79.7834, 38.336 ],
            [ -79.8129, 38.267 ],
            [ -79.9027, 38.1807 ],
            [ -79.9717, 38.0462 ],
            [ -80.1881, 37.8242 ],
            [ -80.2459, 37.751 ],
            [ -80.2853, 37.6771 ],
            [ -80.2554, 37.6453 ],
            [ -80.2458, 37.6208 ],
            [ -80.292, 37.5659 ],
            [ -80.3161, 37.5097 ],
            [ -80.3712, 37.4726 ],
            [ -80.4645, 37.4327 ],
            [ -80.4914, 37.4639 ],
            [ -80.5074, 37.4691 ],
            [ -80.7198, 37.401 ],
            [ -80.77, 37.4016 ],
            [ -80.8211, 37.4231 ],
            [ -80.8435, 37.4217 ],
            [ -80.8624, 37.4146 ],
            [ -80.8719, 37.3994 ],
            [ -80.8731, 37.3406 ],
            [ -80.9154, 37.3114 ],
            [ -80.9437, 37.3019 ],
            [ -81.0573, 37.2937 ],
            [ -81.1781, 37.2633 ],
            [ -81.2271, 37.2633 ],
            [ -81.35, 37.3337 ],
            [ -81.4194, 37.2823 ],
            [ -81.4855, 37.257 ],
            [ -81.5648, 37.2098 ],
            [ -81.589, 37.2081 ],
            [ -81.6608, 37.2218 ],
            [ -81.7522, 37.2708 ],
            [ -81.8293, 37.2986 ],
            [ -81.8756, 37.3296 ],
            [ -81.9131, 37.369 ],
            [ -81.9394, 37.4326 ],
            [ -81.9714, 37.4731 ],
            [ -81.9577, 37.5076 ],
            [ -81.9653, 37.5397 ],
            [ -82.1035, 37.5706 ],
            [ -82.2802, 37.6872 ],
            [ -82.3939, 37.8283 ],
            [ -82.4299, 37.8942 ],
            [ -82.4719, 37.9384 ],
            [ -82.4822, 37.9836 ],
            [ -82.5888, 38.0997 ],
            [ -82.6177, 38.1499 ],
            [ -82.6195, 38.182 ],
            [ -82.5854, 38.2427 ],
            [ -82.5784, 38.2721 ],
            [ -82.5895, 38.4203 ],
            [ -82.6128, 38.4482 ],
            [ -82.4975, 38.415 ],
            [ -82.3871, 38.434 ],
            [ -82.3181, 38.4797 ],
            [ -82.2909, 38.552 ],
            [ -82.2523, 38.5941 ],
            [ -82.2025, 38.6058 ],
            [ -82.1801, 38.6376 ],
            [ -82.1876, 38.7152 ],
            [ -82.2035, 38.7682 ],
            [ -82.1633, 38.8449 ],
            [ -82.0723, 38.9629 ],
            [ -82.0011, 39.0111 ],
            [ -81.9498, 38.9893 ],
            [ -81.9185, 38.9523 ],
            [ -81.9074, 38.9002 ],
            [ -81.8967, 38.8935 ],
            [ -81.8824, 38.8942 ],
            [ -81.8438, 38.9343 ],
            [ -81.8093, 38.95 ],
            [ -81.795, 38.9459 ],
            [ -81.7801, 38.947 ],
            [ -81.7777, 38.9728 ],
            [ -81.805, 39.0441 ],
            [ -81.8026, 39.0861 ],
            [ -81.7707, 39.0988 ],
            [ -81.7367, 39.1466 ],
            [ -81.7006, 39.2295 ],
            [ -81.6572, 39.272 ],
            [ -81.6065, 39.2741 ],
            [ -81.5516, 39.308 ],
            [ -81.4927, 39.3736 ],
            [ -81.4396, 39.3926 ],
            [ -81.3924, 39.3648 ],
            [ -81.3334, 39.3628 ],
            [ -81.2625, 39.3865 ],
            [ -81.1391, 39.456 ],
            [ -80.9633, 39.5711 ],
            [ -80.8743, 39.6643 ],
            [ -80.8722, 39.7355 ],
            [ -80.8035, 39.9091 ],
            [ -80.6683, 40.1852 ],
            [ -80.6018, 40.3639 ],
            [ -80.6041, 40.4452 ],
            [ -80.6232, 40.5116 ],
            [ -80.659, 40.563 ],
            [ -80.6375, 40.6033 ],
            [ -80.5191, 40.647 ],
            [ -80.5202, 40.5321 ],
            [ -80.5201, 40.4165 ],
            [ -80.52, 40.3008 ],
            [ -80.5199, 40.1851 ],
            [ -80.5198, 40.0695 ],
            [ -80.5197, 39.9538 ],
            [ -80.5196, 39.8382 ],
            [ -80.5194, 39.7225 ],
            [ -80.3892, 39.7225 ],
            [ -80.2589, 39.7226 ],
            [ -80.1287, 39.7226 ],
            [ -79.9985, 39.7226 ],
            [ -79.8682, 39.7227 ],
            [ -79.738, 39.7227 ],
            [ -79.6077, 39.7227 ],
            [ -79.4775, 39.7228 ]
          ]
        ]
      },
      "properties": {
        "featurecla": "Admin-1 scale rank",
        "scalerank": 2,
        "adm1_code": "USA-3554",
        "diss_me": 3554,
        "adm1_cod_1": "USA-3554",
        "iso_3166_2": "US-WV",
        "wikipedia": "http://en.wikipedia.org/wiki/West_Virginia",
        "sr_sov_a3": "US1",
        "sr_adm0_a3": "USA",
        "iso_a2": "US",
        "adm0_sr": 1,
        "admin0_lab": 2,
        "name": "West Virginia",
        "name_alt": "WV|W.Va.",
        "name_local": "",
        "type": "State",
        "type_en": "State",
        "code_local": "US54",
        "code_hasc": "US.WV",
        "note": "",
        "hasc_maybe": "",
        "region": "South",
        "region_cod": "",
        "region_big": "South Atlantic",
        "big_code": "",
        "provnum_ne": 0,
        "gadm_level": 1,
        "check_me": 0,
        "scaleran_1": 2,
        "datarank": 1,
        "abbrev": "W.Va.",
        "postal": "WV",
        "area_sqkm": 0,
        "sameascity": -99,
        "labelrank": 0,
        "featurec_1": "Admin-1 scale rank",
        "admin": "United States of America",
        "name_len": 13,
        "mapcolor9": 1,
        "mapcolor13": 1
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [ -104.0289, 43.0014 ],
            [ -104.028, 42.7513 ],
            [ -104.0271, 42.5013 ],
            [ -104.0261, 42.2512 ],
            [ -104.0252, 42.0011 ],
            [ -104.0243, 41.751 ],
            [ -104.0234, 41.501 ],
            [ -104.0226, 41.2509 ],
            [ -104.0217, 41.0009 ],
            [ -104.3357, 41.0009 ],
            [ -104.6498, 41.0009 ],
            [ -104.9638, 41.0009 ],
            [ -105.2778, 41.0009 ],
            [ -105.5919, 41.0009 ],
            [ -105.9059, 41.0009 ],
            [ -106.22, 41.0009 ],
            [ -106.534, 41.0009 ],
            [ -106.8481, 41.0009 ],
            [ -107.1621, 41.0009 ],
            [ -107.4761, 41.0009 ],
            [ -107.7902, 41.0009 ],
            [ -108.1043, 41.0009 ],
            [ -108.4183, 41.0009 ],
            [ -108.7324, 41.0009 ],
            [ -109.0464, 41.0009 ],
            [ -109.2968, 41.0009 ],
            [ -109.5473, 41.0009 ],
            [ -109.7977, 41.0009 ],
            [ -110.0482, 41.0009 ],
            [ -110.2986, 41.0009 ],
            [ -110.5491, 41.0009 ],
            [ -110.7995, 41.0009 ],
            [ -111.05, 41.0009 ],
            [ -111.05, 41.1259 ],
            [ -111.0501, 41.2509 ],
            [ -111.0501, 41.3759 ],
            [ -111.0501, 41.5009 ],
            [ -111.0502, 41.6259 ],
            [ -111.0502, 41.7509 ],
            [ -111.0502, 41.8759 ],
            [ -111.0503, 42.0009 ],
            [ -111.0504, 42.157 ],
            [ -111.0505, 42.3131 ],
            [ -111.0505, 42.4692 ],
            [ -111.0506, 42.6254 ],
            [ -111.0507, 42.7815 ],
            [ -111.0507, 42.9376 ],
            [ -111.0508, 43.0938 ],
            [ -111.0509, 43.2499 ],
            [ -111.0509, 43.406 ],
            [ -111.051, 43.5621 ],
            [ -111.0511, 43.7183 ],
            [ -111.0511, 43.8744 ],
            [ -111.0512, 44.0305 ],
            [ -111.0513, 44.1867 ],
            [ -111.0514, 44.3428 ],
            [ -111.0514, 44.4989 ],
            [ -111.0513, 44.6245 ],
            [ -111.0511, 44.75 ],
            [ -111.051, 44.8755 ],
            [ -111.0509, 45.0011 ],
            [ -110.8317, 45.0011 ],
            [ -110.6125, 45.0011 ],
            [ -110.3933, 45.0011 ],
            [ -110.1742, 45.0011 ],
            [ -109.955, 45.0011 ],
            [ -109.7358, 45.0011 ],
            [ -109.5166, 45.0011 ],
            [ -109.2975, 45.0011 ],
            [ -109.0783, 45.0011 ],
            [ -108.8591, 45.0011 ],
            [ -108.6399, 45.0011 ],
            [ -108.4207, 45.0011 ],
            [ -108.2016, 45.0011 ],
            [ -107.9824, 45.0011 ],
            [ -107.7632, 45.0011 ],
            [ -107.544, 45.0011 ],
            [ -107.3249, 45.0011 ],
            [ -107.1057, 45.0011 ],
            [ -106.8865, 45.0011 ],
            [ -106.6673, 45.0011 ],
            [ -106.4482, 45.0011 ],
            [ -106.229, 45.0011 ],
            [ -106.0098, 45.0011 ],
            [ -105.7906, 45.0011 ],
            [ -105.5715, 45.0011 ],
            [ -105.3523, 45.0011 ],
            [ -105.1331, 45.0011 ],
            [ -104.9139, 45.0011 ],
            [ -104.6947, 45.0011 ],
            [ -104.4756, 45.0011 ],
            [ -104.2564, 45.0011 ],
            [ -104.0372, 45.0011 ],
            [ -104.0362, 44.7512 ],
            [ -104.0351, 44.5012 ],
            [ -104.0341, 44.2513 ],
            [ -104.033, 44.0013 ],
            [ -104.032, 43.7513 ],
            [ -104.031, 43.5013 ],
            [ -104.0299, 43.2514 ],
            [ -104.0289, 43.0014 ]
          ]
        ]
      },
      "properties": {
        "featurecla": "Admin-1 scale rank",
        "scalerank": 2,
        "adm1_code": "USA-3527",
        "diss_me": 3527,
        "adm1_cod_1": "USA-3527",
        "iso_3166_2": "US-WY",
        "wikipedia": "http://en.wikipedia.org/wiki/Wyoming",
        "sr_sov_a3": "US1",
        "sr_adm0_a3": "USA",
        "iso_a2": "US",
        "adm0_sr": 1,
        "admin0_lab": 2,
        "name": "Wyoming",
        "name_alt": "WY|Wyo.",
        "name_local": "",
        "type": "State",
        "type_en": "State",
        "code_local": "US56",
        "code_hasc": "US.WY",
        "note": "",
        "hasc_maybe": "",
        "region": "West",
        "region_cod": "",
        "region_big": "Mountain",
        "big_code": "",
        "provnum_ne": 0,
        "gadm_level": 1,
        "check_me": 0,
        "scaleran_1": 2,
        "datarank": 1,
        "abbrev": "Wyo.",
        "postal": "WY",
        "area_sqkm": 0,
        "sameascity": -99,
        "labelrank": 0,
        "featurec_1": "Admin-1 scale rank",
        "admin": "United States of America",
        "name_len": 7,
        "mapcolor9": 1,
        "mapcolor13": 1
      }
    }
  ],
  "bbox": [ -178.19451843993755, 18.96390918584938, -66.98702205598448, 71.40768682118636 ]
}



// WEBPACK FOOTER //
// ./src/assets/usa_map.js